const ro = {
  'backdated': 'antedatat',
  'Backdated order — recorded on its planned start date': 'Comandă antedatată — înregistrată la data de început planificată',
  'Change language': 'Schimbă limba',
  Home: 'Acasă',
  Login: 'Autentificare',
  Logout: 'Deconectare',
  'Click to switch user': 'Apasă pentru a schimba utilizatorul',
  'Go Back': 'Înapoi',
  Back: 'Înapoi',
  Close: 'Închide',
  Cancel: 'Anulează',
  Instructions: 'Instrucțiuni',
  'Safety notes': 'Note de siguranță',
  'Quality standards': 'Standarde de calitate',
  New: 'Nou',
  'Load more': 'Încarcă mai multe',
  'Loading…': 'Se încarcă…',
  'Saving…': 'Se salvează…',
  'Company Logo': 'Logo companie',
  Online: 'Conectat',
  Offline: 'Deconectat',
  Cart: 'Coș',
  Checkout: 'Finalizare comandă',
  'Checkout - £{total}': 'Finalizare comandă - £{total}',
  'Clear search': 'Șterge căutarea',
  'Search products': 'Caută produse',
  'Search products...': 'Caută produse...',
  'Search products (Enter to go to products page)':
    'Caută produse (Enter pentru pagina de produse)',
  'Search products (go to products page)': 'Caută produse (mergi la pagina de produse)',
  'Open Dashboard Menu': 'Deschide meniul',
  'Close Dashboard Menu': 'Închide meniul',
  'Close Menu': 'Închide meniul',
  'Open Quick Dashboard': 'Deschide panoul rapid',
  'Close Quick Dashboard': 'Închide panoul rapid',
  'Add to favorites': 'Adaugă la favorite',
  'Remove from favorites': 'Elimină de la favorite',

  Superuser: 'Superutilizator',
  'Admin Dashboard': 'Panou administrator',
  'Sales Manager': 'Manager vânzări',
  'Sales Rep': 'Agent vânzări',
  'Customer Manager': 'Manager clienți',
  'Customer Dashboard': 'Panou client',

  Dashboard: 'Panou de control',
  'Product Catalog': 'Catalog produse',
  'Products Admin': 'Administrare produse',
  Barcodes: 'Coduri de bare',
  'Price Management': 'Gestionare prețuri',
  Discounts: 'Reduceri',
  Banners: 'Bannere',
  'Shopping Cart': 'Coș de cumpărături',
  Orders: 'Comenzi',
  'Carts Management': 'Gestionare coșuri',
  Invoices: 'Facturi',
  'Credit Notes': 'Note de credit',
  Map: 'Hartă',
  Customers: 'Clienți',
  'User Management': 'Gestionare utilizatori',
  'System Settings': 'Setări sistem',
  'System Logs': 'Jurnale sistem',
  'Permissions Dashboard': 'Panou permisiuni',
  'Permission Control': 'Control permisiuni',
  'Header Configuration': 'Configurare antet',
  'Sidebar Configuration': 'Configurare meniu lateral',
  'Shop Assignment': 'Alocare magazine',
  'Sales Assignments': 'Alocări vânzări',
  'Customer Permissions': 'Permisiuni clienți',
  'Customer Assignments': 'Alocări clienți',
  'Orders Fulfillment': 'Onorare comenzi',
  Logistics: 'Logistică',
  Routes: 'Rute',
  Drivers: 'Șoferi',
  'Live Tracking': 'Urmărire live',
  Deliveries: 'Livrări',
  Vehicles: 'Vehicule',
  'Route Planner': 'Planificator rute',
  'Location Management': 'Gestionare locații',
  'Delivery Zones': 'Zone de livrare',
  'Zone Neighbors': 'Zone vecine',
  Warehouses: 'Depozite',
  'Purchase Orders': 'Comenzi de achiziție',
  'Purchase Planner': 'Planificator achiziții',
  Suppliers: 'Furnizori',
  'Purchase Invoices': 'Facturi de achiziție',
  'Debit Notes': 'Note de debit',
  'Website Scraper': 'Extragere de pe site',
  'Suppliers Products': 'Produse furnizori',
  Receipt: 'Recepție',
  Picking: 'Culegere',
  Packing: 'Ambalare',
  'Inventory Management': 'Gestionare stocuri',
  'Warehouse Transfers': 'Transferuri între depozite',
  'Production Dashboard': 'Panou producție',
  'Production Planner': 'Planificator producție',
  'Weekly Production Plan': 'Plan săptămânal de producție',
  'BOM Management': 'Gestionare rețete',
  'Production Orders': 'Comenzi de producție',
  'Work Centres': 'Centre de lucru',
  'Production Planning': 'Planificare producție',
  'WIP Tracking': 'Urmărire producție în curs',
  'Operator Station': 'Stație operator',
  'Production Releases': 'Lansări în producție',
  'QR Scanner': 'Scaner QR',
  'Production Reports': 'Rapoarte producție',
  'Operations Management': 'Gestionare operații',
  Skills: 'Competențe',
  Pages: 'Pagini',
  Posts: 'Articole',
  Menus: 'Meniuri',
  'Headers & Footers': 'Anteturi și subsoluri',
  'Site Settings': 'Setări site',
  'CRM Dashboard': 'Panou CRM',
  'Lead Management': 'Gestionare potențiali clienți',
  'Events Log': 'Jurnal evenimente',
  'Call Log': 'Jurnal apeluri',
  'Office Dashboard': 'Panou birou',
  'Task Management': 'Gestionare sarcini',
  'Project Management': 'Gestionare proiecte',
  'Received Documents': 'Documente primite',
  Emails: 'E-mailuri',
  'Memory Monitoring': 'Monitorizare memorie',
  'AI Assistant': 'Asistent AI',
  'AI Assistant Settings': 'Setări asistent AI',
  'Mobile Logistics Dashboard': 'Panou logistică mobil',
  'Mobile Route Management': 'Gestionare rute mobil',
  'Mobile Deliveries': 'Livrări mobil',
  'Mobile GPS Tracking': 'Urmărire GPS mobil',
  'Mobile Vehicle Inspection': 'Inspecție vehicul mobil',
  'Mobile Orders': 'Comenzi mobil',
  'Mobile Settings': 'Setări mobil',
  'Bank Accounts': 'Conturi bancare',
  Transactions: 'Tranzacții',
  'Customer Statement': 'Fișă client',
  'Supplier Statement': 'Fișă furnizor',
  'Scheduled Payments': 'Plăți programate',
  'Opening Balances': 'Solduri inițiale',
  'Bank Reconciliation': 'Reconciliere bancară',
  'Cash Flow Reports': 'Rapoarte flux de numerar',
  Transfers: 'Transferuri',
  Loans: 'Împrumuturi',
  'Cash Settings': 'Setări trezorerie',
  'Chart of Accounts': 'Plan de conturi',
  'Account Balances': 'Solduri conturi',
  'Journal Entries': 'Note contabile',
  'Fiscal Periods': 'Perioade fiscale',
  'Financial Reports': 'Rapoarte financiare',
  'General Ledger': 'Registru general',
  'Fixed Assets': 'Mijloace fixe',
  'Accounting Settings': 'Setări contabilitate',
  'Payroll Dashboard': 'Panou salarizare',
  Employees: 'Angajați',
  'Pay Periods': 'Perioade de plată',
  'Payroll Entries': 'Înregistrări salarizare',
  'Pay Scenarios': 'Scenarii de plată',
  Timesheets: 'Pontaje',
  'Payroll Schedules': 'Programe de salarizare',
  'Sales Targets': 'Ținte de vânzări',
  'Remuneration Rules': 'Reguli de remunerare',
  'Penalization Rules': 'Reguli de penalizare',
  Calculations: 'Calcule',
  'Payment Terms': 'Termene de plată',
  'Customer Segmentation': 'Segmentare clienți',
  'Catalogue Generator': 'Generator de catalog',
  'Analytics Hub': 'Centru de analiză',
  'Sales Reports': 'Rapoarte vânzări',
  'Purchases Reports': 'Rapoarte achiziții',
  'Warehousing Reports': 'Rapoarte depozit',
  'Logistics Reports': 'Rapoarte logistică',
  'Cash Management Reports': 'Rapoarte trezorerie',
  'Payroll Reports': 'Rapoarte salarizare',
  'System Alerts': 'Alerte sistem',
  'Help Centre': 'Centru de ajutor',

  Stocktake: 'Inventar',
  'New stocktake': 'Inventar nou',
  'All stocktakes': 'Toate inventarele',
  'None yet.': 'Niciunul încă.',
  Warehouse: 'Depozit',
  'What to count': 'Ce se numără',
  Groups: 'Grupe',
  Categories: 'Categorii',
  Brands: 'Mărci',
  Zones: 'Zone',
  Locations: 'Locații',
  'Search {scope}': 'Caută în {scope}',
  'Groups mirror the building, so a counter can walk one and finish it.':
    'Grupele reflectă clădirea, așa că un operator poate parcurge una și o poate termina.',
  'Most categories sit inside a single group, so these behave much like groups.':
    'Majoritatea categoriilor se află într-o singură grupă, deci se comportă la fel ca grupele.',
  'A brand is not a place — its products are spread out, and anything not found is set to zero when you finalise.':
    'O marcă nu este un loc — produsele ei sunt răspândite, iar tot ce nu este găsit este pus pe zero la finalizare.',
  'Counts what is physically in the zone. Stock of the same product elsewhere is left alone.':
    'Numără ce se află fizic în zonă. Stocul aceluiași produs din altă parte nu este atins.',
  'Counts what is physically in the location. Stock of the same product elsewhere is left alone.':
    'Numără ce se află fizic în locație. Stocul aceluiași produs din altă parte nu este atins.',
  'Nothing with stock here.': 'Nimic cu stoc aici.',
  'Start counting': 'Începe numărarea',
  'Starting…': 'Se începe…',
  'Pick a warehouse and at least one thing to count':
    'Alege un depozit și cel puțin un lucru de numărat',
  'Could not start the stocktake': 'Nu s-a putut începe inventarul',
  'Could not load stocktakes': 'Nu s-au putut încărca inventarele',
  'Could not load that stocktake': 'Nu s-a putut încărca acel inventar',
  'Pick a stocktake to see its groups.': 'Alege un inventar pentru a-i vedea grupele.',
  'No stocktake in progress. Press New to start one.':
    'Niciun inventar în desfășurare. Apasă Nou pentru a începe unul.',
  'This stocktake has no groups.': 'Acest inventar nu are grupe.',
  'Close stocktake': 'Închide inventarul',
  'Could not close the stocktake': 'Nu s-a putut închide inventarul',
  '{number} closed': '{number} închis',
  Finalise: 'Finalizează',
  'Finalise {name}': 'Finalizează {name}',
  'this group': 'această grupă',
  Posted: 'Înregistrat',
  'Posted as {number}': 'Înregistrat ca {number}',
  'Posted — nothing varied': 'Înregistrat — nicio diferență',
  'Posting…': 'Se înregistrează…',
  'Post stocktake': 'Înregistrează inventarul',
  'Could not post the stocktake': 'Nu s-a putut înregistra inventarul',
  'Only this group is affected. If anything here has not been walked yet, close this and finish counting first.':
    'Este afectată doar această grupă. Dacă mai este ceva de parcurs aici, închide fereastra și termină mai întâi numărarea.',
  'This posts a stock adjustment and moves real stock. It can be reversed afterwards by cancelling that adjustment.':
    'Aceasta înregistrează o ajustare de stoc și mișcă stocul real. Poate fi anulată ulterior prin anularea acelei ajustări.',
  counting: 'în numărare',
  closed: 'închis',
  draft: 'ciornă',
  cancelled: 'anulat',
  completed: 'finalizat',
  lines: 'linii',
  counted: 'numărate',
  variances: 'diferențe',

  Counting: 'Numărare',
  '{counted}/{total} counted': '{counted}/{total} numărate',
  '{percent}% counted': '{percent}% numărat',
  'Search name, SKU or barcode': 'Caută după nume, SKU sau cod de bare',
  Scan: 'Scanează',
  'Scan barcode': 'Scanează codul de bare',
  'Close scanner': 'Închide scanerul',
  'Starting camera…': 'Pornește camera…',
  'Camera permission denied. Allow camera access, or type the code below.':
    'Accesul la cameră a fost refuzat. Permite accesul la cameră sau scrie codul mai jos.',
  'Could not start the camera. Type the code below instead.':
    'Camera nu a putut porni. Scrie codul mai jos.',
  'Type barcode or SKU': 'Scrie codul de bare sau SKU',
  Find: 'Caută',
  'All categories': 'Toate categoriile',
  'All brands': 'Toate mărcile',
  All: 'Toate',
  'Not counted': 'Nenumărate',
  Counted: 'Numărate',
  Variance: 'Diferență',
  'Nothing matches.': 'Niciun rezultat.',
  'Could not load the count lines': 'Nu s-au putut încărca liniile de inventar',
  'Could not look up that barcode': 'Nu s-a putut căuta acel cod de bare',
  'No product matches {barcode}': 'Niciun produs nu corespunde codului {barcode}',
  'This stocktake is closed. It is now a record of what was found and can no longer be changed.':
    'Acest inventar este închis. Este acum o înregistrare a ceea ce s-a găsit și nu mai poate fi modificat.',
  'This group has been posted. Counts here are a record of what was found; changing them no longer moves stock.':
    'Această grupă a fost înregistrată. Numărătorile de aici sunt o înregistrare a ceea ce s-a găsit; modificarea lor nu mai mișcă stocul.',

  System: 'Sistem',
  'Use the system quantity': 'Folosește cantitatea din sistem',
  'Counted quantity': 'Cantitate numărată',
  'Decrease by one': 'Scade cu unu',
  'Increase by one': 'Crește cu unu',
  'Where? e.g. shelf B3, back pallet (optional)':
    'Unde? ex. raft B3, palet din spate (opțional)',
  'Add count': 'Adaugă numărătoarea',
  'Not found': 'Negăsit',
  'Enter a quantity of zero or more': 'Introdu o cantitate de zero sau mai mare',
  'Could not save the count': 'Numărătoarea nu a putut fi salvată',
  'Could not remove that entry': 'Acea intrare nu a putut fi ștearsă',
  'Remove entry': 'Șterge intrarea',
  Batches: 'Loturi',
  hide: 'ascunde',
  '+{count} more': '+încă {count}',
  expired: 'expirat',
  'No batch assigned': 'Fără lot atribuit',
  'Entries ({count})': 'Intrări ({count})',
  'Nothing counted on this line yet.': 'Nimic numărat pe această linie încă.',
  Unknown: 'Necunoscut',

  'Not on this count': 'Nu este pe acest inventar',
  'Which batch is it?': 'Din ce lot este?',
  'exp {date}': 'exp. {date}',
  '{quantity} in stock': '{quantity} în stoc',
  empty: 'gol',
  'Empty batches are listed on purpose — stock found on the floor usually belongs to one the system already wrote down to zero.':
    'Loturile goale sunt afișate intenționat — stocul găsit în depozit aparține de obicei unui lot pe care sistemul l-a trecut deja pe zero.',
  'Expiry date': 'Data expirării',
  'Expiry = expiry of the main input batch consumed': 'Expirare = expirarea lotului principal consumat',
  'Expiry from input batch': 'Expirare din lotul consumat',
  'This product has never had a batch, so counting it opens the first one.':
    'Acest produs nu a avut niciodată un lot, așa că numărarea lui deschide primul lot.',
  'This product has no batch yet — give it an expiry date.':
    'Acest produs nu are încă un lot — dă-i o dată de expirare.',
  'Could not add the product': 'Produsul nu a putut fi adăugat',
  'Add to count': 'Adaugă la inventar',
  'Adding…': 'Se adaugă…',

  "Failed to load tare item types": "Nu s-au putut încărca tipurile de tară",
  "Name is required": "Numele este obligatoriu",
  "Add at least one part — the trolley itself counts as one": "Adaugă cel puțin o componentă — căruciorul însuși contează ca una",
  "Tare item type updated": "Tipul de tară a fost actualizat",
  "Tare item type created": "Tipul de tară a fost creat",
  "Failed to save tare item type": "Tipul de tară nu a putut fi salvat",
  "Delete \"{name}\"? Operations already using it keep their typed values.": "Ștergi „{name}”? Operațiile care îl folosesc deja își păstrează valorile introduse.",
  "Tare item type deleted": "Tipul de tară a fost șters",
  "Failed to delete tare item type": "Tipul de tară nu a putut fi șters",
  "Tare Item Types": "Tipuri de tară",
  "Trolleys, boards and crates defined once and reused by any operation.": "Cărucioare, plăci și navete definite o singură dată și refolosite de orice operație.",
  "Name (e.g. Rama)": "Nume (ex. Ramă)",
  "List everything this tray is made of — the trolley itself counts as a part. Click a padlock to fix that field so the operator cannot change it on the WIP page; the other one becomes what they type.": "Listează tot din ce este alcătuită tava — căruciorul însuși contează ca o componentă. Apasă pe lacăt pentru a fixa acel câmp, astfel încât operatorul să nu îl poată schimba în pagina WIP; celălalt devine cel pe care îl completează el.",
  "Fixed — the operator cannot change this. Click to unlock.": "Fixat — operatorul nu poate schimba asta. Apasă pentru deblocare.",
  "Click to fix this field so the operator cannot change it.": "Apasă pentru a fixa acest câmp, astfel încât operatorul să nu îl poată schimba.",
  "Part name (e.g. Rama, Sticks)": "Nume componentă (ex. Ramă, Bețe)",
  "+ Add part": "+ Adaugă componentă",
  "Total {weight} kg": "Total {weight} kg",
  "Active": "Activ",
  "Save changes": "Salvează modificările",
  "Add type": "Adaugă tip",
  "No tare item types yet. Add one above.": "Niciun tip de tară încă. Adaugă unul mai sus.",
  "no parts": "fără componente",
  "List view": "Vizualizare listă",
  "Table view": "Vizualizare tabel",
  "Operations dashboard": "Panou operații",
  "Quick Produce": "Producție rapidă",
  "⚡ Quick Produce": "⚡ Producție rapidă",
  "Search WIP items...": "Caută articole WIP...",
  "Show all statuses": "Arată toate stările",
  "All Work Centres": "Toate centrele de lucru",
  "Filter by operator skills": "Filtrează după competențele operatorilor",
  "All Operators": "Toți operatorii",
  "Filter by operations {name} can perform": "Filtrează după operațiile pe care {name} le poate efectua",
  "Filter by operation": "Filtrează după operație",
  "All Operations": "Toate operațiile",
  "All dates": "Toate datele",
  "Today": "Astăzi",
  "Last 7 days": "Ultimele 7 zile",
  "Last 14 days": "Ultimele 14 zile",
  "Last 21 days": "Ultimele 21 de zile",
  "Reset": "Resetează",
  "Reset filters": "Resetează filtrele",
  "Reset all filters to defaults": "Resetează toate filtrele la valorile implicite",
  "Filter by status (multi-select)": "Filtrează după stare (selecție multiplă)",
  "Filter by operator skills (shows WIPs with operations they can perform)": "Filtrează după competențele operatorilor (arată WIP-urile cu operații pe care le pot efectua)",
  "Filter by creation period": "Filtrează după perioada de creare",
  "No WIP items found.": "Nu s-au găsit articole WIP.",
  "No WIP items match the current filters.": "Niciun articol WIP nu corespunde filtrelor curente.",
  "Failed to fetch WIP items": "Articolele WIP nu au putut fi încărcate",
  "Has an open partial finish": "Are o finalizare parțială deschisă",
  "Partial": "Parțial",
  "partial": "parțial",
  "{count}d": "{count}z",
  "Disassembly": "Dezasamblare",
  "Assembly": "Asamblare",
  "Operation:": "Operație:",
  "Previous": "Anterior",
  "Next": "Următor",
  "100 per page": "100 pe pagină",
  "200 per page": "200 pe pagină",
  "500 per page": "500 pe pagină",
  "Status: {status}": "Stare: {status}",
  "Started: {when}": "Început: {when}",
  " by {name}": " de {name}",
  "Finished: {when}": "Terminat: {when}",
  "Qty: {actual}/{target}": "Cant.: {actual}/{target}",
  "Qty": "Cant.",
  "{product} — partial run of {parent}": "{product} — rulare parțială din {parent}",
  "All Status": "Toate stările",
  "Status: {count} selected": "Stare: {count} selectate",
  "Production release generated": "Lansarea în producție a fost generată",
  "Failed to generate production release": "Lansarea în producție nu a putut fi generată",
  "Released": "Lansat",
  "Releasing…": "Se lansează…",
  "Release it": "Lansează",
  "Code": "Cod",
  "Progress": "Progres",
  "Operation": "Operație",
  "Date": "Data",
  "Collapse output products": "Restrânge produsele rezultate",
  "Show output products": "Arată produsele rezultate",
  "Multi products ({count})": "Produse multiple ({count})",
  "Shared trunk — {order}": "Trunchi comun — {order}",
  "Split · trunk": "Divizare · trunchi",
  "Branch of {order}": "Ramură din {order}",
  "branch": "ramură",
  "produced": "produs",
  "Showing": "Se afișează",
  "items": "articole",
  "Not Started": "Neînceput",
  "In Progress": "În desfășurare",
  "On Hold": "În așteptare",
  "Completed": "Finalizat",
  "Cancelled": "Anulat",
  "Done": "Gata",
  "Now": "Acum",
  "Pending": "În așteptare",
  "Hold": "Suspendat",
  "Skipped": "Omis",
  "Failed to load operations": "Operațiile nu au putut fi încărcate",
  "Failed to load the station queue": "Coada stației nu a putut fi încărcată",
  "{operation} started — {product}": "{operation} a început — {product}",
  "Failed to start operation": "Operația nu a putut fi începută",
  "started {time}": "început {time}",
  "ready since {time}": "gata de la {time}",
  "planned {time}": "planificat {time}",
  "Start": "Începe",
  "Continue": "Continuă",
  "{count} jobs in queue — pick any free machine": "{count} lucrări în coadă — alege orice mașină liberă",
  "Pick your operation to see its queue": "Alege-ți operația pentru a-i vedea coada",
  "Lay the queue out in columns": "Așază coada pe coloane",
  "No columns": "Fără coloane",
  "Columns: Work centre": "Coloane: Centru de lucru",
  "Columns: Product group": "Coloane: Grup de produse",
  "Columns: Category": "Coloane: Categorie",
  "Operation…": "Operație…",
  "All my operations": "Toate operațiile mele",
  "Refresh queue": "Reîmprospătează coada",
  "Select your operation above — the choice is remembered on this device.": "Selectează-ți operația mai sus — alegerea este reținută pe acest dispozitiv.",
  "Loading queue…": "Se încarcă coada…",
  "Nothing in the queue for {name}.": "Nimic în coadă pentru {name}.",
  "this operation": "această operație",
  "No machine": "Fără mașină",
  "No group": "Fără grup",
  "No category": "Fără categorie",
  "In progress": "În desfășurare",
  "Ready to start": "Gata de început",
  "No valid batches available for QR generation": "Niciun lot valid disponibil pentru generarea codului QR",
  "Sent {count} batch labels to {printer}": "S-au trimis {count} etichete de lot către {printer}",
  "Labels not auto-printed — QZ Tray is not running or no label printer is saved on this PC": "Etichetele nu au fost tipărite automat — QZ Tray nu rulează sau nu este salvată nicio imprimantă de etichete pe acest calculator",
  "Please allow pop-ups to print labels": "Permite ferestrele pop-up pentru a tipări etichetele",
  "Print dialog ready for {count} QR labels": "Fereastra de tipărire este pregătită pentru {count} etichete QR",
  "Failed to print batch labels: {value1}": "Etichetele de lot nu au putut fi tipărite: {value1}",
  "Batch code is required for QR generation": "Codul lotului este necesar pentru generarea codului QR",
  "Manual assignment: Batch {batch_code} → {value2}": "Atribuire manuală: Lotul {batch_code} → {value2}",
  "Batch assignment cancelled by user": "Atribuirea lotului a fost anulată de utilizator",
  "✅ Batch {internal_batch_code} assigned via search": "✅ Lotul {internal_batch_code} a fost atribuit prin căutare",
  "Quantity updated but no batch found: {batch_code}": "Cantitatea a fost actualizată, dar nu s-a găsit niciun lot: {batch_code}",
  "Quantity updated but batch assignment failed: {batch_code}": "Cantitatea a fost actualizată, dar atribuirea lotului a eșuat: {batch_code}",
  "Batch {batch_code} scanned - no active operation materials": "Lotul {batch_code} a fost scanat - nicio materie primă pe operația activă",
  "Incomplete barcode fragment - please scan again": "Fragment de cod de bare incomplet - scanează din nou",
  "Batch {scannedCode} auto-assigned to {value2}": "Lotul {scannedCode} a fost atribuit automat la {value2}",
  "Batch {scannedCode} scanned - no matching material found": "Lotul {scannedCode} a fost scanat - nu s-a găsit nicio materie primă corespunzătoare",
  "Scanned {entity_type}: {scannedCode}": "Scanat {entity_type}: {scannedCode}",
  "Unknown barcode: {scannedCode}": "Cod de bare necunoscut: {scannedCode}",
  "Batch code {scannedCode} scanned - manual assignment needed": "Codul de lot {scannedCode} a fost scanat - este necesară atribuirea manuală",
  "Error scanning: {scannedCode}": "Eroare la scanare: {scannedCode}",
  "Incomplete QR code - please scan again": "Cod QR incomplet - scanează din nou",
  "Barcode Scanner Ready": "Scanerul de coduri de bare este pregătit",
  "Scan batch QR codes to auto-assign materials and quantities.": "Scanează codurile QR ale loturilor pentru a atribui automat materiile prime și cantitățile.",
  "Scanning:": "Se scanează:",
  "Failed to load WIP document": "Documentul WIP nu a putut fi încărcat",
  "Operation started successfully": "Operația a fost începută cu succes",
  "Tare weights saved": "Greutățile de tară au fost salvate",
  "Failed to save tare weights": "Greutățile de tară nu au putut fi salvate",
  "Partial finish recorded": "Finalizarea parțială a fost înregistrată",
  "Enter a produced quantity for each output (at least one above zero)": "Introdu o cantitate produsă pentru fiecare rezultat (cel puțin una peste zero)",
  "Obtained component is 0 — enter the produced quantity, or use Skip": "Componenta obținută este 0 — introdu cantitatea produsă sau folosește Omite",
  "Operation completed successfully": "Operația a fost finalizată cu succes",
  "Failed to complete operation": "Operația nu a putut fi finalizată",
  "Operation closed": "Operația a fost închisă",
  "Status reverted successfully": "Starea a fost readusă cu succes",
  "Failed to revert status": "Starea nu a putut fi readusă",
  "Operation skipped": "Operația a fost omisă",
  "Failed to skip operation": "Operația nu a putut fi omisă",
  "Production line started": "Linia de producție a fost pornită",
  "Failed to start production line": "Linia de producție nu a putut fi pornită",
  "Production line completed": "Linia de producție a fost finalizată",
  "Failed to finish production line": "Linia de producție nu a putut fi finalizată",
  "Production line skipped": "Linia de producție a fost omisă",
  "Failed to skip production line": "Linia de producție nu a putut fi omisă",
  "Operation status reverted successfully": "Starea operației a fost readusă cu succes",
  "Failed to revert operation status": "Starea operației nu a putut fi readusă",
  "Revert Finish {finishNumber}{qtyText}? This deletes its produced batches and restores the operation state.": "Anulezi finalizarea {finishNumber}{qtyText}? Aceasta șterge loturile produse și readuce starea operației.",
  "Finish {finishNumber} reverted": "Finalizarea {finishNumber} a fost anulată",
  "Failed to revert finish": "Finalizarea nu a putut fi anulată",
  "Failed to close the operation": "Operația nu a putut fi închisă",
  "Operation resumed": "Operația a fost reluată",
  "Remove run {finish_number}? It has produced nothing, so nothing else changes.": "Ștergi rularea {finish_number}? Nu a produs nimic, deci nu se schimbă altceva.",
  "Adds a partial run: its own tab with its own clock, materials and finish — for a second smokehouse loaded while the first is still going": "Adaugă o rulare parțială: propria filă cu propriul cronometru, materiile prime și finalizarea ei — pentru o a doua afumătoare încărcată în timp ce prima este încă în lucru",
  "Pool": "Rezervă",
  "in runs": "în rulări",
  "finished": "terminat",
  "remaining": "rămas",
  "started": "început",
  "total": "total",
  "paused — press Resume, or New partial to load the next run": "în pauză — apasă Reia sau Parțial nou pentru a încărca următoarea rulare",
  "running · {hours}h": "în lucru · {hours}h",
  "{count} run(s) in progress": "{count} rulare/rulări în desfășurare",
  "Resume work on this operation — the clock for the next run starts now": "Reia lucrul la această operație — cronometrul pentru următoarea rulare pornește acum",
  "Resume": "Reia",
  "Finish": "Finalizează",
  "No further runs — close the operation with what the partials already produced so the WIP can complete": "Fără alte rulări — închide operația cu ce au produs deja parțialele, ca WIP-ul să se poată finaliza",
  "Close operation": "Închide operația",
  "Skip Line": "Omite linia",
  "Skip": "Omite",
  "Close after finishing": "Închide după finalizare",
  "Requires QZ Tray and a saved label printer on this PC": "Necesită QZ Tray și o imprimantă de etichete salvată pe acest calculator",
  "Print labels after finishing": "Tipărește etichetele după finalizare",
  "Load next run": "Încarcă următoarea rulare",
  "remaining to load": "rămas de încărcat",
  "Load quantity ({unit})": "Cantitate de încărcat ({unit})",
  "Work centre": "Centru de lucru",
  "Auto (next free)": "Automat (următorul liber)",
  "Loaded at (leave empty = now)": "Încărcat la (lasă gol = acum)",
  "Correct run F": "Corectează rularea F",
  "Changes cascade to this run's batch, movements and cost only — other runs are untouched.": "Modificările se propagă doar la lotul, mișcările și costul acestei rulări — celelalte rulări nu sunt afectate.",
  "Started at": "Început la",
  "Finished at": "Terminat la",
  "Move together — changing the start shifts the finish, keeping the worked duration": "Mută împreună — modificarea începutului deplasează finalul, păstrând durata lucrată",
  "Produced quantity ({unit})": "Cantitate produsă ({unit})",
  "Unchanged": "Nemodificat",
  "Run": "Rulare",
  "Loading WIP Document...": "Se încarcă documentul WIP...",
  "WIP Document Not Found": "Documentul WIP nu a fost găsit",
  "WIP rebuilt from the production order": "WIP-ul a fost reconstruit din comanda de producție",
  "Reloaded only — {reason}": "Doar reîncărcat — {reason}",
  "Click to revert to previous status": "Apasă pentru a reveni la starea anterioară",
  "{done}/{total} ops ({percent}%)": "{done}/{total} operații ({percent}%)",
  "Multi-Item ({count})": "Articole multiple ({count})",
  "Related:": "Asociat:",
  "Plan": "Plan",
  "PO": "CP",
  "WIP": "WIP",
  "Release": "Lansare",
  "LINE": "LINIE",
  "Op": "Op",
  "Steps:": "Pași:",
  "Status": "Stare",
  "Started by": "Început de",
  "Completed by": "Finalizat de",
  "Expected Time": "Timp estimat",
  "Start time of this run — moving it moves the hours it will be costed": "Ora de început a acestei rulări — mutarea ei mută orele la care va fi contabilizată",
  "Optional: record when this partial actually started (defaults to now)": "Opțional: înregistrează când a început efectiv această parțială (implicit acum)",
  "back-date (optional)": "dată anterioară (opțional)",
  "Click to edit start time": "Apasă pentru a edita ora de început",
  "Save": "Salvează",
  "Start Line": "Pornește linia",
  "Optional: record the real start time for a late run (defaults to now)": "Opțional: înregistrează ora reală de început pentru o rulare întârziată (implicit acum)",
  "Finish Line": "Finalizează linia",
  "Optional: record the real finish time for a late run (defaults to now)": "Opțional: înregistrează ora reală de finalizare pentru o rulare întârziată (implicit acum)",
  "Click to edit finish time": "Apasă pentru a edita ora de finalizare",
  "Save & Rebuild": "Salvează și reconstruiește",
  "Time changes saved — batches not re-filled yet": "Modificările de timp au fost salvate — loturile nu au fost încă recompletate",
  "Fill completed. Picking movements re-filled: {value1}": "Completare finalizată. Mișcări de culegere recompletate: {value1}",
  "Recorded finish time applied. Batches rebased: {value1}. Picking movements re-filled: {value2}": "Ora de finalizare înregistrată a fost aplicată. Loturi rebazate: {value1}. Mișcări de culegere recompletate: {value2}",
  "Operation not part of this WIP": "Operația nu face parte din acest WIP",
  "N/A": "N/A",
  "Work Centre:": "Centru de lucru:",
  "Work centre for the selected run": "Centrul de lucru pentru rularea selectată",
  "No Work Centre": "Fără centru de lucru",
  "Material": "Materie primă",
  "Material:": "Materie primă:",
  "Batch": "Lot",
  "Planned": "Planificat",
  "Actual": "Efectiv",
  "Input Component - SKU:": "Componentă intrare - SKU:",
  "Input": "Intrare",
  "Output Component - SKU:": "Componentă ieșire - SKU:",
  "Click to create batch manually": "Apasă pentru a crea lotul manual",
  "Auto-create": "Creare automată",
  "No output components defined for this disassembly operation": "Nicio componentă de ieșire definită pentru această operație de dezasamblare",
  "Product": "Produs",
  "Produced": "Produs",
  "Final Product - Planned:": "Produs final - Planificat:",
  "Final Product": "Produs final",
  "Print QR label": "Tipărește eticheta QR",
  "Print QR Label": "Tipărește eticheta QR",
  "Print label": "Tipărește eticheta",
  "Batch ID required for QR generation": "ID-ul lotului este necesar pentru generarea codului QR",
  "more": "mai multe",
  "No batches": "Fără loturi",
  "Not started": "Neînceput",
  "Required": "Necesar",
  "Required:": "Necesar:",
  "Kg": "Kg",
  "Used": "Folosit",
  "Remaining": "Rămas",
  "Sum of the per-tray gross weights below": "Suma greutăților brute pe tavă de mai jos",
  "Gross:": "Brut:",
  "Tare: -{weight} kg": "Tară: -{weight} kg",
  "Net:": "Net:",
  "No tare presets configured for this operation": "Nicio presetare de tară configurată pentru această operație",
  "Tare items refilled from presets": "Elementele de tară au fost recompletate din presetări",
  "Refill": "Recompletează",
  "Applied net weight {toFixed} kg to {targetName}": "Greutatea netă de {toFixed} kg a fost aplicată la {targetName}",
  "Net weight must be greater than 0": "Greutatea netă trebuie să fie mai mare decât 0",
  "Apply Net as Qty": "Aplică netul ca și cantitate",
  "Gross weight of this tray": "Greutatea brută a acestei tăvi",
  "+ Add": "+ Adaugă",
  "Zone materials come from — batch pickers only offer stock in this zone": "Zona din care provin materiile prime — selectoarele de lot oferă doar stocul din această zonă",
  "No zone scoping": "Fără limitare pe zonă",
  "From:": "Din:",
  "Input for Disassembly": "Intrare pentru dezasamblare",
  "Multi-Product:": "Produse multiple:",
  "Shared": "Comun",
  "Product-Specific": "Specific produsului",
  "Semi-product · Op": "Semifabricat · Op",
  "Substituted": "Înlocuit",
  "Substitute for:": "Înlocuitor pentru:",
  "Addition to:": "Adaos la:",
  "Substitute / Add material": "Înlocuiește / Adaugă materie primă",
  "Substitute / Add Material": "Înlocuiește / Adaugă materie primă",
  "Remove substitution": "Elimină înlocuirea",
  "SKU:": "SKU:",
  "Selected": "Selectat",
  "Selected:": "Selectat:",
  "batches": "loturi",
  "Location this material is consumed from": "Locația din care se consumă această materie primă",
  "No batch": "Fără lot",
  "Click item then select →": "Apasă articolul, apoi selectează →",
  "Set quantity to {clickQty} {value2}": "Setează cantitatea la {clickQty} {value2}",
  "Set quantity to {toFixed} {unitLabel}": "Setează cantitatea la {toFixed} {unitLabel}",
  "No materials required for this operation": "Nicio materie primă necesară pentru această operație",
  "Created Batches": "Loturi create",
  "No batches were created.": "Nu a fost creat niciun lot.",
  "Consumed Batches": "Loturi consumate",
  "Operation Notes": "Note operație",
  "Hold 3s to reset all used quantities for this operation": "Ține apăsat 3s pentru a reseta toate cantitățile folosite pentru această operație",
  "Available Batches": "Loturi disponibile",
  "Loc:": "Loc.:",
  "available": "disponibil",
  "Created:": "Creat:",
  "(from {barcode})": "(din {barcode})",
  "No available batches found": "Nu s-a găsit niciun lot disponibil",
  "Select a material to view available batches": "Selectează o materie primă pentru a vedea loturile disponibile",
  "Approved Substitutes": "Înlocuitori aprobați",
  "Loading substitutes...": "Se încarcă înlocuitorii...",
  "No approved substitutes available": "Niciun înlocuitor aprobat disponibil",
  "Ratio: {ratio}x · Qty: {quantity} {unit}": "Raport: {ratio}x · Cant.: {quantity} {unit}",
  "Replace": "Înlocuiește",
  "Add": "Adaugă",
  "Enter a reason for the loss": "Introdu un motiv pentru pierdere",
  "Batch selected{locationText}": "Lot selectat{locationText}",
  "Failed to update batch": "Lotul nu a putut fi actualizat",
  "Failed to load available batches": "Loturile disponibile nu au putut fi încărcate",
  "Applied {toFixed} {label} to material used": "S-au aplicat {toFixed} {label} la materia primă folosită",
  "Applied {toFixed} {label} to obtained component": "S-au aplicat {toFixed} {label} la componenta obținută",
  "Failed to load locations": "Locațiile nu au putut fi încărcate",
  "Failed to update materials zone": "Zona materiilor prime nu a putut fi actualizată",
  "Please set a quantity before creating batch": "Setează o cantitate înainte de a crea lotul",
  "Batch created: {batch_code}": "Lot creat: {batch_code}",
  "Failed to create batch": "Lotul nu a putut fi creat",
  "Location updated successfully": "Locația a fost actualizată cu succes",
  "Failed to update location": "Locația nu a putut fi actualizată",
  "Failed to load available substitutes": "Înlocuitorii disponibili nu au putut fi încărcați",
  "{value1} applied successfully": "{value1} a fost aplicat cu succes",
  "Substitution removed": "Înlocuirea a fost eliminată",
  "Set quantity to {batchQuantity}kg from batch {value2}": "Cantitate setată la {batchQuantity}kg din lotul {value2}",
  "Failed to add batch quantity": "Cantitatea lotului nu a putut fi adăugată",
  "Failed to select batch": "Lotul nu a putut fi selectat",
  "Failed to set batch quantity": "Cantitatea lotului nu a putut fi setată",
  "Set quantity to {batchQuantity}kg from additional batch {value2}": "Cantitate setată la {batchQuantity}kg din lotul suplimentar {value2}",
  "Failed to set additional batch quantity": "Cantitatea lotului suplimentar nu a putut fi setată",
  "All used quantities reset for this operation": "Toate cantitățile folosite au fost resetate pentru această operație",
  "Failed to reset some quantities": "Unele cantități nu au putut fi resetate",
  "Enter this material's used quantity first, then double-click the variance to re-plan": "Introdu mai întâi cantitatea folosită a acestei materii prime, apoi dublu-clic pe diferență pentru replanificare",
  "Enter this material's used quantity first, then double-click it to autofill the others": "Introdu mai întâi cantitatea folosită a acestei materii prime, apoi dublu-clic pe ea pentru a le completa automat pe celelalte",
  "No other materials to autofill": "Nicio altă materie primă de completat automat",
  "Autofilled {count} materials at {percent}% of BOM": "S-au completat automat {count} materii prime la {percent}% din rețetă",
  "Select location...": "Selectează locația...",
  "Close with remainder?": "Închizi cu restul?",
  "Recorded {done} of {total} {unit}. What happened to the remaining {remainder} {unit}?": "S-au înregistrat {done} din {total} {unit}. Ce s-a întâmplat cu restul de {remainder} {unit}?",
  "Recorded": "Înregistrat",
  "Carryover": "Report",
  "The remainder is absorbed into this finish": "Restul este absorbit în această finalizare",
  "Loss": "Pierdere",
  "The remainder was lost or scrapped": "Restul a fost pierdut sau casat",
  "Reason": "Motiv",
  "Confirm & Finish": "Confirmă și finalizează",
  "Close this operation with the {value1} {value2} already produced across its runs? No further runs can be added afterwards.": "Închizi această operație cu {value1} {value2} deja produse în rulările ei? Ulterior nu mai pot fi adăugate alte rulări.",
  "{value1} {value2} still to load — the operation stays open. Press \"Close operation\" when nothing more goes in.": "Mai sunt de încărcat {value1} {value2} — operația rămâne deschisă. Apasă „Închide operația” când nu mai intră nimic.",
  "Packing: {number}": "Ambalare: {number}",
  "Unassigned": "Nealocat",
  "Not Assigned": "Nealocat",
  "Failed to fetch packing task": "Sarcina de ambalare nu a putut fi preluată",
  "Failed to load packing task details": "Detaliile sarcinii de ambalare nu au putut fi încărcate",
  "Returned {length} tray(s) to picking for correction": "S-au returnat {length} tavă/tăvi la culegere pentru corectare",
  "Failed to return trays": "Tăvile nu au putut fi returnate",
  "Picking corrections complete - syncing updated data": "Corecțiile de culegere sunt gata - se sincronizează datele actualizate",
  "Failed to sync data from picking": "Datele de la culegere nu au putut fi sincronizate",
  "Picking corrections were completed - syncing updated data...": "Corecțiile de culegere au fost finalizate - se sincronizează datele actualizate...",
  "Data synced successfully": "Datele au fost sincronizate cu succes",
  "Remaining items picked - syncing updated data": "Articolele rămase au fost culese - se sincronizează datele actualizate",
  "Packing was reopened to include new items": "Ambalarea a fost redeschisă pentru a include articolele noi",
  "Picking completed - syncing remaining items...": "Culegere finalizată - se sincronizează articolele rămase...",
  "Packing updated with remaining items": "Ambalarea a fost actualizată cu articolele rămase",
  "Failed to update packing task": "Sarcina de ambalare nu a putut fi actualizată",
  "marked ready to ship": "marcată gata de expediere",
  "marked as partially packed": "marcată ca ambalată parțial",
  "Packing task {actionPastTense} successfully": "Sarcina de ambalare a fost {actionPastTense} cu succes",
  "Failed to update packing task: {message}": "Sarcina de ambalare nu a putut fi actualizată: {message}",
  "Failed to start packing task": "Sarcina de ambalare nu a putut fi începută",
  "Failed to mark the packing ready to ship": "Ambalarea nu a putut fi marcată gata de expediere",
  "Failed to mark the packing partially packed": "Ambalarea nu a putut fi marcată ca ambalată parțial",
  "Failed to hand the packing to logistics": "Ambalarea nu a putut fi predată către logistică",
  "No picking task linked to this packing": "Nicio sarcină de culegere legată de această ambalare",
  "Failed to refill packing data": "Datele de ambalare nu au putut fi recompletate",
  "Successfully refilled packing data from picking. Tray weights preserved.": "Datele de ambalare au fost recompletate din culegere. Greutățile tăvilor au fost păstrate.",
  "Failed to refill packing task": "Sarcina de ambalare nu a putut fi recompletată",
  "Status reverted to {status}": "Starea a fost readusă la {status}",
  "Failed to update status": "Starea nu a putut fi actualizată",
  "Loading packing task...": "Se încarcă sarcina de ambalare...",
  "Back to Packing": "Înapoi la Ambalare",
  "Packing task not found": "Sarcina de ambalare nu a fost găsită",
  "Order:": "Comandă:",
  "Batch:": "Lot:",
  "Packing:": "Ambalare:",
  "Order: #": "Comandă: #",
  "Order #": "Comandă #",
  "Picking:": "Culegere:",
  "Refilling...": "Se recompletează...",
  "Print Delivery Notes": "Tipărește avizele de însoțire",
  "Start Packing": "Începe ambalarea",
  "Return ({what})": "Returnează ({what})",
  "{count} tray": "{count} tavă",
  "boxes": "cutii",
  "Partially Packed": "Ambalat parțial",
  "Mark Ready": "Marchează gata",
  "Print Supplementary Note": "Tipărește avizul suplimentar",
  "History": "Istoric",
  "Packing Details": "Detalii ambalare",
  "Related Documents": "Documente asociate",
  "This packing is from a partial pick. Some items are still being picked and will appear automatically when ready.": "Această ambalare provine dintr-o culegere parțială. Unele articole sunt încă în curs de culegere și vor apărea automat când sunt gata.",
  "Partially packed — waiting for remaining items from production. Delivery note for current items can be printed.": "Ambalat parțial — se așteaptă articolele rămase din producție. Avizul pentru articolele curente poate fi tipărit.",
  "Status: Pending": "Stare: În așteptare",
  "Click to revert to Pending": "Apasă pentru a reveni la În așteptare",
  "Click to revert to In Progress": "Apasă pentru a reveni la În desfășurare",
  "Click to revert to Ready to Ship": "Apasă pentru a reveni la Gata de expediere",
  "Click to revert to Completed": "Apasă pentru a reveni la Finalizat",
  "Ready to Ship": "Gata de expediere",
  "Priority": "Prioritate",
  "Assigned": "Alocat",
  "Assigned:": "Alocat:",
  "Assigned To": "Alocat lui",
  "Est. Time": "Timp estimat",
  "Ship Date": "Data expedierii",
  "Ship:": "Expediere:",
  "Trays/Items": "Tăvi/Articole",
  "Total Gross": "Total brut",
  "Tray Weight": "Greutate tavă",
  "Total Net": "Total net",
  "Search items or trays...": "Caută articole sau tăvi...",
  "Expand All": "Extinde tot",
  "Collapse All": "Restrânge tot",
  "Pending Production ({count} items)": "În așteptarea producției ({count} articole)",
  "Awaiting": "În așteptare",
  "Click to unmark tray": "Apasă pentru a demarca tava",
  "Click to mark tray as problematic": "Apasă pentru a marca tava ca problematică",
  "Tray": "Tavă",
  "Tray:": "Tavă:",
  "Corrected": "Corectat",
  "Returned": "Returnat",
  "Manually set weight": "Greutate setată manual",
  "Barcode copied!": "Cod de bare copiat!",
  "Click to copy barcode": "Apasă pentru a copia codul de bare",
  "No barcode": "Fără cod de bare",
  "By:": "De:",
  "Item": "Articol",
  "Weight": "Greutate",
  "Click to unmark item": "Apasă pentru a demarca articolul",
  "Click to mark individual item": "Apasă pentru a marca articolul individual",
  "Pending production": "În așteptarea producției",
  "Click to unmark all boxes": "Apasă pentru a demarca toate cutiile",
  "Click to mark all boxes as problematic": "Apasă pentru a marca toate cutiile ca problematice",
  "📦 Boxes": "📦 Cutii",
  "Tare:": "Tară:",
  "Click to narrow to this product": "Apasă pentru a restrânge la acest produs",
  "Click to mark this product": "Apasă pentru a marca acest produs",
  "Click to narrow to this box": "Apasă pentru a restrânge la această cutie",
  "Click to mark this box": "Apasă pentru a marca această cutie",
  "Box": "Cutie",
  "Picking Info": "Informații culegere",
  "Picking Number:": "Număr culegere:",
  "Picking: {number}": "Culegere: {number}",
  "Picked By:": "Cules de:",
  "Status:": "Stare:",
  "Started:": "Început:",
  "Completed:": "Finalizat:",
  "Trays:": "Tăvi:",
  "Trays Gross:": "Brut tăvi:",
  "Trays Weight:": "Greutate tăvi:",
  "Trays Net:": "Net tăvi:",
  "Boxes:": "Cutii:",
  "Boxes Gross:": "Brut cutii:",
  "Boxes Tare:": "Tară cutii:",
  "Boxes Net:": "Net cutii:",
  "Total:": "Total:",
  "trays +": "tăvi +",
  "boxes /": "cutii /",
  "Grand Gross:": "Total brut:",
  "Tray + Tare:": "Tavă + tară:",
  "Grand Net:": "Total net:",
  "Special Instructions": "Instrucțiuni speciale",
  "Activity History": "Istoric activitate",
  "No activity logs yet": "Niciun jurnal de activitate încă",
  "Status Changed": "Stare modificată",
  "shown": "afișate",
  "Failed to load packing tasks": "Sarcinile de ambalare nu au putut fi încărcate",
  "Packing task created: {packing_number}": "Sarcină de ambalare creată: {packing_number}",
  "Failed to create packing task": "Sarcina de ambalare nu a putut fi creată",
  "Please select at least one picking": "Selectează cel puțin o culegere",
  "{successCount} packing task(s) created successfully": "{successCount} sarcină/sarcini de ambalare create cu succes",
  "{skipCount} packing(s) already existed": "{skipCount} ambalare/ambalări existau deja",
  "{failCount} packing task(s) failed to create": "{failCount} sarcină/sarcini de ambalare nu au putut fi create",
  "Failed to create packings": "Ambalările nu au putut fi create",
  "Failed to delete packing task": "Sarcina de ambalare nu a putut fi ștearsă",
  "Completed Pickings": "Culegeri finalizate",
  "Previous day": "Ziua anterioară",
  "Next day": "Ziua următoare",
  "Clear date filter": "Șterge filtrul de dată",
  "Clear date (show all)": "Șterge data (arată tot)",
  "Clear date": "Șterge data",
  "Select All ({count})": "Selectează tot ({count})",
  "Generating...": "Se generează...",
  "Generate ({count})": "Generează ({count})",
  "Generate": "Generează",
  "Loading...": "Se încarcă...",
  "No completed pickings ready for packing": "Nicio culegere finalizată gata de ambalare",
  "items •": "articole •",
  "items /": "articole /",
  "Unknown Customer": "Client necunoscut",
  "Toggle Completed Pickings": "Comută culegerile finalizate",
  "Print ({count})": "Tipărește ({count})",
  "Search...": "Caută...",
  "Ready": "Gata",
  "Loading packing tasks...": "Se încarcă sarcinile de ambalare...",
  "Packing Number": "Număr ambalare",
  "Customer": "Client",
  "Route": "Rută",
  "Items/Weight": "Articole/Greutate",
  "results": "rezultate",
  "Page": "Pagina",
  "Delete Packing Task": "Șterge sarcina de ambalare",
  "Are you sure you want to delete packing task \"{number}\"? This action cannot be undone.": "Sigur vrei să ștergi sarcina de ambalare „{number}”? Această acțiune nu poate fi anulată.",
  "Delete": "Șterge",
  "Start Packing Task": "Începe sarcina de ambalare",
  "Complete Packing Task": "Finalizează sarcina de ambalare",
  "Cancel Packing Task": "Anulează sarcina de ambalare",
  "Are you sure you want to start packing task \"{number}\"?": "Sigur vrei să începi sarcina de ambalare „{number}”?",
  "Are you sure you want to complete packing task \"{number}\"?": "Sigur vrei să finalizezi sarcina de ambalare „{number}”?",
  "Are you sure you want to cancel packing task \"{number}\"?": "Sigur vrei să anulezi sarcina de ambalare „{number}”?",
  "Are you sure you want to update packing task \"{number}\"?": "Sigur vrei să actualizezi sarcina de ambalare „{number}”?",
  "Packing Task": "Sarcină de ambalare",
  "Confirm": "Confirmă",
  "Complete": "Finalizează",
  "Insufficient stock. Available: {available}": "Stoc insuficient. Disponibil: {available}",
  "User {id}": "Utilizator {id}",
  "FIFO": "FIFO",
  "Zone Picking": "Culegere pe zone",
  "No barcode available": "Niciun cod de bare disponibil",
  "Failed to load picking task": "Sarcina de culegere nu a putut fi încărcată",
  "Failed to load picking task details": "Detaliile sarcinii de culegere nu au putut fi încărcate",
  "Saving and completing picking...": "Se salvează și se finalizează culegerea...",
  "Failed to save data. Please save manually before completing.": "Datele nu au putut fi salvate. Salvează manual înainte de finalizare.",
  "Cannot complete: {length} picked item(s) not saved to server ({missingNames}). Please save first or re-scan these items.": "Nu se poate finaliza: {length} articol(e) culese nu sunt salvate pe server ({missingNames}). Salvează mai întâi sau rescanează aceste articole.",
  "Cannot complete: unsaved quantity changes for: {join}. Please save first.": "Nu se poate finaliza: modificări de cantitate nesalvate pentru: {join}. Salvează mai întâi.",
  "Saving and partially completing picking...": "Se salvează și se finalizează parțial culegerea...",
  "Failed to save data. Please save manually before partially completing.": "Datele nu au putut fi salvate. Salvează manual înainte de finalizarea parțială.",
  "Cannot complete: {length} picked item(s) not saved to server ({missingNamesP}). Please save first or re-scan these items.": "Nu se poate finaliza: {length} articol(e) culese nu sunt salvate pe server ({missingNamesP}). Salvează mai întâi sau rescanează aceste articole.",
  "Saving and completing remaining items...": "Se salvează și se finalizează articolele rămase...",
  "Cannot complete: {length} picked item(s) not saved to server ({missingNamesR}). Please save first or re-scan these items.": "Nu se poate finaliza: {length} articol(e) culese nu sunt salvate pe server ({missingNamesR}). Salvează mai întâi sau rescanează aceste articole.",
  "Picking task started successfully!": "Sarcina de culegere a fost începută cu succes!",
  "Picking task completed successfully!": "Sarcina de culegere a fost finalizată cu succes!",
  "Picking partially completed! Picked items are ready for packing.": "Culegere finalizată parțial! Articolele culese sunt gata de ambalare.",
  "Remaining items completed! Packing will be updated.": "Articolele rămase au fost finalizate! Ambalarea va fi actualizată.",
  "Picking task reverted to in progress!": "Sarcina de culegere a revenit la În desfășurare!",
  "Picking task cancelled!": "Sarcina de culegere a fost anulată!",
  "Picking task updated successfully!": "Sarcina de culegere a fost actualizată cu succes!",
  "Failed to start picking task": "Sarcina de culegere nu a putut fi începută",
  "Failed to complete picking task": "Sarcina de culegere nu a putut fi finalizată",
  "Failed to partially complete picking task": "Sarcina de culegere nu a putut fi finalizată parțial",
  "Failed to complete the remaining items": "Articolele rămase nu au putut fi finalizate",
  "Failed to revert picking task": "Sarcina de culegere nu a putut fi readusă",
  "Failed to cancel picking task": "Sarcina de culegere nu a putut fi anulată",
  "Failed to update picking task": "Sarcina de culegere nu a putut fi actualizată",
  "Cannot revert: Packing {packing_number} has been generated": "Nu se poate reveni: ambalarea {packing_number} a fost generată",
  "Cannot change priority - picking is cancelled": "Nu se poate schimba prioritatea - culegerea este anulată",
  "Priority changed to {toUpperCase}!": "Prioritatea a fost schimbată în {toUpperCase}!",
  "Failed to update priority": "Prioritatea nu a putut fi actualizată",
  "Corrections marked complete - packing updated": "Corecțiile au fost marcate ca finalizate - ambalarea a fost actualizată",
  "Corrections reopened for editing": "Corecțiile au fost redeschise pentru editare",
  "Failed to toggle corrections status": "Starea corecțiilor nu a putut fi comutată",
  "You do not have permission to generate invoices": "Nu ai permisiunea de a genera facturi",
  "Picking must be completed before generating invoice": "Culegerea trebuie finalizată înainte de a genera factura",
  "Invoice {number} updated successfully": "Factura {number} a fost actualizată cu succes",
  "Invoice {number} generated successfully": "Factura {number} a fost generată cu succes",
  "Failed to generate invoice": "Factura nu a putut fi generată",
  "Order unlinked successfully": "Comanda a fost dezlegată cu succes",
  "Failed to unlink order": "Comanda nu a putut fi dezlegată",
  " (including order notes)": " (inclusiv notele comenzii)",
  "Picking data refilled successfully from order{notesMsg}!": "Datele de culegere au fost recompletate cu succes din comandă{notesMsg}!",
  "Failed to refill picking data": "Datele de culegere nu au putut fi recompletate",
  "Please start picking first before editing tray weights": "Începe mai întâi culegerea înainte de a edita greutățile tăvilor",
  "Cannot modify tray weights - picking is completed": "Nu se pot modifica greutățile tăvilor - culegerea este finalizată",
  "Corrections marked complete - click the green badge to enable editing": "Corecțiile au fost marcate ca finalizate - apasă insigna verde pentru a activa editarea",
  "Please start picking first before editing quantities": "Începe mai întâi culegerea înainte de a edita cantitățile",
  "Cannot modify quantities - picking is completed": "Nu se pot modifica cantitățile - culegerea este finalizată",
  "Batch cleared": "Lot șters",
  "Cannot scan items - picking is completed": "Nu se pot scana articole - culegerea este finalizată",
  "All boxes already picked for this item": "Toate cutiile au fost deja culese pentru acest articol",
  "+{quantityToAdd} → {product_name}: {newQty} (Tray {value4})": "+{quantityToAdd} → {product_name}: {newQty} (Tava {value4})",
  "+{quantityToAdd} → {product_name}: {newQty} (Assigned to Tray {currentTrayNumber})": "+{quantityToAdd} → {product_name}: {newQty} (Alocat la tava {currentTrayNumber})",
  "🆕 New row: {product_name} ({quantityToAdd} {base_unit}) → Tray {currentTrayNumber}": "🆕 Rând nou: {product_name} ({quantityToAdd} {base_unit}) → Tava {currentTrayNumber}",
  "Found: {product_name}": "Găsit: {product_name}",
  "Item \"{searchTerm}\" not found in current picking list.": "Articolul „{searchTerm}” nu a fost găsit în lista de culegere curentă.",
  "Global Product": "Produs global",
  "Barcode {linkBarcodeValue} linked to {name}": "Codul de bare {linkBarcodeValue} a fost legat de {name}",
  "+{quantity} → {name}: {newQty}": "+{quantity} → {name}: {newQty}",
  "Added: {name} ({quantity})": "Adăugat: {name} ({quantity})",
  "Failed to link barcode: {errMsg}": "Codul de bare nu a putut fi legat: {errMsg}",
  "+{quantityToAdd} → {name}{itemType}: {newQty} {value5} (Tray {currentTrayNumber})": "+{quantityToAdd} → {name}{itemType}: {newQty} {value5} (Tava {currentTrayNumber})",
  "+{quantityToAdd} → {name}{itemType}: {newQty} {value5} (Assigned to Tray {currentTrayNumber})": "+{quantityToAdd} → {name}{itemType}: {newQty} {value5} (Alocat la tava {currentTrayNumber})",
  "🆕 New row: {name} ({quantity} {base_unit}) → Tray {currentTrayNumber}": "🆕 Rând nou: {name} ({quantity} {base_unit}) → Tava {currentTrayNumber}",
  "🆕 Added: {name} ({quantity} {base_unit})": "🆕 Adăugat: {name} ({quantity} {base_unit})",
  "Item added locally but failed to sync to server": "Articolul a fost adăugat local, dar nu a putut fi sincronizat cu serverul",
  "Search failed: {message}": "Căutarea a eșuat: {message}",
  "Cannot delete items - picking is completed": "Nu se pot șterge articole - culegerea este finalizată",
  "Item not found": "Articolul nu a fost găsit",
  "Cannot delete original picking list items": "Nu se pot șterge articolele originale din lista de culegere",
  "Failed to delete item from server": "Articolul nu a putut fi șters de pe server",
  "Split item {sequenceNumber} deleted": "Articolul divizat {sequenceNumber} a fost șters",
  "New item deleted": "Articolul nou a fost șters",
  "Please start picking first before managing trays": "Începe mai întâi culegerea înainte de a gestiona tăvile",
  "Cannot delete trays - picking is {status}": "Nu se pot șterge tăvile - culegerea este {status}",
  "No empty trays to delete": "Nicio tavă goală de șters",
  "Empty trays deleted": "Tăvile goale au fost șterse",
  "Please start picking first before splitting items": "Începe mai întâi culegerea înainte de a diviza articole",
  "Cannot split items - picking is completed": "Nu se pot diviza articole - culegerea este finalizată",
  "Split item created: {baseNumber}.{nextSplitNumber} in Tray {splitTrayNumber}": "Articol divizat creat: {baseNumber}.{nextSplitNumber} în tava {splitTrayNumber}",
  "Box #{box_number} — {netWeight} kg": "Cutia #{box_number} — {netWeight} kg",
  "Failed to record box": "Cutia nu a putut fi înregistrată",
  "Box removed": "Cutia a fost eliminată",
  "Failed to delete box": "Cutia nu a putut fi ștearsă",
  "Assigned batch {batchCodeToAssign} to Box {currentBoxNum}": "Lotul {batchCodeToAssign} a fost alocat cutiei {currentBoxNum}",
  "Assigned batch {batchCodeToAssign} to all boxes": "Lotul {batchCodeToAssign} a fost alocat tuturor cutiilor",
  "No remaining quantity to allocate": "Nicio cantitate rămasă de alocat",
  "Assigned batch {batchCodeToAssign} to {product_name}": "Lotul {batchCodeToAssign} a fost alocat la {product_name}",
  "Failed to assign batch": "Lotul nu a putut fi alocat",
  "Quantity must be greater than 0": "Cantitatea trebuie să fie mai mare decât 0",
  "Allocated {quantity} from batch {code}": "S-au alocat {quantity} din lotul {code}",
  "Please select trays to print": "Selectează tăvile de tipărit",
  "Sent {count} tray labels to {printer}": "S-au trimis {count} etichete de tavă către {printer}",
  "Direct print failed: {value1}. Opening print dialog instead.": "Tipărirea directă a eșuat: {value1}. Se deschide fereastra de tipărire.",
  "Generated labels for {count} trays": "S-au generat etichete pentru {count} tăvi",
  "Failed to generate tray labels": "Etichetele de tavă nu au putut fi generate",
  "Please start picking first before saving changes": "Începe mai întâi culegerea înainte de a salva modificările",
  "Cannot save changes - picking is completed": "Nu se pot salva modificările - culegerea este finalizată",
  "Save already in progress, please wait...": "Salvare deja în curs, așteaptă...",
  "Failed to delete item from Django": "Articolul nu a putut fi șters din Django",
  "Failed to save some items": "Unele articole nu au putut fi salvate",
  "Failed to save new item: {product_name}": "Articolul nou nu a putut fi salvat: {product_name}",
  "Quantities updated! Added {count} new items.": "Cantitățile au fost actualizate! S-au adăugat {count} articole noi.",
  "Quantities updated successfully!": "Cantitățile au fost actualizate cu succes!",
  "{count} items failed to save.": "{count} articole nu au putut fi salvate.",
  "Changes saved successfully": "Modificările au fost salvate cu succes",
  "Failed to update quantities": "Cantitățile nu au putut fi actualizate",
  "NEW ITEM": "ARTICOL NOU",
  "Scanned: {quantity}": "Scanat: {quantity}",
  "Excellent ✓": "Excelent ✓",
  "{quantity} split to tray {tray}": "{quantity} divizat pe tava {tray}",
  "Under by {quantity}": "Sub cu {quantity}",
  "Over by {quantity}": "Peste cu {quantity}",
  "Loading picking task...": "Se încarcă sarcina de culegere...",
  "Back to Picking": "Înapoi la Culegere",
  "Picking task not found": "Sarcina de culegere nu a fost găsită",
  "Scanning...": "Se scanează...",
  "Switch to Terminal View": "Comută la vizualizarea Terminal",
  "Terminal": "Terminal",
  "Start Picking": "Începe culegerea",
  "Partial Complete": "Finalizare parțială",
  "Complete Remaining": "Finalizează restul",
  "Click to update invoice": "Apasă pentru a actualiza factura",
  "Generate Invoice": "Generează factura",
  "Invoiced": "Facturat",
  "Invoice": "Factură",
  "Effective date:": "Data efectivă:",
  "Effective date set{extra}": "Data efectivă a fost setată{extra}",
  ", {count} product(s) refilled": ", {count} produs(e) recompletate",
  "Effective date cleared": "Data efectivă a fost ștearsă",
  "Failed to save: {message}": "Salvarea a eșuat: {message}",
  "Clear back to auto (uses completed_at / now)": "Revino la automat (folosește completed_at / acum)",
  "clear": "șterge",
  "Saving cascades onto existing movements and re-runs fill.": "Salvarea se propagă la mișcările existente și rulează din nou completarea.",
  "Orders:": "Comenzi:",
  "Unlink orders": "Dezleagă comenzile",
  "Refill from order": "Recompletează din comandă",
  "Due Date": "Termen",
  "Due:": "Termen:",
  "Cancel Picking": "Anulează culegerea",
  "Quantity": "Cantitate",
  "Picking Details": "Detalii culegere",
  "Items to Pick": "Articole de cules",
  "products": "produse",
  "Product already in list — selected: {product_name}": "Produsul este deja în listă — selectat: {product_name}",
  "Added global product: {product_name}": "Produs global adăugat: {product_name}",
  "Failed to save item to server": "Articolul nu a putut fi salvat pe server",
  "GLOBAL": "GLOBAL",
  "Unit:": "Unitate:",
  "Ordered:": "Comandat:",
  "Groups:": "Grupe:",
  "All ({count})": "Toate ({count})",
  "Ungrouped ({count})": "Negrupate ({count})",
  "Unpicked ({count})": "Neculese ({count})",
  "Sequence": "Secvență",
  "Location": "Locație",
  "A-Z": "A-Z",
  "Last added": "Ultimele adăugate",
  "Partially completed — {picked} of {total} items sent to packing.": "Finalizat parțial — {picked} din {total} articole trimise la ambalare.",
  "Click to delete": "Apasă pentru a șterge",
  "DELETE": "ȘTERGE",
  "Click to show delete": "Apasă pentru a afișa ștergerea",
  "Click to delete split item": "Apasă pentru a șterge articolul divizat",
  "Click to show delete option": "Apasă pentru a afișa opțiunea de ștergere",
  "Click to split this item": "Apasă pentru a diviza acest articol",
  "SPLIT": "DIVIZEAZĂ",
  "Sent to packing": "Trimis la ambalare",
  "Target": "Țintă",
  "Target:": "Țintă:",
  "scans": "scanări",
  "Picked": "Cules",
  "Please start picking first before assigning trays": "Începe mai întâi culegerea înainte de a aloca tăvi",
  "Cannot change tray assignments - picking is completed": "Nu se pot schimba alocările de tăvi - culegerea este finalizată",
  "Click to pick next box": "Apasă pentru a culege următoarea cutie",
  "Exit Multi": "Ieși din modul multiplu",
  "Calculator": "Calculator",
  "Allocated:": "Alocat:",
  "Exp:": "Exp.:",
  "Allocating from:": "Se alocă din:",
  "Clear": "Șterge",
  "(unsaved)": "(nesalvat)",
  "Remove box": "Elimină cutia",
  "Click to pick — use calculator": "Apasă pentru a culege — folosește calculatorul",
  "📦 Box": "📦 Cutie",
  "Editing: Tray": "Se editează: Tava",
  "Weight (kg)": "Greutate (kg)",
  "Exit Multi-Batch": "Ieși din modul multi-lot",
  "Multi-Batch": "Multi-lot",
  "Current Allocations:": "Alocări curente:",
  "Remove": "Elimină",
  "Hide out of stock": "Ascunde ce nu este în stoc",
  "Select/deselect all trays": "Selectează/deselectează toate tăvile",
  "Click to add new tray": "Apasă pentru a adăuga o tavă nouă",
  "Cannot add trays - picking is {status}": "Nu se pot adăuga tăvi - culegerea este {status}",
  "Please set weight for Tray {currentTrayNumber} before adding a new tray": "Setează greutatea pentru tava {currentTrayNumber} înainte de a adăuga o tavă nouă",
  "Tray Summary": "Sumar tăvi",
  "products • Tray:": "produse • Tava:",
  "Add new tray": "Adaugă o tavă nouă",
  "Default": "Implicit",
  "Cannot edit default tray weight - picking is {status}": "Nu se poate edita greutatea implicită a tăvii - culegerea este {status}",
  "Delete empty trays": "Șterge tăvile goale",
  "Cannot edit tray weights - picking is completed. Use \"Revert to In Progress\" to make changes.": "Nu se pot edita greutățile tăvilor - culegerea este finalizată. Folosește „Revino la În desfășurare” pentru a face modificări.",
  "Cannot edit tray weights - picking is cancelled": "Nu se pot edita greutățile tăvilor - culegerea este anulată",
  "Copied: {barcode}": "Copiat: {barcode}",
  "Net": "Net",
  "Gross": "Brut",
  "Boxes Summary": "Sumar cutii",
  "boxes —": "cutii —",
  "items)": "articole)",
  "kg · Gross:": "kg · Brut:",
  "kg gross": "kg brut",
  "(Batch:": "(Lot:",
  "Order Notes": "Note comandă",
  "Insufficient Stock": "Stoc insuficient",
  "Product:": "Produs:",
  "Available stock:": "Stoc disponibil:",
  "You have permission to override this restriction. Do you want to proceed?": "Ai permisiunea de a ignora această restricție. Vrei să continui?",
  "Override": "Ignoră restricția",
  "Link Barcode": "Leagă codul de bare",
  "not linked.": "nelegat.",
  "Stored as:": "Stocat ca:",
  "Search product name or SKU...": "Caută nume produs sau SKU...",
  "Searching...": "Se caută...",
  "No products found for \"{term}\"": "Niciun produs găsit pentru „{term}”",
  "(SKU:": "(SKU:",
  "Product default": "Implicit produs",
  "Qty Barcode": "Cod de bare cu cantitate",
  "Qty per scan:": "Cantitate pe scanare:",
  "Quantity extracted from barcode digits automatically.": "Cantitatea este extrasă automat din cifrele codului de bare.",
  "Showing logs for:": "Se afișează jurnalele pentru:",
  "No status changes yet": "Nicio schimbare de stare încă",
  "Start Picking Task": "Începe sarcina de culegere",
  "Complete Picking Task": "Finalizează sarcina de culegere",
  "Partially Complete Picking Task": "Finalizează parțial sarcina de culegere",
  "Complete Remaining Items": "Finalizează articolele rămase",
  "Revert Picking Task": "Readu sarcina de culegere",
  "Cancel Picking Task": "Anulează sarcina de culegere",
  "Are you sure you want to start picking task \"{number}\"?": "Sigur vrei să începi sarcina de culegere „{number}”?",
  "Are you sure you want to complete picking task \"{number}\"?": "Sigur vrei să finalizezi sarcina de culegere „{number}”?",
  "Are you sure you want to partially complete picking task \"{number}\"?": "Sigur vrei să finalizezi parțial sarcina de culegere „{number}”?",
  "Are you sure you want to complete the remaining items of picking task \"{number}\"?": "Sigur vrei să finalizezi articolele rămase din sarcina de culegere „{number}”?",
  "Are you sure you want to revert picking task \"{number}\"?": "Sigur vrei să readuci sarcina de culegere „{number}”?",
  "Are you sure you want to cancel picking task \"{number}\"?": "Sigur vrei să anulezi sarcina de culegere „{number}”?",
  "Are you sure you want to update picking task \"{number}\"?": "Sigur vrei să actualizezi sarcina de culegere „{number}”?",
  "Picking Task": "Sarcină de culegere",
  "Revert": "Readu",
  "Failed to load picking tasks": "Sarcinile de culegere nu au putut fi încărcate",
  "Failed to load unpicked orders": "Comenzile neculese nu au putut fi încărcate",
  "Failed to load comparison data": "Datele de comparație nu au putut fi încărcate",
  "Please select a customer": "Selectează un client",
  "Failed to create scan picking": "Culegerea prin scanare nu a putut fi creată",
  "Please select at least one order": "Selectează cel puțin o comandă",
  "Generated {count} picking tasks successfully!": "S-au generat {count} sarcini de culegere cu succes!",
  "Skipped {count} orders (already have picking)": "S-au omis {count} comenzi (au deja culegere)",
  "Failed to generate {count} picking tasks": "{count} sarcini de culegere nu au putut fi generate",
  "Failed to generate picking tasks": "Sarcinile de culegere nu au putut fi generate",
  "Picking task generated and order status updated to processing!": "Sarcina de culegere a fost generată, iar starea comenzii a trecut la În procesare!",
  "Picking task generated successfully!": "Sarcina de culegere a fost generată cu succes!",
  "Failed to generate picking task": "Sarcina de culegere nu a putut fi generată",
  "Please select at least one picking task to export": "Selectează cel puțin o sarcină de culegere pentru export",
  "Exported {count} picking tasks to 1C successfully!": "S-au exportat {count} sarcini de culegere în 1C cu succes!",
  "Failed to export {count} picking tasks": "{count} sarcini de culegere nu au putut fi exportate",
  "Failed to export picking tasks": "Sarcinile de culegere nu au putut fi exportate",
  "Please select at least one completed picking": "Selectează cel puțin o culegere finalizată",
  "Packing task updated": "Sarcina de ambalare a fost actualizată",
  "{count} packing tasks created": "S-au creat {count} sarcini de ambalare",
  "{count} packing tasks updated": "S-au actualizat {count} sarcini de ambalare",
  "{count} packing tasks failed": "{count} sarcini de ambalare au eșuat",
  "Failed to generate packing tasks": "Sarcinile de ambalare nu au putut fi generate",
  "Failed to delete picking task": "Sarcina de culegere nu a putut fi ștearsă",
  "Unpicked Orders": "Comenzi neculese",
  "All ({selected}/{total})": "Toate ({selected}/{total})",
  "Create separate picking for each order": "Creează culegere separată pentru fiecare comandă",
  "Individual ({count})": "Individual ({count})",
  "Loading orders...": "Se încarcă comenzile...",
  "No unpicked orders found": "Nu s-a găsit nicio comandă neculeasă",
  "All orders have picking tasks generated": "Toate comenzile au sarcini de culegere generate",
  "Debug: Orders loaded:": "Depanare: comenzi încărcate:",
  "Comparison": "Comparație",
  "Ord: {count} ({quantity} Kg)": "Com.: {count} ({quantity} Kg)",
  "Pick: ({quantity} Kg)": "Cules: ({quantity} Kg)",
  "None:": "Niciunul:",
  "Kg)": "Kg)",
  "Short:": "Lipsă:",
  "Over:": "Peste:",
  "OK:": "OK:",
  "No items found": "Niciun articol găsit",
  "Ord:": "Com.:",
  "Pick:": "Cules:",
  "Toggle Unpicked Orders": "Comută comenzile neculese",
  "+ Create": "+ Creează",
  "Status is pinned to Completed while \"Not invoiced\" is on": "Starea este fixată pe Finalizat cât timp „Nefacturat” este activ",
  "Toggle to show only pickings with returned items": "Comută pentru a afișa doar culegerile cu articole returnate",
  "Show completed pickings that have no invoice yet (clears the date filter)": "Arată culegerile finalizate care nu au încă factură (șterge filtrul de dată)",
  "Not Invoiced": "Nefacturat",
  "Packing ({count})": "Ambalare ({count})",
  "Exporting...": "Se exportă...",
  "Export {count}": "Exportă {count}",
  "Loading picking tasks...": "Se încarcă sarcinile de culegere...",
  "Nothing is waiting to be invoiced": "Nimic nu așteaptă să fie facturat",
  "Every completed picking has an invoice.": "Fiecare culegere finalizată are factură.",
  "No picking tasks found": "Nu s-a găsit nicio sarcină de culegere",
  "Select all completed picking tasks": "Selectează toate sarcinile de culegere finalizate",
  "Task Number": "Număr sarcină",
  "Items/Qty": "Articole/Cant.",
  "Actions": "Acțiuni",
  "Click to change priority": "Apasă pentru a schimba prioritatea",
  "Click to compare ordered vs picked": "Apasă pentru a compara comandat cu cules",
  "Picking exported to 1C successfully": "Culegerea a fost exportată în 1C cu succes",
  "Export failed: {error}": "Exportul a eșuat: {error}",
  "Select All ({selected}/{total})": "Selectează tot ({selected}/{total})",
  "Delete Picking Task": "Șterge sarcina de culegere",
  "Are you sure you want to delete picking task \"{number}\"? This action cannot be undone.": "Sigur vrei să ștergi sarcina de culegere „{number}”? Această acțiune nu poate fi anulată.",
  "Create Scan Picking": "Creează culegere prin scanare",
  "Select a customer for the scan picking document:": "Selectează un client pentru documentul de culegere prin scanare:",
  "Creating...": "Se creează...",
  "Create Picking": "Creează culegerea",
  "Code scanned successfully!": "Codul a fost scanat cu succes!",
  "Code not recognized": "Codul nu a fost recunoscut",
  "Failed to scan code": "Codul nu a putut fi scanat",
  "Scan failed": "Scanarea a eșuat",
  "Could not access camera. Please check permissions.": "Camera nu a putut fi accesată. Verifică permisiunile.",
  "QR code detection requires a QR scanning library. Please use manual input for now.": "Detectarea codurilor QR necesită o bibliotecă de scanare QR. Deocamdată, folosește introducerea manuală.",
  "QR Code Scanner": "Scaner de coduri QR",
  "Scan or enter production QR codes": "Scanează sau introdu coduri QR de producție",
  "Camera Scanner": "Scaner cu cameră",
  "Camera preview will appear here": "Previzualizarea camerei va apărea aici",
  "Start Camera": "Pornește camera",
  "Capture": "Capturează",
  "Stop": "Oprește",
  "Manual Input": "Introducere manuală",
  "Enter QR Code or Barcode": "Introdu codul QR sau codul de bare",
  "Scan anywhere on page or enter manually...": "Scanează oriunde pe pagină sau introdu manual...",
  "Scan Code": "Scanează codul",
  "Quick Examples:": "Exemple rapide:",
  "Scan Result": "Rezultatul scanării",
  "Code Value": "Valoarea codului",
  "Entity Type": "Tip entitate",
  "Suggested Action": "Acțiune sugerată",
  "Method": "Metodă",
  "Linked Object": "Obiect legat",
  "ID:": "ID:",
  "Order Number:": "Număr comandă:",
  "Smart Routing:": "Rutare inteligentă:",
  "Redirecting to": "Se redirecționează către",
  "Navigate to": "Navighează la",
  "Detail": "Detaliu",
  "Error:": "Eroare:",
  "Scanned code:": "Cod scanat:",
  "{errorMsg} You have permission to override. Proceed anyway?": "{errorMsg} Ai permisiunea de a ignora restricția. Continui oricum?",
  "Failed to override quantity": "Cantitatea nu a putut fi suprascrisă",
  "Failed to update quantity": "Cantitatea nu a putut fi actualizată",
  "Picking is already completed": "Culegerea este deja finalizată",
  "Start the picking first before scanning": "Începe mai întâi culegerea înainte de a scana",
  "Product not found in this picking": "Produsul nu a fost găsit în această culegere",
  "Item is awaiting stock replenishment": "Articolul așteaptă reaprovizionarea stocului",
  "{product_name}: {newQty}/{targetQty}": "{product_name}: {newQty}/{targetQty}",
  "Failed to load items": "Articolele nu au putut fi încărcate",
  "Mark this picking as complete?": "Marchezi această culegere ca finalizată?",
  "Cancel this picking?": "Anulezi această culegere?",
  "Picking completed": "Culegere finalizată",
  "Picking refilled from order": "Culegerea a fost recompletată din comandă",
  "Failed to refill": "Recompletarea a eșuat",
  "Failed to refill picking": "Culegerea nu a putut fi recompletată",
  "Failed to load batches": "Loturile nu au putut fi încărcate",
  "Batch changed to {internal_batch_code}": "Lotul a fost schimbat în {internal_batch_code}",
  "Terminal set as your default view": "Terminalul a fost setat ca vizualizare implicită",
  "Failed to save preference": "Preferința nu a putut fi salvată",
  "Loading picking...": "Se încarcă culegerea...",
  "Switch to Classic View": "Comută la vizualizarea clasică",
  "Classic": "Clasic",
  "Show all": "Arată tot",
  "Hide done": "Ascunde ce e gata",
  "Awaiting Stock": "Așteaptă stoc",
  "No batches available": "Niciun lot disponibil",
  "No expiry": "Fără expirare",
  "No items in this group": "Niciun articol în această grupă",
  "Set as default view": "Setează ca vizualizare implicită",
  "Failed to update picking": "Culegerea nu a putut fi actualizată",
  "Withdraw the close — the runs stay, the pool opens again": "Retrage închiderea — rulările rămân, rezerva se redeschide",
  "Reopen": "Redeschide",
  "{qty} {unit} is in the current partial, not finished yet": "{qty} {unit} sunt în parțiala curentă, încă nefinalizate",
  "Main": "Principal",
  "Online Shop": "Magazin online",
  "Products": "Produse",
  "Sales": "Vânzări",
  "Organiser": "Organizator",
  "CMS": "CMS",
  "Purchases": "Achiziții",
  "Warehousing": "Depozitare",
  "Production": "Producție",
  "Cash Management": "Trezorerie",
  "Payroll": "Salarizare",
  "Accounting": "Contabilitate",
  "Analytics": "Analiză",
  "Other": "Altele",
  "Drag to reorder": "Trage pentru reordonare",
  "Bold": "Îngroșat",
  "Color": "Culoare",
  "Manage featured pages": "Gestionează paginile favorite",
  "No featured pages yet. Star pages from the sidebar.": "Nicio pagină favorită încă. Marchează pagini cu stea din meniul lateral.",
  "Star pages in sidebar": "Marchează pagini cu stea în meniul lateral",
  "Receipt: {number}": "Recepție: {number}",
  "Failed to load receipt": "Recepția nu a putut fi încărcată",
  "Failed to load receipt details": "Detaliile recepției nu au putut fi încărcate",
  "Failed to load receipts": "Recepțiile nu au putut fi încărcate",
  "No movements with missing batches found for these products": "Nu s-au găsit mișcări cu loturi lipsă pentru aceste produse",
  "Updated: {picking_movements_updated} picking, {wip_materials_updated} WIP materials, {wip_movements_created} WIP movements created": "Actualizate: {picking_movements_updated} culegeri, {wip_materials_updated} materii prime WIP, {wip_movements_created} mișcări WIP create",
  "Error: {message}": "Eroare: {message}",
  "Failed to update {count} items. Please check and try again.": "{count} articole nu au putut fi actualizate. Verifică și încearcă din nou.",
  "Failed to send the receipt for inspection: {message}": "Recepția nu a putut fi trimisă la inspecție: {message}",
  "Failed to approve the receipt: {message}": "Recepția nu a putut fi aprobată: {message}",
  "Failed to reject the receipt: {message}": "Recepția nu a putut fi respinsă: {message}",
  "Failed to update the receipt: {message}": "Recepția nu a putut fi actualizată: {message}",
  "✅ Applied to {appliedProductName}": "✅ Aplicat la {appliedProductName}",
  "✅ Applied {count} pending scans": "✅ S-au aplicat {count} scanări în așteptare",
  "✅ Data applied to {value1}": "✅ Date aplicate la {value1}",
  "Undid scan for {productName}": "Scanarea pentru {productName} a fost anulată",
  "❌ All barcodes already scanned for this label": "❌ Toate codurile de bare de pe această etichetă au fost deja scanate",
  "⚠️ Scan doesn't match any expected barcode for this label": "⚠️ Scanarea nu corespunde niciunui cod de bare așteptat pentru această etichetă",
  "⚠️ Already scanned: {value1}": "⚠️ Deja scanat: {value1}",
  "Barcode #{position}": "Cod de bare #{position}",
  "✅ Label complete: all {length} barcodes scanned": "✅ Etichetă completă: toate cele {length} coduri de bare au fost scanate",
  "✅ Scanned: {value1} | Remaining: {nextLabel}": "✅ Scanat: {value1} | Rămâne: {nextLabel}",
  "Cannot scan items - receipt is completed": "Nu se pot scana articole - recepția este finalizată",
  "✓ Auto-applied: {name}": "✓ Aplicat automat: {name}",
  "Net: {weight} kg": "Net: {weight} kg",
  "Gross: {weight} kg": "Brut: {weight} kg",
  "Count: {count}": "Număr: {count}",
  "⚠️ Product \"{name}\" not in this receipt": "⚠️ Produsul „{name}” nu este în această recepție",
  "⚠️ Please scan a product barcode first": "⚠️ Scanează mai întâi un cod de bare de produs",
  "Batch ✓": "Lot ✓",
  "Expiry ✓": "Expirare ✓",
  "Gross Weight ✓": "Greutate brută ✓",
  "Net Weight ✓": "Greutate netă ✓",
  "✅ Scanned: {join}": "✅ Scanat: {join}",
  "❌ No data found in barcode": "❌ Nu s-au găsit date în codul de bare",
  "✓ Auto-applied: {productNameForPush}": "✓ Aplicat automat: {productNameForPush}",
  "❌ Product not found for barcode: {barcode}": "❌ Nu s-a găsit niciun produs pentru codul de bare: {barcode}",
  "❌ Error: {message}": "❌ Eroare: {message}",
  "Failed to link barcode": "Codul de bare nu a putut fi legat",
  "Added \"{productName}\" to receipt as unplanned item": "„{productName}” a fost adăugat la recepție ca articol neplanificat",
  "Linked barcode to \"{productName}\"": "Codul de bare a fost legat de „{productName}”",
  "Failed to add unplanned item": "Articolul neplanificat nu a putut fi adăugat",
  "Could not match product to a receipt line": "Produsul nu a putut fi asociat unei linii de recepție",
  "Routed scan to \"{productName}\"": "Scanarea a fost direcționată către „{productName}”",
  "Revert deletes ALL movements and batches from this receipt. Use \"Correct Items\" for partial fixes. Continue?": "Revenirea șterge TOATE mișcările și loturile din această recepție. Folosește „Corectează articole” pentru corecții parțiale. Continui?",
  "Failed to revert status: {message}": "Starea nu a putut fi readusă: {message}",
  "Correction mode active. Edit items, then click Finish Correction.": "Modul de corectare este activ. Editează articolele, apoi apasă Finalizează corectarea.",
  "Correction applied: {changed} changed, {added} added, {removed} removed. {rebatched} downstream picking movement(s) rebatched.": "Corectare aplicată: {changed} modificate, {added} adăugate, {removed} eliminate. {rebatched} mișcare/mișcări de culegere din aval reloturizate.",
  "Cancel correction? Any edits made in this session will be discarded and the receipt will return to its previous state.": "Anulezi corectarea? Toate modificările din această sesiune vor fi pierdute, iar recepția va reveni la starea anterioară.",
  "Correction cancelled. {items_restored} item(s) restored, {items_dropped} dropped.": "Corectare anulată. {items_restored} articol(e) restaurate, {items_dropped} eliminate.",
  "Failed to generate batch: {message}": "Lotul nu a putut fi generat: {message}",
  "Error generating batch: {message}": "Eroare la generarea lotului: {message}",
  "Failed to delete batch: {message}": "Lotul nu a putut fi șters: {message}",
  "Error deleting batch: {message}": "Eroare la ștergerea lotului: {message}",
  "{name} added to receipt": "{name} a fost adăugat la recepție",
  "Failed to add product: {error}": "Produsul nu a putut fi adăugat: {error}",
  "Remove \"{name}\" from this receipt? Its stock movement will be reversed on Finish Correction.": "Elimini „{name}” din această recepție? Mișcarea de stoc va fi anulată la Finalizează corectarea.",
  "Remove \"{name}\" from this receipt?": "Elimini „{name}” din această recepție?",
  "{product_name} removed from receipt": "{product_name} a fost eliminat din recepție",
  "Failed to remove item: {error}": "Articolul nu a putut fi eliminat: {error}",
  "Failed to save quantity: {message}": "Cantitatea nu a putut fi salvată: {message}",
  "Failed to save quantity: {error}": "Cantitatea nu a putut fi salvată: {error}",
  "Failed to save unit: {message}": "Unitatea nu a putut fi salvată: {message}",
  "Failed to save unit: {error}": "Unitatea nu a putut fi salvată: {error}",
  "Failed to save batch code: {message}": "Codul lotului nu a putut fi salvat: {message}",
  "Failed to save batch code: {error}": "Codul lotului nu a putut fi salvat: {error}",
  "Failed to save the field: {message}": "Câmpul nu a putut fi salvat: {message}",
  "Failed to save {field}: {error}": "Câmpul {field} nu a putut fi salvat: {error}",
  "Received quantity cannot be negative": "Cantitatea recepționată nu poate fi negativă",
  "Received quantity is too large": "Cantitatea recepționată este prea mare",
  "Batch code is too long (max 100 characters)": "Codul lotului este prea lung (maximum 100 de caractere)",
  "Invalid location selected": "Locație selectată invalidă",
  "Invalid quality status": "Stare de calitate invalidă",
  "Quality notes are too long (max 500 characters)": "Notele de calitate sunt prea lungi (maximum 500 de caractere)",
  "Refilled from invoice: {items_added} added, {items_updated} updated, {items_removed} removed — receipt now mirrors the invoice": "Recompletat din factură: {items_added} adăugate, {items_updated} actualizate, {items_removed} eliminate — recepția oglindește acum factura",
  "Failed to refill from invoice": "Recompletarea din factură a eșuat",
  "Loading receipt...": "Se încarcă recepția...",
  "Back to Receipts": "Înapoi la Recepții",
  "Receipt not found": "Recepția nu a fost găsită",
  "🟢 Scanner Active": "🟢 Scaner activ",
  "⚫ Scanner Inactive": "⚫ Scaner inactiv",
  "Scan or enter barcode...": "Scanează sau introdu codul de bare...",
  "Label Type": "Tip etichetă",
  "Auto-detect label type...": "Detectează automat tipul etichetei...",
  "barcodes)": "coduri de bare)",
  "Auto-apply when all barcodes are scanned": "Aplică automat când toate codurile de bare sunt scanate",
  "Scan in any order — the system matches each barcode by content.": "Scanează în orice ordine — sistemul potrivește fiecare cod de bare după conținut.",
  "✓ Apply All ({count})": "✓ Aplică tot ({count})",
  "Dismiss this scan without applying": "Renunță la această scanare fără a o aplica",
  "✓ Apply": "✓ Aplică",
  "Scan a product barcode to begin. Each scan stacks here until you Apply.": "Scanează un cod de bare de produs pentru a începe. Fiecare scanare se adună aici până când apeși Aplică.",
  "Back to receipts list": "Înapoi la lista de recepții",
  "Click to revert to {status}": "Apasă pentru a reveni la {status}",
  "Receipt Details": "Detalii recepție",
  "Start Inspection": "Începe inspecția",
  "Click to disable scanner": "Apasă pentru a dezactiva scanerul",
  "Click to enable scanner": "Apasă pentru a activa scanerul",
  "Scanner On": "Scaner pornit",
  "Scanner Off": "Scaner oprit",
  "Complete all items before approving": "Finalizează toate articolele înainte de aprobare",
  "Approve": "Aprobă",
  "Final delivery": "Livrare finală",
  "Last delivery for {po}: lines still short on the order are closed and no longer expected": "Ultima livrare pentru {po}: liniile din comandă care încă lipsesc se închid și nu mai sunt așteptate",
  "Reject": "Respinge",
  "Edit individual items without losing untouched movements": "Editează articole individuale fără a pierde mișcările neatinse",
  "Correct Items": "Corectează articole",
  "Fill Missing Batches": "Completează loturile lipsă",
  "Finishing…": "Se finalizează…",
  "Finish Correction": "Finalizează corectarea",
  "Cancel Correction": "Anulează corectarea",
  "Correct": "Corectează",
  "Fill Batches": "Completează loturile",
  "Audit": "Audit",
  "Receipt Progress": "Progres recepție",
  "Completion": "Finalizare",
  "Items with quantity differences": "Articole cu diferențe de cantitate",
  "Quality Passed": "Calitate admisă",
  "Items approved": "Articole aprobate",
  "Quality Issues": "Probleme de calitate",
  "Items failed/conditional": "Articole respinse/condiționate",
  "All items processed! Receipt ready for approval.": "Toate articolele au fost procesate! Recepția este gata de aprobare.",
  "Receipt Information": "Informații recepție",
  "Purchase Order": "Comandă de achiziție",
  "None": "Niciunul",
  "Refill items from purchase order": "Recompletează articolele din comanda de achiziție",
  "Invoice Number": "Număr factură",
  "Refill items from invoice": "Recompletează articolele din factură",
  "Refill from invoice (keeps existing items, adds/updates only differences)": "Recompletează din factură (păstrează articolele existente, adaugă/actualizează doar diferențele)",
  "Received By": "Recepționat de",
  "Created By": "Creat de",
  "Scheduled Date": "Data programată",
  "Received Date": "Data recepției",
  "Started At": "Început la",
  "Supplier Information": "Informații furnizor",
  "Supplier: {name}": "Furnizor: {name}",
  "Expected Quantity": "Cantitate așteptată",
  "Received Quantity": "Cantitate recepționată",
  "Receipt Notes": "Note recepție",
  "Enter receipt notes...": "Introdu notele recepției...",
  "No notes": "Fără note",
  "Received Items": "Articole recepționate",
  "different products": "produse diferite",
  "✓ Batches created and inventory updated": "✓ Loturile au fost create și stocul a fost actualizat",
  "+ Add Product": "+ Adaugă produs",
  "Search product by name or SKU...": "Caută produsul după nume sau SKU...",
  "Recv = Invoiced": "Recepționat = Facturat",
  "Set Location...": "Setează locația...",
  "Set Quality...": "Setează calitatea...",
  "Conditional": "Condiționat",
  "Item completed": "Articol finalizat",
  "Item pending": "Articol în așteptare",
  "Product: {name}": "Produs: {name}",
  "← SEL": "← SEL",
  "Batch...": "Lot...",
  "Select...": "Selectează...",
  "Notes...": "Note...",
  "Delete batch": "Șterge lotul",
  "Generate batch": "Generează lotul",
  "Gen": "Gen",
  "Remove item from receipt": "Elimină articolul din recepție",
  "SELECTED": "SELECTAT",
  "Ordered": "Comandat",
  "Difference:": "Diferență:",
  "Batch Code": "Cod lot",
  "Quality Notes": "Note de calitate",
  "Delete Batch": "Șterge lotul",
  "Recv": "Recep.",
  "Ord": "Com.",
  "Inv": "Fact.",
  "Loc": "Loc.",
  "Quality": "Calitate",
  "In Correction": "În corectare",
  "Receipt {receipt_number} created for Invoice {invoice_number}": "Recepția {receipt_number} a fost creată pentru factura {invoice_number}",
  "Failed to create receipt": "Recepția nu a putut fi creată",
  "Error creating receipt from invoice": "Eroare la crearea recepției din factură",
  "Receipt {receipt_number} created for PO {po_number}": "Recepția {receipt_number} a fost creată pentru comanda {po_number}",
  "Error creating receipt": "Eroare la crearea recepției",
  "Please generate receipts from pending invoices or purchase orders": "Generează recepții din facturile sau comenzile de achiziție în așteptare",
  "Receipt cancelled successfully": "Recepția a fost anulată cu succes",
  "Failed to cancel receipt": "Recepția nu a putut fi anulată",
  "Toggle pending receipts sidebar": "Comută panoul recepțiilor în așteptare",
  "Manage incoming receipts and deliveries": "Gestionează recepțiile și livrările primite",
  "Filters": "Filtre",
  "New Receipt": "Recepție nouă",
  "Manage incoming receipts": "Gestionează recepțiile primite",
  "Search receipts...": "Caută recepții...",
  "Awaiting Receipt": "Așteaptă recepția",
  "Receiving in Progress": "Recepție în desfășurare",
  "Receipt Completed": "Recepție finalizată",
  "Receipt Cancelled": "Recepție anulată",
  "From Date": "De la data",
  "To Date": "Până la data",
  "Supplier name": "Nume furnizor",
  "Pending Receipts": "Recepții în așteptare",
  "No invoices pending receipt": "Nicio factură în așteptarea recepției",
  "PO:": "CA:",
  "Items:": "Articole:",
  "Date:": "Data:",
  "Generate Receipt": "Generează recepția",
  "No purchase orders pending receipt": "Nicio comandă de achiziție în așteptarea recepției",
  "Expected:": "Așteptat:",
  "Loading receipts...": "Se încarcă recepțiile...",
  "Receipt Number": "Număr recepție",
  "PO Number": "Număr comandă",
  "Items": "Articole",
  "No Invoice": "Fără factură",
  "Invoice:": "Factură:",
  "Scheduled:": "Programat:",
  "Delete Receipt": "Șterge recepția",
  "Are you sure you want to delete receipt \"{number}\"? This action cannot be undone.": "Sigur vrei să ștergi recepția „{number}”? Această acțiune nu poate fi anulată.",
  "{quantity} units, batch_id {batch}": "{quantity} unități, batch_id {batch}",
  "Loading audit log…": "Se încarcă jurnalul de audit…",
  "No corrections recorded for this receipt.": "Nicio corectare înregistrată pentru această recepție.",
  "Correction by": "Corectare de",
  "Supplier batch": "Lot furnizor",
  "ADDED": "ADĂUGAT",
  "REMOVED": "ELIMINAT",
  "Scan History": "Istoric scanări",
  "Close scan history": "Închide istoricul scanărilor",
  "Session total:": "Total sesiune:",
  "across": "pe",
  "scan": "scanare",
  "No scans yet. Start scanning items — each successful apply will appear here so you can undo if needed.": "Nicio scanare încă. Începe să scanezi articole — fiecare aplicare reușită va apărea aici, ca să poți anula dacă e nevoie.",
  "gross": "brut",
  "batch": "lot",
  "prod": "prod.",
  "Undo this scan": "Anulează această scanare",
  "No scans yet. Each successful apply will appear here so you can undo if needed.": "Nicio scanare încă. Fiecare aplicare reușită va apărea aici, ca să poți anula dacă e nevoie.",
  "Scanner": "Scaner",
  "Barcode not on this receipt": "Codul de bare nu este pe această recepție",
  "Unknown barcode": "Cod de bare necunoscut",
  "Scanned:": "Scanat:",
  "Belongs to": "Aparține de",
  "Pick a product to link this barcode to.": "Alege un produs de care să legi acest cod de bare.",
  "Filter by product name or SKU…": "Filtrează după nume produs sau SKU…",
  "On this receipt ({count})": "Pe această recepție ({count})",
  "No receipt items match.": "Niciun articol de recepție nu corespunde.",
  "expected": "așteptat",
  "received": "recepționat",
  "Other products from this supplier ({count})": "Alte produse de la acest furnizor ({count})",
  "No supplier products match.": "Niciun produs al furnizorului nu corespunde.",
  "supplier SKU {sku}": "SKU furnizor {sku}",
  "+ add to receipt": "+ adaugă la recepție",
  "This barcode is already linked to a different product. Either you scanned the wrong item, or the supplier shipped something not on this receipt. Cancel to return, or contact the supplier.": "Acest cod de bare este deja legat de un alt produs. Ori ai scanat articolul greșit, ori furnizorul a livrat ceva ce nu se află pe această recepție. Anulează pentru a reveni sau contactează furnizorul.",
  "Please paste some data": "Lipește niște date",
  "No valid data found": "Nu s-au găsit date valide",
  "Invalid format - expected \"Product Name  Quantity\"": "Format invalid - se aștepta „Nume produs  Cantitate”",
  "Product not found": "Produsul nu a fost găsit",
  "Missing quantity": "Cantitate lipsă",
  "Please assign at least one column as \"Product Name / SKU\"": "Alocă cel puțin o coloană ca „Nume produs / SKU”",
  "No products entered": "Niciun produs introdus",
  "Removed from matched list": "Eliminat din lista potrivirilor",
  "No items to import": "Niciun articol de importat",
  "Imported {length} item(s)": "S-au importat {length} articol(e)",
  "Matched: {name}": "Potrivit: {name}",
  "Product name is required": "Numele produsului este obligatoriu",
  "Please select a unit": "Selectează o unitate",
  "Created: {productName}": "Creat: {productName}",
  "Failed to create product": "Produsul nu a putut fi creat",
  "Failed to create product: {errMsg}": "Produsul nu a putut fi creat: {errMsg}",
  "Review Import —": "Verifică importul —",
  "items parsed": "articole analizate",
  "Matched ({count})": "Potrivite ({count})",
  "Unmatched ({count})": "Nepotrivite ({count})",
  "No matched items yet": "Niciun articol potrivit încă",
  "Resolve unmatched items to add them here": "Rezolvă articolele nepotrivite pentru a le adăuga aici",
  "Consolidation on import:": "Consolidare la import:",
  "(merged)": "(comasat)",
  "Line": "Linie",
  "SKU": "SKU",
  "Unit": "Unitate",
  "will merge": "se vor comasa",
  "All items resolved!": "Toate articolele au fost rezolvate!",
  "Quantity:": "Cantitate:",
  "e.g. kg, pcs, boxes": "ex. kg, buc, cutii",
  "Product name / Search:": "Nume produs / Căutare:",
  "Type to search or edit product name...": "Scrie pentru a căuta sau edita numele produsului...",
  "Re-search": "Caută din nou",
  "Suggested matches:": "Potriviri sugerate:",
  "% match)": "% potrivire)",
  "Create as new product": "Creează ca produs nou",
  "Select unit...": "Selectează unitatea...",
  "Create & Match": "Creează și potrivește",
  "Skip this item": "Omite acest articol",
  "Skipped ({count})": "Omise ({count})",
  "Restore": "Restaurează",
  "Back to paste": "Înapoi la lipire",
  "Import Products by Copy/Paste": "Importă produse prin copiere/lipire",
  "Text Mode": "Mod text",
  "Table Mode": "Mod tabel",
  "Paste data with SKU/Product Name, Quantity, and optionally Unit separated by tab, comma, semicolon, or space": "Lipește date cu SKU/Nume produs, Cantitate și opțional Unitate, separate prin tab, virgulă, punct și virgulă sau spațiu",
  "Paste your data here...": "Lipește datele aici...",
  "SKU001": "SKU001",
  "Product Name,50,kg": "Nume produs,50,kg",
  "SKU003;25;pieces": "SKU003;25;bucăți",
  "SKU004 30 boxes": "SKU004 30 cutii",
  "SKU005,75": "SKU005,75",
  "Add column": "Adaugă coloană",
  "+ Add rows": "+ Adaugă rânduri",
  "Product Name / SKU": "Nume produs / SKU",
  "Expiry Date": "Data expirării",
  "Skip (ignore)": "Omite (ignoră)",
  "Delete cycle count {countNumber}? This cannot be undone.": "Ștergi inventarul ciclic {countNumber}? Această acțiune nu poate fi anulată.",
  "Cycle count {countNumber} deleted": "Inventarul ciclic {countNumber} a fost șters",
  "Cycle Counts": "Inventare ciclice",
  "Search count numbers...": "Caută numere de inventar...",
  "All Warehouses": "Toate depozitele",
  "All Statuses": "Toate stările",
  "Scheduled": "Programat",
  "Start Cycle Count": "Începe inventarul ciclic",
  "Count #": "Inventar #",
  "Started By": "Început de",
  "Items Counted": "Articole numărate",
  "Discrepancies": "Diferențe",
  "Started": "Început",
  "No cycle counts found": "Nu s-a găsit niciun inventar ciclic",
  "Failed to load batch details": "Detaliile lotului nu au putut fi încărcate",
  "Batch updated. Synced expiry to {updated_receipt_items} receipt item(s) and {updated_invoice_items} invoice item(s)": "Lot actualizat. Expirarea a fost sincronizată cu {updated_receipt_items} articol(e) de recepție și {updated_invoice_items} articol(e) de factură",
  "Batch updated successfully": "Lotul a fost actualizat cu succes",
  "Expired": "Expirat",
  "Expires in": "Expiră în",
  "days": "zile",
  "Good until": "Valabil până la",
  "Loading batch details...": "Se încarcă detaliile lotului...",
  "Batch Not Found": "Lotul nu a fost găsit",
  "Back to Batches": "Înapoi la Loturi",
  "Edit Batch": "Editează lotul",
  "Batch Details": "Detalii lot",
  "Stock Movements ({count})": "Mișcări de stoc ({count})",
  "Picking History ({count})": "Istoric culegeri ({count})",
  "Batch Information": "Informații lot",
  "Batch Number": "Număr lot",
  "Supplier Batch": "Lot furnizor",
  "Supplier": "Furnizor",
  "Quality Status": "Stare calitate",
  "Quantity Information": "Informații cantitate",
  "Initial Quantity": "Cantitate inițială",
  "Current Quantity": "Cantitate curentă",
  "Allocated Quantity": "Cantitate alocată",
  "Available Quantity": "Cantitate disponibilă",
  "Manufacturing Date": "Data fabricației",
  "No expiry date": "Fără dată de expirare",
  "Timeline": "Cronologie",
  "Created": "Creat",
  "Last Updated": "Ultima actualizare",
  "Received": "Recepționat",
  "Not recorded": "Neînregistrat",
  "Notes": "Note",
  "Type": "Tip",
  "Balance": "Sold",
  "Reference": "Referință",
  "No stock movements": "Nicio mișcare de stoc",
  "No movements recorded for this batch yet.": "Nicio mișcare înregistrată pentru acest lot încă.",
  "No picking history": "Niciun istoric de culegere",
  "This batch has not been used in any picking tasks yet.": "Acest lot nu a fost folosit în nicio sarcină de culegere încă.",
  "Passed": "Admis",
  "Failed": "Respins",
  "Quarantine": "Carantină",
  "Update expiry date on related receipt and purchase invoice items": "Actualizează data expirării pe articolele de recepție și de factură de achiziție asociate",
  "Add batch notes...": "Adaugă note pentru lot...",
  "Update Batch": "Actualizează lotul",
  "Failed to load cycle count details": "Detaliile inventarului ciclic nu au putut fi încărcate",
  "No discrepancy": "Nicio diferență",
  "Discrepancy found": "S-a găsit o diferență",
  "Count recorded successfully": "Numărătoarea a fost înregistrată cu succes",
  "Failed to record count": "Numărătoarea nu a putut fi înregistrată",
  "Count recorded": "Numărătoare înregistrată",
  "System quantities updated successfully": "Cantitățile din sistem au fost actualizate cu succes",
  "Failed to update system quantities": "Cantitățile din sistem nu au putut fi actualizate",
  "Copied system quantities for {length} items": "S-au copiat cantitățile din sistem pentru {length} articole",
  "Cleared counted quantities for {length} items": "S-au șters cantitățile numărate pentru {length} articole",
  "Saving {length} pending counts...": "Se salvează {length} numărători în așteptare...",
  "All counts saved": "Toate numărătorile au fost salvate",
  "Cycle count completed successfully": "Inventarul ciclic a fost finalizat cu succes",
  "Failed to complete cycle count": "Inventarul ciclic nu a putut fi finalizat",
  "Failed to revert cycle count": "Inventarul ciclic nu a putut fi readus",
  "Cycle count reverted": "Inventarul ciclic a fost readus",
  "Failed to update status: {errorMessage}": "Starea nu a putut fi actualizată: {errorMessage}",
  "Status changed to {status}": "Starea a fost schimbată în {status}",
  "Status updated successfully": "Starea a fost actualizată cu succes",
  "Are you sure you want to delete {size} items?": "Sigur vrei să ștergi {size} articole?",
  "Deleted {deleted_count} items": "S-au șters {deleted_count} articole",
  "Failed to delete items": "Articolele nu au putut fi șterse",
  "Updated expiry date for {updated_count} items": "S-a actualizat data expirării pentru {updated_count} articole",
  "Failed to update expiry dates": "Datele de expirare nu au putut fi actualizate",
  "Applied {adjustments_created} discrepancies to stock": "S-au aplicat {adjustments_created} diferențe asupra stocului",
  "No discrepancies found to apply": "Nu s-au găsit diferențe de aplicat",
  "Failed to apply discrepancies": "Diferențele nu au putut fi aplicate",
  "All discrepancies have already been applied": "Toate diferențele au fost deja aplicate",
  "Failed to load products": "Produsele nu au putut fi încărcate",
  "Failed to load warehouses": "Depozitele nu au putut fi încărcate",
  "Failed to load zones": "Zonele nu au putut fi încărcate",
  "Failed to load categories": "Categoriile nu au putut fi încărcate",
  "Failed to load groups": "Grupele nu au putut fi încărcate",
  "Please create the cycle count first": "Creează mai întâi inventarul ciclic",
  "Added {added_count} items with quantities from copy-paste": "S-au adăugat {added_count} articole cu cantități din copiere/lipire",
  "Added {added_count} items but some quantities failed to save": "S-au adăugat {added_count} articole, dar unele cantități nu au putut fi salvate",
  "Added {added_count} items from copy-paste": "S-au adăugat {added_count} articole din copiere/lipire",
  "Failed to add products": "Produsele nu au putut fi adăugate",
  "Please select a warehouse": "Selectează un depozit",
  "Please select a category": "Selectează o categorie",
  "Please select a group": "Selectează o grupă",
  "Please select a zone": "Selectează o zonă",
  "Please select a location": "Selectează o locație",
  "Cycle count updated successfully": "Inventarul ciclic a fost actualizat cu succes",
  "Cycle count created successfully": "Inventarul ciclic a fost creat cu succes",
  "Count updated but failed to load items": "Inventarul a fost actualizat, dar articolele nu au putut fi încărcate",
  "Failed to save cycle count": "Inventarul ciclic nu a putut fi salvat",
  "Please select products to add": "Selectează produsele de adăugat",
  "Added {added_count} items to cycle count": "S-au adăugat {added_count} articole la inventarul ciclic",
  "Cycle count not found": "Inventarul ciclic nu a fost găsit",
  "Back to Inventory": "Înapoi la Stocuri",
  "Show count details": "Arată detaliile inventarului",
  "Hide count details": "Ascunde detaliile inventarului",
  "Start New Cycle Count": "Începe un inventar ciclic nou",
  "Cycle Count {number}": "Inventar ciclic {number}",
  "Click to change back to {status}": "Apasă pentru a reveni la {status}",
  "Click to change status": "Apasă pentru a schimba starea",
  "Configure and start a new inventory cycle count": "Configurează și începe un nou inventar ciclic",
  "Apply": "Aplică",
  "Count Type": "Tip inventar",
  "Full Warehouse": "Depozit complet",
  "Zone": "Zonă",
  "Category": "Categorie",
  "Group": "Grupă",
  "Select warehouse": "Selectează depozitul",
  "Select category": "Selectează categoria",
  "Select group": "Selectează grupa",
  "All zones": "Toate zonele",
  "All locations": "Toate locațiile",
  "Location {id}": "Locația {id}",
  "Count Date": "Data inventarului",
  "Updating...": "Se actualizează...",
  "Update Count": "Actualizează inventarul",
  "Create Count": "Creează inventarul",
  "Select all": "Selectează tot",
  "item": "articol",
  "selected": "selectate",
  "Items to Count": "Articole de numărat",
  "Show only discrepancies": "Arată doar diferențele",
  "Marked for batch generation": "Marcat pentru generare de lot",
  "Unmarked for batch generation": "Demarcat pentru generare de lot",
  "Unmark": "Demarchează",
  "Mark": "Marchează",
  "Generate Batch": "Generează lot",
  "Update Expiry Date": "Actualizează data expirării",
  "Update Expiry Date ({count} items)": "Actualizează data expirării ({count} articole)",
  "Expiry": "Expirare",
  "Delete Selected": "Șterge selecția",
  "Copy/Paste Import": "Import prin copiere/lipire",
  "Add Products": "Adaugă produse",
  "Search items...": "Caută articole...",
  "System Qty": "Cant. sistem",
  "Refresh system quantities from current stock levels": "Reîmprospătează cantitățile din sistem după stocurile curente",
  "Counted Qty": "Cant. numărată",
  "Clear all counted quantities": "Șterge toate cantitățile numărate",
  "Copy system quantities to counted quantities (does not submit)": "Copiază cantitățile din sistem în cantitățile numărate (nu trimite)",
  "Discrepancy": "Diferență",
  "No Cycle Count Yet": "Niciun inventar ciclic încă",
  "Select warehouse and count type above, then click \"Create Count\" to begin": "Selectează depozitul și tipul de inventar mai sus, apoi apasă „Creează inventarul” pentru a începe",
  "No Items to Count": "Niciun articol de numărat",
  "Use \"Add Products\" button to add items to this cycle count": "Folosește butonul „Adaugă produse” pentru a adăuga articole la acest inventar ciclic",
  "New batch": "Lot nou",
  "Batch updated": "Lot actualizat",
  "Select batch...": "Selectează lotul...",
  "Location updated": "Locație actualizată",
  "Failed to update expiry date": "Data expirării nu a putut fi actualizată",
  "Live": "Live",
  "Applied": "Aplicat",
  "Show more ({count} remaining)": "Arată mai multe ({count} rămase)",
  "Change Cycle Count Status": "Schimbă starea inventarului ciclic",
  "Note:": "Notă:",
  "Changing from completed back to in-progress will allow you to continue editing counted quantities.": "Trecerea de la finalizat înapoi la în desfășurare îți va permite să continui editarea cantităților numărate.",
  "Update Status": "Actualizează starea",
  "Add Products to Cycle Count": "Adaugă produse la inventarul ciclic",
  "Search": "Caută",
  "Category Filter": "Filtru categorie",
  "All Categories": "Toate categoriile",
  "products selected": "produse selectate",
  "Add Selected Products": "Adaugă produsele selectate",
  "Count Item": "Numără articolul",
  "System Quantity": "Cantitate sistem",
  "Counted Quantity": "Cantitate numărată",
  "Enter counted quantity": "Introdu cantitatea numărată",
  "Record Count": "Înregistrează numărătoarea",
  "Update": "Actualizează",
  "process yield loss": "pierdere de randament în proces",
  "Failed to load transfer": "Transferul nu a putut fi încărcat",
  "Failed to load transfers": "Transferurile nu au putut fi încărcate",
  "Action failed": "Acțiunea a eșuat",
  "Transfer updated successfully": "Transferul a fost actualizat cu succes",
  "Transfer preparation started": "Pregătirea transferului a început",
  "Transfer approved": "Transferul a fost aprobat",
  "Transfer shipped": "Transferul a fost expediat",
  "Transfer received": "Transferul a fost recepționat",
  "Transfer completed": "Transferul a fost finalizat",
  "Transfer cancelled": "Transferul a fost anulat",
  "Transfer reactivated": "Transferul a fost reactivat",
  "Transfer completion reverted": "Finalizarea transferului a fost anulată",
  "Failed to start the transfer preparation": "Pregătirea transferului nu a putut fi începută",
  "Failed to approve the transfer": "Transferul nu a putut fi aprobat",
  "Failed to ship the transfer": "Transferul nu a putut fi expediat",
  "Failed to receive the transfer": "Transferul nu a putut fi recepționat",
  "Failed to complete the transfer": "Transferul nu a putut fi finalizat",
  "Failed to cancel the transfer": "Transferul nu a putut fi anulat",
  "Failed to reactivate the transfer": "Transferul nu a putut fi reactivat",
  "Failed to revert the transfer completion": "Finalizarea transferului nu a putut fi anulată",
  "Failed to update the transfer": "Transferul nu a putut fi actualizat",
  "Reactivate this cancelled transfer back to Requested?": "Reactivezi acest transfer anulat înapoi la Solicitat?",
  "Revert this completed transfer? This deletes its stock movements and returns the stock to source.": "Anulezi finalizarea acestui transfer? Aceasta îi șterge mișcările de stoc și returnează stocul la sursă.",
  "Failed to change batch": "Lotul nu a putut fi schimbat",
  "Failed to complete transfer": "Transferul nu a putut fi finalizat",
  "Failed to autofill prepared quantities": "Cantitățile pregătite nu au putut fi completate automat",
  "{missing} of {length} items have no prepared quantity and will transfer 0. Complete anyway?": "{missing} din {length} articole nu au cantitate pregătită și vor transfera 0. Finalizezi oricum?",
  "Failed to save prepared quantity": "Cantitatea pregătită nu a putut fi salvată",
  "Scanned {barcode} — no matching item on this transfer": "S-a scanat {barcode} — niciun articol corespunzător pe acest transfer",
  "{product_name}: prepared {next}": "{product_name}: pregătit {next}",
  "Loading transfer...": "Se încarcă transferul...",
  "Transfer not found": "Transferul nu a fost găsit",
  "Back to Transfers": "Înapoi la Transferuri",
  "Location Relocation": "Relocare în depozit",
  "Warehouse Transfer": "Transfer între depozite",
  "Click to reactivate back to Requested": "Apasă pentru a reactiva înapoi la Solicitat",
  "Click to revert completion (deletes stock movements)": "Apasă pentru a anula finalizarea (șterge mișcările de stoc)",
  "Start Preparation": "Începe pregătirea",
  "Ship": "Expediază",
  "Receive": "Recepționează",
  "Transfer Details": "Detalii transfer",
  "Requires Approval": "Necesită aprobare",
  "Carrier": "Transportator",
  "Tracking Number": "Număr de urmărire",
  "Shipping Cost": "Cost transport",
  "Requested": "Solicitat",
  "Approved": "Aprobat",
  "Shipped": "Expediat",
  "Items ({count})": "Articole ({count})",
  "Preparation mode — scan a barcode or edit prepared quantities, then Complete.": "Mod pregătire — scanează un cod de bare sau editează cantitățile pregătite, apoi apasă Finalizează.",
  "From Location": "Din locația",
  "To Location": "În locația",
  "Requested Qty": "Cant. solicitată",
  "Prepared Qty": "Cant. pregătită",
  "(avail": "(disp.",
  "Click to fill prepared with requested qty": "Apasă pentru a completa pregătit cu cantitatea solicitată",
  "No items": "Niciun articol",
  "Source and destination warehouses must be different": "Depozitul sursă și cel de destinație trebuie să fie diferite",
  "Each item needs a product, quantity, batch and source location": "Fiecare articol are nevoie de produs, cantitate, lot și locație sursă",
  "Transfer created successfully": "Transferul a fost creat cu succes",
  "Failed to update transfer": "Transferul nu a putut fi actualizat",
  "Failed to create transfer": "Transferul nu a putut fi creat",
  "Failed to start preparation": "Pregătirea nu a putut fi începută",
  "Failed to reactivate transfer": "Transferul nu a putut fi reactivat",
  "Failed to revert transfer": "Transferul nu a putut fi readus",
  "Loading transfers...": "Se încarcă transferurile...",
  "Manage inter-warehouse inventory movements": "Gestionează mișcările de stoc între depozite",
  "New Transfer": "Transfer nou",
  "Transfer number...": "Număr transfer...",
  "In Transit": "În tranzit",
  "All Types": "Toate tipurile",
  "Transfer": "Transfer",
  "Relocation": "Relocare",
  "All Reasons": "Toate motivele",
  "All Sources": "Toate sursele",
  "All Destinations": "Toate destinațiile",
  "Transfer #": "Transfer #",
  "Expected Date": "Data așteptată",
  "Total Qty:": "Cant. totală:",
  "Edit": "Editează",
  "Prepare": "Pregătește",
  "No transfers found": "Nu s-a găsit niciun transfer",
  "Try adjusting your filters to see more results.": "Ajustează filtrele pentru a vedea mai multe rezultate.",
  "Get started by creating your first transfer.": "Începe prin a crea primul tău transfer.",
  "Edit Transfer": "Editează transferul",
  "Create New Transfer": "Creează un transfer nou",
  "Transfer Type *": "Tip transfer *",
  "Warehouse to Warehouse": "De la depozit la depozit",
  "From Warehouse *": "Din depozitul *",
  "Select Source": "Selectează sursa",
  "To Warehouse *": "În depozitul *",
  "Select Destination": "Selectează destinația",
  "Reason *": "Motiv *",
  "Low": "Scăzută",
  "Normal": "Normală",
  "High": "Ridicată",
  "Urgent": "Urgentă",
  "Transfer Items": "Articole transfer",
  "Select Product": "Selectează produsul",
  "Select Batch": "Selectează lotul",
  "(qty": "(cant.",
  "Source Location": "Locație sursă",
  "Destination (optional)": "Destinație (opțional)",
  "Remove item": "Elimină articolul",
  "Add Item": "Adaugă articol",
  "Additional notes (optional)": "Note suplimentare (opțional)",
  "Save Changes": "Salvează modificările",
  "Create Transfer": "Creează transferul",
  "Rebalancing": "Reechilibrare",
  "Shortage": "Deficit",
  "Excess": "Surplus",
  "Consolidation": "Consolidare",
  "Seasonal": "Sezonier",
  "Maintenance": "Mentenanță",
  "Earliest outgoing of {product}: {when} — a back-date must land before this to cover it": "Cea mai veche ieșire pentru {product}: {when} — o dată anterioară trebuie să cadă înainte de aceasta pentru a o acoperi",
  "Exceeds {wc} capacity of {cap} {unit}": "Depășește capacitatea centrului {wc} de {cap} {unit}",
  "Only {qty} {unit} of the upstream step is finished so far": "Doar {qty} {unit} din etapa anterioară sunt finalizate până acum",
  "upstream": "în amonte",
  "still in production": "încă în producție",
  "Admin": "Administrare",
  "CRM": "CRM",
  "Alerts": "Alerte",
  "Help": "Ajutor",
  "Office": "Birou",
  "{count} lines were never counted. What should happen to them?": "{count} linii nu au fost numărate. Ce se întâmplă cu ele?",
  "Leave them unchanged": "Lasă-le neschimbate",
  "Only counted lines move stock. Use this whenever part of the area was not walked.": "Doar liniile numărate mișcă stocul. Folosește această opțiune ori de câte ori o parte din zonă nu a fost parcursă.",
  "Set them to zero": "Pune-le pe zero",
  "The whole area was walked, so anything not found is not there. This clears phantom stock.": "Toată zona a fost parcursă, deci ce nu a fost găsit nu există. Aceasta șterge stocul fantomă.",
  "{count} lines will be written down to zero stock.": "{count} linii vor fi trecute pe stoc zero.",
  "This group was already posted as {number}. Re-posting takes that document back and rewrites it with what the sheet says now — same document, one set of movements.": "Această grupă a fost deja înregistrată ca {number}. Reînregistrarea preia înapoi acel document și îl rescrie cu ce spune fișa acum — același document, un singur set de mișcări.",
  "Re-post stocktake": "Reînregistrează inventarul",
  "Re-post": "Reînregistrează",
  "{count} counts · {total} {unit}": "{count} numărători · {total} {unit}",
  "Count": "Numărătoare",
  "Entries": "Intrări",
  "Counted on {code}": "Numărat pe {code}",
  "this product has no batches yet": "acest produs nu are încă loturi",
  "Reset the batches I left blank to zero": "Pune pe zero loturile lăsate necompletate",
  "A count of the product says what is there. Untick if you only walked one pallet and are not speaking for the rest.": "O numărătoare a produsului spune ce există. Debifează dacă ai parcurs doar un palet și nu răspunzi pentru rest.",
  "Total across {count} batches": "Total pe {count} loturi",
  "Add {count} counts · {total}": "Adaugă {count} numărători · {total}",
  "Blind count": "Numărare oarbă",
  "Counters do not see system quantities. The figures appear once a group is posted.": "Numărătorii nu văd cantitățile din sistem. Cifrele apar după ce o grupă este înregistrată.",
  "Free count": "Numărare liberă",
  "Start with an empty sheet and add products by search or scan. Only products in the chosen scope can be added.": "Începe cu o fișă goală și adaugă produse prin căutare sau scanare. Pot fi adăugate doar produsele din domeniul ales.",
  "Full count — reset stock": "Numărare completă — resetează stocul",
  "Each product on a sheet is reset to zero across the warehouse when the sheet is posted, then set to what was counted. Lines nobody counted go to zero.": "La înregistrarea fișei, fiecare produs de pe ea este resetat la zero în tot depozitul, apoi setat la cantitatea numărată. Liniile nenumărate trec pe zero.",
  "Only for groups, categories and brands — a zone or location count does not cover whole products.": "Doar pentru grupe, categorii și mărci — o numărare pe zonă sau locație nu acoperă produsele întregi.",
  "A sheet is already posted, so this can no longer be changed.": "O fișă este deja înregistrată, deci această opțiune nu mai poate fi schimbată.",
  "A full count resets whole products, so it cannot count a zone or location": "O numărare completă resetează produse întregi, deci nu poate număra o zonă sau o locație",
  "Full count — stock is reset first": "Numărare completă — stocul este resetat mai întâi",
  "Every product on this sheet is reset to zero across the warehouse, then set to what was counted.": "Fiecare produs de pe această fișă este resetat la zero în tot depozitul, apoi setat la cantitatea numărată.",
  "Products that also hold stock in another warehouse are posted the usual way, without the reset.": "Produsele care au stoc și în alt depozit sunt înregistrate obișnuit, fără resetare.",
  "Posted as {number}, after stock reset {reset}": "Înregistrat ca {number}, după resetarea stocului {reset}",
  "Not reset — these also hold stock in another warehouse, so they were posted the usual way: {names}": "Nu au fost resetate — acestea au stoc și în alt depozit, deci au fost înregistrate obișnuit: {names}",
  "Reopen {number} so its counts can be corrected?": "Redeschizi {number} pentru ca numărătorile să poată fi corectate?",
  "Could not reopen the stocktake": "Inventarul nu a putut fi redeschis",
  "{number} reopened": "{number} a fost redeschis",
  "Reopen stocktake": "Redeschide inventarul",
  "Could not load that product": "Acel produs nu a putut fi încărcat",
  "{name} is not part of {scope}": "{name} nu face parte din {scope}",
  "Matching products": "Produse potrivite",
  "Added": "Adăugat",
  "Nothing counted yet. Search or scan a product to add it.": "Nimic numărat încă. Caută sau scanează un produs pentru a-l adăuga.",
  "Could not work out where the counts will land": "Nu s-a putut determina unde vor ajunge numărătorile",
  "Working it out…": "Se calculează…",
  "Hide allocation": "Ascunde alocarea",
  "Preview allocation": "Previzualizează alocarea",
  "Upstream produced {req} for this run — using {typed} leaves {diff} {unit} in stock. An intake re-weigh belongs in the produced quantity, not here.": "Etapa anterioară a produs {req} pentru această rulare — folosind {typed} rămân {diff} {unit} în stoc. O recântărire la intrare aparține cantității produse, nu aici.",
  "Expected": "Așteptat",
  "Obtained": "Obținut",
  "Unused upstream stock": "Stoc nefolosit din amonte",
  "will be written off as loss/waste": "va fi scos din gestiune ca pierdere/rebut",
  "will be carried over": "va fi reportat",
  "within the expected process loss for this operation": "în limita pierderii de proces așteptate pentru această operație",
  "Consume unused upstream stock into this operation as process loss": "Consumă stocul nefolosit din amonte în această operație ca pierdere de proces",
  "Confirm & Close": "Confirmă și închide",
  "Upstream residue consumed as process loss: {list}": "Rest din amonte consumat ca pierdere de proces: {list}",
  "pool complete — Close the operation": "rezervă completă — închide operația",
  "{qty} {unit} remaining — within expected process loss. Close the operation.": "{qty} {unit} rămase — în limita pierderii de proces așteptate. Închide operația.",
  "{qty} {unit} unprocessed — closing now writes this off as loss/waste": "{qty} {unit} neprocesate — închiderea acum le scoate din gestiune ca pierdere/rebut",
  "waiting for machine": "așteaptă mașina",
  "Start this run — needs a free machine, or pick one to override": "Pornește această rulare — necesită o mașină liberă sau alege una pentru a suprascrie",
  "Start this run on the chosen machine, in use or not": "Pornește această rulare pe mașina aleasă, ocupată sau nu",
  "Machine to start on — pick one to start even while it is marked in use": "Mașina pe care pornește — alege una pentru a porni chiar dacă e marcată ocupată",
  "Auto (first free)": "Automat (prima liberă)",
  "in the machine": "în mașină",
  "{qty} still to come out": "{qty} încă de scos",
  "{qty} {unit} available": "{qty} {unit} disponibil",
  "fully loaded": "încărcat complet",
  "Every machine is marked in use — Run {n} will share one": "Toate mașinile sunt marcate ocupate — Rularea {n} va împărți una",
  "A machine standing empty is still marked held until its run is finished here. Start works anyway — the run opens on its own machine, or on the one you pick beside Start.": "O mașină goală rămâne marcată ocupată până când rularea ei este finalizată aici. Start funcționează oricum — rularea pornește pe mașina proprie sau pe cea aleasă lângă Start.",
  "Remaining pool": "Rezervă rămasă",
  "this WIP": "acest WIP",
  "Run queued — no machine free": "Rulare pusă în așteptare — nicio mașină liberă",
  "Run started": "Rularea a început",
  "Run cancelled": "Rularea a fost anulată",
  "Run corrected": "Rularea a fost corectată",
  "Give the batch an expiry date first": "Dă mai întâi lotului o dată de expirare",
  "Could not open a batch": "Nu s-a putut deschide un lot",
  "Batch {code} opened": "Lotul {code} a fost deschis",
  "This product has no batches yet.": "Acest produs nu are încă loturi.",
  "Opening…": "Se deschide…",
  "Open batch": "Deschide lot",
  "Switch User": "Schimbă utilizatorul",
  "Switched to user: {username}": "S-a comutat pe utilizatorul: {username}",
  "Failed to switch user. Please check the QR code.": "Schimbarea utilizatorului a eșuat. Verifică codul QR.",
  "Error switching user. Please try again.": "Eroare la schimbarea utilizatorului. Încearcă din nou.",
  "Camera started. Point at QR code to scan.": "Camera a pornit. Îndreapt-o spre codul QR pentru a scana.",
  "Failed to access camera. Please use barcode scanner instead.": "Camera nu a putut fi accesată. Folosește scanerul de coduri de bare.",
  "Camera preview": "Previzualizare cameră",
  "Stop Camera": "Oprește camera",
  "Or scan with barcode scanner": "Sau scanează cu scanerul de coduri de bare",
  "Scan QR Code": "Scanează codul QR",
  "Scan QR code here...": "Scanează codul QR aici...",
  "Switching...": "Se comută...",
  "Scan the QR code of the user you want to switch to.": "Scanează codul QR al utilizatorului pe care vrei să îl folosești.",
  "Only users with QR login enabled can switch accounts.": "Doar utilizatorii cu autentificare prin QR activată pot schimba contul.",
  "My Account": "Contul meu",
  "Signed in as {username}": "Autentificat ca {username}",
  "Could not load your profile": "Profilul tău nu a putut fi încărcat",
  "Language": "Limbă",
  "The interface language for your account. It follows you onto any terminal you sign in to.": "Limba interfeței pentru contul tău. Te însoțește pe orice terminal pe care te autentifici.",
  "Your details": "Datele tale",
  "First name": "Prenume",
  "Last name": "Nume",
  "Email": "E-mail",
  "Phone": "Telefon",
  "Your username and access rights are managed by an administrator.": "Numele de utilizator și drepturile de acces sunt gestionate de un administrator.",
  "Save details": "Salvează datele",
  "Your details have been saved": "Datele tale au fost salvate",
  "Could not save your details": "Datele tale nu au putut fi salvate",
  "Password": "Parolă",
  "You need your current password to set a new one.": "Ai nevoie de parola curentă pentru a seta una nouă.",
  "Current password": "Parola curentă",
  "New password": "Parola nouă",
  "Repeat new password": "Repetă parola nouă",
  "At least 8 characters.": "Cel puțin 8 caractere.",
  "Changing…": "Se schimbă…",
  "Change password": "Schimbă parola",
  "The new passwords do not match": "Parolele noi nu coincid",
  "Your password has been changed": "Parola ta a fost schimbată",
  "Could not change your password": "Parola ta nu a putut fi schimbată",
  "Current password is incorrect": "Parola curentă este incorectă",
  "The new password must be at least 8 characters": "Parola nouă trebuie să aibă cel puțin 8 caractere",
  "The new password must be different from the current one": "Parola nouă trebuie să fie diferită de cea curentă",
  "That email address is already in use": "Această adresă de e-mail este deja folosită",
  "My login QR code": "Codul meu QR de autentificare",
  "Scan this on another terminal to sign in there as yourself.": "Scanează-l pe alt terminal pentru a te autentifica acolo cu contul tău.",
  "Treat it like your password — anyone who photographs it can sign in as you.": "Tratează-l ca pe parola ta — oricine îl fotografiază se poate autentifica în locul tău.",
  "Show my QR code": "Arată codul meu QR",
  "Hide": "Ascunde",
  "Could not load your QR code": "Codul tău QR nu a putut fi încărcat",
  "QR login is not enabled for your account. An administrator can turn it on.": "Autentificarea prin QR nu este activată pentru contul tău. Un administrator o poate activa.",
  "QR login is not enabled for your account": "Autentificarea prin QR nu este activată pentru contul tău",
  "Could not generate your QR code": "Codul tău QR nu a putut fi generat",
  "Hand the terminal to a colleague — scan their QR code to sign them in here.": "Dă terminalul unui coleg — scanează-i codul QR pentru a-l autentifica aici.",
  '{count} entry': {
    one: '{count} intrare',
    few: '{count} intrări',
    other: '{count} de intrări',
  },
  '{count} lines': {
    one: '{count} linie',
    few: '{count} linii',
    other: '{count} de linii',
  },
  '{count} products': {
    one: '{count} produs',
    few: '{count} produse',
    other: '{count} de produse',
  },
  '{count} variances': {
    one: '{count} diferență',
    few: '{count} diferențe',
    other: '{count} de diferențe',
  },
  '{count} lines were never counted and will be set to zero.': {
    one: '{count} linie nu a fost numărată și va fi pusă pe zero.',
    few: '{count} linii nu au fost numărate și vor fi puse pe zero.',
    other: '{count} de linii nu au fost numărate și vor fi puse pe zero.',
  },
  '{count} documents will be created, each counted and finalised on its own.': {
    one: 'Se va crea {count} document, numărat și finalizat separat.',
    few: 'Se vor crea {count} documente, fiecare numărat și finalizat separat.',
    other: 'Se vor crea {count} de documente, fiecare numărat și finalizat separat.',
  },
  "Week plans": "Planuri săptămânale",
  "Templates": "Șabloane",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mie",
  "Thu": "Joi",
  "Fri": "Vin",
  "Sat": "Sâm",
  "Sun": "Dum",
  "no active assembly BOM": "nicio rețetă de asamblare activă",
  "Confirmed": "Confirmat",
  "Draft": "Ciornă",
  "Pick a template": "Alege un șablon",
  "Failed to generate the week": "Săptămâna nu a putut fi generată",
  "Generate week": "Generează săptămâna",
  "Template": "Șablon",
  "No active templates": "Niciun șablon activ",
  "Week starting (Monday)": "Săptămâna începe (luni)",
  "Adjust whole week %": "Ajustare toată săptămâna %",
  "Failed to load week plans": "Planurile săptămânale nu au putut fi încărcate",
  "Failed to create the template": "Șablonul nu a putut fi creat",
  "Failed to copy the template": "Șablonul nu a putut fi copiat",
  "Plan the week from a standard template, adjust what changed, then launch each day.": "Planifică săptămâna dintr-un șablon standard, ajustează ce s-a schimbat, apoi lansează fiecare zi.",
  "Refresh": "Reîmprospătează",
  "New template": "Șablon nou",
  "Week": "Săptămână",
  "Starts": "Începe",
  "Planned kg": "Kg planificate",
  "Days launched": "Zile lansate",
  "No week plans yet. Generate one from a template.": "Niciun plan săptămânal încă. Generează unul dintr-un șablon.",
  "Week kg": "Kg pe săptămână",
  "Working days": "Zile lucrătoare",
  "No templates yet. Create one and build it from sales.": "Niciun șablon încă. Creează unul și construiește-l din vânzări.",
  "Inactive": "Inactiv",
  "Copy": "Copiază",
  "Failed to load the launch list": "Lista de lansare nu a putut fi încărcată",
  "Draft production orders created: {count}": "Comenzi de producție ciornă create: {count}",
  "Failed to launch the day": "Ziua nu a putut fi lansată",
  "Launch {day}": "Lansează {day}",
  "Covers": "Acoperă",
  "Free stock": "Stoc liber",
  "Open production": "Producție deschisă",
  "Netted": "Scăzut",
  "Make": "De produs",
  "Nothing is planned on this day.": "Nimic planificat în această zi.",
  "Weekly": "Săptămânal",
  "Daily": "Zilnic",
  "no active BOM": "nicio rețetă activă",
  "Launched, nothing to make": "Lansat, nimic de produs",
  "Lines": "Linii",
  "Launching...": "Se lansează...",
  "Create draft orders": "Creează comenzi ciornă",
  "Failed to load the week plan": "Planul săptămânal nu a putut fi încărcat",
  "Failed to save the quantity": "Cantitatea nu a putut fi salvată",
  "Plan recalculated. Lines typed by hand and launched lines were kept.": "Plan recalculat. Liniile introduse manual și cele lansate au fost păstrate.",
  "Failed to recalculate": "Recalcularea a eșuat",
  "Failed to update the plan": "Planul nu a putut fi actualizat",
  "Replace the template base of the selected products ({count}) with what recent sales suggest, then recalculate this week?": "Înlocuiești baza din șablon a produselor selectate ({count}) cu ce sugerează vânzările recente, apoi recalculezi săptămâna?",
  "Template updated from recent sales": "Șablon actualizat din vânzările recente",
  "Failed to accept the suggestions": "Sugestiile nu au putut fi acceptate",
  "Delete this week plan?": "Ștergi acest plan săptămânal?",
  "Failed to delete the plan": "Planul nu a putut fi șters",
  "Template target": "Țintă din șablon",
  "launches": "lansări",
  "Back to draft": "Înapoi la ciornă",
  "Confirm plan": "Confirmă planul",
  "inactive": "inactiv",
  "Recalculate": "Recalculează",
  "Moved more than 15% from the template: {count}": "Abatere de peste 15% față de șablon: {count}",
  "Accept suggestions into template ({count})": "Acceptă sugestiile în șablon ({count})",
  "Adj %": "Ajust. %",
  "Launched": "Lansat",
  "Confirm the plan before launching": "Confirmă planul înainte de lansare",
  "Launch": "Lansează",
  "Recent sales": "Vânzări recente",
  "Drift": "Abatere",
  "The template has no products.": "Șablonul nu are produse.",
  "Total": "Total",
  "Added from sales: {created} · refreshed: {updated}": "Adăugate din vânzări: {created} · actualizate: {updated}",
  "Failed to build from sales": "Construirea din vânzări a eșuat",
  "Each product's base is its recent sales plus the sales of products packed from it (trays from gastro), weighted towards the latest week, one-off big orders left out. Products already in the template only get their base refreshed. Products with no sales are skipped.": "Baza fiecărui produs este vânzarea recentă plus vânzările produselor ambalate din el (caserole din gastro), ponderată spre ultima săptămână, fără comenzile mari ocazionale. Produsele deja în șablon primesc doar baza actualizată. Produsele fără vânzări sunt sărite.",
  "Lead days": "Zile înainte",
  "Weeks of sales": "Săptămâni de vânzări",
  "Launch days": "Zile de lansare",
  "All Groups": "Toate grupele",
  "Select all new": "Selectează toate cele noi",
  "No products with an active BOM match.": "Niciun produs cu rețetă activă nu se potrivește.",
  "in template": "în șablon",
  "Building...": "Se construiește...",
  "Build from sales ({count})": "Construiește din vânzări ({count})",
  "Failed to load the template": "Șablonul nu a putut fi încărcat",
  "Template saved": "Șablon salvat",
  "Failed to save the template": "Șablonul nu a putut fi salvat",
  "Failed to save the line": "Linia nu a putut fi salvată",
  "Remove {name} from the template?": "Scoți {name} din șablon?",
  "Failed to remove the line": "Linia nu a putut fi scoasă",
  "Template name": "Numele șablonului",
  "An invoice line bigger than this many times the customer's usual line is treated as a one-off and left out of suggestions. 0 keeps everything.": "O linie de factură mai mare decât de atâtea ori linia obișnuită a clientului este considerată ocazională și lăsată în afara sugestiilor. 0 păstrează tot.",
  "One-off factor": "Factor ocazional",
  "Build from sales": "Construiește din vânzări",
  "No products yet. Use Build from sales to add them.": "Niciun produs încă. Folosește Construiește din vânzări pentru a le adăuga.",
  "Delete the template \"{name}\" and all its products? Week plans made from it keep their lines but can no longer be recalculated.": "Ștergi șablonul „{name}” cu toate produsele lui? Planurile săptămânale făcute din el își păstrează liniile, dar nu mai pot fi recalculate.",
  "Failed to delete the template": "Șablonul nu a putut fi șters",
  "Remove the selected products ({count}) from the template?": "Scoți produsele selectate ({count}) din șablon?",
  "Failed to remove the lines": "Liniile nu au putut fi scoase",
  "Delete template": "Șterge șablonul",
  "Delete selected ({count})": "Șterge selectate ({count})",
  "{name} (copy)": "{name} (copie)",
  "Sort by product: A–Z, Z–A, then back to the template order": "Sortează după produs: A–Z, Z–A, apoi înapoi la ordinea din șablon",
  "This template does not exist any more.": "Acest șablon nu mai există.",
  "This week plan does not exist any more.": "Acest plan săptămânal nu mai există.",
  "Click to sort, again to reverse, a third time for the template order": "Apasă pentru sortare, din nou pentru ordine inversă, a treia oară pentru ordinea din șablon",
  "Quantities are mix kg going in; ≈ Finished is what it yields through the BOM. Weekly lines net free stock and open production, daily lines only production already planned for this day. A line above its max per order is split into several draft orders.": "Cantitățile sunt kg de amestec care intră; ≈ Finit este ce rezultă prin rețetă. Liniile săptămânale scad stocul liber și producția deschisă, cele zilnice doar producția deja planificată pentru această zi. O linie peste maximul pe comandă se împarte în mai multe comenzi ciornă.",
  "Planned mix": "Amestec planificat",
  "Mix to launch": "Amestec de lansat",
  "≈ Finished": "≈ Finit",
  "{split} orders": "{split} comenzi",
  "{count} orders": "{count} comenzi",
  "Day cells are mix kg going in (what each launch puts in production); ≈ is the finished kg it yields through the BOM, and N× the number of orders when above the max per order. Week is mix kg; Template and Recent sales are sales (finished) kg. Blue-bordered cells were typed by hand and survive Recalculate.": "Celulele zilelor sunt kg de amestec care intră (ce pune fiecare lansare în producție); ≈ este kg de produs finit rezultat prin rețetă, iar N× numărul de comenzi când depășește maximul pe comandă. Săptămâna este în kg de amestec; Șablon și Vânzări recente sunt kg vândute (finite). Celulele cu chenar albastru au fost introduse manual și rămân la Recalculează.",
  "Round to (mix kg)": "Rotunjire la (kg amestec)",
  "Most mix kg one order can hold (e.g. one chamber). Bigger launches are split into several orders. 0 = no limit": "Cele mai multe kg de amestec pe care le poate avea o comandă (ex. o celulă). Lansările mai mari se împart în mai multe comenzi. 0 = fără limită",
  "Max / order (mix kg)": "Max / comandă (kg amestec)",
  "Batch size in mix kg going in": "Mărimea șarjei în kg de amestec care intră",
  "Round to (mix)": "Rotunjire (amestec)",
  "Max / order (mix)": "Max / comandă (amestec)",
  "No subgroup": "Fără subgrupă",
  "Launch days set for {count} products": "Zile de lansare setate pentru {count} produse",
  "Set for selected ({count})": "Setează pentru selectate ({count})",
  "Complete weeks of sales the usual Mon–Sun sales are averaged over (latest week weighs most). Used by Build and Refresh from sales and by Recent sales in the week plan.": "Săptămâni complete de vânzări din care se face media vânzărilor obișnuite Lun–Dum (ultima săptămână contează cel mai mult). Folosit la Construiește și Reîmprospătează din vânzări și la Vânzări recente în planul săptămânal.",
  "Refresh from sales": "Reîmprospătează din vânzări",
  "Refreshed {count} products from {weeks} weeks of sales": "Au fost reîmprospătate {count} produse din {weeks} săptămâni de vânzări",
  "Failed to refresh from sales": "Reîmprospătarea din vânzări a eșuat",
  "Usual sales that weekday (finished kg)": "Vânzarea obișnuită în acea zi (kg finite)",
  "Update the Mon–Sun sales of {count} products from the last {weeks} weeks? Launch quantities stay as they are.": "Actualizezi vânzările Lun–Dum ale celor {count} produse din ultimele {weeks} săptămâni? Cantitățile de lansare rămân neschimbate.",
  "Update the Mon–Sun sales from the last {weeks} weeks, keeping the launch quantities: the selected products, or every product on this tab": "Actualizează vânzările Lun–Dum din ultimele {weeks} săptămâni, păstrând cantitățile de lansare: produsele selectate sau toate produsele din acest tab",
  "Refresh sales ({count})": "Reîmprospătează vânzările ({count})",
  "Refresh sales": "Reîmprospătează vânzările",
  "Work out the launch quantities of {count} products again from their sales? Quantities you typed are replaced.": "Recalculezi cantitățile de lansare ale celor {count} produse din vânzări? Cantitățile introduse manual sunt înlocuite.",
  "Launch quantities filled for {count} products": "Cantități de lansare completate pentru {count} produse",
  "Failed to fill the launch quantities": "Completarea cantităților de lansare a eșuat",
  "Work out the launch quantities again from the sales, lead days, launch days and BOM yield: the selected products, or every product on this tab": "Recalculează cantitățile de lansare din vânzări, zile înainte, zile de lansare și randamentul rețetei: produsele selectate sau toate produsele din acest tab",
  "Autofill launch ({count})": "Completează lansarea ({count})",
  "Autofill launch": "Completează lansarea",
  "Made from {name}": "Făcut din {name}",
  "DRAFT": "CIORNĂ",
  "Printed {date}": "Tipărit {date}",
  "Popup blocked — allow popups to print": "Fereastra a fost blocată — permite ferestrele pop-up pentru a tipări",
  "Production plan {week}": "Plan de producție {week}",
  "Nothing is planned this week.": "Nu este nimic planificat în această săptămână.",
  "Mix kg going in. ✓ = launched (the launched quantity); ≈ = finished kg it yields through the BOM; N× = number of production orders.": "Kg de amestec care intră. ✓ = lansat (cantitatea lansată); ≈ = kg de produs finit rezultat prin rețetă; N× = numărul de comenzi de producție.",
  "Production sheet {day}": "Fișă de producție {day}",
  "Mix kg": "Kg amestec",
  "≈ Finished kg": "≈ Kg finit",
  "Actual kg": "Kg real",
  "Initials": "Inițiale",
  "Lines without ✓ are not launched yet and show the planned mix. At launch, weekly lines net free stock and open production, so they can come out lower.": "Liniile fără ✓ nu sunt încă lansate și arată amestecul planificat. La lansare, liniile săptămânale scad stocul liber și producția deschisă, deci pot ieși mai mici.",
  "Checked by": "Verificat de",
  "Signature": "Semnătură",
  "Print week": "Tipărește săptămâna",
  "Print the day sheet": "Tipărește fișa zilei",
  "Sales from": "Vânzări din",
  "Higher of ordered / invoiced": "Maximul dintre comandat / facturat",
  "What was sent, on the invoice date": "Ce s-a trimis, la data facturii",
  "What customers asked for, on the delivery date, so short deliveries do not lower the plan": "Ce au cerut clienții, la data livrării, astfel încât livrările incomplete nu scad planul",
  "Per order the bigger of ordered and invoiced, on the delivery date; invoices with no order count as invoiced": "Pe fiecare comandă, cantitatea mai mare dintre comandat și facturat, la data livrării; facturile fără comandă contează ca facturat",
  "Sales from (Invoiced / Ordered / Higher of the two) chooses what the grey sales are worked out from the next time you Refresh sales or Build from sales.": "Vânzări din (Facturat / Comandat / Maximul celor două) alege din ce se calculează vânzările gri la următoarea Reîmprospătare a vânzărilor sau Construire din vânzări.",
  "Made from": "Făcut din",
  "— not linked —": "— nelegat —",
  "Counts in parent": "Contează la părinte",
  "in {tab}": "în {tab}",
  "Show / hide the products made from it": "Arată / ascunde produsele făcute din el",
  "Taken that day by the products made from it (finished kg)": "Luat în acea zi de produsele făcute din el (kg finite)",
  "Taken by the products made from it (finished kg)": "Luat de produsele făcute din el (kg finite)",
  "Link to parents": "Leagă de părinți",
  "Link to parents ({count})": "Leagă de părinți ({count})",
  "Put each product under the product its recipe is made from (tray under gastro), when that product is in the template: the selected products, or every product on this tab": "Pune fiecare produs sub produsul din care îl face rețeta (caserola sub gastro), când acel produs e în șablon: produsele selectate sau toate produsele din acest tab",
  "Put {count} products under the product they are made from? Each parent is then launched for its children's launch quantities instead of their sales.": "Pui {count} produse sub produsul din care sunt făcute? Fiecare părinte se lansează apoi pentru cantitățile de lansare ale copiilor, nu pentru vânzările lor.",
  "Linked {count} products to the product they are made from": "{count} produse legate de produsul din care sunt făcute",
  "Failed to link the products": "Legarea produselor a eșuat",
  "Ticked: the parent is launched for this product's launch quantities, and its sales leave the parent's sales. Unticked: its sales count in the parent's sales, as before.": "Bifat: părintele se lansează pentru cantitățile de lansare ale acestui produs, iar vânzările lui ies din vânzările părintelui. Nebifat: vânzările lui contează în vânzările părintelui, ca înainte.",
  "Made from: a product linked under the one it is made from (tray under gastro) is shown beneath it. When it counts in its parent, the parent is launched for its launch quantities (purple +, on its launch days) and its sales leave the parent's grey sales, so nothing is counted twice. Changing a child's boxes works the parent's boxes out again.": "Făcut din: un produs legat sub cel din care e făcut (caserola sub gastro) apare sub el. Când contează la părinte, părintele se lansează pentru cantitățile lui de lansare (+ mov, în zilele lui de lansare), iar vânzările lui ies din vânzările gri ale părintelui, deci nimic nu se numără de două ori. Schimbarea căsuțelor unui copil recalculează căsuțele părintelui.",
  "Each day: grey on the left = usual sales that weekday (finished kg), box = mix (base) kg to launch that day, the production order quantity. Week: grey = sales, bold = the finished kg the launched mix yields through the BOM, so the two compare directly. Autofill launch works the boxes out from sales, shifted by lead days and rounded to whole batches. Refresh sales only updates the grey sales.": "Fiecare zi: cu gri în stânga = vânzarea obișnuită în acea zi (kg finite), căsuța = kg de amestec (bază) de lansat în acea zi, cantitatea din comanda de producție. Săptămâna: gri = vânzări, îngroșat = kg finite pe care le dă amestecul lansat prin rețetă, deci se compară direct. Completează lansarea calculează căsuțele din vânzări, decalat cu zilele înainte și rotunjit la șarje întregi. Reîmprospătează vânzările actualizează doar vânzările gri.",
  "Weekly lines launch only on their launch days (set them for selected rows above). Grey on the left = usual sales that weekday, box = mix kg to launch; the Week total shows the finished kg it yields. Autofill launch makes each launch cover the sale days up to the next launch (shifted by lead days); type over it to set your own. Free stock is netted off when launching.": "Liniile săptămânale se lansează doar în zilele lor de lansare (setează-le pentru rândurile selectate mai sus). Cu gri în stânga = vânzarea obișnuită în acea zi, căsuța = kg de amestec de lansat; totalul pe săptămână arată kg finite rezultate. Completează lansarea face ca fiecare lansare să acopere zilele de vânzare până la lansarea următoare (decalat cu zilele înainte); scrie peste ea pentru a seta propria valoare. Stocul liber se scade la lansare.",
  "Mix kg launched: {mix}": "Kg amestec lansate: {mix}",
  "Mix kg launched: {mix} — yields this many finished kg through the BOM": "Kg amestec lansate: {mix} — dau atâtea kg finite prin rețetă",
  "Lead": "Zile",
  "Round": "Rotunj.",
  "Max": "Max",
  "Lead days: how many days before the sale day it is launched": "Zile înainte: cu câte zile înainte de ziua vânzării se lansează",
  "Launch days for the selected products only; their launch quantities are worked out again from sales": "Zile de lansare doar pentru produsele selectate; cantitățile lor de lansare se recalculează din vânzări",
  "Select every product in {name}": "Selectează toate produsele din {name}",
  "nets stock": "scade stocul",
  "Add products to {tab} from sales": "Adaugă produse în {tab} din vânzări",
  "Leave empty to launch every day": "Lasă gol pentru lansare în fiecare zi",
  "Launch days (empty = every day)": "Zile de lansare (gol = în fiecare zi)",
  "Give the tab a name.": "Dă un nume tabului.",
  "Tab saved": "Tab salvat",
  "Failed to save the tab": "Tabul nu a putut fi salvat",
  "New tab": "Tab nou",
  "Failed to add the tab": "Tabul nu a putut fi adăugat",
  "Delete the tab \"{name}\"?": "Ștergi tabul „{name}”?",
  "Failed to delete the tab": "Tabul nu a putut fi șters",
  "Add a tab": "Adaugă un tab",
  "Tab name": "Numele tabului",
  "Remove or move this tab's products first": "Scoate sau mută mai întâi produsele acestui tab",
  "Delete this tab": "Șterge acest tab",
  "Tab": "Tab",
  "Move to another tab": "Mută în alt tab",
  "By lead": "După zile înainte",
  "By stock": "După stoc",
  "By operations": "După operații",
  "By operations: products whose recipe has only the operations ticked above (e.g. tray sealing, vacuum packing) come here by themselves. Stock is not netted at launch. Their sales also count for the product they are made from, all the way down the chain.": "După operații: produsele a căror rețetă are doar operațiile bifate mai sus (ex. sigilare caserole, vidare) ajung aici singure. Stocul nu se scade la lansare. Vânzările lor contează și pentru produsul din care sunt făcute, pe tot lanțul.",
  "By stock: free stock and open production are subtracted when a day is launched, for products that keep (smoked). Grey on the left = usual sales that weekday, box = mix kg to launch; the Week total shows the finished kg it yields.": "După stoc: stocul liber și producția deschisă se scad la lansarea unei zile, pentru produsele care se păstrează (afumate). Cu gri în stânga = vânzarea obișnuită în acea zi, căsuța = kg de amestec de lansat; totalul pe săptămână arată kg finite rezultate.",
  "By lead: each sale day is launched lead days earlier on the row's launch days; stock is not netted. Grey on the left = usual sales that weekday (finished kg), box = mix (base) kg to launch, the production order quantity. Week: grey = sales, bold = the finished kg the launched mix yields. Autofill launch works the boxes out from sales; Refresh sales only updates the grey sales.": "După zile înainte: fiecare zi de vânzare se lansează cu „zile înainte” mai devreme, în zilele de lansare ale rândului; stocul nu se scade. Cu gri în stânga = vânzarea obișnuită în acea zi (kg finite), căsuța = kg de amestec (bază) de lansat, cantitatea din comanda de producție. Săptămâna: gri = vânzări, îngroșat = kg finite rezultate din amestecul lansat. Completează lansarea calculează căsuțele din vânzări; Reîmprospătează vânzările actualizează doar vânzările gri.",
  "Warehouse changed to {name}": "Depozitul a fost schimbat în {name}",
  "Failed to change warehouse": "Depozitul nu a putut fi schimbat",
  "Account manager assignment": "Alocare account manager",
  "Add or remove people from the group on the Users page.": "Adaugi sau scoți oameni din grup din pagina Utilizatori.",
  "Advanced": "Avansat",
  "All accounts": "Toate conturile",
  "All customers": "Toți clienții",
  "All leads": "Toate lead-urile",
  "Allow all": "Permite tot",
  "Assigned only": "Doar alocați",
  "Buttons and fields": "Butoane și câmpuri",
  "Can manage {group}: {from} → {to}": "Gestionează {group}: {from} → {to}",
  "Card {card}: only for {group}": "Cardul {card}: doar pentru {group}",
  "Card {card}: {from} → {to}": "Cardul {card}: {from} → {to}",
  "Cards stay hidden until you tick them. A new card is shown to nobody until a group is allowed.": "Cardurile sunt ascunse până le bifezi. Un card nou nu apare la nimeni până nu e permis unui grup.",
  "Change undone": "Modificarea a fost anulată",
  "Changes on this tab are saved straight away.": "Modificările din acest tab se salvează imediat.",
  "Choose a group and decide which pages, buttons, fields and dashboard cards its members see, and which data they can reach.": "Alegi un grup și stabilești ce pagini, butoane, câmpuri și carduri de dashboard văd membrii lui și la ce date au acces.",
  "Close all": "Închide tot",
  "Compare two groups": "Compară două grupuri",
  "Compares saved settings only.": "Compară doar setările salvate.",
  "Compare…": "Compară…",
  "Copied from {group}. Check the changes, then save.": "Copiat de la {group}. Verifică modificările, apoi salvează.",
  "Copy from": "Copiază de la",
  "Copy from…": "Copiază de la…",
  "Copy into {group}": "Copiază în {group}",
  "Could not create the group": "Grupul nu a putut fi creat",
  "Could not delete the group": "Grupul nu a putut fi șters",
  "Could not load the access settings.": "Setările de acces nu au putut fi încărcate.",
  "Could not rename the group": "Grupul nu a putut fi redenumit",
  "Could not save the changes": "Modificările nu au putut fi salvate",
  "Could not save: {error}": "Nu s-a putut salva: {error}",
  "Could not undo the change": "Modificarea nu a putut fi anulată",
  "Customer map filter": "Filtru în harta clienților",
  "Data access": "Acces date",
  "Defaults": "Implicit",
  "Delete group": "Șterge grupul",
  "Delete {group}? Its members lose the access it gives.": "Ștergi {group}? Membrii lui pierd accesul pe care îl dă grupul.",
  "Different from the default": "Diferit de implicit",
  "Disabled / Read only": "Dezactivat / Doar citire",
  "Discard": "Renunță",
  "Django model permissions. Today only Customers, Sales, Users and part of Warehousing check them on the server; the other modules ignore them.": "Permisiuni Django pe modele. Azi doar Clienți, Vânzări, Utilizatori și o parte din Depozit le verifică pe server; celelalte module le ignoră.",
  "Effective access": "Acces efectiv",
  "Element": "Element",
  "Exit": "Ieși",
  "Filter groups": "Filtrează grupurile",
  "Filter…": "Filtrează…",
  "Group name": "Numele grupului",
  "Groups it can manage": "Grupuri pe care le poate gestiona",
  "Hidden": "Ascuns",
  "Hiding it also blocks the action on the server": "Ascunderea blochează acțiunea și pe server",
  "History · {group}": "Istoric · {group}",
  "Keep": "Păstrează",
  "Members": "Membri",
  "Members of {group} can add people to, remove them from and edit people in the ticked groups.": "Membrii grupului {group} pot adăuga, scoate și edita oameni din grupurile bifate.",
  "New group": "Grup nou",
  "No active accounts found": "Nu există conturi active",
  "No changes recorded for this group yet.": "Nicio modificare înregistrată încă pentru acest grup.",
  "Nobody is in this group yet.": "Nu e nimeni în acest grup încă.",
  "Nothing is saved until you press Save.": "Nimic nu se salvează până nu apeși Salvează.",
  "Only add what is missing": "Doar adaugă ce lipsește",
  "Only allowed pages": "Doar paginile permise",
  "Only groups that can open the page count. The most permissive state wins; the outlined cell shows which group decided.": "Contează doar grupurile care pot deschide pagina. Câștigă starea cea mai permisivă; celula încadrată arată grupul care a decis.",
  "Only restrictions": "Doar restricțiile",
  "Only superusers can manage access.": "Doar superuserii pot administra accesul.",
  "Open Users": "Deschide Utilizatori",
  "Own account only": "Doar propriul cont",
  "Page {page}: allowed only for {group}": "Pagina {page}: permisă doar pentru {group}",
  "Page {page}: {from} → {to}": "Pagina {page}: {from} → {to}",
  "Pages and cards are closed until allowed. Buttons, tabs and fields are visible until hidden.": "Paginile și cardurile sunt închise până le permiți. Butoanele, tab-urile și câmpurile sunt vizibile până le ascunzi.",
  "Pages and elements": "Pagini și elemente",
  "Pages, cards and buttons only; data is not filtered.": "Doar pagini, carduri și butoane; datele nu sunt filtrate.",
  "Pick a user on the left.": "Alege un utilizator din stânga.",
  "Public": "Publică",
  "Rename": "Redenumește",
  "Replace everything": "Înlocuiește tot",
  "Result": "Rezultat",
  "Sales assignment": "Alocare vânzări",
  "Save or discard the changes first, so the preview shows them.": "Salvează sau renunță întâi la modificări, ca previzualizarea să le arate.",
  "Saved": "Salvat",
  "Search page, button or field…": "Caută pagină, buton sau câmp…",
  "Search user": "Caută utilizator",
  "Search user…": "Caută utilizator…",
  "Selected accounts": "Doar conturile selectate",
  "Shop assignment": "Alocare magazine",
  "Show elements": "Arată elementele",
  "Staff accounts. Search to find anyone else.": "Conturi de angajați. Caută ca să găsești pe oricine altcineva.",
  "Superuser: sees everything regardless of groups": "Superuser: vede tot, indiferent de grupuri",
  "Team": "Echipa",
  "The page is closed for this group, so these settings have no effect. Tick the page to change them.": "Pagina e închisă pentru acest grup, deci setările de mai jos nu au efect. Bifeaz-o ca să le poți modifica.",
  "The pages, elements, dashboard cards and home page of {target} become the same as those of {source}.": "Paginile, elementele, cardurile și pagina de start ale lui {target} devin identice cu ale lui {source}.",
  "Home page: {a} {pageA}, {b} {pageB}": "Pagina de start: {a} {pageA}, {b} {pageB}",
  "automatic": "automată",
  "Home page: {from} → {to}": "Pagina de start: {from} → {to}",
  "Home page": "Pagina de start",
  "Automatic: {page}": "Automat: {page}",
  "Automatic: product catalogue": "Automat: catalogul de produse",
  "{page} (not allowed any more)": "{page} (nu mai este permisă)",
  "Where members land after logging in or opening an unknown address. The Access Denied page links back here. Only allowed pages can be chosen; if the page is closed later, the first allowed page is used.": "Pagina pe care ajung membrii după autentificare sau când deschid o adresă necunoscută. Pagina „Acces interzis” trimite tot aici. Se pot alege doar paginile permise; dacă pagina este închisă ulterior, se folosește prima pagină permisă.",
  "The two groups have exactly the same access.": "Cele două grupuri au exact același acces.",
  "Undo": "Anulează",
  "Unsaved changes": "Modificări nesalvate",
  "Users": "Utilizatori",
  "View as this group": "Vezi ca acest grup",
  "Viewing as": "Vizualizezi ca",
  "Visible / Editable": "Vizibil / Editabil",
  "You do not have access to this action": "Nu ai acces la această acțiune",
  "also blocked on the server": "blocat și pe server",
  "and": "și",
  "applies on every page the group can open": "se aplică pe toate paginile pe care grupul le poate deschide",
  "default": "implicit",
  "different from the default": "diferit de implicit",
  "does not count": "nu contează",
  "mobile app": "aplicația mobilă",
  "no access to the page": "fără acces la pagină",
  "no elements yet": "încă fără elemente",
  "no groups": "fără grupuri",
  "not in code": "nu mai e în cod",
  "public page": "pagină publică",
  "saved together in one go": "se salvează toate odată",
  "superuser": "superuser",
  "through {groups}": "prin {groups}",
  "undone": "anulat",
  "unknown error": "eroare necunoscută",
  "{allowed} of {total} pages allowed": "{allowed} din {total} pagini permise",
  "{allowed} pages allowed, {closed} closed.": "Pagini permise: {allowed}. Închise: {closed}.",
  "{target} also gets the pages and cards of {source}. Its current restrictions stay.": "{target} primește în plus paginile și cardurile lui {source}. Restricțiile existente rămân.",
  "CRM leads": "Lead-uri CRM",
  "Bank accounts": "Conturi bancare",
  "Where the group appears in lists": "Unde apare grupul în liste",
  "Which customers the group sees in lists, reports and exports.": "Ce clienți vede grupul în liste, rapoarte și exporturi.",
  "\"All leads\" includes unassigned leads from the website form. \"Assigned only\" shows leads assigned to the user.": "„Toate lead-urile” include și lead-urile nealocate venite din formularul site-ului. „Doar alocați” arată doar lead-urile alocate utilizatorului.",
  "Which accounts appear in Cash and when recording payments.": "Ce conturi apar în Cash și la înregistrarea plăților.",
  "This does not give or take away access. It only decides whether the group is offered as an option in these pickers.": "Asta nu dă și nu ia acces. Decide doar dacă grupul apare ca opțiune în aceste liste de alegere.",
  "Shared elements": "Elemente comune",
  "Shared on every page": "Comune pe toate paginile",
  "Button": "Buton",
  "Column": "Coloană",
  "Badge": "Badge",
  "Section": "Secțiune",
  "Action": "Acțiune",
  "Field": "Câmp",
  "Visible": "Vizibil",
  "Disabled": "Dezactivat",
  "Editable": "Editabil",
  "Read only": "Doar citire",
  "yes": "da",
  "no": "nu",
  "allowed": "permisă",
  "visible": "vizibil",
  "hidden": "ascuns",
  "{count} elements": { one: "{count} element", few: "{count} elemente", other: "{count} de elemente" },
  "{count} restrictions": { one: "{count} restricție", few: "{count} restricții", other: "{count} de restricții" },
  "{count} pages allowed": { one: "{count} pagină permisă", few: "{count} pagini permise", other: "{count} de pagini permise" },
  "{count} cards": { one: "{count} card", few: "{count} carduri", other: "{count} de carduri" },
  "{count} users": { one: "{count} utilizator", few: "{count} utilizatori", other: "{count} de utilizatori" },
  "{count} differences": { one: "{count} diferență", few: "{count} diferențe", other: "{count} de diferențe" },
  "{count} unsaved changes": { one: "{count} modificare nesalvată", few: "{count} modificări nesalvate", other: "{count} de modificări nesalvate" },
  "Saved. Access is updated straight away for {count} people.": { one: "Salvat. Accesul s-a actualizat imediat pentru {count} persoană.", few: "Salvat. Accesul s-a actualizat imediat pentru {count} persoane.", other: "Salvat. Accesul s-a actualizat imediat pentru {count} de persoane." },
  "Show as filter option in Customer Map": "Apare ca filtru în harta clienților",
  "Available for shop assignment": "Disponibil la alocarea magazinelor",
  "Available for sales assignment": "Disponibil la alocarea vânzărilor",
  "Available for account manager assignment": "Disponibil la alocarea account managerilor",
  "Stock Adjustments": "Ajustări de stoc",
  "WIP Tracking V2": "Urmărire producție în curs V2",
  "Workstation": "Stație de lucru",
  "Mobile": "Mobil",
  "Customer Receipt": "Încasare client",
  "Supplier Payment": "Plată furnizor",
  "Employee Payment": "Plată angajat",
  "Adjust balance": "Ajustează soldul",
  "Edit account": "Editează contul",
  "Recalculate balance": "Recalculează soldul",
  "Set as default account": "Setează ca cont implicit",
  "Transaction amount": "Suma tranzacției",
  "Bank details": "Date bancare",
  "Current balance": "Sold curent",
  "Account balances": "Solduri conturi",
  "Bank details section": "Secțiunea date bancare",
  "Balance summary": "Sumar solduri",
  "Save employee payment": "Salvează plata angajatului",
  "Allocate to invoices": "Alocă pe facturi",
  "Allocate to payroll entries": "Alocă pe înregistrări de salarizare",
  "Save supplier payment": "Salvează plata furnizorului",
  "Save customer receipt": "Salvează încasarea clientului",
  "Cancel scheduled payment": "Anulează plata programată",
  "New scheduled payment": "Plată programată nouă",
  "Delete scheduled payment": "Șterge plata programată",
  "Edit scheduled payment": "Editează plata programată",
  "Execute scheduled payment": "Execută plata programată",
  "Pause scheduled payment": "Suspendă plata programată",
  "Resume scheduled payment": "Reia plata programată",
  "Amount": "Sumă",
  "Add allocation": "Adaugă alocare",
  "Auto-allocate": "Alocare automată",
  "Cancel transaction": "Anulează tranzacția",
  "Clear all allocations": "Șterge toate alocările",
  "Complete transaction": "Finalizează tranzacția",
  "Edit transaction": "Editează tranzacția",
  "Link to proforma": "Leagă de proformă",
  "New supplier payment": "Plată furnizor nouă",
  "New customer receipt": "Încasare client nouă",
  "New transfer": "Transfer nou",
  "Remove allocation": "Elimină alocarea",
  "Set transaction to draft": "Trece tranzacția în ciornă",
  "Unlink proforma": "Dezleagă proforma",
  "Running balance": "Sold cumulat",
  "Create transfer": "Creează transfer",
  "Cancel credit note": "Anulează nota de credit",
  "Create credit note": "Creează notă de credit",
  "Edit credit note": "Editează nota de credit",
  "Email credit note": "Trimite nota de credit pe e-mail",
  "Export credit notes": "Exportă notele de credit",
  "Export statement": "Exportă fișa",
  "Post credit note": "Înregistrează nota de credit",
  "Print credit note": "Tipărește nota de credit",
  "Save credit note": "Salvează nota de credit",
  "Sync batches from picking": "Sincronizează loturile din culegere",
  "Revert to draft": "Readu la ciornă",
  "Discount amount": "Valoare reducere",
  "Unit price": "Preț unitar",
  "Totals": "Totaluri",
  "Related documents": "Documente asociate",
  "Customer statement": "Fișă client",
  "Bulk edit customers": "Editare în masă clienți",
  "Create customer": "Creează client",
  "Edit customer": "Editează clientul",
  "Edit customer login": "Editează autentificarea clientului",
  "Email statement": "Trimite fișa pe e-mail",
  "Export customers": "Exportă clienții",
  "Link to Companies House": "Leagă de Companies House",
  "Generate / verify location": "Generează / verifică locația",
  "Review Companies House changes": "Revizuiește modificările din Companies House",
  "Export statement Excel": "Exportă fișa în Excel",
  "Export statement PDF": "Exportă fișa în PDF",
  "Credit status": "Stare credit",
  "Price type": "Tip de preț",
  "Credit hold": "Blocare credit",
  "Credit limit override": "Limită de credit personalizată",
  "Default account": "Cont implicit",
  "Max outstanding invoices": "Nr. maxim de facturi neachitate",
  "Payment terms": "Termene de plată",
  "Effective credit limits": "Limite de credit efective",
  "CRM activity tab": "Tab activitate CRM",
  "Companies House tab": "Tab Companies House",
  "Credit control tab": "Tab control credit",
  "Fulfilment tab": "Tab onorare",
  "Logistics tab": "Tab logistică",
  "Statement tab": "Tab fișă",
  "Related order badge": "Badge comandă asociată",
  "Statement opening balance": "Sold inițial fișă",
  "Add missing items to invoice": "Adaugă articolele lipsă pe factură",
  "Apply discounts": "Aplică reducerile",
  "Apply prices": "Aplică prețurile",
  "Create invoice from missing items": "Creează factură din articolele lipsă",
  "Create invoice": "Creează factură",
  "Edit invoice": "Editează factura",
  "Edit invoice number": "Editează numărul facturii",
  "Email invoice": "Trimite factura pe e-mail",
  "Export invoices": "Exportă facturile",
  "Export to 1C": "Exportă în 1C",
  "Print invoice": "Tipărește factura",
  "Record payment": "Înregistrează plata",
  "Refill from picking": "Recompletează din culegere",
  "Save invoice": "Salvează factura",
  "Send extra items to picking": "Trimite articolele suplimentare la culegere",
  "Sync 1C mismatches": "Sincronizează diferențele 1C",
  "1C export column": "Coloana export 1C",
  "Balance due": "Rest de plată",
  "Line total": "Total linie",
  "Total amount": "Sumă totală",
  "Discount": "Reducere",
  "Financial summary": "Sumar financiar",
  "Statement": "Fișă",
  "Invoiced badge": "Badge facturat",
  "Order status": "Starea comenzii",
  "Change delivery date (bulk)": "Schimbă data livrării (în masă)",
  "Change order status": "Schimbă starea comenzii",
  "Copy order": "Copiază comanda",
  "Create order": "Creează comandă",
  "Generate picking": "Generează culegerea",
  "Import orders": "Importă comenzi",
  "Print orders": "Tipărește comenzile",
  "Refill prices": "Recompletează prețurile",
  "Resolve imported line": "Rezolvă linia importată",
  "Save order": "Salvează comanda",
  "Send to 1C": "Trimite în 1C",
  "Copy column": "Coloana copiere",
  "Created by": "Creat de",
  "Created date": "Data creării",
  "Delivery date": "Data livrării",
  "Export status": "Stare export",
  "Fulfilment type": "Tip onorare",
  "Line prices": "Prețuri pe linie",
  "Order number": "Număr comandă",
  "Order lines": "Linii comandă",
  "Pickings": "Culegeri",
  "Order totals": "Totaluri comandă",
  "Revert status": "Readu starea",
  "Generate packing": "Generează ambalarea",
  "Mark ready to ship": "Marchează gata de expediere",
  "Mark partially packed": "Marchează ambalat parțial",
  "Print delivery note": "Tipărește avizul de însoțire",
  "Print supplementary note": "Tipărește avizul suplimentar",
  "Return trays to picking": "Returnează tăvile la culegere",
  "Start packing": "Începe ambalarea",
  "Amount due badge": "Badge sumă de plată",
  "Bulk update employees": "Actualizare în masă angajați",
  "Add employee": "Adaugă angajat",
  "Edit employee": "Editează angajatul",
  "Manage departments and titles": "Gestionează departamente și funcții",
  "Amount due": "Sumă de plată",
  "Pay rate": "Tarif de plată",
  "Payroll history tab": "Tab istoric salarizare",
  "Approve payroll entry": "Aprobă înregistrarea de salarizare",
  "Edit payroll entry": "Editează înregistrarea de salarizare",
  "Edit timesheet": "Editează pontajul",
  "Recalculate payroll entry": "Recalculează înregistrarea de salarizare",
  "Unapprove payroll entry": "Retrage aprobarea înregistrării de salarizare",
  "View payslip": "Vezi fluturașul de salariu",
  "Pay amounts": "Sume salariale",
  "Pay breakdown": "Defalcare salariu",
  "Pay scenario and rate": "Scenariu de plată și tarif",
  "Pay totals": "Totaluri salariu",
  "Payment history": "Istoric plăți",
  "Payment status": "Stare plată",
  "Add payroll entry": "Adaugă înregistrare de salarizare",
  "Calculate payroll": "Calculează salarizarea",
  "Close pay period": "Închide perioada de plată",
  "Delete selected payroll entries": "Șterge înregistrările de salarizare selectate",
  "Delete pay period": "Șterge perioada de plată",
  "Delete timesheet": "Șterge pontajul",
  "Delete selected timesheets": "Șterge pontajele selectate",
  "Fill from previous period": "Completează din perioada anterioară",
  "Import timesheet CSV": "Importă pontaj CSV",
  "Reopen pay period": "Redeschide perioada de plată",
  "Run payroll": "Rulează salarizarea",
  "Timesheets tab": "Tab pontaje",
  "Change priority": "Schimbă prioritatea",
  "Mark returned corrections complete": "Marchează corecțiile returnate ca finalizate",
  "Order amount": "Valoare comandă",
  "Bulk export to 1C": "Export în masă în 1C",
  "Cancel picking": "Anulează culegerea",
  "Complete picking": "Finalizează culegerea",
  "Complete remaining": "Finalizează restul",
  "Create picking": "Creează culegere",
  "Generate picking from orders": "Generează culegere din comenzi",
  "Generate invoice": "Generează factura",
  "Partial complete": "Finalizare parțială",
  "Print tray labels": "Tipărește etichetele tăvilor",
  "Refill order data": "Recompletează datele comenzii",
  "Start picking": "Începe culegerea",
  "Unlink order": "Dezleagă comanda",
  "Assigned to": "Alocat lui",
  "Due date": "Termen",
  "Items / quantity": "Articole / cantitate",
  "Task number": "Număr sarcină",
  "Effective date": "Data efectivă",
  "Copy BOM": "Copiază rețeta",
  "Create BOM": "Creează rețetă",
  "Edit BOM": "Editează rețeta",
  "Version history": "Istoric versiuni",
  "Print BOM": "Tipărește rețeta",
  "Refresh BOM prices": "Reîmprospătează prețurile rețetei",
  "Activate / deactivate BOM": "Activează / dezactivează rețeta",
  "Validate BOM": "Validează rețeta",
  "Costs and prices": "Costuri și prețuri",
  "Calculator tab": "Tab calculator",
  "Components tab": "Tab componente",
  "Cost history tab": "Tab istoric costuri",
  "BOM details tab": "Tab detalii rețetă",
  "Instructions tab": "Tab instrucțiuni",
  "Operations tab": "Tab operații",
  "Validation tab": "Tab validare",
  "Advance status": "Avansează starea",
  "Change status": "Schimbă starea",
  "Copy production order": "Copiază comanda de producție",
  "Create production order": "Creează comandă de producție",
  "Delete production order": "Șterge comanda de producție",
  "Edit production order": "Editează comanda de producție",
  "Generate WIP": "Generează WIP",
  "Generate material transfer": "Generează transfer de materii prime",
  "Print QR codes": "Tipărește codurile QR",
  "Regenerate from BOM": "Regenerează din rețetă",
  "Rename order": "Redenumește comanda",
  "Work centre assignment": "Alocare centru de lucru",
  "Costs and values": "Costuri și valori",
  "Inputs tab": "Tab intrări",
  "Expected outputs tab": "Tab ieșiri așteptate",
  "Related documents tab": "Tab documente asociate",
  "Timeline tab": "Tab cronologie",
  "Approve cost update": "Aprobă actualizarea costului",
  "Generate releases": "Generează lansările",
  "Regenerate traceability": "Regenerează trasabilitatea",
  "Reject cost update": "Respinge actualizarea costului",
  "Revert release": "Anulează lansarea",
  "Cost analysis": "Analiză costuri",
  "Batch genealogy tab": "Tab genealogie loturi",
  "Overview tab": "Tab prezentare generală",
  "Pending cost updates tab": "Tab actualizări de cost în așteptare",
  "Signatures tab": "Tab semnături",
  "Variance analysis tab": "Tab analiză diferențe",
  "Generate production release": "Generează lansarea în producție",
  "Quick produce": "Producție rapidă",
  "Adjust batch stock": "Ajustează stocul lotului",
  "Bulk edit products": "Editare în masă produse",
  "Clear batch overdraft": "Elimină stocul negativ al lotului",
  "Consolidate products": "Consolidează produsele",
  "Copy product": "Copiază produsul",
  "Create product": "Creează produs",
  "Deep cleanup": "Curățare completă",
  "Delete products": "Șterge produsele",
  "Export products to Excel": "Exportă produsele în Excel",
  "Fill missing batches": "Completează loturile lipsă",
  "Generate stock adjustment": "Generează ajustare de stoc",
  "Generate SKUs": "Generează SKU-uri",
  "Manage badges": "Gestionează badge-urile",
  "Manage barcodes": "Gestionează codurile de bare",
  "Edit customs data": "Editează datele vamale",
  "Manage extra units": "Gestionează unitățile suplimentare",
  "Manage kit components": "Gestionează componentele kitului",
  "Manage product images": "Gestionează imaginile produsului",
  "Manage supplier mappings": "Gestionează corespondențele cu furnizorii",
  "Print / export products": "Tipărește / exportă produsele",
  "Recalculate stock": "Recalculează stocul",
  "Save product": "Salvează produsul",
  "Show / hide base unit": "Arată / ascunde unitatea de bază",
  "Enable / disable product": "Activează / dezactivează produsul",
  "Cost price": "Preț de cost",
  "Margin %": "Marjă %",
  "Markup %": "Adaos %",
  "Sales price": "Preț de vânzare",
  "Supplier price": "Preț furnizor",
  "Min quantity": "Cantitate minimă",
  "Step quantity": "Pas cantitate",
  "Price types section": "Secțiunea tipuri de preț",
  "Analytics tab": "Tab analiză",
  "Badges tab": "Tab badge-uri",
  "Barcodes tab": "Tab coduri de bare",
  "Batches tab": "Tab loturi",
  "Categories, groups, brands, units and SKU ranges": "Categorii, grupe, mărci, unități și intervale SKU",
  "Composition tab": "Tab compoziție",
  "Customs tab": "Tab vamal",
  "Media tab": "Tab media",
  "Movements tab": "Tab mișcări",
  "Price history tab": "Tab istoric prețuri",
  "Production tab": "Tab producție",
  "Scraped products tab": "Tab produse extrase",
  "Supplier mappings tab": "Tab corespondențe furnizori",
  "Sent to 1C badge": "Badge trimis în 1C",
  "Add Bill as Landed Cost": "Adaugă factura de cheltuieli ca cost accesoriu",
  "Allocate Bill as Landed Cost": "Alocă factura de cheltuieli ca cost accesoriu",
  "Allocate service cost": "Alocă costul serviciului",
  "Copy Bill": "Copiază factura de cheltuieli",
  "Remove Landed Cost Allocation": "Elimină alocarea costului accesoriu",
  "Delete Invoice": "Șterge factura",
  "Export Statement Excel": "Exportă fișa în Excel",
  "Export Statement PDF": "Exportă fișa în PDF",
  "New Invoice": "Factură nouă",
  "Recalculate Selected": "Recalculează selectatele",
  "Record Payment": "Înregistrează plata",
  "Refill from purchase order": "Recompletează din comanda de achiziție",
  "Remove service line": "Elimină linia de serviciu",
  "Save as supplier cost": "Salvează ca cost furnizor",
  "Send Selected to 1C": "Trimite selectatele în 1C",
  "Update prices": "Actualizează prețurile",
  "Update Prices Selected": "Actualizează prețurile selectatelor",
  "Line amount": "Valoare linie",
  "Due for payment": "Scadent la plată",
  "Landed services": "Servicii accesorii",
  "Line tax": "TVA linie",
  "Tax": "TVA",
  "Unit cost": "Cost unitar",
  "Bill Landed Cost": "Cost accesoriu din factura de cheltuieli",
  "Landed Cost Overlay": "Suprapunere cost accesoriu",
  "Service lines": "Linii de servicii",
  "Bills": "Facturi de cheltuieli",
  "Customs declaration": "Declarație vamală",
  "Details": "Detalii",
  "Supplier statement": "Fișă furnizor",
  "Email to supplier": "Trimite pe e-mail furnizorului",
  "Reopen closed lines": "Redeschide liniile închise",
  "Close orders short": "Închide comenzile cu livrare parțială",
  "Confirm purchase order": "Confirmă comanda de achiziție",
  "Copy purchase order": "Copiază comanda de achiziție",
  "Create product from line": "Creează produs din linie",
  "Delete purchase order": "Șterge comanda de achiziție",
  "Edit purchase order": "Editează comanda de achiziție",
  "Export to Excel": "Exportă în Excel",
  "Generate invoice from proforma": "Generează factura din proformă",
  "New purchase order": "Comandă de achiziție nouă",
  "Change product match": "Schimbă produsul asociat",
  "Save purchase order": "Salvează comanda de achiziție",
  "Send purchase order": "Trimite comanda de achiziție",
  "Advance payments": "Avansuri",
  "Add product": "Adaugă produs",
  "Approve receipt": "Aprobă recepția",
  "Cancel receipt": "Anulează recepția",
  "Correct items": "Corectează articole",
  "Generate receipt": "Generează recepția",
  "New receipt": "Recepție nouă",
  "Refill items from source document": "Recompletează articolele din documentul sursă",
  "Revert receipt status": "Readu starea recepției",
  "Start inspection": "Începe inspecția",
  "Document total": "Total document",
  "Edit batch": "Editează lotul",
  "Sync expiry to receipts and invoices": "Sincronizează expirarea cu recepțiile și facturile",
  "Stock movements tab": "Tab mișcări de stoc",
  "Picking history tab": "Tab istoric culegeri",
  "Adjust batch": "Ajustează lotul",
  "Count batch": "Numără lotul",
  "Count product": "Numără produsul",
  "Create batch": "Creează lot",
  "Delete cycle count": "Șterge inventarul ciclic",
  "Start cycle count": "Începe inventarul ciclic",
  "Stock value": "Valoare stoc",
  "Stock adjustments tab": "Tab ajustări de stoc",
  "Batch management tab": "Tab gestionare loturi",
  "Cycle counts tab": "Tab inventare ciclice",
  "Stock levels tab": "Tab niveluri de stoc",
  "Add line": "Adaugă linie",
  "Apply adjustment": "Aplică ajustarea",
  "Apply staged changes": "Aplică modificările pregătite",
  "Delete adjustment": "Șterge ajustarea",
  "Delete lines": "Șterge liniile",
  "Duplicate adjustment": "Duplică ajustarea",
  "Export and print": "Exportă și tipărește",
  "Fix batches": "Corectează loturile",
  "New adjustment": "Ajustare nouă",
  "Paste list": "Lipește lista",
  "Refill costs": "Recompletează costurile",
  "Refill from movements": "Recompletează din mișcări",
  "Revert adjustment": "Anulează aplicarea ajustării",
  "Set expiry": "Setează expirarea",
  "Reset stock": "Resetează stocul",
  "Toggle sign": "Inversează semnul",
  "Value impact": "Impact valoric",
  "History tab": "Tab istoric",
  "Delete stocktake": "Șterge inventarul",
  "Edit stocktake": "Editează inventarul",
  "Finalise area": "Finalizează zona",
  "Remove area": "Elimină zona",
  "Cancel transfer": "Anulează transferul",
  "Complete transfer": "Finalizează transferul",
  "Confirm transfer": "Confirmă transferul",
  "Edit transfer": "Editează transferul",
  "Reactivate transfer": "Reactivează transferul",
  "Receive transfer": "Recepționează transferul",
  "Revert transfer completion": "Anulează finalizarea transferului",
  "Ship transfer": "Expediază transferul",
  "Start preparation": "Începe pregătirea",
  "Shipping cost": "Cost transport",
  "Turns the page on or off for everyone, in every group": "Pornește sau oprește pagina pentru toată lumea, în toate grupurile",
  "{page} is active again for everyone": "{page} este din nou activă pentru toată lumea",
  "{page} is now inactive for everyone": "{page} este acum inactivă pentru toată lumea",
  "Could not change the page": "Pagina nu a putut fi modificată",
  "Expand all": "Deschide tot",
  "Collapse all": "Strânge tot",
  "All pages": "Toate paginile",
  "Switch it on in All pages": "Se pornește din Toate paginile",
  "Search page…": "Caută pagină…",
  "Search page": "Caută pagină",
  "Only pages without a group": "Doar paginile fără grup",
  "Only inactive pages": "Doar paginile inactive",
  "Click a group to give or take away its access to the page. Active / Inactive applies to everyone straight away.": "Apasă pe un grup ca să-i dai sau să-i iei accesul la pagină. Activă / Inactivă se aplică imediat tuturor.",
  "open to everyone logged in": "deschisă oricui e autentificat",
  "no group: superusers only": "niciun grup: doar superuserii",
  "Who can open each page. Buttons, fields and dashboard cards are set per group.": "Cine poate deschide fiecare pagină. Butoanele, câmpurile și cardurile se setează pe grup.",
  "{count} groups": { one: "{count} grup", few: "{count} grupuri", other: "{count} de grupuri" },
  "{count} pages": { one: "{count} pagină", few: "{count} pagini", other: "{count} de pagini" },
  "{count} inactive": { one: "{count} inactivă", few: "{count} inactive", other: "{count} de inactive" },
  "{count} public": { one: "{count} publică", few: "{count} publice", other: "{count} de publice" },
  "{count} without a group": { one: "{count} fără grup", few: "{count} fără grup", other: "{count} fără grup" },
  "You save": "Economisești",
  "Cart total": "Total coș",
  "Total items": "Total articole",
  "Clear cart": "Golește coșul",
  "Delete saved cart": "Șterge coșul salvat",
  "Load saved cart": "Încarcă coșul salvat",
  "Save cart as template": "Salvează coșul ca șablon",
  "Product image": "Imagine produs",
  "Product name": "Nume produs",
  "Outstanding balance": "Sold restant",
  "Order total": "Total comandă",
  "Complete order": "Finalizează comanda",
  "Billing address": "Adresă de facturare",
  "Delivery address": "Adresă de livrare",
  "Fulfillment method": "Metodă de onorare",
  "Full name": "Nume complet",
  "Order notes": "Note comandă",
  "Pickup time window": "Interval orar de ridicare",
  "Delivery address same as billing": "Adresa de livrare este aceeași cu cea de facturare",
  "Alcohol split order notice": "Notificare comandă separată pentru alcool",
  "Alcohol Licensing": "Licențiere alcool",
  "Credit status warning": "Avertizare stare credit",
  "Delivery information": "Informații livrare",
  "Order customer": "Clientul comenzii",
  "Order summary": "Sumar comandă",
  "Stock shortage warnings": "Avertizări stoc insuficient",
  "Export as CSV": "Exportă ca CSV",
  "Export as Excel": "Exportă ca Excel",
  "Export as PDF": "Exportă ca PDF",
  "Available quantity": "Cantitate disponibilă",
  "Credit note number": "Număr notă de credit",
  "Invoiced quantity": "Cantitate facturată",
  "Operation type": "Tip operație",
  "Credit quantity": "Cantitate creditată",
  "Internal reference": "Referință internă",
  "Stock action": "Acțiune stoc",
  "Credit note details": "Detalii notă de credit",
  "Invoice total and balance": "Total și sold factură",
  "Quantity in cart": "Cantitate în coș",
  "Discount badge": "Badge reducere",
  "Premises licence notice": "Notificare licență pentru spațiu",
  "Product count": "Număr produse",
  "Add to cart": "Adaugă în coș",
  "Remove from cart": "Elimină din coș",
  "Switch view": "Schimbă vizualizarea",
  "Barcode": "Cod de bare",
  "Price": "Preț",
  "Product badges": "Badge-uri produs",
  "Stock": "Stoc",
  "VAT rate": "Cotă TVA",
  "Unit selector": "Selector unitate",
  "Order history (usual / last order)": "Istoric comenzi (obișnuită / ultima comandă)",
  "Custom export": "Export personalizat",
  "Customer email": "E-mail client",
  "Customer phone": "Telefon client",
  "External ID": "ID extern",
  "Picking mismatch indicator": "Indicator diferențe culegere",
  "Branch": "Filială",
  "Invoice date": "Data facturii",
  "Invoice number": "Număr factură",
  "Items count": "Număr articole",
  "Tax rate": "Cotă TVA",
  "Customer reference": "Referință client",
  "Created and imported info": "Informații creare și import",
  "Customer information": "Informații client",
  "Invoice details": "Detalii factură",
  "Invoice items": "Articole factură",
  "Picking mismatch": "Diferențe culegere",
  "Related order": "Comandă asociată",
  "Zero price warnings": "Avertizări preț zero",
  "Consolidated badge": "Badge consolidat",
  "Header total": "Total antet",
  "Imported badge": "Badge importat",
  "Reactivate picking": "Reactivează culegerea",
  "Remove line": "Elimină linia",
  "Reorder lines": "Reordonează liniile",
  "Line base unit": "Unitate de bază linie",
  "Line discount": "Reducere linie",
  "Line discounted price": "Preț redus linie",
  "Line product": "Produs linie",
  "Select column": "Coloana de selecție",
  "Add product search": "Căutare adăugare produs",
  "Line quantity": "Cantitate linie",
  "Line unit": "Unitate linie",
  "Resolve line: product ID": "Rezolvă linia: ID produs",
  "Resolve line: unit ID": "Rezolvă linia: ID unitate",
  "Exported date": "Data exportului",
  "Last modified by": "Modificat ultima dată de",
  "Packing info": "Informații ambalare",
  "Unresolved imported lines": "Linii importate nerezolvate",
  "List page": "Pagina de listă",
  "Detail page": "Pagina de detaliu",
  "Create page": "Pagina de creare",
  "Preview": "Previzualizare",
  "Preview as {group}": "Previzualizare ca {group}",
  "unsaved changes included": "include modificările nesalvate",
  "Page to preview": "Pagina de previzualizat",
  "Go": "Deschide",
  "Open in a new tab (without the preview)": "Deschide într-un tab nou (fără previzualizare)",
  "Close preview": "Închide previzualizarea",
  "Loading the app…": "Se încarcă aplicația…",
  "Fit": "Încadrat",
  "Zoom": "Zoom",
  'Stock Action': 'Acțiune stoc',
  'No batches from picking': 'Niciun lot din culegere',
  'Select batch…': 'Selectează lotul…',
  'Original picking has no batch info for this product.': 'Culegerea originală nu are informații despre lot pentru acest produs.',
  'Select location…': 'Selectează locația…',
  'Available': 'Disponibil',
  'Credit Qty': 'Cant. creditată',
  'Invoice Items': 'Articole factură',
  '({count} selected)': { one: '({count} selectat)', few: '({count} selectate)', other: '({count} selectate)' },
  'Hide Unselected': 'Ascunde neselectatele',
  'Loading items...': 'Se încarcă articolele...',
  'No items match your search': 'Niciun articol nu corespunde căutării',
  'No items selected': 'Niciun articol selectat',
  'No items available': 'Niciun articol disponibil',
  'Read only for your group': 'Doar citire pentru grupul tău',
  'Select row': 'Selectează rândul',
  'Failed to fetch statement': 'Fișa nu a putut fi încărcată',
  'PDF exported successfully': 'PDF exportat cu succes',
  'Failed to export PDF': 'Exportul PDF a eșuat',
  'Excel exported successfully': 'Excel exportat cu succes',
  'Failed to export Excel': 'Exportul Excel a eșuat',
  'Failed to load invoice items': 'Articolele facturii nu au putut fi încărcate',
  'Select at least one item to credit.': 'Selectează cel puțin un articol de creditat.',
  'Select a location for "{name}" before saving.': 'Selectează o locație pentru „{name}” înainte de salvare.',
  'Credit note updated successfully': 'Nota de credit a fost actualizată cu succes',
  'Failed to update credit note': 'Nota de credit nu a putut fi actualizată',
  'Failed to save credit note': 'Nota de credit nu a putut fi salvată',
  'Are you sure you want to post this credit note? This action cannot be undone.': 'Sigur vrei să înregistrezi această notă de credit? Această acțiune nu poate fi anulată.',
  'Credit note posted successfully': 'Nota de credit a fost înregistrată cu succes',
  'Failed to post credit note': 'Nota de credit nu a putut fi înregistrată',
  'Are you sure you want to cancel this credit note?': 'Sigur vrei să anulezi această notă de credit?',
  'Credit note cancelled': 'Nota de credit a fost anulată',
  'Failed to cancel credit note': 'Nota de credit nu a putut fi anulată',
  'Are you sure you want to revert this credit note to draft? This will remove it from customer statements.': 'Sigur vrei să readuci această notă de credit la ciornă? Aceasta o va elimina din fișele clienților.',
  'Credit note reverted to draft': 'Nota de credit a fost readusă la ciornă',
  'Failed to unpost credit note': 'Înregistrarea notei de credit nu a putut fi anulată',
  'Updated {count} line(s) from picking.': { one: 'S-a actualizat {count} linie din culegere.', few: 'S-au actualizat {count} linii din culegere.', other: 'S-au actualizat {count} de linii din culegere.' },
  'Picking has multiple batches per product — pick manually for {count} line(s).': { one: 'Culegerea are mai multe loturi pe produs — alege manual pentru {count} linie.', few: 'Culegerea are mai multe loturi pe produs — alege manual pentru {count} linii.', other: 'Culegerea are mai multe loturi pe produs — alege manual pentru {count} de linii.' },
  'No batches available from the linked picking yet.': 'Încă nu există loturi disponibile din culegerea asociată.',
  'All lines already in sync.': 'Toate liniile sunt deja sincronizate.',
  'Failed to sync from picking': 'Sincronizarea din culegere a eșuat',
  'Email credit note {number} to {recipient}?': 'Trimiți nota de credit {number} pe e-mail către {recipient}?',
  'Email credit note {number} to the customer?': 'Trimiți nota de credit {number} pe e-mail clientului?',
  'Credit note sent': 'Nota de credit a fost trimisă',
  'Failed to email credit note': 'Nota de credit nu a putut fi trimisă pe e-mail',
  'Failed to print credit note': 'Nota de credit nu a putut fi tipărită',
  'Loading credit note...': 'Se încarcă nota de credit...',
  'Back to Credit Notes': 'Înapoi la notele de credit',
  'No batch yet': 'Încă fără lot',
  'Description': 'Descriere',
  'Discount Given': 'Reducere acordată',
  'Destination': 'Destinație',
  'Financial Only': 'Doar financiar',
  'Unit Price': 'Preț unitar',
  'Click to revert to draft (reverses stock movements)': 'Apasă pentru a readuce la ciornă (inversează mișcările de stoc)',
  'Refresh batches from the linked picking': 'Reîmprospătează loturile din culegerea asociată',
  'Sync from picking': 'Sincronizează din culegere',
  'Post': 'Înregistrează',
  'Print': 'Tipărește',
  'Sending…': 'Se trimite…',
  'Credit Note': 'Notă de credit',
  'PDF': 'PDF',
  'Excel': 'Excel',
  'Date From': 'De la data',
  'Date To': 'Până la data',
  'Loading statement...': 'Se încarcă fișa...',
  'Opening Balance': 'Sold inițial',
  'Closing Balance': 'Sold final',
  'Statement Period': 'Perioada fișei',
  'Total Due': 'Total de plată',
  'Aging Summary': 'Sumar vechime solduri',
  'Transaction History': 'Istoric tranzacții',
  'Debit': 'Debit',
  'Credit': 'Credit',
  'No transactions': 'Nicio tranzacție',
  'No transactions found for the selected period.': 'Nu s-au găsit tranzacții pentru perioada selectată.',
  'Credit Note Details': 'Detalii notă de credit',
  'Credit Note Number': 'Număr notă de credit',
  'Original Invoice': 'Factura originală',
  '-- Select Invoice --': '-- Selectează factura --',
  'Credited: £{amount}': 'Creditat: £{amount}',
  'Reason...': 'Motiv...',
  'Internal reference (not shown to customer)...': 'Referință internă (nu este afișată clientului)...',
  'Click to revert to draft': 'Apasă pentru a readuce la ciornă',
  'Discount Amount': 'Valoare reducere',
  'Select an invoice to choose items to credit.': 'Selectează o factură pentru a alege articolele de creditat.',
  '1 item selected': '1 articol selectat',
  '{count} items selected': { one: '{count} articol selectat', few: '{count} articole selectate', other: '{count} de articole selectate' },
  'Subtotal:': 'Subtotal:',
  'Tax:': 'TVA:',
  'Discount Details': 'Detalii reducere',
  'Credit Note #': 'Notă de credit #',
  'Loading credit notes...': 'Se încarcă notele de credit...',
  'Search credit notes...': 'Caută note de credit...',
  'Hide Filters': 'Ascunde filtrele',
  'Export the {count} selected credit notes': { one: 'Exportă {count} notă de credit selectată', few: 'Exportă cele {count} note de credit selectate', other: 'Exportă cele {count} de note de credit selectate' },
  'Export every credit note matching the filters': 'Exportă toate notele de credit care corespund filtrelor',
  'Export': 'Exportă',
  'New Credit Note': 'Notă de credit nouă',
  'Search customers...': 'Caută clienți...',
  'No customers available': 'Niciun client disponibil',
  'Date Range': 'Interval de date',
  'No credit notes found': 'Nu s-au găsit note de credit',
  'Showing {from} to {to} of {total}': 'Se afișează {from}–{to} din {total}',
  'Rows': 'Rânduri',
  'Page {page} of {total}': 'Pagina {page} din {total}',
  'No sales price configured for this product': 'Niciun preț de vânzare configurat pentru acest produs',
  '£0.00 due to 100% discount': '£0.00 din cauza reducerii de 100%',
  'Manual': 'Manual',
  'Qty:': 'Cant.:',
  'Price:': 'Preț:',
  'Disc:': 'Red.:',
  'Base:': 'Bază:',
  'Invoice: {number}': 'Factură: {number}',
  'Not specified': 'Nespecificat',
  'Invalid date': 'Dată invalidă',
  'Failed to generate print version. Please try again.': 'Versiunea de tipărire nu a putut fi generată. Încearcă din nou.',
  'Invoice sent to customer': 'Factura a fost trimisă clientului',
  'Failed to send email': 'E-mailul nu a putut fi trimis',
  'Failed to send email to customer': 'E-mailul nu a putut fi trimis clientului',
  'Auto-applied sales prices to {count} item(s) that had £0.00': { one: 'S-a aplicat automat prețul de vânzare la {count} articol care avea £0.00', few: 'S-au aplicat automat prețurile de vânzare la {count} articole care aveau £0.00', other: 'S-au aplicat automat prețurile de vânzare la {count} de articole care aveau £0.00' },
  'Cannot save: {count} item(s) have £0.00 price with no sales price found:\n{names}': { one: 'Nu se poate salva: {count} articol are prețul £0.00 și nu s-a găsit niciun preț de vânzare:\n{names}', few: 'Nu se poate salva: {count} articole au prețul £0.00 și nu s-a găsit niciun preț de vânzare:\n{names}', other: 'Nu se poate salva: {count} de articole au prețul £0.00 și nu s-a găsit niciun preț de vânzare:\n{names}' },
  'Cannot save: {count} item(s) have £0.00 price and sales prices could not be looked up:\n{names}': { one: 'Nu se poate salva: {count} articol are prețul £0.00, iar prețurile de vânzare nu au putut fi căutate:\n{names}', few: 'Nu se poate salva: {count} articole au prețul £0.00, iar prețurile de vânzare nu au putut fi căutate:\n{names}', other: 'Nu se poate salva: {count} de articole au prețul £0.00, iar prețurile de vânzare nu au putut fi căutate:\n{names}' },
  'Invoice updated successfully!': 'Factura a fost actualizată cu succes!',
  'Failed to save invoice': 'Factura nu a putut fi salvată',
  'Added {name} to invoice': '{name} a fost adăugat pe factură',
  'Failed to add product': 'Produsul nu a putut fi adăugat',
  'Item removed': 'Articol eliminat',
  'Invoice refilled from picking data': 'Factura a fost recompletată din datele de culegere',
  'Failed to refill invoice': 'Factura nu a putut fi recompletată',
  'Failed to refill from picking': 'Recompletarea din culegere a eșuat',
  'No prices found for this price type and date': 'Nu s-au găsit prețuri pentru acest tip de preț și această dată',
  'Failed to apply prices': 'Prețurile nu au putut fi aplicate',
  'No applicable discounts found for this customer': 'Nu s-au găsit reduceri aplicabile pentru acest client',
  'Failed to apply discounts': 'Reducerile nu au putut fi aplicate',
  'applied discounts to {count}': 'reduceri aplicate la {count}',
  'Customer changed to {name}: {changes}': 'Clientul a fost schimbat în {name}: {changes}',
  'Customer changed to {name}: no prices or discounts applied': 'Clientul a fost schimbat în {name}: nu s-au aplicat prețuri sau reduceri',
  'Failed to re-price/re-apply discounts for new customer': 'Prețurile și reducerile nu au putut fi reaplicate pentru noul client',
  'Invoice Details': 'Detalii factură',
  'Loading invoice details...': 'Se încarcă detaliile facturii...',
  'Invoice not found': 'Factura nu a fost găsită',
  'New invoice': 'Factura nouă',
  'created': 'a fost creată',
  '{count} item(s) added to invoice': { one: '{count} articol a fost adăugat pe factură', few: '{count} articole au fost adăugate pe factură', other: '{count} de articole au fost adăugate pe factură' },
  'Create a new invoice with {count} missing item(s)?': { one: 'Creezi o factură nouă cu {count} articol lipsă?', few: 'Creezi o factură nouă cu {count} articole lipsă?', other: 'Creezi o factură nouă cu {count} de articole lipsă?' },
  'Create a new invoice with {count} item(s)?': { one: 'Creezi o factură nouă cu {count} articol?', few: 'Creezi o factură nouă cu {count} articole?', other: 'Creezi o factură nouă cu {count} de articole?' },
  '{count} item(s) sent to picking {picking}': { one: '{count} articol a fost trimis la culegerea {picking}', few: '{count} articole au fost trimise la culegerea {picking}', other: '{count} de articole au fost trimise la culegerea {picking}' },
  'Discounted Price': 'Preț redus',
  'Tax Rate': 'Cotă TVA',
  'No items. Use the search above to add products.': 'Niciun articol. Folosește căutarea de mai sus pentru a adăuga produse.',
  '{name} (from customer)': '{name} (de la client)',
  'Invoice {number}': 'Factura {number}',
  'Sending...': 'Se trimite...',
  'View version history': 'Vezi istoricul versiunilor',
  'Refill invoice items from the latest picking data': 'Recompletează articolele facturii din cele mai recente date de culegere',
  'Refill from Picking': 'Recompletează din culegere',
  'Apply customer discounts to all items': 'Aplică reducerile clientului la toate articolele',
  'Applying...': 'Se aplică...',
  'Apply Discounts': 'Aplică reducerile',
  'Cannot save: {names} have no sales price configured': 'Nu se poate salva: {names} nu au preț de vânzare configurat',
  'Saving...': 'Se salvează...',
  'Related': 'Asociate',
  'Loading mismatch details...': 'Se încarcă detaliile diferențelor...',
  'This picking is shared with {count} other invoice(s):': { one: 'Această culegere este comună cu încă {count} factură:', few: 'Această culegere este comună cu alte {count} facturi:', other: 'Această culegere este comună cu alte {count} de facturi:' },
  'Not Invoiced — Potential Lost Revenue ({count})': 'Nefacturat — venit potențial pierdut ({count})',
  'Add to Invoice': 'Adaugă pe factură',
  'Create New Invoice': 'Creează factură nouă',
  'Select customer for new invoice:': 'Selectează clientul pentru factura nouă:',
  'Create': 'Creează',
  'Difference': 'Diferență',
  'NONE': 'NIMIC',
  'Invoiced in Other Invoice(s) ({count})': 'Facturat pe alte facturi ({count})',
  'Invoiced In': 'Facturat pe',
  'Extra in Invoice — Not in Picking ({count})': 'În plus pe factură — nu este în culegere ({count})',
  'Send to Picking': 'Trimite la culegere',
  'Customer Information': 'Informații client',
  'Click to apply prices from price document effective on invoice date': 'Apasă pentru a aplica prețurile din documentul de prețuri în vigoare la data facturii',
  'Applying prices...': 'Se aplică prețurile...',
  'Customer: {name}': 'Client: {name}',
  'Issued': 'Emisă',
  'Canceled': 'Anulată',
  'Order #{number}': 'Comanda #{number}',
  'Order: {number}': 'Comandă: {number}',
  'Enter reference': 'Introdu referința',
  '-- Select Payment Terms --': '-- Selectează termenul de plată --',
  'Enter notes': 'Introdu note',
  'Financial Summary': 'Sumar financiar',
  'Gross Total:': 'Total brut:',
  'Total Discount:': 'Reducere totală:',
  'Paid:': 'Plătit:',
  'Balance Due:': 'Rest de plată:',
  'Account Balance:': 'Sold cont:',
  '{count} items': { one: '{count} articol', few: '{count} articole', other: '{count} de articole' },
  'Cannot save: {count} line item(s) are £0.00 with no sales price configured': { one: 'Nu se poate salva: {count} linie are £0.00 fără preț de vânzare configurat', few: 'Nu se poate salva: {count} linii au £0.00 fără preț de vânzare configurat', other: 'Nu se poate salva: {count} de linii au £0.00 fără preț de vânzare configurat' },
  'Set a unit price on each line, or configure a sales price for the product, before saving.': 'Setează un preț unitar pe fiecare linie sau configurează un preț de vânzare pentru produs înainte de salvare.',
  '{count} line item(s) priced at £0.00 (100% discount applied)': { one: '{count} linie cu prețul £0.00 (reducere de 100% aplicată)', few: '{count} linii cu prețul £0.00 (reducere de 100% aplicată)', other: '{count} de linii cu prețul £0.00 (reducere de 100% aplicată)' },
  'Add Product': 'Adaugă produs',
  'Search products by name, SKU, or barcode...': 'Caută produse după nume, SKU sau cod de bare...',
  'No products found': 'Nu s-au găsit produse',
  'SKU: {sku}': 'SKU: {sku}',
  'Barcode: {barcode}': 'Cod de bare: {barcode}',
  'Created on {date}': 'Creată la {date}',
  'by {name}': 'de {name}',
  'Imported from 1C on {date}': 'Importată din 1C la {date}',
  'Selected all {count} invoices': { one: 'S-a selectat {count} factură', few: 'S-au selectat toate cele {count} facturi', other: 'S-au selectat toate cele {count} de facturi' },
  'Failed to select all invoices': 'Nu s-au putut selecta toate facturile',
  'Failed to export invoices': 'Facturile nu au putut fi exportate',
  'Failed to print invoices': 'Facturile nu au putut fi tipărite',
  '{count} invoice(s) sent to 1C': { one: '{count} factură trimisă în 1C', few: '{count} facturi trimise în 1C', other: '{count} de facturi trimise în 1C' },
  'Only issued invoices can be sent to 1C': 'Doar facturile emise pot fi trimise în 1C',
  '{count} invoice(s) skipped (not issued)': { one: '{count} factură omisă (neemisă)', few: '{count} facturi omise (neemise)', other: '{count} de facturi omise (neemise)' },
  'Export to 1C failed': 'Exportul în 1C a eșuat',
  '1C export data copied to clipboard': 'Datele de export 1C au fost copiate în clipboard',
  'Invoice number cannot be empty': 'Numărul facturii nu poate fi gol',
  'Invoice number updated successfully': 'Numărul facturii a fost actualizat cu succes',
  'Failed to update invoice number': 'Numărul facturii nu a putut fi actualizat',
  'Syncing {count} selected invoice(s)...': { one: 'Se sincronizează {count} factură selectată...', few: 'Se sincronizează {count} facturi selectate...', other: 'Se sincronizează {count} de facturi selectate...' },
  'Syncing all invoices...': 'Se sincronizează toate facturile...',
  'Updated {updated} invoice(s). {total} total with mismatches.': 'Facturi actualizate: {updated}. Total cu diferențe: {total}.',
  'Invoice number is required': 'Numărul facturii este obligatoriu',
  'Invoice {number} created successfully': 'Factura {number} a fost creată cu succes',
  'Failed to create invoice': 'Factura nu a putut fi creată',
  'Invoice sent to 1C successfully': 'Factura a fost trimisă în 1C cu succes',
  'Invoice must be issued before it can be sent to 1C': 'Factura trebuie emisă înainte de a putea fi trimisă în 1C',
  'Failed to export invoice': 'Factura nu a putut fi exportată',
  'No invoices to send': 'Nicio factură de trimis',
  'Invoice Management': 'Gestionare facturi',
  'Application Error': 'Eroare de aplicație',
  'Reload Page': 'Reîncarcă pagina',
  'Loading invoices...': 'Se încarcă facturile...',
  'Sent': 'Trimis',
  'Click to resend': 'Apasă pentru a retrimite',
  'Send It': 'Trimite',
  'Invoice #': 'Factură #',
  'Invoice Date': 'Data facturii',
  'Payment': 'Plată',
  'Balance Due': 'Rest de plată',
  'Click to record receipt': 'Apasă pentru a înregistra încasarea',
  'Record payment from customer': 'Înregistrează plata de la client',
  '1C Export': 'Export 1C',
  'Amount search — click to switch to text': 'Căutare după sumă — apasă pentru a trece la text',
  'Text search — click to search by amount (£)': 'Căutare text — apasă pentru a căuta după sumă (£)',
  'Search by amount...': 'Caută după sumă...',
  'Search invoices...': 'Caută facturi...',
  '{count} selected': { one: '{count} selectat', few: '{count} selectate', other: '{count} selectate' },
  'Custom Export': 'Export personalizat',
  'Sync mismatches for {count} selected': { one: 'Sincronizează diferențele pentru {count} factură selectată', few: 'Sincronizează diferențele pentru {count} facturi selectate', other: 'Sincronizează diferențele pentru {count} de facturi selectate' },
  'Sync mismatches for all invoices': 'Sincronizează diferențele pentru toate facturile',
  'Sync ({count})': 'Sincronizează ({count})',
  'Sync Mismatches': 'Sincronizează diferențele',
  'Create new invoice': 'Creează factură nouă',
  'Create Invoice': 'Creează factură',
  'Send {count} selected invoice(s) to 1C': { one: 'Trimite {count} factură selectată în 1C', few: 'Trimite {count} facturi selectate în 1C', other: 'Trimite {count} de facturi selectate în 1C' },
  'Send all {count} unsent issued invoices to 1C': { one: 'Trimite {count} factură emisă netrimisă în 1C', few: 'Trimite toate cele {count} facturi emise netrimise în 1C', other: 'Trimite toate cele {count} de facturi emise netrimise în 1C' },
  'Send Selected ({count})': 'Trimite selectatele ({count})',
  'Send All ({count})': 'Trimite toate ({count})',
  'No customers match your search': 'Niciun client nu corespunde căutării',
  'Picking Match': 'Potrivire culegere',
  'Any Mismatch': 'Orice diferență',
  'Missing (Lost Revenue)': 'Lipsă (venit pierdut)',
  'Extra Items': 'Articole în plus',
  'No Mismatch': 'Fără diferențe',
  'Reset all filters': 'Resetează toate filtrele',
  'No invoices found matching your criteria.': 'Nu s-au găsit facturi care să corespundă criteriilor.',
  'Showing {from} to {to} of': 'Se afișează {from}–{to} din',
  'Click to select all filtered invoices': 'Apasă pentru a selecta toate facturile filtrate',
  'invoices': 'facturi',
  '{count} per page': '{count} pe pagină',
  '1C Export Result': 'Rezultat export 1C',
  'Exported {count} invoice(s) to 1C format': { one: 'S-a exportat {count} factură în format 1C', few: 'S-au exportat {count} facturi în format 1C', other: 'S-au exportat {count} de facturi în format 1C' },
  'Copy JSON': 'Copiază JSON',
  'No customers found': 'Nu s-au găsit clienți',
  'auto-calculated': 'calculat automat',
  'Optional notes...': 'Note opționale...',
  'Please select an invoice': 'Selectează o factură',
  'Please enter a discount amount': 'Introdu valoarea reducerii',
  'Discount amount cannot exceed invoice balance': 'Valoarea reducerii nu poate depăși soldul facturii',
  'Please select at least one item to credit': 'Selectează cel puțin un articol de creditat',
  'Credit note created successfully': 'Nota de credit a fost creată cu succes',
  'Failed to create credit note': 'Nota de credit nu a putut fi creată',
  'Search customer...': 'Caută client...',
  'Type to search customers': 'Scrie pentru a căuta clienți',
  'Reason for credit note...': 'Motivul notei de credit...',
  'Invoice Total': 'Total factură',
  'Already credited: £{amount}': 'Deja creditat: £{amount}',
  'Invoice Balance': 'Sold factură',
  'Cannot exceed invoice balance': 'Nu poate depăși soldul facturii',
  'After applying this discount:': 'După aplicarea acestei reduceri:',
  'New Balance:': 'Sold nou:',
  'Discount credit note': 'Notă de credit pentru reducere',
  'Create Credit Note': 'Creează notă de credit',
  'Line resolved': 'Linie rezolvată',
  'Failed to resolve line': 'Linia nu a putut fi rezolvată',
  '(no id)': '(fără id)',
  'Product ID': 'ID produs',
  'Unit ID (opt)': 'ID unitate (opț.)',
  'Resolving…': 'Se rezolvă…',
  'Resolve': 'Rezolvă',
  'Disc. Price:': 'Preț redus:',
  'Disc. Price': 'Preț redus',
  'Decrease by {step}': 'Scade cu {step}',
  'Increase by {step}': 'Crește cu {step}',
  'Alcohol items moved to order #{number} ({warehouse}).': 'Articolele cu alcool au fost mutate în comanda #{number} ({warehouse}).',
  'Picking list {number} created successfully': 'Lista de culegere {number} a fost creată cu succes',
  'No items to refill prices for': 'Niciun articol pentru care să se recompleteze prețurile',
  'Prices refilled for new customer': 'Prețurile au fost recompletate pentru noul client',
  'Failed to refill prices': 'Prețurile nu au putut fi recompletate',
  'Error updating order status': 'Eroare la actualizarea stării comenzii',
  'Failed to reactivate picking': 'Culegerea nu a putut fi reactivată',
  'Error reactivating picking': 'Eroare la reactivarea culegerii',
  'Loading order details...': 'Se încarcă detaliile comenzii...',
  'Order not found': 'Comanda nu a fost găsită',
  'Copy Order': 'Copiază comanda',
  'New Order': 'Comandă nouă',
  'Click to reapply prices': 'Apasă pentru a reaplica prețurile',
  "Customer's branch (automatic)": 'Filiala clientului (automat)',
  'Locked after picking. Cancel the picking to change the branch.': 'Blocat după culegere. Anulează culegerea pentru a schimba filiala.',
  'Back to Orders': 'Înapoi la comenzi',
  'Consolidated': 'Consolidată',
  'Imported': 'Importată',
  'Total: £{amount}': 'Total: £{amount}',
  'Create Picking List': 'Creează lista de culegere',
  'Create Order': 'Creează comanda',
  'Dismiss': 'Închide',
  'Order Details': 'Detalii comandă',
  'Fulfillment': 'Onorare',
  'Fulfillment Type': 'Tip onorare',
  'Internal Delivery': 'Livrare proprie',
  'Customer Pickup': 'Ridicare de către client',
  '3rd Party Shipping': 'Expediere prin terți',
  '— Not set —': '— Nesetat —',
  '{name} (not a branch)': '{name} (nu este filială)',
  'Pickup Date': 'Data ridicării',
  'Delivery Date': 'Data livrării',
  'Delivery Address': 'Adresa de livrare',
  'No address specified': 'Nicio adresă specificată',
  'Add notes about this order...': 'Adaugă note despre această comandă...',
  'Exported': 'Exportată',
  'Picking Information': 'Informații culegere',
  'Picking Number': 'Număr culegere',
  'Click to reactivate picking': 'Apasă pentru a reactiva culegerea',
  '(Click to reactivate)': '(Apasă pentru a reactiva)',
  '{picked} / {total} items': '{picked} / {total} articole',
  '{count} line(s) need review': { one: '{count} linie necesită verificare', few: '{count} linii necesită verificare', other: '{count} de linii necesită verificare' },
  'These lines from the imported order could not be matched to a product/unit. Pick the correct product to add them to the order.': 'Aceste linii din comanda importată nu au putut fi asociate cu un produs/unitate. Alege produsul corect pentru a le adăuga în comandă.',
  'Order Items ({count})': 'Articole comandă ({count})',
  'Refill prices based on customer price type (or default prices if no customer)': 'Recompletează prețurile după tipul de preț al clientului (sau prețurile implicite dacă nu există client)',
  'Refill Prices': 'Recompletează prețurile',
  'Recalculate discounts for all items based on current customer and quantities': 'Recalculează reducerile pentru toate articolele în funcție de clientul și cantitățile curente',
  'Calculating...': 'Se calculează...',
  'Barcode:': 'Cod de bare:',
  'Stock:': 'Stoc:',
  'Only orders with "Pending" status can be edited': 'Doar comenzile cu starea „În așteptare” pot fi editate',
  'Please select orders to print': 'Selectează comenzile de tipărit',
  'Please allow popups to enable printing': 'Permite ferestrele pop-up pentru a putea tipări',
  'Print dialog opened for {count} orders': { one: 'Fereastra de tipărire a fost deschisă pentru {count} comandă', few: 'Fereastra de tipărire a fost deschisă pentru {count} comenzi', other: 'Fereastra de tipărire a fost deschisă pentru {count} de comenzi' },
  'Failed to prepare orders for printing': 'Comenzile nu au putut fi pregătite pentru tipărire',
  'Please select orders to update': 'Selectează comenzile de actualizat',
  'Please select a delivery date': 'Selectează o dată de livrare',
  'Updated {orders} orders, {pickings} pickings, {deliveries} deliveries': 'Actualizate: {orders} comenzi, {pickings} culegeri, {deliveries} livrări',
  'Failed to update delivery dates': 'Datele de livrare nu au putut fi actualizate',
  'Cannot generate picking for selected orders': 'Nu se poate genera culegerea pentru comenzile selectate',
  'Created consolidated picking for {count} order(s)': { one: 'S-a creat culegerea consolidată pentru {count} comandă', few: 'S-a creat culegerea consolidată pentru {count} comenzi', other: 'S-a creat culegerea consolidată pentru {count} de comenzi' },
  'Created {count} picking(s)': { one: 'S-a creat {count} culegere', few: 'S-au creat {count} culegeri', other: 'S-au creat {count} de culegeri' },
  '{count} order(s) skipped (already have picking)': { one: '{count} comandă omisă (are deja culegere)', few: '{count} comenzi omise (au deja culegere)', other: '{count} de comenzi omise (au deja culegere)' },
  '{count} order(s) failed': { one: '{count} comandă a eșuat', few: '{count} comenzi au eșuat', other: '{count} de comenzi au eșuat' },
  'Failed to generate picking': 'Culegerea nu a putut fi generată',
  'Order ID': 'ID comandă',
  'Created Date': 'Data creării',
  'Copy this order': 'Copiază această comandă',
  'Order Management': 'Gestionare comenzi',
  'Change Delivery Date': 'Schimbă data livrării',
  'Update delivery date for 1 selected order.': 'Actualizează data livrării pentru 1 comandă selectată.',
  'Update delivery date for {count} selected orders.': { one: 'Actualizează data livrării pentru {count} comandă selectată.', few: 'Actualizează data livrării pentru {count} comenzi selectate.', other: 'Actualizează data livrării pentru {count} de comenzi selectate.' },
  'This will also update related picking and delivery documents.': 'Se vor actualiza și documentele de culegere și de livrare asociate.',
  'New Delivery Date': 'Data nouă de livrare',
  'Update Date': 'Actualizează data',
  'Show Filters': 'Arată filtrele',
  'Hide Invoiced': 'Ascunde facturatele',
  'No Inv.': 'Nefact.',
  'Customer...': 'Client...',
  'Import Orders (Copy-Paste, File Upload, or Worksheets)': 'Importă comenzi (copiere-lipire, încărcare fișier sau foi de lucru)',
  'Import Orders': 'Importă comenzi',
  'Preparing print...': 'Se pregătește tipărirea...',
  'Print Selected ({count})': 'Tipărește selectatele ({count})',
  'Printing...': 'Se tipărește...',
  'Change Delivery Date for {count} orders': { one: 'Schimbă data livrării pentru {count} comandă', few: 'Schimbă data livrării pentru {count} comenzi', other: 'Schimbă data livrării pentru {count} de comenzi' },
  'Change Date ({count})': 'Schimbă data ({count})',
  'Generate Consolidated Picking ({count} orders)': { one: 'Generează culegere consolidată ({count} comandă)', few: 'Generează culegere consolidată ({count} comenzi)', other: 'Generează culegere consolidată ({count} de comenzi)' },
  'Generate Picking': 'Generează culegerea',
  'Picking ({count})': 'Culegere ({count})',
  'Delivery': 'Livrare',
  'Collection': 'Ridicare',
  'Shipping': 'Expediere',
  'No orders found matching your criteria.': 'Nu s-au găsit comenzi care să corespundă criteriilor.',
  'Create New Order': 'Creează comandă nouă',
  'Showing {from} to {to} of {total} orders': 'Se afișează {from}–{to} din {total} comenzi',
  'Showing {from} to {to} of {total} leads': 'Se afișează {from}–{to} din {total} potențiali clienți',
  're-priced {count} items': { one: 'prețuri reaplicate la {count} articol', few: 'prețuri reaplicate la {count} articole', other: 'prețuri reaplicate la {count} de articole' },
  're-priced {count} item': 'preț reaplicat la {count} articol',
  'Discounts applied to {count} items': { one: 'Reduceri aplicate la {count} articol', few: 'Reduceri aplicate la {count} articole', other: 'Reduceri aplicate la {count} de articole' },
  'Discounts applied to {count} item': 'Reduceri aplicate la {count} articol',
  'Click to enable edits': 'Apasă pentru a activa editarea',
  'Click to mark corrections complete': 'Apasă pentru a marca corecțiile ca finalizate',
  'Product unmatched': 'Produsul a fost dezasociat',
  'Product matched': 'Produsul a fost potrivit',
  'Scraped Products': 'Produse extrase',
  'Match Scraped Product': 'Potrivește produs extras',
  'Supplier products matched to this product from website scraping.': 'Produse ale furnizorilor potrivite cu acest produs prin extragerea de pe site-uri.',
  'Search Unmatched Scraped Products': 'Caută produse extrase nepotrivite',
  'Search by name, SKU, or supplier code...': 'Caută după nume, SKU sau cod furnizor...',
  'Code:': 'Cod:',
  'Supplier:': 'Furnizor:',
  'Match': 'Potrivește',
  'No unmatched scraped products found': 'Nu s-au găsit produse extrase nepotrivite',
  'Type to search for unmatched scraped products': 'Scrie pentru a căuta produse extrase nepotrivite',
  'No scraped products matched to this product yet.': 'Încă nu există produse extrase potrivite cu acest produs.',
  'Image': 'Imagine',
  'Name': 'Nume',
  'In Stock': 'În stoc',
  'Yes': 'Da',
  'No': 'Nu',
  'Unmatch this product': 'Anulează potrivirea acestui produs',
  'Adjustment {adjustmentNumber} created': 'Ajustarea {adjustmentNumber} a fost creată',
  'Failed to create stock adjustment': 'Ajustarea de stoc nu a putut fi creată',
  'Retro-fill complete: {updated} picking movement(s) reassigned': 'Completare retroactivă finalizată: mișcări de culegere reatribuite: {updated}',
  'Failed to fill missing batches': 'Completarea loturilor lipsă a eșuat',
  'Cleared {updated} picking movement(s) from this batch': 'Mișcări de culegere eliberate din acest lot: {updated}',
  'No better batch found — overdraft remains': 'Nu s-a găsit un lot mai bun — depășirea rămâne',
  'Failed to clear overdraft': 'Eliminarea depășirii a eșuat',
  'Failed to scan for issues': 'Scanarea pentru probleme a eșuat',
  '{count} duplicates removed': { one: '{count} duplicat eliminat', few: '{count} duplicate eliminate', other: '{count} de duplicate eliminate' },
  '{count} orphan batches removed': { one: '{count} lot orfan eliminat', few: '{count} loturi orfane eliminate', other: '{count} de loturi orfane eliminate' },
  '{count} movements nulled': { one: '{count} mișcare anulată', few: '{count} mișcări anulate', other: '{count} de mișcări anulate' },
  '{count} movements split': { one: '{count} mișcare divizată', few: '{count} mișcări divizate', other: '{count} de mișcări divizate' },
  'Cleanup complete, no issues found': 'Curățare finalizată, nu s-au găsit probleme',
  'Failed to execute deep cleanup': 'Curățarea completă a eșuat',
  'Failed to load product details': 'Detaliile produsului nu au putut fi încărcate',
  'Badge removed': 'Badge eliminat',
  'Badge added': 'Badge adăugat',
  'Failed to update badges': 'Badge-urile nu au putut fi actualizate',
  'Badge name is required': 'Numele badge-ului este obligatoriu',
  'Badge created successfully': 'Badge creat cu succes',
  'Failed to create badge': 'Badge-ul nu a putut fi creat',
  'Badge updated successfully': 'Badge actualizat cu succes',
  'Failed to update badge': 'Badge-ul nu a putut fi actualizat',
  'Are you sure you want to delete this badge? It will be removed from all products.': 'Sigur vrei să ștergi acest badge? Va fi eliminat de pe toate produsele.',
  'Badge deleted successfully': 'Badge șters cu succes',
  'Failed to delete badge': 'Badge-ul nu a putut fi șters',
  'Product updated successfully': 'Produsul a fost actualizat cu succes',
  '{error}\n\nAre you sure you want to proceed?': '{error}\n\nSigur vrei să continui?',
  'Failed to update product': 'Produsul nu a putut fi actualizat',
  'Please fill in all fields': 'Completează toate câmpurile',
  'Extra unit added successfully': 'Unitatea suplimentară a fost adăugată cu succes',
  'Failed to add extra unit': 'Unitatea suplimentară nu a putut fi adăugată',
  'Extra unit updated successfully': 'Unitatea suplimentară a fost actualizată cu succes',
  'Failed to update extra unit': 'Unitatea suplimentară nu a putut fi actualizată',
  'Are you sure you want to delete this extra unit?': 'Sigur vrei să ștergi această unitate suplimentară?',
  'Extra unit removed successfully': 'Unitatea suplimentară a fost eliminată cu succes',
  'Failed to remove extra unit': 'Unitatea suplimentară nu a putut fi eliminată',
  'HS Code, Country of Origin, and Customs Unit are required': 'Codul HS, țara de origine și unitatea vamală sunt obligatorii',
  'Customs data saved': 'Datele vamale au fost salvate',
  'Failed to save customs data': 'Datele vamale nu au putut fi salvate',
  'Are you sure you want to delete customs data?': 'Sigur vrei să ștergi datele vamale?',
  'Customs data deleted': 'Datele vamale au fost șterse',
  'Failed to delete customs data': 'Datele vamale nu au putut fi șterse',
  'Images uploaded successfully': 'Imaginile au fost încărcate cu succes',
  'Failed to upload images': 'Imaginile nu au putut fi încărcate',
  'Image deleted successfully': 'Imaginea a fost ștearsă cu succes',
  'Failed to delete image': 'Imaginea nu a putut fi ștearsă',
  'Primary image updated successfully': 'Imaginea principală a fost actualizată cu succes',
  'Failed to set primary image': 'Imaginea principală nu a putut fi setată',
  'Barcode added successfully': 'Codul de bare a fost adăugat cu succes',
  'Failed to add barcode': 'Codul de bare nu a putut fi adăugat',
  'Barcode updated successfully': 'Codul de bare a fost actualizat cu succes',
  'Failed to update barcode': 'Codul de bare nu a putut fi actualizat',
  'Are you sure you want to delete this barcode?': 'Sigur vrei să ștergi acest cod de bare?',
  'Barcode deleted successfully': 'Codul de bare a fost șters cu succes',
  'Failed to delete barcode': 'Codul de bare nu a putut fi șters',
  'Supplier mapping added successfully': 'Asocierea cu furnizorul a fost adăugată cu succes',
  'Failed to add supplier mapping': 'Asocierea cu furnizorul nu a putut fi adăugată',
  'Supplier mapping updated successfully': 'Asocierea cu furnizorul a fost actualizată cu succes',
  'Failed to update supplier mapping': 'Asocierea cu furnizorul nu a putut fi actualizată',
  'Are you sure you want to delete this supplier mapping?': 'Sigur vrei să ștergi această asociere cu furnizorul?',
  'Supplier mapping deleted successfully': 'Asocierea cu furnizorul a fost ștearsă cu succes',
  'Failed to delete supplier mapping': 'Asocierea cu furnizorul nu a putut fi ștearsă',
  'Component product, quantity and unit are required': 'Produsul component, cantitatea și unitatea sunt obligatorii',
  'Kit component added': 'Componenta kitului a fost adăugată',
  'Failed to add kit component': 'Componenta kitului nu a putut fi adăugată',
  'Kit component updated': 'Componenta kitului a fost actualizată',
  'Failed to update kit component': 'Componenta kitului nu a putut fi actualizată',
  'Kit component removed': 'Componenta kitului a fost eliminată',
  'Failed to remove kit component': 'Componenta kitului nu a putut fi eliminată',
  'Loading product details...': 'Se încarcă detaliile produsului...',
  'Breakdown': 'Defalcare',
  'Stock by Warehouse': 'Stoc pe depozite',
  'No warehouse': 'Fără depozit',
  'Reassign picking batches via FEFO so red/orange balances clear when possible': 'Reatribuie loturile de culegere prin FEFO, astfel încât soldurile roșii/portocalii să dispară când este posibil',
  'Filling…': 'Se completează…',
  'Fill Missing': 'Completează lipsurile',
  'Mark a matching extra unit as the sugar tax unit below, or this product cannot be included in levy reports.': 'Marchează mai jos o unitate suplimentară potrivită ca unitate pentru taxa pe zahăr, altfel acest produs nu poate fi inclus în rapoartele de taxă.',
  'Edit Product: {name}': 'Editează produsul: {name}',
  '* Required fields': '* Câmpuri obligatorii',
  'Product Details': 'Detalii produs',
  'Supplier Mappings': 'Asocieri furnizori',
  'Media': 'Media',
  'Badges': 'Badge-uri',
  'Composition': 'Compoziție',
  'Price History': 'Istoric prețuri',
  'Movements': 'Mișcări',
  'Customs': 'Vamă',
  'Auto-generate next available SKU based on category range': 'Generează automat următorul SKU disponibil din intervalul categoriei',
  'Select a category first - SKU ranges are configured per category': 'Selectează mai întâi o categorie - intervalele SKU sunt configurate pe categorie',
  'Generated SKU: {sku}': 'SKU generat: {sku}',
  'Failed to generate SKU': 'SKU-ul nu a putut fi generat',
  'Managed in Barcodes tab': 'Se gestionează în tabul Coduri de bare',
  'No primary barcode — set in Barcodes tab': 'Niciun cod de bare principal — setează-l în tabul Coduri de bare',
  'Select Category': 'Selectează categoria',
  'Select Group': 'Selectează grupa',
  'Select Brand': 'Selectează marca',
  'Select Unit': 'Selectează unitatea',
  'Price (£)': 'Preț (£)',
  'Inventory': 'Stocabil',
  'Kit': 'Kit',
  'Non-Stock': 'Nestocabil',
  'Service': 'Serviciu',
  '-- Select VAT Rate --': '-- Selectează cota TVA --',
  '-- Not liable --': '-- Nu se aplică --',
  '{name} (£{amount} per {unit})': '{name} (£{amount} per {unit})',
  'Finished Products': 'Produse finite',
  'Semi Products': 'Semifabricate',
  'Raw Materials': 'Materii prime',
  'Packaging': 'Ambalaje',
  'Spices': 'Condimente',
  'Casings': 'Membrane',
  'Purchase': 'Achiziție',
  'Both': 'Ambele',
  'Track Stock': 'Urmărește stocul',
  'Min Quantity': 'Cantitate minimă',
  'Step Quantity': 'Pas cantitate',
  'Landed Cost Allocation Scope': 'Domeniul de alocare a costului accesoriu',
  'When allocating this service on a purchase invoice, the cost is spread only across items matching any of the selections below. Leave everything empty to allocate to all items.': 'La alocarea acestui serviciu pe o factură de achiziție, costul se repartizează doar pe articolele care corespund oricăreia dintre selecțiile de mai jos. Lasă totul gol pentru a aloca pe toate articolele.',
  'Specific Products': 'Produse specifice',
  'Kit Components': 'Componente kit',
  'Add Component': 'Adaugă componentă',
  'Save the product first to manage components': 'Salvează mai întâi produsul pentru a gestiona componentele',
  'No components added yet. Add products that make up this kit.': 'Încă nu s-au adăugat componente. Adaugă produsele care alcătuiesc acest kit.',
  'Save the product as a Kit to start adding components.': 'Salvează produsul ca Kit pentru a începe să adaugi componente.',
  'Search Product': 'Caută produs',
  'Search by name or SKU...': 'Caută după nume sau SKU...',
  'Select unit': 'Selectează unitatea',
  'Disabled (Hide from storefront)': 'Dezactivat (ascuns din magazinul online)',
  'Available in Sales Documents': 'Disponibil în documentele de vânzare',
  'Hide Base Unit': 'Ascunde unitatea de bază',
  'Imported Product': 'Produs importat',
  'Price Types': 'Tipuri de preț',
  'Formula': 'Formulă',
  'margin {value}%': 'marjă {value}%',
  'markup {value}%': 'adaos {value}%',
  'No price types configured.': 'Niciun tip de preț configurat.',
  'Extra Units': 'Unități suplimentare',
  'Add Extra Unit': 'Adaugă unitate suplimentară',
  'Edit Extra Unit': 'Editează unitatea suplimentară',
  'Add New Extra Unit': 'Adaugă o unitate suplimentară nouă',
  'Conversion Factor': 'Factor de conversie',
  'e.g., 10': 'ex.: 10',
  'Skip Tray (Box Picking)': 'Fără tavă (culegere pe cutie)',
  'Box Tare (kg):': 'Tara cutiei (kg):',
  'Sugar Tax ({unit} per {base})': 'Taxa pe zahăr ({unit} per {base})',
  'base unit': 'unitate de bază',
  'The sugar tax unit must be {unit} to match the {band} band.': 'Unitatea pentru taxa pe zahăr trebuie să fie {unit} pentru a corespunde categoriei {band}.',
  'Box Picking (Tare: {weight}kg)': 'Culegere pe cutie (tara: {weight}kg)',
  'Box Picking': 'Culegere pe cutie',
  'Sugar Tax': 'Taxa pe zahăr',
  'Edit extra unit': 'Editează unitatea suplimentară',
  'Delete extra unit': 'Șterge unitatea suplimentară',
  'No extra units configured for this product.': 'Nicio unitate suplimentară configurată pentru acest produs.',
  'Supplier Product Mappings': 'Asocieri produs–furnizor',
  'Add Mapping': 'Adaugă asociere',
  'Manage supplier-specific SKUs and product names. This helps with invoice imports when suppliers use different names.': 'Gestionează SKU-urile și denumirile de produs specifice furnizorilor. Ajută la importul facturilor când furnizorii folosesc alte denumiri.',
  'Edit Supplier Mapping': 'Editează asocierea cu furnizorul',
  'Add New Supplier Mapping': 'Adaugă o asociere nouă cu furnizorul',
  'Supplier *': 'Furnizor *',
  'Select a supplier': 'Selectează un furnizor',
  'Supplier SKU': 'SKU furnizor',
  'e.g., SUP-12345': 'ex.: SUP-12345',
  'Supplier Product Name': 'Denumire produs la furnizor',
  'e.g., Premium Widget XL': 'ex.: Premium Widget XL',
  'Supplier Unit Cost': 'Cost unitar furnizor',
  'Additional notes...': 'Note suplimentare...',
  'Preferred Supplier': 'Furnizor preferat',
  'Unit Cost': 'Cost unitar',
  'Preferred': 'Preferat',
  'No supplier mappings configured. Click "Add Mapping" to create one.': 'Nicio asociere cu furnizori configurată. Apasă „Adaugă asociere” pentru a crea una.',
  'Product Barcodes': 'Coduri de bare produs',
  'Add Barcode': 'Adaugă cod de bare',
  'Add multiple barcodes for this product (pallet, box, piece). Mark one as primary.': 'Adaugă mai multe coduri de bare pentru acest produs (palet, cutie, bucată). Marchează unul ca principal.',
  'Edit Barcode': 'Editează codul de bare',
  'Add New Barcode': 'Adaugă un cod de bare nou',
  'Barcode Value *': 'Valoare cod de bare *',
  'e.g., 1234567890123': 'ex.: 1234567890123',
  'Quantity Per Unit': 'Cantitate per unitate',
  'Quantity Barcode': 'Cod de bare cu cantitate',
  'Primary Barcode': 'Cod de bare principal',
  'Primary': 'Principal',
  'No barcodes configured. Click "Add Barcode" to create one.': 'Niciun cod de bare configurat. Apasă „Adaugă cod de bare” pentru a crea unul.',
  'Product Images': 'Imagini produs',
  'Upload Images': 'Încarcă imagini',
  'Product image {number}': 'Imagine produs {number}',
  'Set as primary': 'Setează ca principală',
  'Delete image': 'Șterge imaginea',
  'No images uploaded for this product.': 'Nicio imagine încărcată pentru acest produs.',
  'Click here to upload images': 'Apasă aici pentru a încărca imagini',
  'Product Badges': 'Badge-uri produs',
  'Create New Badge': 'Creează badge nou',
  'Assign badges to display on this product card (e.g., New, Best Seller, Frozen).': 'Atribuie badge-uri care să apară pe cardul acestui produs (ex.: Nou, Cel mai vândut, Congelat).',
  'Edit Badge': 'Editează badge-ul',
  'Name *': 'Nume *',
  'e.g., Best Seller': 'ex.: Cel mai vândut',
  'Background Color': 'Culoare fundal',
  'Text Color': 'Culoare text',
  'Position': 'Poziție',
  'Badge Preview': 'Previzualizare badge',
  'Update Badge': 'Actualizează badge-ul',
  'Create Badge': 'Creează badge',
  'Assigned Badges': 'Badge-uri atribuite',
  'Remove badge': 'Elimină badge-ul',
  'No badges assigned to this product.': 'Niciun badge atribuit acestui produs.',
  'Available Badges (click to toggle)': 'Badge-uri disponibile (apasă pentru a comuta)',
  'Edit badge': 'Editează badge-ul',
  'Delete badge': 'Șterge badge-ul',
  'No badges created yet.': 'Încă nu s-au creat badge-uri.',
  'Create your first badge': 'Creează primul badge',
  'Composition Coefficients': 'Coeficienți de compoziție',
  'Nutritional composition percentages used in BOM theoretical calculations.': 'Procentele compoziției nutriționale folosite în calculele teoretice ale rețetei.',
  'e.g. 20.50': 'ex.: 20.50',
  'e.g. 15.00': 'ex.: 15.00',
  'e.g. 60.00': 'ex.: 60.00',
  'e.g. 5.00': 'ex.: 5.00',
  'Target Specification Ranges': 'Intervale de specificație țintă',
  'Acceptable ranges for the finished product. Used to generate alerts in BOM composition analysis.': 'Intervale acceptabile pentru produsul finit. Folosite pentru a genera alerte în analiza compoziției rețetei.',
  'Min': 'Min',
  'Composition specifications are not applicable for packaging products.': 'Specificațiile de compoziție nu se aplică produselor de ambalare.',
  'Market Value Settings': 'Setări valoare de piață',
  'Used for cost allocation in disassembly BOMs. Priority: Reference Product > % of Input > Residual': 'Folosită pentru alocarea costului în rețetele de dezasamblare. Prioritate: Produs de referință > % din intrare > Rezidual',
  'Not set': 'Nesetat',
  'Reference Product': 'Produs de referință',
  'Input Price %': '% din prețul de intrare',
  'Residual': 'Rezidual',
  'Default MV source when this product appears as a BOM output': 'Sursa implicită a valorii de piață când acest produs apare ca ieșire într-o rețetă',
  'Search purchased equivalent...': 'Caută echivalentul achiziționat...',
  "Purchased equivalent — its cost price = this product's market value": 'Echivalentul achiziționat — prețul său de cost = valoarea de piață a acestui produs',
  'e.g., 60': 'ex.: 60',
  'Fallback: MV = input cost/kg x this %': 'Alternativă: valoare de piață = cost intrare/kg x acest %',
  'Bills of Materials': 'Rețete',
  'BOMs associated with this product.': 'Rețete asociate cu acest produs.',
  'Yield:': 'Randament:',
  'Cost: £': 'Cost: £',
  '{count} components': { one: '{count} componentă', few: '{count} componente', other: '{count} de componente' },
  'No BOMs found for this product.': 'Nu s-au găsit rețete pentru acest produs.',
  'Create your first BOM': 'Creează prima rețetă',
  'Used In BOMs': 'Folosit în rețete',
  'BOMs where this product appears as a component.': 'Rețete în care acest produs apare ca componentă.',
  'Search by price type or document...': 'Caută după tipul de preț sau document...',
  'Purchase Invoice': 'Factură de achiziție',
  'Initial': 'Inițial',
  'Changes only': 'Doar modificările',
  'No price history records found': 'Nu s-au găsit înregistrări în istoricul prețurilor',
  'records': 'înregistrări',
  'Search by reference, batch, or notes...': 'Caută după referință, lot sau note...',
  'Reassign picks with NULL, empty, or overdrawn batches to eligible earlier-dated receipts': 'Reatribuie culegerile cu loturi NULL, goale sau depășite la recepții eligibile cu dată anterioară',
  'Filling...': 'Se completează...',
  'Goods Receipt': 'Recepție marfă',
  'Order Picking': 'Culegere comandă',
  'Picking Document': 'Document de culegere',
  'Order Packing': 'Ambalare comandă',
  'Stock Adjustment': 'Ajustare de stoc',
  'Location Transfer': 'Transfer între locații',
  'Expiry Removal': 'Scoatere la expirare',
  'Damage Write-off': 'Casare pentru deteriorare',
  'Cycle Count': 'Inventar ciclic',
  'Production Output': 'Ieșire din producție',
  'Production Input': 'Intrare în producție',
  'All Directions': 'Toate direcțiile',
  'In': 'Intrare',
  'Out': 'Ieșire',
  'No movement records found': 'Nu s-au găsit înregistrări de mișcări',
  'Exp.': 'Exp.',
  'Batches & Stock Levels': 'Loturi și niveluri de stoc',
  'Deep Cleanup': 'Curățare completă',
  'Deep Cleanup Scan Results': 'Rezultatele scanării pentru curățare completă',
  'No issues found': 'Nu s-au găsit probleme',
  'Stock data is clean for this product': 'Datele de stoc sunt curate pentru acest produs',
  'Duplicate Movements ({count} to remove)': 'Mișcări duplicate ({count} de eliminat)',
  'ID': 'ID',
  'Orphan Batches ({count} to remove)': 'Loturi orfane ({count} de eliminat)',
  'Current': 'Curent',
  'Picking Items': 'Articole culegere',
  'Over-Allocated Movements ({count} to fix)': 'Mișcări supraalocate ({count} de corectat)',
  'Split': 'Divizează',
  'Unassign batch': 'Dezatribuie lotul',
  'Executing...': 'Se execută...',
  'Execute Cleanup': 'Execută curățarea',
  'No batches found for this product': 'Nu s-au găsit loturi pentru acest produs',
  'Received:': 'Recepționat:',
  'Current:': 'Curent:',
  "Try to reassign this batch's overdrawn picks to a newer eligible positive-stock batch": 'Încearcă să reatribui culegerile care depășesc acest lot unui lot mai nou, eligibil, cu stoc pozitiv',
  'Clearing...': 'Se elimină...',
  'Adjust': 'Ajustează',
  'Warehouse:': 'Depozit:',
  'Expiry:': 'Expirare:',
  'Allocated': 'Alocat',
  'NEGATIVE': 'NEGATIV',
  'Empty': 'Gol',
  'No stock levels recorded': 'Niciun nivel de stoc înregistrat',
  'Movements for this batch': 'Mișcările acestui lot',
  'No movements found': 'Nu s-au găsit mișcări',
  'Direction': 'Direcție',
  'IN': 'INTRARE',
  'OUT': 'IEȘIRE',
  'TRANSFER': 'TRANSFER',
  'Unassigned (No Batch)': 'Neatribuite (fără lot)',
  '{count} movements': { one: '{count} mișcare', few: '{count} mișcări', other: '{count} de mișcări' },
  '{count} movement': '{count} mișcare',
  'These movements have no batch assigned. Use "Fill Missing Batches" after receipting new stock to assign them.': 'Aceste mișcări nu au lot atribuit. Folosește „Completează loturile lipsă” după recepția stocului nou pentru a le atribui.',
  'Unassigned movements': 'Mișcări neatribuite',
  'Customs & Import Data': 'Date vamale și de import',
  'Select HS Code': 'Selectează codul HS',
  'Add new HS Code': 'Adaugă cod HS nou',
  'Code (e.g., 0202.30)': 'Cod (ex.: 0202.30)',
  'HS Code created': 'Codul HS a fost creat',
  'Failed to create HS Code': 'Codul HS nu a putut fi creat',
  'Select Country': 'Selectează țara',
  'e.g., 27.500': 'ex.: 27.500',
  'e.g., 25.000': 'ex.: 25.000',
  'Save Customs Data': 'Salvează datele vamale',
  'Delete Customs Data': 'Șterge datele vamale',
  'Fast': 'Rapid',
  'Medium': 'Mediu',
  'Slow': 'Lent',
  'Dead': 'Fără mișcare',
  'Unclassified': 'Neclasificat',
  'Unranked': 'Neclasat',
  'Any Band': 'Orice categorie',
  'Not Liable': 'Nu se aplică',
  'Any Badge': 'Orice badge',
  'No Badge': 'Fără badge',
  'Tracked': 'Urmărit',
  'Not Tracked': 'Neurmărit',
  'Enabled': 'Activat',
  'Include products with positive stock': 'Include produsele cu stoc pozitiv',
  'Include products with negative stock': 'Include produsele cu stoc negativ',
  'Negative': 'Negativ',
  'Never received — picked with no receipt history': 'Niciodată recepționat — cules fără istoric de recepție',
  'Overdrawn — picks exceed received quantity on a known batch': 'Depășit — culegerile depășesc cantitatea recepționată pe un lot cunoscut',
  'Available — positive stock on non-expired batches': 'Disponibil — stoc pozitiv pe loturi neexpirate',
  'Expired — physical stock on expired batches': 'Expirat — stoc fizic pe loturi expirate',
  'Failed to update': 'Actualizarea a eșuat',
  'Failed to load preview': 'Previzualizarea nu a putut fi încărcată',
  'Are you sure? This will merge all selected products into the target and cannot be easily undone.': 'Ești sigur? Toate produsele selectate vor fi comasate în produsul țintă, iar operația nu poate fi anulată ușor.',
  'Consolidation failed': 'Consolidarea a eșuat',
  'Are you sure you want to permanently delete {count} product(s)?\n\nThis will also delete all related records (orders, stock, movements, etc.) and cannot be undone.': { one: 'Sigur vrei să ștergi definitiv {count} produs?\n\nSe vor șterge și toate înregistrările asociate (comenzi, stoc, mișcări etc.), iar operația nu poate fi anulată.', few: 'Sigur vrei să ștergi definitiv {count} produse?\n\nSe vor șterge și toate înregistrările asociate (comenzi, stoc, mișcări etc.), iar operația nu poate fi anulată.', other: 'Sigur vrei să ștergi definitiv {count} de produse?\n\nSe vor șterge și toate înregistrările asociate (comenzi, stoc, mișcări etc.), iar operația nu poate fi anulată.' },
  'FINAL WARNING: This will permanently delete {count} product(s) and ALL their related data. Type-check: are you absolutely sure?': { one: 'AVERTISMENT FINAL: Se va șterge definitiv {count} produs și TOATE datele asociate. Verificare: ești absolut sigur?', few: 'AVERTISMENT FINAL: Se vor șterge definitiv {count} produse și TOATE datele asociate. Verificare: ești absolut sigur?', other: 'AVERTISMENT FINAL: Se vor șterge definitiv {count} de produse și TOATE datele asociate. Verificare: ești absolut sigur?' },
  'Failed to delete products': 'Produsele nu au putut fi șterse',
  'Select at least one bucket (R, O, G, or X).': 'Selectează cel puțin o categorie (R, O, G sau X).',
  'Adjustment {adjustment_number} created with {items_created} line item(s).': 'Ajustarea {adjustment_number} a fost creată. Linii: {items_created}.',
  'Failed to generate adjustment': 'Ajustarea nu a putut fi generată',
  'Failed to copy product': 'Produsul nu a putut fi copiat',
  'Failed to load prices for the selected price type': 'Prețurile pentru tipul de preț selectat nu au putut fi încărcate',
  "Generate SKUs for {size} selected product(s) without SKU?\nSKUs are assigned based on each product's category range.": 'Generezi SKU-uri pentru produsele selectate fără SKU ({size})?\nSKU-urile se atribuie din intervalul categoriei fiecărui produs.',
  'Failed to generate SKUs': 'SKU-urile nu au putut fi generate',
  'Fill missing batches for {count} selected product(s)?\nReassigns NULL / overdrawn picking movements via FEFO.': { one: 'Completezi loturile lipsă pentru {count} produs selectat?\nReatribuie prin FEFO mișcările de culegere NULL / depășite.', few: 'Completezi loturile lipsă pentru {count} produse selectate?\nReatribuie prin FEFO mișcările de culegere NULL / depășite.', other: 'Completezi loturile lipsă pentru {count} de produse selectate?\nReatribuie prin FEFO mișcările de culegere NULL / depășite.' },
  'Fill missing batches for ALL products with NULL-batch picks, overdrawn batches or out-of-sync stock?\nAuto-detects affected products, reassigns via FEFO and rebuilds stock.': 'Completezi loturile lipsă pentru TOATE produsele cu culegeri fără lot (NULL), loturi depășite sau stoc desincronizat?\nDetectează automat produsele afectate, le reatribuie prin FEFO și reconstruiește stocul.',
  'Failed to start fill job': 'Lucrarea de completare nu a putut fi pornită',
  'Nothing to fill — no NULL picks, overdrawn batches or out-of-sync stock found.': 'Nimic de completat — nu s-au găsit culegeri NULL, loturi depășite sau stoc desincronizat.',
  'Filling missing batches: 0 / {total} processed': 'Se completează loturile lipsă: 0 / {total} procesate',
  'Lost connection to fill job — refresh to see results.': 'Conexiunea cu lucrarea de completare s-a pierdut — reîmprospătează pentru a vedea rezultatele.',
  'Filling missing batches: {processed} / {total} processed · {updated} reassigned': 'Se completează loturile lipsă: {processed} / {total} procesate · {updated} reatribuite',
  'Fill complete: {updated} movement(s) reassigned across {total} product(s).': 'Completare finalizată: mișcări reatribuite: {updated}, produse: {total}.',
  'Fill failed: {error}': 'Completarea a eșuat: {error}',
  'Fill job not found (may have expired).': 'Lucrarea de completare nu a fost găsită (este posibil să fi expirat).',
  'Supplier Price': 'Preț furnizor',
  'Cost Price': 'Preț de cost',
  'Min Qty': 'Cant. min.',
  'Step Qty': 'Pas cant.',
  'Base Unit': 'Unitate de bază',
  'Product Type': 'Tip produs',
  'Restock Method': 'Metodă de reaprovizionare',
  'Loading products...': 'Se încarcă produsele...',
  'Bulk Edit': 'Editare în masă',
  'Consolidate': 'Consolidează',
  'Generate a stock adjustment document for the selected products based on bucket filters': 'Generează un document de ajustare de stoc pentru produsele selectate pe baza filtrelor de categorie',
  'Generate Adjustment': 'Generează ajustarea',
  'Selection mode (when rows selected) OR auto-detect mode (otherwise). Reassigns NULL/overdrawn picking movements via FEFO and rebuilds stock.': 'Mod selecție (când sunt rânduri selectate) SAU mod detectare automată (altfel). Reatribuie prin FEFO mișcările de culegere NULL/depășite și reconstruiește stocul.',
  'Fill Missing Batches ({count})': 'Completează loturile lipsă ({count})',
  'Create Product': 'Creează produs',
  'Manage categories, groups, and SKU ranges': 'Gestionează categoriile, grupele și intervalele SKU',
  'No products found. Try adjusting your filters.': 'Nu s-au găsit produse. Încearcă să ajustezi filtrele.',
  'Showing {from} to {to} of {total} products': 'Se afișează {from}–{to} din {total} produse',
  'Showing {count} products': { one: 'Se afișează {count} produs', few: 'Se afișează {count} produse', other: 'Se afișează {count} de produse' },
  'Showing {count} product': 'Se afișează {count} produs',
  'Display All': 'Afișează tot',
  'Generate Stock Adjustment': 'Generează ajustare de stoc',
  'Select which stock bucket(s) to write off for {count} product(s). One line item per batch/location will be created with quantity set to the negative of the current stock.': { one: 'Selectează categoria (categoriile) de stoc de casat pentru {count} produs. Se va crea câte o linie pe lot/locație, cu cantitatea egală cu negativul stocului curent.', few: 'Selectează categoria (categoriile) de stoc de casat pentru {count} produse. Se va crea câte o linie pe lot/locație, cu cantitatea egală cu negativul stocului curent.', other: 'Selectează categoria (categoriile) de stoc de casat pentru {count} de produse. Se va crea câte o linie pe lot/locație, cu cantitatea egală cu negativul stocului curent.' },
  'Overdrawn — known batch went negative': 'Depășit — un lot cunoscut a ajuns pe negativ',
  'Expired — stock on expired batches': 'Expirat — stoc pe loturi expirate',
  'Notes (optional)': 'Note (opțional)',
  'Why is this adjustment being created?': 'De ce se creează această ajustare?',
  'Generating…': 'Se generează…',
  'Bulk Edit {count} Product(s)': { one: 'Editare în masă: {count} produs', few: 'Editare în masă: {count} produse', other: 'Editare în masă: {count} de produse' },
  'Selecting...': 'Se selectează...',
  'Select All {total} Products': 'Selectează toate cele {total} produse',
  'General': 'General',
  'Leave fields empty to keep current values. Only changed fields will be updated.': 'Lasă câmpurile goale pentru a păstra valorile curente. Se vor actualiza doar câmpurile modificate.',
  'Group / Subgroup': 'Grupă / Subgrupă',
  'A group sets the group and removes any subgroup; a subgroup sets both': 'O grupă setează grupa și elimină orice subgrupă; o subgrupă le setează pe amândouă',
  '-- No Change --': '-- Fără modificare --',
  'Brand': 'Marcă',
  'Inventory Type': 'Tip de stocare',
  'Available in Sales': 'Disponibil la vânzare',
  'Base Unit Visibility': 'Vizibilitate unitate de bază',
  'Show Base Unit': 'Afișează unitatea de bază',
  'Yes - Track Stock': 'Da - urmărește stocul',
  "No - Don't Track": 'Nu - nu urmări',
  'Leave empty for no change': 'Lasă gol pentru nicio modificare',
  'VAT Rate': 'Cotă TVA',
  'Clear VAT Rate': 'Șterge cota TVA',
  'Sugar Tax Band': 'Categorie taxă pe zahăr',
  'Set to Not Liable': 'Setează ca neaplicabil',
  'Yes - Imported': 'Da - importat',
  'No - Not Imported': 'Nu - neimportat',
  'HS Code': 'Cod HS',
  'Country of Origin': 'Țara de origine',
  'Badge Operation': 'Operație badge-uri',
  'Add Badges': 'Adaugă badge-uri',
  'Remove Badges': 'Elimină badge-uri',
  'Replace All': 'Înlocuiește tot',
  'Add selected badges to products (keeps existing badges)': 'Adaugă badge-urile selectate la produse (păstrează badge-urile existente)',
  'Remove selected badges from products': 'Elimină badge-urile selectate de pe produse',
  'Replace all badges with selected badges': 'Înlocuiește toate badge-urile cu cele selectate',
  'Select Badges': 'Selectează badge-uri',
  'No badges available. Create badges in the product detail page.': 'Niciun badge disponibil. Creează badge-uri în pagina de detalii a produsului.',
  'Apply Changes': 'Aplică modificările',
  'Product Settings': 'Setări produse',
  'Root level': 'Nivel rădăcină',
  'New category name': 'Numele categoriei noi',
  'Failed to create category': 'Categoria nu a putut fi creată',
  'Alcohol': 'Alcool',
  'inherited': 'moștenit',
  'Delete category "{name}"?': 'Ștergi categoria „{name}”?',
  'Failed to delete': 'Ștergerea a eșuat',
  'Subgroups sit under a group (e.g. FRESH → Mici). A product keeps its group for reports, prices and accounting, and can also be given a subgroup.': 'Subgrupele se află sub o grupă (ex.: FRESH → Mici). Un produs își păstrează grupa pentru rapoarte, prețuri și contabilitate și poate primi și o subgrupă.',
  'New subgroup name': 'Numele subgrupei noi',
  'New group name': 'Numele grupei noi',
  'Create it at the top level or as a subgroup': 'Creeaz-o la nivelul de sus sau ca subgrupă',
  'Top level': 'Nivelul de sus',
  'Failed to create group': 'Grupa nu a putut fi creată',
  'Delete group "{name}"?': 'Ștergi grupa „{name}”?',
  'New brand name': 'Numele mărcii noi',
  'Failed to create brand': 'Marca nu a putut fi creată',
  'Delete brand "{name}"?': 'Ștergi marca „{name}”?',
  'Unit name (e.g. Kilograms)': 'Numele unității (ex.: Kilograme)',
  'Symbol (e.g. kg)': 'Simbol (ex.: kg)',
  'Failed to create unit': 'Unitatea nu a putut fi creată',
  'Symbol': 'Simbol',
  'Quantities in this unit display as whole numbers (requirements round up)': 'Cantitățile în această unitate se afișează ca numere întregi (necesarul se rotunjește în sus)',
  'Integer': 'Întreg',
  'Delete unit "{name} ({symbol})"?': 'Ștergi unitatea „{name} ({symbol})”?',
  "Configure SKU number ranges per category. New SKUs will be generated within the category's range, filling gaps first.": 'Configurează intervalele de numere SKU pe categorie. SKU-urile noi se generează în intervalul categoriei, completând mai întâi golurile.',
  'End': 'Sfârșit',
  'e.g. 10000': 'ex.: 10000',
  'e.g. 19999': 'ex.: 19999',
  'Choose where each filter sits: on the top bar, inside the filter panel, or hidden. Hiding a filter clears its current value.': 'Alege unde stă fiecare filtru: în bara de sus, în panoul de filtre sau ascuns. Ascunderea unui filtru îi șterge valoarea curentă.',
  'Toggle which columns are visible in the product list.': 'Alege ce coloane sunt vizibile în lista de produse.',
  'Print / Export {count} Product(s)': { one: 'Tipărire / Export {count} produs', few: 'Tipărire / Export {count} produse', other: 'Tipărire / Export {count} de produse' },
  'Select columns to include in the print / export.': 'Selectează coloanele de inclus în tipărire / export.',
  'Select All': 'Selectează tot',
  'Deselect All': 'Deselectează tot',
  'Deselect all': 'Deselectează tot',
  'Reset to template': 'Revino la șablon',
  'Reset to template ({count})': 'Revino la șablon ({count})',
  'Back to the template': 'Înapoi la șablon',
  'Reset to the template: {count} day(s)': 'Readus la șablon: {count} zi(le)',
  'Put the days typed by hand of the selected products ({count}) back to the template, then recalculate this week?': 'Readuci la șablon zilele introduse manual ale produselor selectate ({count}), apoi recalculezi săptămâna?',
  'Name (always included)': 'Nume (inclus întotdeauna)',
  'Price type for the Price column': 'Tipul de preț pentru coloana Preț',
  'Current sales price (default)': 'Prețul de vânzare curent (implicit)',
  'Products with no price for the selected type export as “-”.': 'Produsele fără preț pentru tipul selectat se exportă ca „-”.',
  'Export Excel': 'Export Excel',
  'Consolidate Products - Select Target': 'Consolidare produse - selectează ținta',
  'Consolidate Products - Review': 'Consolidare produse - verificare',
  'Consolidation Complete': 'Consolidare finalizată',
  'Select the target product to keep. All other products will be merged into it and disabled.': 'Selectează produsul țintă care se păstrează. Toate celelalte produse vor fi comasate în el și dezactivate.',
  '(Disabled)': '(Dezactivat)',
  'TARGET': 'ȚINTĂ',
  'Warning:': 'Atenție:',
  'This will move all related records from source products to the target, recalculate stock, and disable source products. This cannot be easily undone.': 'Toate înregistrările asociate vor fi mutate de la produsele sursă la produsul țintă, stocul va fi recalculat, iar produsele sursă vor fi dezactivate. Operația nu poate fi anulată ușor.',
  '{count} records to migrate': { one: '{count} înregistrare de migrat', few: '{count} înregistrări de migrat', other: '{count} de înregistrări de migrat' },
  'Record Type': 'Tip înregistrare',
  'No related records found.': 'Nu s-au găsit înregistrări asociate.',
  'Conflicts (auto-resolved):': 'Conflicte (rezolvate automat):',
  'Merged:': 'Comasate:',
  'Records moved:': 'Înregistrări mutate:',
  'Conflicts resolved:': 'Conflicte rezolvate:',
  'Review Changes': 'Verifică modificările',
  'Consolidating...': 'Se consolidează...',
  'Confirm Consolidation': 'Confirmă consolidarea',
  'Change match': 'Schimbă asocierea',
  'Remove match': 'Elimină asocierea',
  'Unmapped': 'Neasociat',
  '+ New': '+ Nou',
  'PO: New': 'CA: Nouă',
  'PO: {number}': 'CA: {number}',
  'Failed to save purchase order': 'Comanda de achiziție nu a putut fi salvată',
  '+{qty} {name}': '+{qty} {name}',
  '{changed} price(s) updated': 'Prețuri actualizate: {changed}',
  'Failed to load product data': 'Datele produsului nu au putut fi încărcate',
  'Save the purchase order first': 'Salvează mai întâi comanda de achiziție',
  'Failed to save supplier costs': 'Costurile furnizorului nu au putut fi salvate',
  'Clear all {length} items?': 'Ștergi toate articolele ({length})?',
  'Product mapped': 'Produsul a fost asociat',
  'Product unmapped': 'Asocierea produsului a fost eliminată',
  'Product mapped and supplier mapping updated': 'Produsul a fost asociat, iar asocierea cu furnizorul a fost actualizată',
  'Failed to remap product': 'Produsul nu a putut fi reasociat',
  'Product created, but supplier mapping was not saved. You can add it later.': 'Produsul a fost creat, dar asocierea cu furnizorul nu a fost salvată. O poți adăuga mai târziu.',
  'Product created and mapped': 'Produsul a fost creat și asociat',
  'Product created but could not be mapped to this row. Use Map to attach it.': 'Produsul a fost creat, dar nu a putut fi asociat cu acest rând. Folosește Asociază pentru a-l atașa.',
  'No unmapped items to match': 'Niciun articol neasociat de potrivit',
  'Auto-matched {matched} item(s)': 'Articole potrivite automat: {matched}',
  'No matching supplier mappings found': 'Nu s-au găsit asocieri cu furnizorul potrivite',
  'Close this order short? Lines still short will not be expected any more. Reason:': 'Închizi această comandă cu livrare parțială? Liniile care încă lipsesc nu vor mai fi așteptate. Motiv:',
  'Closed short: {closed_lines} line(s)': 'Închise cu livrare parțială: linii: {closed_lines}',
  'Reopen the lines closed short? They will be expected from the supplier again.': 'Redeschizi liniile închise cu livrare parțială? Vor fi din nou așteptate de la furnizor.',
  'Reopened {reopened_lines} line(s)': 'Linii redeschise: {reopened_lines}',
  'Applied supplier discounts (1 line updated)': 'Reducerile furnizorului au fost aplicate (1 linie actualizată)',
  'Applied supplier discounts ({count} lines updated)': { one: 'Reducerile furnizorului au fost aplicate ({count} linie actualizată)', few: 'Reducerile furnizorului au fost aplicate ({count} linii actualizate)', other: 'Reducerile furnizorului au fost aplicate ({count} de linii actualizate)' },
  'An invoice already exists for this PO. Create another for remaining uninvoiced quantities?': 'Există deja o factură pentru această comandă de achiziție. Creezi alta pentru cantitățile rămase nefacturate?',
  'Error creating invoice': 'Eroare la crearea facturii',
  'Purchase order sent to supplier': 'Comanda de achiziție a fost trimisă furnizorului',
  'Failed to send email to supplier': 'E-mailul către furnizor nu a putut fi trimis',
  'Purchase order exported to Excel': 'Comanda de achiziție a fost exportată în Excel',
  'Failed to export purchase order': 'Comanda de achiziție nu a putut fi exportată',
  'Loading purchase order...': 'Se încarcă comanda de achiziție...',
  'Back to Purchase Orders': 'Înapoi la comenzile de achiziție',
  'Purchase order not found': 'Comanda de achiziție nu a fost găsită',
  'New Purchase Order': 'Comandă de achiziție nouă',
  'Create a new purchase order': 'Creează o comandă de achiziție nouă',
  'Send': 'Trimite',
  'More': 'Mai mult',
  'Email to Supplier': 'Trimite e-mail furnizorului',
  'Apply supplier discount rules to all lines': 'Aplică regulile de reducere ale furnizorului pe toate liniile',
  'The rest of this order is not coming: stop expecting the lines still short': 'Restul acestei comenzi nu mai vine: nu mai aștepta liniile care încă lipsesc',
  'Close short': 'Închide cu livrare parțială',
  'Expect the lines closed short again': 'Așteaptă din nou liniile închise cu livrare parțială',
  'Still expected:': 'Încă așteptate:',
  'Closed short:': 'Închise cu livrare parțială:',
  '{product} {received} of {ordered} {unit}': '{product} {received} din {ordered} {unit}',
  '(final delivery {number})': '(livrare finală {number})',
  'PO Details': 'Detalii comandă de achiziție',
  'Statement for {name}': 'Fișă pentru {name}',
  '1-30 Days': '1-30 zile',
  '31-60 Days': '31-60 zile',
  '61-90 Days': '61-90 zile',
  '90+ Days': '90+ zile',
  'Show in {currency}': 'Afișează în {currency}',
  'Show in GBP': 'Afișează în GBP',
  'Search suppliers...': 'Caută furnizori...',
  'Number': 'Număr',
  'Auto-generated': 'Generat automat',
  'Proforma No.': 'Nr. proformă',
  'PRO-001': 'PRO-001',
  'Proforma Date': 'Data proformei',
  'Expected Delivery': 'Livrare estimată',
  'Tax Regime': 'Regim fiscal',
  'Zero-rated import (reverse charge)': 'Import cu cotă zero (taxare inversă)',
  'Domestic': 'Intern',
  'Additional notes': 'Note suplimentare',
  'Proforma': 'Proformă',
  'Not proforma': 'Nu este proformă',
  'Display out of stock on site': 'Afișează pe site când nu este în stoc',
  'Not displayed on site': 'Nu se afișează pe site',
  'Displayed on site': 'Afișat pe site',
  'Display expired': 'Afișarea a expirat',
  'Subtotal': 'Subtotal',
  '≈ {percent}% per item': '≈ {percent}% per articol',
  'Advance Payments': 'Avansuri',
  'Rate: 1 {currency} = £{rate}': 'Curs: 1 {currency} = £{rate}',
  'Total Paid': 'Total plătit',
  'Purchase Order Items ({count})': 'Articole comandă de achiziție ({count})',
  'Hide Original Order': 'Ascunde comanda originală',
  'Show Original Order': 'Afișează comanda originală',
  'Hide Supplier Names': 'Ascunde denumirile furnizorului',
  'Show Supplier Names': 'Afișează denumirile furnizorului',
  'Auto-match ({count} unmapped)': 'Potrivire automată ({count} neasociate)',
  'Show Mapped': 'Afișează asociatele',
  'Hide Mapped': 'Ascunde asociatele',
  'Paste List': 'Lipește lista',
  'Select Products': 'Selectează produse',
  'Add product by name, SKU, or barcode...': 'Adaugă produs după nume, SKU sau cod de bare...',
  'Supplier Cost': 'Cost furnizor',
  'Load': 'Încarcă',
  'Save current unit costs as supplier cost prices': 'Salvează costurile unitare curente ca prețuri de cost ale furnizorului',
  'Save as Cost': 'Salvează ca cost',
  'Ord. Qty': 'Cant. com.',
  'Ord. Unit': 'UM com.',
  'Ord. Price': 'Preț com.',
  'Ord. Total': 'Total com.',
  'Clear All': 'Șterge tot',
  'No items found for this purchase order': 'Nu s-au găsit articole pentru această comandă de achiziție',
  'Discount:': 'Reducere:',
  'Search by name, SKU, barcode...': 'Caută după nume, SKU, cod de bare...',
  'Closed {orders} order(s) short ({lines} line(s))': 'Comenzi închise cu livrare parțială: {orders} (linii: {lines})',
  'Are you sure you want to delete purchase order {number}? This action cannot be undone.': 'Sigur vrei să ștergi comanda de achiziție {number}? Această acțiune nu poate fi anulată.',
  'Total Amount': 'Sumă totală',
  'Copying...': 'Se copiază...',
  'Search purchase orders...': 'Caută comenzi de achiziție...',
  'All statuses': 'Toate stările',
  'Orders still waiting for goods although they were due more than 7 days ago': 'Comenzi care încă așteaptă marfa, deși termenul a trecut de mai mult de 7 zile',
  'Stale orders': 'Comenzi întârziate',
  'Hide filters': 'Ascunde filtrele',
  'Show filters': 'Afișează filtrele',
  'Loading purchase orders...': 'Se încarcă comenzile de achiziție...',
  'No purchase orders found': 'Nu s-au găsit comenzi de achiziție',
  'Showing {from} to {to} of {total} results': 'Se afișează {from}–{to} din {total} rezultate',
  'Close stale orders short': 'Închide comenzile întârziate cu livrare parțială',
  'Orders still waiting for goods although they were due more than {days} days ago. Closing them short stops expecting the lines still short, so the Purchase Planner and the stock forecast stop counting them. Received quantities, receipts and invoices are not changed, and each order can be reopened.': 'Comenzi care încă așteaptă marfa, deși termenul a trecut de mai mult de {days} zile. Închiderea lor cu livrare parțială oprește așteptarea liniilor care încă lipsesc, astfel încât Planificatorul de achiziții și prognoza de stoc nu le mai iau în calcul. Cantitățile recepționate, recepțiile și facturile nu se modifică, iar fiecare comandă poate fi redeschisă.',
  'No stale orders.': 'Nicio comandă întârziată.',
  'Order': 'Comandă',
  'Due': 'Termen',
  'Still short': 'Încă lipsesc',
  '{days} days ago': 'acum {days} zile',
  '{product}: {received} of {ordered} {unit}': '{product}: {received} din {ordered} {unit}',
  'Closing...': 'Se închide...',
  'Close {count} order(s) short': { one: 'Închide {count} comandă cu livrare parțială', few: 'Închide {count} comenzi cu livrare parțială', other: 'Închide {count} de comenzi cu livrare parțială' },
  'Cancel this bill? It will be excluded from break-even and most reports. You can change the status back later.': 'Anulezi această factură de cheltuieli? Va fi exclusă din pragul de rentabilitate și din majoritatea rapoartelor. Poți schimba starea înapoi mai târziu.',
  'Pick a category — this transaction type requires one.': 'Alege o categorie — acest tip de tranzacție necesită una.',
  'Pick a VAT rate. For a zero-rated bill choose the ZERO rate rather than leaving it blank.': 'Alege o cotă TVA. Pentru o factură de cheltuieli cu cotă zero alege cota ZERO în loc să lași câmpul gol.',
  'Enter the net amount.': 'Introdu valoarea netă.',
  'Shared / Company': 'Comun / Companie',
  '{code} (Default)': '{code} (implicit)',
  'Type to search…': 'Scrie pentru a căuta…',
  'Clear supplier': 'Șterge furnizorul',
  'No matches': 'Nicio potrivire',
  '{count} more — refine your search': 'Încă {count} — rafinează căutarea',
  '— select —': '— selectează —',
  'Select a category…': 'Selectează o categorie…',
  '— none —': '— niciuna —',
  '— select — (use ZERO for zero-rated)': '— selectează — (folosește ZERO pentru cota zero)',
  'Notional rate — VAT not charged on this bill (reverse charge applies).': 'Cotă teoretică — TVA nu se percepe pe această factură de cheltuieli (se aplică taxarea inversă).',
  'Verified': 'Verificat',
  'Disputed': 'Contestat',
  "Cancelled bills are excluded from break-even and most reports. You'll be asked to confirm on save.": 'Facturile de cheltuieli anulate sunt excluse din pragul de rentabilitate și din majoritatea rapoartelor. Ți se va cere confirmarea la salvare.',
  'Allocated as landed cost — remove the allocation to change the net amount, VAT rate, currency or regime.': 'Alocată ca cost accesoriu — elimină alocarea pentru a schimba valoarea netă, cota TVA, moneda sau regimul.',
  'VAT': 'TVA',
  '(reverse charge — 0)': '(taxare inversă — 0)',
  'Reset to auto': 'Revino la automat',
  '(auto)': '(auto)',
  'Supplier reference': 'Referință furnizor',
  "Supplier's bill / invoice number": 'Numărul facturii furnizorului',
  'Optional internal reference': 'Referință internă opțională',
  'auto: prior payment to this supplier': 'auto: plată anterioară către acest furnizor',
  'auto: most recent payment in {code}': 'auto: cea mai recentă plată în {code}',
  'auto: prior invoice': 'auto: factură anterioară',
  'auto: live rate': 'auto: curs în timp real',
  'auto: rate history': 'auto: istoric curs',
  'auto: {source}': 'auto: {source}',
  'Exchange rate': 'Curs de schimb',
  'base': 'moneda de bază',
  'e.g. 0.857500': 'ex. 0.857500',
  'Manual override — supersedes auto-fill.': 'Valoare manuală — înlocuiește completarea automată.',
  'A cancelled bill cannot be allocated as landed cost': 'O factură de cheltuieli anulată nu poate fi alocată ca cost accesoriu',
  'Enter a net amount above zero before allocating this bill': 'Introdu o valoare netă mai mare decât zero înainte de a aloca această factură de cheltuieli',
  'Remove the landed-cost allocation? The cost prices on the target invoices will be recomputed, and this bill goes back to counting as an expense.': 'Elimini alocarea costului accesoriu? Prețurile de cost de pe facturile țintă vor fi recalculate, iar această factură de cheltuieli va fi din nou contabilizată ca cheltuială.',
  'Landed-cost allocation removed': 'Alocarea costului accesoriu a fost eliminată',
  'Failed to remove allocation': 'Alocarea nu a putut fi eliminată',
  'Landed cost': 'Cost accesoriu',
  'Removing…': 'Se elimină…',
  "Move this bill's value into the cost price of goods on one or more invoices": 'Mută valoarea acestei facturi de cheltuieli în prețul de cost al mărfurilor de pe una sau mai multe facturi',
  'Allocate as landed cost': 'Alocă drept cost accesoriu',
  'This bill is excluded from Expenses — its value sits in the cost price of the goods below.': 'Această factură de cheltuieli este exclusă din Cheltuieli — valoarea ei este inclusă în prețul de cost al mărfurilor de mai jos.',
  '{count} targets still need Allocate to rows on the invoice page.': { one: '{count} factură țintă necesită încă „Alocă pe rânduri” în pagina facturii.', few: '{count} facturi țintă necesită încă „Alocă pe rânduri” în pagina facturii.', other: '{count} de facturi țintă necesită încă „Alocă pe rânduri” în pagina facturii.' },
  '1 target still needs Allocate to rows on the invoice page.': '1 factură țintă necesită încă „Alocă pe rânduri” în pagina facturii.',
  'Applied to product rows on every target.': 'Aplicat pe rândurile de produse ale tuturor facturilor țintă.',
  'Target Invoice': 'Factură țintă',
  'Share (GBP)': 'Cotă (GBP)',
  'applied': 'aplicat',
  'pending on invoice': 'în așteptare pe factură',
  "This bill counts as an expense under {category}. Allocate it to one or more goods invoices to move its value into those products' cost price instead.": 'Această factură de cheltuieli este contabilizată ca cheltuială la {category}. Aloc-o pe una sau mai multe facturi de mărfuri pentru a muta valoarea ei în prețul de cost al acelor produse.',
  'its category': 'categoria sa',
  'Stock adjustment created successfully': 'Ajustarea de stoc a fost creată cu succes',
  'Failed to create adjustment': 'Ajustarea nu a putut fi creată',
  'Select at least one adjustment to export': 'Selectează cel puțin o ajustare pentru export',
  'Export failed': 'Exportul a eșuat',
  'Failed to export adjustments': 'Exportul ajustărilor a eșuat',
  'Printing the first {cap} of {count} selected': 'Se tipăresc primele {cap} din cele selectate ({count})',
  'Print failed': 'Tipărirea a eșuat',
  'Failed to print adjustment': 'Tipărirea ajustării a eșuat',
  'Stock adjustment {number} cancelled successfully': 'Ajustarea de stoc {number} a fost anulată cu succes',
  'Failed to cancel stock adjustment': 'Ajustarea de stoc nu a putut fi anulată',
  'Duplicated {number} → {newNumber}': 'Duplicat {number} → {newNumber}',
  'Failed to duplicate stock adjustment': 'Ajustarea de stoc nu a putut fi duplicată',
  'Stock adjustment {number} deleted successfully': 'Ajustarea de stoc {number} a fost ștearsă cu succes',
  'Failed to delete stock adjustment': 'Ajustarea de stoc nu a putut fi ștearsă',
  'Stock reset failed': 'Resetarea stocului a eșuat',
  'Failed to change status': 'Starea nu a putut fi schimbată',
  'Qty Impact': 'Impact cantitate',
  'Effective': 'Data efectivă',
  'Print this adjustment': 'Tipărește această ajustare',
  'Duplicate': 'Duplică',
  'Search products, refs...': 'Caută produse, referințe...',
  'Print first 3 of {count} selected': 'Tipărește primele 3 din cele selectate ({count})',
  'Print {count} selected': 'Tipărește selectatele ({count})',
  'Export ({count})': 'Exportă ({count})',
  'Reset Stock': 'Resetează stocul',
  'New Adjustment': 'Ajustare nouă',
  'No documents found': 'Nu s-a găsit niciun document',
  'New Stock Adjustment': 'Ajustare de stoc nouă',
  'Select product': 'Selectează produsul',
  'Negative to decrease, positive to increase': 'Negativ pentru scădere, pozitiv pentru creștere',
  'Use negative values (e.g. -5) for stock decrease, positive (e.g. +3) for increase': 'Folosește valori negative (ex. -5) pentru scăderea stocului și pozitive (ex. +3) pentru creștere',
  'Select reason...': 'Selectează motivul...',
  'Effective Date': 'Data efectivă',
  'Reason for adjustment...': 'Motivul ajustării...',
  'Additional Notes': 'Note suplimentare',
  'Any additional details...': 'Alte detalii...',
  'Create Adjustment': 'Creează ajustarea',
  'This will set stock quantities to zero in the selected warehouse, computed from the movement log as of the chosen moment.': 'Aceasta va pune pe zero cantitățile de stoc din depozitul selectat, calculate din jurnalul de mișcări la momentul ales.',
  'Movements after the chosen moment are not touched and continue to apply on top.': 'Mișcările de după momentul ales nu sunt atinse și continuă să se aplice peste.',
  'Leave as "All locations" to reset every location in the warehouse, or pick one to scope the reset to a single location.': 'Lasă „Toate locațiile” pentru a reseta toate locațiile din depozit sau alege una pentru a limita resetarea la o singură locație.',
  'All groups': 'Toate grupele',
  'Optionally limit the reset to products in one group and/or category. Category includes its subcategories.': 'Opțional, limitează resetarea la produsele dintr-o grupă și/sau categorie. Categoria include și subcategoriile sale.',
  'Reset as of': 'Resetează la data',
  'Defaults to the current moment. Pick a past datetime to reset stock as it was at that point in time.': 'Implicit, momentul curent. Alege o dată și oră din trecut pentru a reseta stocul așa cum era în acel moment.',
  'Resetting...': 'Se resetează...',
  'The server accepted the request but returned no bill. Nothing was created.': 'Serverul a acceptat cererea, dar nu a returnat nicio factură de cheltuieli. Nu s-a creat nimic.',
  'Bill was not created': 'Factura de cheltuieli nu a fost creată',
  'Bill {number} created': 'Factura de cheltuieli {number} a fost creată',
  'Bill updated': 'Factura de cheltuieli a fost actualizată',
  'Loading bill…': 'Se încarcă factura de cheltuieli…',
  'Back to Bills': 'Înapoi la Facturi de cheltuieli',
  'New Bill': 'Factură de cheltuieli nouă',
  'Bill {number}': 'Factura de cheltuieli {number}',
  'Bill Details': 'Detalii factură de cheltuieli',
  'Bill was not saved': 'Factura de cheltuieli nu a fost salvată',
  'User details updated': 'Detaliile utilizatorului au fost actualizate',
  'Group "{name}" created': 'Grupa „{name}” a fost creată',
  'Group renamed to "{name}"': 'Grupa a fost redenumită „{name}”',
  'Failed to update group': 'Grupa nu a putut fi actualizată',
  'Zone "{name}" created': 'Zona „{name}” a fost creată',
  'Failed to create zone': 'Zona nu a putut fi creată',
  'Zone renamed to "{name}"': 'Zona a fost redenumită „{name}”',
  'Failed to update zone': 'Zona nu a putut fi actualizată',
  'Customer not found': 'Clientul nu a fost găsit',
  'Failed to load customer details': 'Detaliile clientului nu au putut fi încărcate',
  'Enter time window (e.g., 09:00-17:00):': 'Introdu intervalul orar (ex. 09:00-17:00):',
  'Invalid time window format. Use HH:MM-HH:MM (e.g., 09:00-17:00)': 'Format de interval orar invalid. Folosește HH:MM-HH:MM (ex. 09:00-17:00)',
  'Customer updated successfully!': 'Clientul a fost actualizat cu succes!',
  'Failed to update customer': 'Clientul nu a putut fi actualizat',
  'This customer has no email address on file': 'Acest client nu are o adresă de e-mail înregistrată',
  'Email this statement to {email}?': 'Trimiți această fișă pe e-mail la {email}?',
  'Statement sent to {email}': 'Fișa a fost trimisă la {email}',
  'Failed to email statement': 'Fișa nu a putut fi trimisă pe e-mail',
  'Sales rep assigned successfully': 'Agentul de vânzări a fost alocat cu succes',
  'Failed to assign sales rep': 'Agentul de vânzări nu a putut fi alocat',
  'Sales rep removed successfully': 'Agentul de vânzări a fost eliminat cu succes',
  'Failed to remove sales rep': 'Agentul de vânzări nu a putut fi eliminat',
  'Manager assigned successfully': 'Managerul a fost alocat cu succes',
  'Failed to assign manager': 'Managerul nu a putut fi alocat',
  'Manager removed successfully': 'Managerul a fost eliminat cu succes',
  'Failed to remove manager': 'Managerul nu a putut fi eliminat',
  'Account manager assigned successfully': 'Account managerul a fost alocat cu succes',
  'Failed to assign account manager': 'Account managerul nu a putut fi alocat',
  'Account manager removed successfully': 'Account managerul a fost eliminat cu succes',
  'Failed to remove account manager': 'Account managerul nu a putut fi eliminat',
  'Customer has no address to generate location from': 'Clientul nu are o adresă din care să se genereze locația',
  'Location generated successfully': 'Locația a fost generată cu succes',
  'Failed to generate location': 'Locația nu a putut fi generată',
  'Location verified successfully': 'Locația a fost verificată cu succes',
  'Failed to verify location': 'Locația nu a putut fi verificată',
  'Assigned to {name}': 'Alocat lui {name}',
  'Delivery zone cleared': 'Zona de livrare a fost eliminată',
  'Failed to update delivery zone': 'Zona de livrare nu a putut fi actualizată',
  'Customer has no address to refresh location from': 'Clientul nu are o adresă din care să se reîmprospăteze locația',
  'Location refreshed from address': 'Locația a fost reîmprospătată din adresă',
  'Failed to refresh location': 'Locația nu a putut fi reîmprospătată',
  'Back to Customers': 'Înapoi la Clienți',
  'User #{id}': 'Utilizator #{id}',
  'Search users by name or email...': 'Caută utilizatori după nume sau e-mail...',
  'No users found': 'Nu s-a găsit niciun utilizator',
  'This customer is an employee': 'Acest client este angajat',
  'Link to Employee': 'Leagă de angajat',
  '-- Select Employee --': '-- Selectează angajatul --',
  'No employee linked': 'Niciun angajat legat',
  'Basic Information': 'Informații de bază',
  'Premises Licence Number': 'Număr licență pentru spațiu',
  'None — cannot buy alcohol': 'Niciuna — nu poate cumpăra alcool',
  'Blank = cannot buy alcohol': 'Gol = nu poate cumpăra alcool',
  'Priority (Picking)': 'Prioritate (culegere)',
  'Can export orders': 'Poate exporta comenzi',
  'Allow external connection': 'Permite conexiune externă',
  'User Account': 'Cont de utilizator',
  'Click to edit user details': 'Apasă pentru a edita detaliile utilizatorului',
  'No user account linked': 'Niciun cont de utilizator legat',
  'Assigned To (Sales Rep)': 'Alocat lui (agent vânzări)',
  'Not assigned to any sales rep': 'Nealocat niciunui agent de vânzări',
  'Remove sales rep': 'Elimină agentul de vânzări',
  '+ Add sales rep...': '+ Adaugă agent de vânzări...',
  'Managed By (Shop Manager)': 'Gestionat de (manager magazin)',
  'Not assigned to any manager': 'Nealocat niciunui manager',
  'Remove manager': 'Elimină managerul',
  '+ Add manager...': '+ Adaugă manager...',
  'Responsible: Account Manager': 'Responsabil: account manager',
  'Not assigned to any account manager': 'Nealocat niciunui account manager',
  'Remove account manager': 'Elimină account managerul',
  '+ Add account manager...': '+ Adaugă account manager...',
  'Address Information': 'Informații adresă',
  'System default': 'Implicit sistem',
  '— Use system default —': '— Folosește valoarea implicită a sistemului —',
  'Used to bias address geocoding on the map. Leave blank to use the system default.': 'Folosit pentru a orienta geocodarea adresei pe hartă. Lasă gol pentru a folosi valoarea implicită a sistemului.',
  'Use same address for delivery': 'Folosește aceeași adresă pentru livrare',
  'Logistics Location': 'Locație logistică',
  'Generate Location': 'Generează locația',
  'Refresh map from current address': 'Reîmprospătează harta din adresa curentă',
  'Verify Location': 'Verifică locația',
  'Verified by {name}': 'Verificat de {name}',
  'Not Verified': 'Neverificat',
  'Address changed since last verification': 'Adresa s-a schimbat de la ultima verificare',
  'No logistics location — click "Generate Location" to create one': 'Nicio locație logistică — apasă „Generează locația” pentru a crea una',
  'Pricing': 'Prețuri',
  'Price Type': 'Tip de preț',
  'Type {id}': 'Tipul {id}',
  'Not set. Choose a price type before invoicing this customer.': 'Nesetat. Alege un tip de preț înainte de a factura acest client.',
  '-- Select Price Type --': '-- Selectează tipul de preț --',
  'Customer Group': 'Grupă de clienți',
  '-- Select Group --': '-- Selectează grupa --',
  'Create new group': 'Creează grupă nouă',
  'Rename selected group': 'Redenumește grupa selectată',
  'Rename group': 'Redenumește grupa',
  '-- Select Ownership --': '-- Selectează apartenența --',
  'House': 'Firmă',
  'Hybrid': 'Hibrid',
  'Sales Zone': 'Zonă de vânzări',
  '-- Select Zone --': '-- Selectează zona --',
  'Create new zone': 'Creează zonă nouă',
  'Rename selected zone': 'Redenumește zona selectată',
  'Rename zone': 'Redenumește zona',
  'New zone name': 'Numele noii zone',
  'Accounts': 'Conturi',
  'Default Account': 'Cont implicit',
  '-- Select Account --': '-- Selectează contul --',
  'Default Credit Limit:': 'Limită de credit implicită:',
  'No limit': 'Fără limită',
  'Default Max Invoices:': 'Nr. maxim implicit de facturi:',
  'Credit Control Overrides': 'Excepții de control al creditului',
  'Account on Credit Hold': 'Cont cu credit blocat',
  'Credit Limit Override (£)': 'Limită de credit personalizată (£)',
  'Using payment term default': 'Se folosește valoarea implicită a termenului de plată',
  'Leave empty to use payment term default': 'Lasă gol pentru a folosi valoarea implicită a termenului de plată',
  'Max Outstanding Invoices Override': 'Nr. maxim personalizat de facturi neachitate',
  '{count} invoices': { one: '{count} factură', few: '{count} facturi', other: '{count} de facturi' },
  'Hold Reason': 'Motivul blocării',
  'Reason for credit hold...': 'Motivul blocării creditului...',
  'Effective Credit Limits': 'Limite de credit efective',
  'Credit Limit': 'Limită de credit',
  'Override active': 'Excepție activă',
  'Max Outstanding Invoices': 'Nr. maxim de facturi neachitate',
  'Current Usage': 'Utilizare curentă',
  '£{amount} balance': 'Sold £{amount}',
  'Credit Status': 'Stare credit',
  'Blocked': 'Blocat',
  'Credit Control Active': 'Control credit activ',
  'Credit Hold (block all orders)': 'Blocare credit (blochează toate comenzile)',
  'Available Days': 'Zile disponibile',
  'Select days or leave empty for any day': 'Selectează zilele sau lasă gol pentru orice zi',
  'Any day available': 'Disponibil în orice zi',
  'Pickup Time Windows': 'Intervale orare de ridicare',
  '+ Add time window': '+ Adaugă interval orar',
  'No time windows set': 'Niciun interval orar setat',
  'Select days first to configure time windows': 'Selectează mai întâi zilele pentru a configura intervalele orare',
  'Fulfillment Configuration': 'Configurare onorare',
  'Delivery Branch': 'Filială de livrare',
  'Primary branch': 'Filiala principală',
  'New orders from this customer are assigned to this branch. Existing orders are not moved.': 'Comenzile noi ale acestui client sunt alocate acestei filiale. Comenzile existente nu sunt mutate.',
  '-- Primary branch --': '-- Filiala principală --',
  'Default Fulfillment Type': 'Tip de onorare implicit',
  'Statement of {name}': 'Fișă: {name}',
  'Include full group': 'Include toată grupa',
  'Load statement': 'Încarcă fișa',
  'Email this statement to {email}': 'Trimite această fișă pe e-mail la {email}',
  'This customer has no email address': 'Acest client nu are adresă de e-mail',
  'Click "Load Statement" to view account transactions': 'Apasă „Încarcă fișa” pentru a vedea tranzacțiile contului',
  'Created from lead': 'Creat dintr-un lead',
  '(lead since {date})': '(lead din {date})',
  'View Lead →': 'Vezi lead-ul →',
  'CRM Activity': 'Activitate CRM',
  'Log Event': 'Înregistrează eveniment',
  'Send Email': 'Trimite e-mail',
  'Loading activity...': 'Se încarcă activitatea...',
  'No CRM events logged for this customer yet.': 'Încă nu există evenimente CRM înregistrate pentru acest client.',
  'with {name}': 'cu {name}',
  'Email Replies': 'Răspunsuri e-mail',
  'Delivery Location': 'Locație de livrare',
  'Address': 'Adresă',
  'Postcode': 'Cod poștal',
  'Verification Status': 'Stare verificare',
  'Verify': 'Verifică',
  'Address has changed since last verification': 'Adresa s-a schimbat de la ultima verificare',
  'Original: {address}': 'Original: {address}',
  'Coordinates': 'Coordonate',
  'No logistics location assigned': 'Nicio locație logistică alocată',
  'Delivery Zone': 'Zonă de livrare',
  'No delivery zone': 'Fără zonă de livrare',
  'Zone Sequence': 'Ordine în zonă',
  'Last Delivered': 'Ultima livrare',
  'No delivery zone assigned': 'Nicio zonă de livrare alocată',
  'Generate a delivery location first to assign a zone': 'Generează mai întâi o locație de livrare pentru a aloca o zonă',
  'View statement': 'Vezi fișa',
  'Balance: £{amount} CR': 'Sold: £{amount} CR',
  'Balance: £{amount}': 'Sold: £{amount}',
  'Employee': 'Angajat',
  'Credit Hold': 'Blocare credit',
  'Companies House has 1 change.': 'Companies House are 1 modificare.',
  'Companies House has {count} changes.': { one: 'Companies House are {count} modificare.', few: 'Companies House are {count} modificări.', other: 'Companies House are {count} de modificări.' },
  'Review': 'Revizuiește',
  'Linked to Companies House.': 'Legat de Companies House.',
  'Failed to link.': 'Legarea a eșuat.',
  'Edit User Account': 'Editează contul de utilizator',
  'Customer:': 'Client:',
  'Username': 'Nume de utilizator',
  'Password (leave blank to keep current)': 'Parolă (lasă gol pentru a o păstra pe cea actuală)',
  'Leave blank to keep current password': 'Lasă gol pentru a păstra parola actuală',
  'Account is active': 'Contul este activ',
  'User details for {name} updated successfully.': 'Detaliile utilizatorului {name} au fost actualizate cu succes.',
  'Exported {count} customer(s). {missing} selected customer(s) were not on the loaded pages and were skipped.': 'Clienți exportați: {count}. Clienți selectați care nu erau pe paginile încărcate și au fost omiși: {missing}.',
  'Exported {count} customer(s).': 'Clienți exportați: {count}.',
  'Sales rep assignment': 'Alocare agent de vânzări',
  'Customer #{id}': 'Client #{id}',
  'Unknown error': 'Eroare necunoscută',
  'Network error': 'Eroare de rețea',
  'Successfully updated {count} customers': { one: '{count} client actualizat cu succes', few: '{count} clienți actualizați cu succes', other: '{count} de clienți actualizați cu succes' },
  'Successfully updated 1 customer': '1 client actualizat cu succes',
  'Customer "{name}" created successfully': 'Clientul „{name}” a fost creat cu succes',
  'Unverified': 'Neverificat',
  'No Location': 'Fără locație',
  'No Address': 'Fără adresă',
  'No account': 'Fără cont',
  'Collapse': 'Restrânge',
  'Expand': 'Extinde',
  'Stage': 'Etapă',
  'ABC': 'ABC',
  'Account Mgr': 'Account manager',
  'Credit control active': 'Control credit activ',
  'OK': 'OK',
  'New Customer': 'Client nou',
  'Export Selected': 'Exportă selectații',
  'Pickup': 'Ridicare',
  'Not Configured': 'Neconfigurat',
  'Has Location': 'Are locație',
  'ABC Tier': 'Clasă ABC',
  'No Group': 'Fără grupă',
  'No Sales Rep': 'Fără agent de vânzări',
  'No Account Mgr': 'Fără account manager',
  'Ownership': 'Apartenență',
  'No Zone': 'Fără zonă',
  'Clear all filters': 'Șterge toate filtrele',
  'Loading customers...': 'Se încarcă clienții...',
  'No customers found matching your search.': 'Nu s-a găsit niciun client care să corespundă căutării.',
  'No customers found.': 'Nu s-a găsit niciun client.',
  'No customers match the selected filters.': 'Niciun client nu corespunde filtrelor selectate.',
  '1 customer': '1 client',
  '{count} customers': { one: '{count} client', few: '{count} clienți', other: '{count} de clienți' },
  'Balance (high)': 'Sold (descrescător)',
  'Balance (low)': 'Sold (crescător)',
  '{count} total': 'Total: {count}',
  '{from}–{to} of {total}': '{from}–{to} din {total}',
  'Create User Account': 'Creează cont de utilizator',
  'Enter password': 'Introdu parola',
  'Look up on Companies House': 'Caută în Companies House',
  'Linked:': 'Legat:',
  'Customer name': 'Numele clientului',
  'Email address': 'Adresă de e-mail',
  'Phone number': 'Număr de telefon',
  'Create Customer': 'Creează clientul',
  'Failed to load items from the selected invoice': 'Articolele din factura selectată nu au putut fi încărcate',
  'Select a location for "{product_name}" before saving.': 'Selectează o locație pentru „{product_name}” înainte de salvare.',
  'Debit note updated successfully': 'Nota de debit a fost actualizată cu succes',
  'Failed to update debit note': 'Nota de debit nu a putut fi actualizată',
  'Failed to save debit note': 'Nota de debit nu a putut fi salvată',
  'Are you sure you want to post this debit note? This action cannot be undone.': 'Sigur vrei să înregistrezi această notă de debit? Această acțiune nu poate fi anulată.',
  'Debit note posted successfully': 'Nota de debit a fost înregistrată cu succes',
  'Failed to post debit note': 'Nota de debit nu a putut fi înregistrată',
  'Are you sure you want to cancel this debit note?': 'Sigur vrei să anulezi această notă de debit?',
  'Debit note cancelled': 'Nota de debit a fost anulată',
  'Failed to cancel debit note': 'Nota de debit nu a putut fi anulată',
  'Updated {cn_items_updated} line(s) from receipt.': 'Linii actualizate din recepție: {cn_items_updated}.',
  'Receipt has multiple batches per product — pick manually for {skipped_multi_batch} line(s).': 'Recepția are mai multe loturi pe produs — alege manual. Linii afectate: {skipped_multi_batch}.',
  'No batches available from the related receipt yet.': 'Încă nu există loturi disponibile din recepția asociată.',
  'Failed to sync from receipt': 'Sincronizarea din recepție a eșuat',
  'Revert this debit note to draft? Stock movements will be reversed.': 'Readuci această notă de debit la ciornă? Mișcările de stoc vor fi inversate.',
  'Debit note reverted to draft': 'Nota de debit a fost readusă la ciornă',
  'Failed to unpost debit note': 'Anularea înregistrării notei de debit a eșuat',
  'Email debit note {debit_note_number} to the supplier?': 'Trimiți nota de debit {debit_note_number} pe e-mail furnizorului?',
  'Debit note sent': 'Nota de debit a fost trimisă',
  'Failed to email debit note': 'Nota de debit nu a putut fi trimisă pe e-mail',
  'Failed to print debit note': 'Nota de debit nu a putut fi tipărită',
  'Loading debit note...': 'Se încarcă nota de debit...',
  'Back to Debit Notes': 'Înapoi la Note de debit',
  'Replace items with lines from the new invoice? Any current edits will be lost.': 'Înlocuiești articolele cu liniile din noua factură? Modificările curente se vor pierde.',
  'Clear all items? Any current edits will be lost.': 'Ștergi toate articolele? Modificările curente se vor pierde.',
  'stock in {unit}': 'stoc în {unit}',
  'Stock is kept in {unit}': 'Stocul este ținut în {unit}',
  'Refresh batches from the related receipt': 'Reîmprospătează loturile din recepția asociată',
  'Sync from receipt': 'Sincronizează din recepție',
  'Debit Note': 'Notă de debit',
  'Debit Note Details': 'Detalii notă de debit',
  'Debit Note Number': 'Număr notă de debit',
  '— No invoice —': '— Fără factură —',
  'Select supplier…': 'Selectează furnizorul…',
  'Reference...': 'Referință...',
  'Debit Note #': 'Notă de debit #',
  'Loading debit notes...': 'Se încarcă notele de debit...',
  'Search debit notes...': 'Caută note de debit...',
  'Select debit notes to print': 'Selectează notele de debit de tipărit',
  'Print Selected': 'Tipărește selectatele',
  'New Debit Note': 'Notă de debit nouă',
  'No suppliers available': 'Niciun furnizor disponibil',
  'No debit notes found': 'Nu s-a găsit nicio notă de debit',
  'Please select a supplier': 'Selectează un furnizor',
  'Please select a purchase invoice': 'Selectează o factură de achiziție',
  'Please select at least one item': 'Selectează cel puțin un articol',
  'Debit note created successfully': 'Nota de debit a fost creată cu succes',
  'Failed to create debit note': 'Nota de debit nu a putut fi creată',
  'No receipt batches': 'Niciun lot din recepție',
  'No batch trace from receipt.': 'Nicio trasabilitate a lotului din recepție.',
  'Original': 'Inițial',
  'Debit Qty': 'Cant. debitată',
  'Select supplier...': 'Selectează furnizorul...',
  'Debited: £{amount}': 'Debitat: £{amount}',
  'Operation Type': 'Tip operațiune',
  'Debit Note Date': 'Data notei de debit',
  'Reason for debit note...': 'Motivul notei de debit...',
  'Internal reference...': 'Referință internă...',
  'Already debited: £{amount}': 'Deja debitat: £{amount}',
  'Loading invoice items...': 'Se încarcă articolele facturii...',
  'Discount debit note': 'Notă de debit pentru reducere',
  'Create Debit Note': 'Creează nota de debit',
  '{count} prices updated': { one: '{count} preț actualizat', few: '{count} prețuri actualizate', other: '{count} de prețuri actualizate' },
  'Save the invoice first': 'Salvează mai întâi factura',
  'Failed to update prices': 'Prețurile nu au putut fi actualizate',
  'Failed to update split method': 'Metoda de repartizare nu a putut fi actualizată',
  'Allocated to rows': 'Alocat pe rânduri',
  'Failed to allocate': 'Alocarea a eșuat',
  'Deallocated': 'Dezalocat',
  'Failed to deallocate': 'Dezalocarea a eșuat',
  'this bill': 'această factură de cheltuieli',
  'this service': 'acest serviciu',
  'Remove the landed cost from {source}? It is allocated to {count} invoices and will be detached from all of them. Cost prices on the affected invoices are recomputed, and the bill counts as an expense again.': { one: 'Elimini costul accesoriu din {source}? Este alocat pe {count} factură și va fi detașat de ea. Prețurile de cost de pe factura afectată se recalculează, iar factura de cheltuieli este din nou contabilizată ca cheltuială.', few: 'Elimini costul accesoriu din {source}? Este alocat pe {count} facturi și va fi detașat de toate. Prețurile de cost de pe facturile afectate se recalculează, iar factura de cheltuieli este din nou contabilizată ca cheltuială.', other: 'Elimini costul accesoriu din {source}? Este alocat pe {count} de facturi și va fi detașat de toate. Prețurile de cost de pe facturile afectate se recalculează, iar factura de cheltuieli este din nou contabilizată ca cheltuială.' },
  'Remove the landed cost from {source}? Cost prices on the affected invoices are recomputed, and the bill counts as an expense again.': 'Elimini costul accesoriu din {source}? Prețurile de cost de pe facturile afectate se recalculează, iar factura de cheltuieli este din nou contabilizată ca cheltuială.',
  'Remove the landed cost from {source}? It is allocated to {count} invoices and will be detached from all of them. Cost prices on the affected invoices are recomputed.': { one: 'Elimini costul accesoriu din {source}? Este alocat pe {count} factură și va fi detașat de ea. Prețurile de cost de pe factura afectată se recalculează.', few: 'Elimini costul accesoriu din {source}? Este alocat pe {count} facturi și va fi detașat de toate. Prețurile de cost de pe facturile afectate se recalculează.', other: 'Elimini costul accesoriu din {source}? Este alocat pe {count} de facturi și va fi detașat de toate. Prețurile de cost de pe facturile afectate se recalculează.' },
  'Remove the landed cost from {source}? Cost prices on the affected invoices are recomputed.': 'Elimini costul accesoriu din {source}? Prețurile de cost de pe facturile afectate se recalculează.',
  'Cross-invoice allocation removed': 'Alocarea între facturi a fost eliminată',
  'Failed to deallocate across invoices': 'Dezalocarea între facturi a eșuat',
  'Failed to load customs declaration': 'Declarația vamală nu a putut fi încărcată',
  'Select a supplier before saving': 'Selectează un furnizor înainte de salvare',
  'Failed to save purchase invoice': 'Factura de achiziție nu a putut fi salvată',
  'Failed to send to 1C': 'Trimiterea în 1C a eșuat',
  'New Purchase Invoice': 'Factură de achiziție nouă',
  'Create a new purchase invoice': 'Creează o factură de achiziție nouă',
  'Sent to 1C': 'Trimis în 1C',
  'Resend to 1C': 'Retrimite în 1C',
  'Update Prices': 'Actualizează prețurile',
  'Customs Declaration': 'Declarație vamală',
  'Invoice Information': 'Informații factură',
  'e.g. 0.8575': 'ex. 0.8575',
  'Services': 'Servicii',
  '+ {count} services': { one: '+ {count} serviciu', few: '+ {count} servicii', other: '+ {count} de servicii' },
  'Hide Ordered/Received columns': 'Ascunde coloanele Comandat/Recepționat',
  'Show Ordered/Received columns': 'Arată coloanele Comandat/Recepționat',
  'Ord/Rcv': 'Com/Rec',
  'Clear all {count} items?': { one: 'Ștergi {count} articol?', few: 'Ștergi toate cele {count} articole?', other: 'Ștergi toate cele {count} de articole?' },
  'Cost: {cost}': 'Cost: {cost}',
  'Ordered Qty': 'Cant. comandată',
  'Invoiced Qty': 'Cant. facturată',
  'Received Qty': 'Cant. recepționată',
  'Disc %': 'Red. %',
  'Landed Services': 'Servicii accesorii',
  'Use the search field above to add products to this invoice': 'Folosește câmpul de căutare de mai sus pentru a adăuga produse în această factură',
  'No items added to this invoice': 'Niciun articol adăugat în această factură',
  'Select': 'Selectează',
  'Disabled: zero-rated import regime': 'Dezactivat: regim de import cu cotă zero',
  'ext': 'ext',
  'from': 'din',
  'Landed costs total:': 'Total costuri accesorii:',
  'of {amount}': 'din {amount}',
  'Service Lines ({count})': 'Linii de servicii ({count})',
  'Search for service products above to add service lines.': 'Caută produse de tip serviciu mai sus pentru a adăuga linii de servicii.',
  'This service has an allocation scope — it allocates only to matching items (set on the service product)': 'Acest serviciu are un domeniu de alocare — se alocă doar pe articolele care corespund (setat pe produsul serviciu)',
  'scoped': 'limitat',
  'Description...': 'Descriere...',
  'Deallocate first to change split method': 'Dezalocă mai întâi pentru a schimba metoda de repartizare',
  'Split method': 'Metodă de repartizare',
  'by_amount': 'după valoare',
  'by_weight': 'după greutate',
  'by_quantity': 'după cantitate',
  'Unallocate': 'Dezalocă',
  'Allocate to rows': 'Alocă pe rânduri',
  'Remove cross-invoice allocation': 'Elimină alocarea între facturi',
  'Unallocate cross-invoice ({count})': 'Dezalocă între facturi ({count})',
  'Allocate this service across other invoices': 'Alocă acest serviciu pe alte facturi',
  'Allocate across invoices': 'Alocă pe alte facturi',
  'Allocated to other invoices': 'Alocat pe alte facturi',
  'Share': 'Cotă',
  'allocated on target': 'alocat pe factura țintă',
  'pending on target': 'în așteptare pe factura țintă',
  "External Landed Costs (bills and other suppliers' invoices)": 'Costuri accesorii externe (facturi de cheltuieli și facturi ale altor furnizori)',
  'Add invoice rows first — a landed cost needs rows to allocate to': 'Adaugă mai întâi rânduri în factură — un cost accesoriu are nevoie de rânduri pe care să fie alocat',
  'Attach a transport, customs or broker bill as landed cost': 'Atașează o factură de cheltuieli de transport, vamă sau broker ca cost accesoriu',
  'Add bill': 'Adaugă factură de cheltuieli',
  'Origin': 'Origine',
  'external': 'extern',
  'from bill': 'din factura de cheltuieli',
  'allocated': 'alocat',
  'pending': 'în așteptare',
  'Detach this bill from the invoice — it goes back to counting as an expense': 'Detașează această factură de cheltuieli de factură — va fi din nou contabilizată ca cheltuială',
  'Remove this cross-invoice allocation': 'Elimină această alocare între facturi',
  'No external landed costs yet. Attach a transport, customs or broker bill with Add bill, or allocate a service line from another invoice.': 'Încă nu există costuri accesorii externe. Atașează o factură de cheltuieli de transport, vamă sau broker cu „Adaugă factură de cheltuieli” sau alocă o linie de serviciu din altă factură.',
  'Net Weight (kg)': 'Greutate netă (kg)',
  'Gross Weight (kg)': 'Greutate brută (kg)',
  'Value': 'Valoare',
  'Item Breakdown by HS Code': 'Defalcare articole pe cod HS',
  'Net (kg)': 'Net (kg)',
  'Gross (kg)': 'Brut (kg)',
  'No customs data available. Ensure imported products have customs data configured.': 'Nu există date vamale. Asigură-te că produsele importate au datele vamale configurate.',
  'Services:': 'Servicii:',
  'Allocated as landed cost; some target invoices still need "Allocate to rows"': 'Alocat ca cost accesoriu; unele facturi țintă necesită încă „Alocă pe rânduri”',
  'Allocated as landed cost and applied to product rows': 'Alocat ca cost accesoriu și aplicat pe rândurile de produse',
  'Landed cost · pending': 'Cost accesoriu · în așteptare',
  'Failed to load bill for copy': 'Factura de cheltuieli nu a putut fi încărcată pentru copiere',
  'Invoice {number} sent to 1C successfully': 'Factura {number} a fost trimisă în 1C cu succes',
  'No invoices selected': 'Nicio factură selectată',
  '{count} invoice(s) failed to send': 'Facturi netrimise: {count}',
  'Failed to send invoices to 1C': 'Trimiterea facturilor în 1C a eșuat',
  'Failed to recalculate totals': 'Recalcularea totalurilor a eșuat',
  'Prices updated: {processed} processed, {current} up-to-date, {failed} failed': 'Actualizare prețuri: procesate {processed}, la zi {current}, eșuate {failed}',
  '{count} invoice(s) failed to update prices': 'Facturi cu prețuri neactualizate: {count}',
  '{days} days overdue': 'Zile de întârziere: {days}',
  'Delete cancelled bill': 'Șterge factura de cheltuieli anulată',
  'Delete cancelled invoice': 'Șterge factura anulată',
  'Sent {date}': 'Trimis {date}',
  'Bill #': 'Factură de cheltuieli #',
  'Bill #{id}': 'Factura de cheltuieli #{id}',
  'Tax Type': 'Tip taxă',
  'Zero-rated import': 'Import cu cotă zero',
  'Due for Payment': 'Scadent la plată',
  'Prices': 'Prețuri',
  'Due for Payment: {amount}': 'Scadent la plată: {amount}',
  'Invoice: {date}': 'Factură: {date}',
  'Due: {date}': 'Termen: {date}',
  'All payments': 'Toate plățile',
  'All types': 'Toate tipurile',
  'All branches': 'Toate filialele',
  'Send to 1C ({count})': 'Trimite în 1C ({count})',
  'Recalculate totals for {count} selected invoice(s)': 'Recalculează totalurile pentru facturile selectate: {count}',
  'Recalculating...': 'Se recalculează...',
  'Recalculate ({count})': 'Recalculează ({count})',
  'Update cost prices from {count} selected invoice(s)': 'Actualizează prețurile de cost din facturile selectate: {count}',
  'Update Prices ({count})': 'Actualizează prețurile ({count})',
  'Loading purchase invoices...': 'Se încarcă facturile de achiziție...',
  'No bills found': 'Nu s-a găsit nicio factură de cheltuieli',
  'No purchase invoices found': 'Nu s-a găsit nicio factură de achiziție',
  'Dispute Purchase Invoice': 'Contestă factura de achiziție',
  'Verify Purchase Invoice': 'Verifică factura de achiziție',
  'Are you sure you want to dispute invoice "{number}"?': 'Sigur vrei să contești factura „{number}”?',
  'Are you sure you want to verify invoice "{number}"?': 'Sigur vrei să verifici factura „{number}”?',
  'Dispute': 'Contestă',
  'Delete Purchase Invoice': 'Șterge factura de achiziție',
  'Are you sure you want to delete invoice "{number}"? This action cannot be undone.': 'Sigur vrei să ștergi factura „{number}”? Această acțiune nu poate fi anulată.',
  '{count} invoice(s) exported to 1C successfully': 'Facturi exportate în 1C cu succes: {count}',
  'Copy to Clipboard': 'Copiază în clipboard',
  'Effective:': 'Efectiv:',
  '{count} pending change': '{count} modificare în așteptare',
  '{count} pending changes': { one: '{count} modificare în așteptare', few: '{count} modificări în așteptare', other: '{count} de modificări în așteptare' },
  'Applying…': 'Se aplică…',
  'Apply All': 'Aplică tot',
  'Rebuilds items from movement history as of the effective date, scoped to the Group/Category set in the header': 'Reconstruiește articolele din istoricul mișcărilor la data efectivă, limitat la grupa/categoria setată în antet',
  'Refill from Movements': 'Recompletează din mișcări',
  'Loading history…': 'Se încarcă istoricul…',
  'No changes recorded yet.': 'Încă nu s-au înregistrat modificări.',
  'Effective Date & Time': 'Data și ora efectivă',
  'Select warehouse...': 'Selectează depozitul...',
  'Auto (first available)': 'Auto (prima disponibilă)',
  'Product group scope (used by Refill from Movements on resets)': 'Limitare la grupa de produse (folosită de „Recompletează din mișcări” la resetări)',
  'Product category scope (used by Refill from Movements on resets)': 'Limitare la categoria de produse (folosită de „Recompletează din mișcări” la resetări)',
  'Overall reason...': 'Motiv general...',
  'Toggle +/-': 'Inversează +/-',
  'Re-point pending lines onto the batch that should hold the stock: newest batch for a surplus, earliest expiry still holding stock for a shortfall': 'Mută liniile în așteptare pe lotul care ar trebui să dețină stocul: cel mai nou lot pentru un surplus, lotul cu cea mai apropiată expirare care mai are stoc pentru un minus',
  'Fix Batches': 'Corectează loturile',
  'Set Expiry': 'Setează expirarea',
  'Populate unit cost from product cost price': 'Completează costul unitar din prețul de cost al produsului',
  'Refill Costs': 'Recompletează costurile',
  'Value:': 'Valoare:',
  'Search product...': 'Caută produs...',
  'Warehouse...': 'Depozit...',
  'Auto': 'Auto',
  '-5 or +3': '-5 sau +3',
  'Cost': 'Cost',
  'Stage new row (applied on Apply Changes)': 'Pregătește un rând nou (se aplică la „Aplică modificările”)',
  'new': 'nou',
  'auto': 'auto',
  'Remove staged row': 'Elimină rândul pregătit',
  'Set Expiry Date': 'Setează data expirării',
  'Set expiry date for batches of {count} selected item(s).': 'Setează data expirării pentru loturile articolelor selectate: {count}.',
  'Failed to load mapped products': 'Produsele asociate nu au putut fi încărcate',
  'Failed to load supplier statement': 'Fișa furnizorului nu a putut fi încărcată',
  'Both fields are required': 'Ambele câmpuri sunt obligatorii',
  'Mapping added': 'Asocierea a fost adăugată',
  'Mapping updated': 'Asocierea a fost actualizată',
  'Failed to save mapping': 'Asocierea nu a putut fi salvată',
  'Mapping deleted': 'Asocierea a fost ștearsă',
  'Failed to delete mapping': 'Asocierea nu a putut fi ștearsă',
  'No valid items found': 'Nu s-a găsit niciun articol valid',
  '{created} created, {updated} updated': 'Create: {created}, actualizate: {updated}',
  'Failed to import items': 'Importul articolelor a eșuat',
  'Please assign a "Supplier Product Name" column': 'Atribuie o coloană „Denumire produs la furnizor”',
  'Failed to map product': 'Produsul nu a putut fi asociat',
  'Updated': 'Actualizat',
  'Failed to add': 'Adăugarea a eșuat',
  'Cleared {cleared} items': 'Articole golite: {cleared}',
  'Failed to clear column': 'Coloana nu a putut fi golită',
  'Product "{name}" created and mapped': 'Produsul „{name}” a fost creat și asociat',
  'No products selected': 'Niciun produs selectat',
  'This will create {created} new product(s) and update {updated} existing product(s) with supplier barcode. Continue?': 'Produse noi de creat: {created}. Produse existente de actualizat cu codul de bare al furnizorului: {updated}. Continui?',
  'Created: {created}, Updated: {updated}, Errors: {errors}': 'Create: {created}, actualizate: {updated}, erori: {errors}',
  'Created: {created}, Updated: {updated}': 'Create: {created}, actualizate: {updated}',
  'Bulk operation failed': 'Operațiunea în masă a eșuat',
  'Delete this mapping?': 'Ștergi această asociere?',
  'No matches found for unmapped products': 'Nu s-au găsit potriviri pentru produsele neasociate',
  'Found {count} potential match(es)': 'Potriviri posibile găsite: {count}',
  'Auto-match failed': 'Potrivirea automată a eșuat',
  'No matches selected': 'Nicio potrivire selectată',
  'Mapped {applied} product(s)': 'Produse asociate: {applied}',
  'Supplier updated successfully': 'Furnizorul a fost actualizat cu succes',
  'Failed to update supplier': 'Furnizorul nu a putut fi actualizat',
  'GS1 mappings updated successfully': 'Asocierile GS1 au fost actualizate cu succes',
  'Failed to update GS1 mappings': 'Asocierile GS1 nu au putut fi actualizate',
  'Enter a barcode value before auto-detecting': 'Introdu o valoare de cod de bare înainte de detectarea automată',
  'Replace {count} existing mapping(s) with auto-detected ones?': 'Înlocuiești asocierile existente cu cele detectate automat? Asocieri existente: {count}',
  'Failed to parse barcode': 'Codul de bare nu a putut fi interpretat',
  'No GS1 AIs detected in this barcode': 'Nu s-au detectat AI-uri GS1 în acest cod de bare',
  'Detected {count} AI(s) ({history} from supplier history)': 'AI-uri detectate: {count} ({history} din istoricul furnizorului)',
  'Detected {count} AI(s)': 'AI-uri detectate: {count}',
  'Barcode configurations updated successfully': 'Configurațiile codurilor de bare au fost actualizate cu succes',
  'Failed to update barcode configurations': 'Configurațiile codurilor de bare nu au putut fi actualizate',
  'Loading supplier...': 'Se încarcă furnizorul...',
  'Back to Suppliers': 'Înapoi la Furnizori',
  'Supplier not found': 'Furnizorul nu a fost găsit',
  'Balance ({currency})': 'Sold ({currency})',
  'Credit (overpayment)': 'Credit (plată în plus)',
  'Amount owed to supplier': 'Sumă datorată furnizorului',
  'Balance (GBP)': 'Sold (GBP)',
  'Currency': 'Monedă',
  'Company Name': 'Numele companiei',
  '+ Manage list': '+ Gestionează lista',
  'https://example.com': 'https://example.com',
  'Contact Information': 'Informații de contact',
  'Postal Code': 'Cod poștal',
  'Business Terms': 'Condiții comerciale',
  'Default Currency': 'Monedă implicită',
  'Default Tax Regime': 'Regim fiscal implicit',
  'Delivery Lead Time (days)': 'Termen de livrare (zile)',
  'A weighed purchase order line (kg) counts as fully received when it arrives no more than this percent short. Lines in pieces must arrive in full.': 'O linie cântărită (kg) din comanda de achiziție este considerată recepționată integral când lipsa nu depășește acest procent. Liniile în bucăți trebuie să sosească integral.',
  'Receive Tolerance, weighed goods (%)': 'Toleranță la recepție, mărfuri cântărite (%)',
  'Minimum Order Amount': 'Valoare minimă a comenzii',
  'Default Payment Type': 'Tip de plată implicit',
  '-- Select Payment Type --': '-- Selectează tipul de plată --',
  'Default Category': 'Categorie implicită',
  '-- Select Category --': '-- Selectează categoria --',
  'Additional notes about this supplier...': 'Note suplimentare despre acest furnizor...',
  'Supplier Contacts': 'Contacte furnizor',
  'Add Contact': 'Adaugă contact',
  'Title': 'Titlu',
  'Department': 'Departament',
  'No contacts found for this supplier': 'Nu s-a găsit niciun contact pentru acest furnizor',
  'Barcode Label Configurations': 'Configurații etichete cu coduri de bare',
  'Configure supplier barcode label types with multiple barcodes and GS1 AI mappings': 'Configurează tipurile de etichete ale furnizorului cu mai multe coduri de bare și asocieri AI GS1',
  'Edit Configurations': 'Editează configurațiile',
  'Label Type Name (e.g., Pallet Label, Box Label)': 'Denumire tip etichetă (ex. Etichetă palet, Etichetă cutie)',
  'Priority: {priority}': 'Prioritate: {priority}',
  'Available in Receipt': 'Disponibil la recepție',
  'Available in Picking': 'Disponibil la culegere',
  'Barcode value (e.g., 01234567890123)': 'Valoare cod de bare (ex. 01234567890123)',
  'Parse this barcode and auto-fill GS1 AI mappings': 'Interpretează acest cod de bare și completează automat asocierile AI GS1',
  'Auto-detect': 'Detectează automat',
  'Ignored': 'Ignorat',
  'Ignore this barcode': 'Ignoră acest cod de bare',
  'GS1 AI Mappings': 'Asocieri AI GS1',
  'Add AI Mapping': 'Adaugă asociere AI',
  '(00) SSCC': '(00) SSCC',
  '(01) GTIN': '(01) GTIN',
  '(02) Content': '(02) Conținut',
  '(10) Batch/Lot': '(10) Lot',
  '(11) Production Date': '(11) Data producției',
  '(17) Expiry Date': '(17) Data expirării',
  '(21) Serial Number': '(21) Număr de serie',
  '(37) Count': '(37) Număr de bucăți',
  '(90) Mutually Agreed': '(90) Convenit reciproc',
  '(241) Customer Part': '(241) Cod piesă client',
  '(426) Frequency of Shipments': '(426) Frecvența expedierilor',
  '(3100) Net Weight (0 dp)': '(3100) Greutate netă (0 zecimale)',
  '(3101) Net Weight (1 dp)': '(3101) Greutate netă (1 zecimală)',
  '(3102) Net Weight (2 dp)': '(3102) Greutate netă (2 zecimale)',
  '(3103) Net Weight (3 dp)': '(3103) Greutate netă (3 zecimale)',
  '(3104) Net Weight (4 dp)': '(3104) Greutate netă (4 zecimale)',
  '(3105) Net Weight (5 dp)': '(3105) Greutate netă (5 zecimale)',
  '(3300) Gross Weight (0 dp)': '(3300) Greutate brută (0 zecimale)',
  '(3301) Gross Weight (1 dp)': '(3301) Greutate brută (1 zecimală)',
  '(3302) Gross Weight (2 dp)': '(3302) Greutate brută (2 zecimale)',
  '(3303) Gross Weight (3 dp)': '(3303) Greutate brută (3 zecimale)',
  '(3304) Gross Weight (4 dp)': '(3304) Greutate brută (4 zecimale)',
  '(3305) Gross Weight (5 dp)': '(3305) Greutate brută (5 zecimale)',
  'Receipt Fields': 'Câmpuri recepție',
  'ReceiptItem.production_date': 'ReceiptItem.production_date',
  'ReceiptItem.expiry_date': 'ReceiptItem.expiry_date',
  'ReceiptItem.net_quantity_kg': 'ReceiptItem.net_quantity_kg',
  'ReceiptItem.gross_weight_kg': 'ReceiptItem.gross_weight_kg',
  'ReceiptItem.supplier_batch_code': 'ReceiptItem.supplier_batch_code',
  'ReceiptItem.received_quantity': 'ReceiptItem.received_quantity',
  'ReceiptItem.scanned_barcode_data': 'ReceiptItem.scanned_barcode_data',
  'Picking Fields': 'Câmpuri culegere',
  'PickingItem.quantity_picked': 'PickingItem.quantity_picked',
  'PickingItem.notes': 'PickingItem.notes',
  'Product Identifier': 'Identificator produs',
  'Ignore': 'Ignoră',
  'No AI mappings configured': 'Nicio asociere AI configurată',
  'No barcodes defined for this label type': 'Niciun cod de bare definit pentru acest tip de etichetă',
  'No barcode label configurations for this supplier': 'Nicio configurație de etichete cu coduri de bare pentru acest furnizor',
  'Configure label types with multiple barcodes and GS1 AI mappings to enable automatic field population during scanning operations.': 'Configurează tipuri de etichete cu mai multe coduri de bare și asocieri AI GS1 pentru a completa automat câmpurile în timpul scanării.',
  'Purchase Documents': 'Documente de achiziție',
  'All Documents': 'Toate documentele',
  'Supplier Performance': 'Performanța furnizorului',
  'Total Orders': 'Total comenzi',
  'Total Invoices': 'Total facturi',
  'Total Spend': 'Cheltuieli totale',
  'Avg Invoice Value': 'Valoare medie factură',
  'Unpaid Balance': 'Sold neachitat',
  'Overdue Invoices': 'Facturi restante',
  'Total Returns': 'Total retururi',
  '{count} debit notes': { one: '{count} notă de debit', few: '{count} note de debit', other: '{count} de note de debit' },
  'On-Time Delivery': 'Livrare la timp',
  'Order Status Breakdown ({days} days)': 'Comenzi pe stări (zile: {days})',
  'No orders in this period': 'Nicio comandă în această perioadă',
  'Invoice Payment Status ({days} days)': 'Stare plată facturi (zile: {days})',
  'No invoices in this period': 'Nicio factură în această perioadă',
  'Monthly Spend (Last 12 Months)': 'Cheltuieli lunare (ultimele 12 luni)',
  'Spend in Period ({days} days)': 'Cheltuieli în perioadă (zile: {days})',
  'Loading performance data...': 'Se încarcă datele de performanță...',
  'Unmap': 'Anulează asocierea',
  'Create new product from this entry': 'Creează un produs nou din această intrare',
  'Supplier Products ({count})': 'Produse furnizor ({count})',
  'Matching...': 'Se potrivește...',
  'Auto-match': 'Potrivire automată',
  'Processing...': 'Se procesează...',
  'Create / Update ({count})': 'Creează / Actualizează ({count})',
  'Create / Update': 'Creează / Actualizează',
  'Clear Column': 'Golește coloana',
  'Import List': 'Importă lista',
  'Paste supplier product list (tab-separated: Name, SKU, Unit Cost, Unit — one per line)': 'Lipește lista de produse a furnizorului (separate prin tab: Nume, SKU, Cost unitar, Unitate — câte unul pe linie)',
  'Importing...': 'Se importă...',
  'Import': 'Importă',
  'Hide Unit Mappings ({count})': 'Ascunde asocierile de unități ({count})',
  'Show Unit Mappings ({count})': 'Arată asocierile de unități ({count})',
  'Supplier Unit Mappings': 'Asocieri unități furnizor',
  "Map supplier's unit names to your system units. Used to auto-resolve units during import.": 'Asociază denumirile unităților furnizorului cu unitățile din sistem. Folosite pentru rezolvarea automată a unităților la import.',
  'Supplier Unit': 'Unitate furnizor',
  'System Unit': 'Unitate sistem',
  'Supplier unit (e.g., Buc)': 'Unitate furnizor (ex. Buc)',
  'Select system unit': 'Selectează unitatea din sistem',
  'Auto-match Results ({accepted}/{total} selected)': 'Rezultate potrivire automată ({accepted}/{total} selectate)',
  'Apply Selected': 'Aplică selectatele',
  'Supplier Product': 'Produs furnizor',
  'Matched Product': 'Produs potrivit',
  'Match %': 'Potrivire %',
  "No products for this supplier. Use \"Import List\" to add supplier's product list.": 'Niciun produs pentru acest furnizor. Folosește „Importă lista” pentru a adăuga lista de produse a furnizorului.',
  'Add new': 'Adaugă nou',
  'Save first, then map': 'Salvează mai întâi, apoi asociază',
  'Select a column to clear for all supplier products:': 'Selectează o coloană de golit pentru toate produsele furnizorului:',
  'Select column...': 'Selectează coloana...',
  'Country': 'Țară',
  'Updated {count} supplier(s)': 'Furnizori actualizați: {count}',
  'Deleted {count} supplier(s)': 'Furnizori șterși: {count}',
  'Contact: {name}': 'Contact: {name}',
  'Created: {date}': 'Creat: {date}',
  'on': 'active',
  'New Supplier': 'Furnizor nou',
  'Supplies': 'Ce furnizează',
  'Select all {count} matching': 'Selectează toate rezultatele ({count})',
  'Edit selected': 'Editează selectații',
  'Delete selected': 'Șterge selectații',
  'Loading suppliers...': 'Se încarcă furnizorii...',
  '1 supplier': '1 furnizor',
  '{count} suppliers': { one: '{count} furnizor', few: '{count} furnizori', other: '{count} de furnizori' },
  'Some suppliers were kept': 'Unii furnizori au fost păstrați',
  'Delete {count} supplier(s)?': 'Ștergi furnizorii selectați ({count})?',
  'Deleted {deleted} supplier(s). The {kept} below were kept because they have movements on record - they stay selected so you can review them.': 'Furnizori șterși: {deleted}. Cei de mai jos ({kept}) au fost păstrați pentru că au mișcări înregistrate - rămân selectați ca să îi poți verifica.',
  'This permanently deletes the selected suppliers. Any supplier with movements - purchase orders, invoices, debit notes, cash transactions, opening balances, goods receipts or stock batches - is skipped automatically and reported back.': 'Aceasta șterge definitiv furnizorii selectați. Orice furnizor cu mișcări - comenzi de achiziție, facturi, note de debit, tranzacții de numerar, solduri inițiale, recepții de marfă sau loturi de stoc - este omis automat și raportat.',
  'This cannot be undone. Deactivating a supplier is the reversible alternative.': 'Acțiunea nu poate fi anulată. Dezactivarea unui furnizor este alternativa reversibilă.',
  'Deleting...': 'Se șterge...',
  'Delete {count}': 'Șterge ({count})',
  'Edit {count} supplier(s)': 'Editează furnizorii ({count})',
  'Only the fields you change below are applied. Anything left on "Leave unchanged" stays as it is on each supplier.': 'Se aplică doar câmpurile pe care le modifici mai jos. Tot ce rămâne pe „Lasă neschimbat” rămâne așa cum este la fiecare furnizor.',
  'Leave unchanged': 'Lasă neschimbat',
  'Set country': 'Setează țara',
  'e.g., United Kingdom (leave empty to clear)': 'ex. Regatul Unit (lasă gol pentru a șterge)',
  'Apply to {count}': 'Aplică la selecție ({count})',
  'Delete Supplier': 'Șterge furnizorul',
  'Are you sure you want to delete supplier "{name}"? This action cannot be undone.': 'Sigur vrei să ștergi furnizorul „{name}”? Această acțiune nu poate fi anulată.',
  'Field sales': 'Agent de teren',
  "Production Summary": "Rezumat producție",
  "Total Input": "Total intrare",
  "Finished Product": "Produs finit",
  "Specific Consumption": "Consum specific",
  "Shrinkage": "Scăzământ",
  "Cost per kg": "Cost pe kg",
  "Total Cost": "Cost total",
  "Cost/Unit (£)": "Cost/unitate (£)",
  "Cost (£)": "Cost (£)",
  "Protein (g)": "Proteine (g)",
  "Fat (g)": "Grăsimi (g)",
  "Water (g)": "Apă (g)",
  "Add Components by Copy/Paste": "Adaugă componente prin copiere/lipire",
  "Paste tab-separated data from Excel/spreadsheet.": "Lipește date separate prin tab din Excel/foaie de calcul.",
  "Multiple hierarchy formats supported:": "Sunt acceptate mai multe formate de ierarhie:",
  "Method 1: Excel Right-Align (Easiest!)": "Metoda 1: aliniere la dreapta în Excel (cea mai simplă!)",
  "1. In Excel, select child items → Right-click → Format Cells → Alignment → Horizontal: Right": "1. În Excel, selectează articolele copil → clic dreapta → Format Cells → Alignment → Horizontal: Right",
  "2. Or use Ctrl+R to right-align selected cells": "2. Sau folosește Ctrl+R pentru a alinia la dreapta celulele selectate",
  "3. Right-aligned cells get leading spaces that create hierarchy!": "3. Celulele aliniate la dreapta primesc spații la început, care creează ierarhia!",
  "Method 2: Empty Columns": "Metoda 2: coloane goale",
  "[empty]Product A[TAB]Quantity": "[gol]Produs A[TAB]Cantitate",
  "[TAB]Product B[TAB]Quantity (child of A)": "[TAB]Produs B[TAB]Cantitate (copil al lui A)",
  "Method 3: Prefix System": "Metoda 3: sistem cu prefix",
  "Product A[TAB]Quantity": "Produs A[TAB]Cantitate",
  ">Product B[TAB]Quantity (child of A)": ">Produs B[TAB]Cantitate (copil al lui A)",
  ">>Product C[TAB]Quantity (grandchild)": ">>Produs C[TAB]Cantitate (nepot)",
  "Method 4: Level Column": "Metoda 4: coloană de nivel",
  "0[TAB]Product A[TAB]Quantity": "0[TAB]Produs A[TAB]Cantitate",
  "1[TAB]Product B[TAB]Quantity (child)": "1[TAB]Produs B[TAB]Cantitate (copil)",
  "Quantity is typically in column 8. Check console (F12) for parsing details.": "Cantitatea este de obicei în coloana 8. Verifică consola (F12) pentru detaliile de interpretare.",
  "Paste from Excel with hierarchy... System will auto-detect format.": "Lipește din Excel cu ierarhie... Sistemul va detecta automat formatul.",
  "Add Components": "Adaugă componente",
  "Match Unrecognized Products": "Potrivește produsele nerecunoscute",
  "{count} products could not be found. Please match them with existing products or skip.": { one: "{count} produs nu a putut fi găsit. Potrivește-l cu un produs existent sau sari peste.", few: "{count} produse nu au putut fi găsite. Potrivește-le cu produse existente sau sari peste.", other: "{count} de produse nu au putut fi găsite. Potrivește-le cu produse existente sau sari peste." },
  "{count} product could not be found. Please match them with existing products or skip.": { one: "{count} produs nu a putut fi găsit. Potrivește-l cu un produs existent sau sari peste.", few: "{count} produse nu au putut fi găsite. Potrivește-le cu produse existente sau sari peste.", other: "{count} de produse nu au putut fi găsite. Potrivește-le cu produse existente sau sari peste." },
  "Search for a product to match...": "Caută un produs de potrivit...",
  "Or select from similar products:": "Sau alege dintre produsele similare:",
  "{matched} of {total} products matched": "Produse potrivite: {matched} din {total}",
  "Add Matched Components": "Adaugă componentele potrivite",
  "No cost history yet — entries are recorded when raw material prices change, components/operations are edited, or prices are manually refreshed.": "Încă nu există istoric de costuri — înregistrările apar când se schimbă prețurile materiilor prime, când se editează componentele/operațiile sau când prețurile sunt reîmprospătate manual.",
  "Source": "Sursă",
  "Old /{unit}": "Vechi /{unit}",
  "New /{unit}": "Nou /{unit}",
  "/{unit} Change": "Modificare /{unit}",
  "Total Change": "Modificare totală",
  "By": "De către",
  "Search and select product...": "Caută și selectează produsul...",
  "BOM Name": "Nume rețetă",
  "e.g., Retail Cut, Wholesale Cut": "ex. Tranșare retail, Tranșare en-gros",
  "Optional name to differentiate multiple BOMs (recommended for disassembly BOMs)": "Nume opțional pentru a deosebi mai multe rețete (recomandat pentru rețetele de dezasamblare)",
  "e.g., 250830": "ex. 250830",
  "Auto-fill with today's date (YYMMDD format)": "Completează automat cu data de azi (format AALLZZ)",
  "e.g., 1, A, Rev1": "ex. 1, A, Rev1",
  "Cost Price Type": "Tip preț de cost",
  "(Default: {name})": "(Implicit: {name})",
  "Reload all component prices from selected price type": "Reîncarcă toate prețurile componentelor din tipul de preț selectat",
  "BOM Type": "Tip rețetă",
  "Disassembly BOM": "Rețetă de dezasamblare",
  "Assembly BOM": "Rețetă de asamblare",
  "Combine inputs": "Combină intrările",
  "Break down product": "Descompune produsul",
  "Click to set yield quantity equal to base quantity (100% efficiency)": "Apasă pentru a seta cantitatea obținută egală cu cantitatea de bază (eficiență 100%)",
  "Click to use {amount}{unit} as yield quantity": "Apasă pentru a folosi {amount}{unit} drept cantitate obținută",
  "Operations": "Operații",
  "Time": "Timp",
  "Days": "Zile",
  "Set as active BOM": "Setează ca rețetă activă",
  "Can be purchased instead of manufactured": "Poate fi cumpărat în loc să fie fabricat",
  "Additional notes about this BOM...": "Note suplimentare despre această rețetă...",
  "Click to set 100% efficiency (yield = base quantity)": "Apasă pentru a seta eficiența la 100% (cantitate obținută = cantitate de bază)",
  "Open product detail": "Deschide detaliile produsului",
  "Unknown Product": "Produs necunoscut",
  "Optional name": "Nume opțional",
  "Edit yield in the Components header": "Editează randamentul în antetul Componente",
  "Validity": "Valabilitate",
  "Input Cost": "Cost intrare",
  "Updates automatically when the product's cost price changes": "Se actualizează automat când se schimbă prețul de cost al produsului",
  "Refresh input cost from the product's current cost price and re-allocate outputs": "Reîmprospătează costul de intrare din prețul de cost curent al produsului și realocă ieșirile",
  "Updates automatically when a component's cost price changes": "Se actualizează automat când se schimbă prețul de cost al unei componente",
  "£{amount} · {count} comp": "£{amount} · {count} comp.",
  "£{amount} · {count} op": "£{amount} · {count} op.",
  "£{amount} · {count} ops": "£{amount} · {count} op.",
  "Snapshot": "Instantaneu",
  "no snapshot": "fără instantaneu",
  "Input Material: {pct}%": "Materie primă de intrare: {pct}%",
  "Materials: {pct}%": "Materii prime: {pct}%",
  "Disassembly Ops: {pct}%": "Operații de dezasamblare: {pct}%",
  "Operations: {pct}%": "Operații: {pct}%",
  "Output Summary": "Rezumat ieșiri",
  "Outputs": "Ieșiri",
  "Waste": "Deșeuri",
  "Recovery": "Recuperare",
  "Output Cost": "Cost ieșiri",
  "of £{amount} input": "din £{amount} intrare",
  "Yield": "Randament",
  "({gap}% gap)": "(diferență {gap}%)",
  "Composition Analysis": "Analiză compoziție",
  "Spec. Consumption": "Consum spec.",
  "No spec set": "Nicio specificație setată",
  "Warning": "Avertisment",
  "Unset": "Nesetat",
  "Specific Consumption:": "Consum specific:",
  "Auto-update costs": "Actualizare automată costuri",
  "Auto-update input cost when the product's cost price changes": "Actualizează automat costul de intrare când se schimbă prețul de cost al produsului",
  "Auto-update component costs when their cost prices change": "Actualizează automat costurile componentelor când li se schimbă prețurile de cost",
  "Enter BOM notes...": "Introdu note pentru rețetă...",
  "Select a product": "Selectează un produs",
  "Input substitute added": "Înlocuitorul de intrare a fost adăugat",
  "Failed to add input substitute": "Înlocuitorul de intrare nu a putut fi adăugat",
  "Delete this input substitute?": "Ștergi acest înlocuitor de intrare?",
  "Input substitute deleted": "Înlocuitorul de intrare a fost șters",
  "Input substitutes ({count})": "Înlocuitori de intrare ({count})",
  "Products the operator may break down instead of {product} — same outputs, same yields.": "Produse pe care operatorul le poate descompune în locul lui {product} — aceleași ieșiri, aceleași randamente.",
  "Ratio": "Raport",
  "Mode": "Mod",
  "Substitute Only": "Doar înlocuire",
  "Addition Only": "Doar adăugare",
  "Ratio updated": "Raportul a fost actualizat",
  "Mode updated": "Modul a fost actualizat",
  "Substitute": "Înlocuire",
  "Addition": "Adăugare",
  "Activated": "Activat",
  "Deactivated": "Dezactivat",
  "No input substitutes — only {product} can be used.": "Niciun înlocuitor de intrare — se poate folosi doar {product}.",
  "Add operations first.": "Adaugă mai întâi operații.",
  "Enter work instructions...": "Introdu instrucțiunile de lucru...",
  "No instructions": "Nicio instrucțiune",
  "Safety Notes": "Note de siguranță",
  "Enter safety requirements...": "Introdu cerințele de siguranță...",
  "No safety notes": "Nicio notă de siguranță",
  "Quality Standards": "Standarde de calitate",
  "Enter quality standards...": "Introdu standardele de calitate...",
  "No quality standards": "Niciun standard de calitate",
  "Select an Operation": "Selectează o operație",
  "Choose an operation to view instructions.": "Alege o operație pentru a vedea instrucțiunile.",
  "Click again to confirm deletion": "Apasă din nou pentru a confirma ștergerea",
  "Click to prepare for deletion": "Apasă pentru a pregăti ștergerea",
  "Sequence number": "Număr de secvență",
  "Add sub-component": "Adaugă subcomponentă",
  "Component": "Componentă",
  "Variant \"{name}\" created (BOM {bom_code}) — this row now uses it": "Varianta „{name}” a fost creată (rețeta {bom_code}) — acest rând o folosește acum",
  "Search materials...": "Caută materii prime...",
  "Edit product": "Editează produsul",
  "Create new product and select it here": "Creează un produs nou și selectează-l aici",
  "+new": "+nou",
  "Hide details": "Ascunde detaliile",
  "Show details": "Arată detaliile",
  "Click to use calculated quantity: {quantity}": "Apasă pentru a folosi cantitatea calculată: {quantity}",
  "Yield % (auto-calculated from quantity)": "Randament % (calculat automat din cantitate)",
  "Cost allocation percentage": "Procent de alocare a costului",
  "Critical": "Critic",
  "Type:": "Tip:",
  "Finished": "Finit",
  "Semi": "Semifabricat",
  "Raw": "Materie primă",
  "Parent:": "Părinte:",
  "🏠 Root": "🏠 Rădăcină",
  "Op:": "Op.:",
  "No Op": "Fără op.",
  "Validity:": "Valabilitate:",
  "Optional": "Opțional",
  "MV Source:": "Sursă VP:",
  "MV Ref:": "Ref. VP:",
  "Reference product...": "Produs de referință...",
  "MV %:": "% VP:",
  "Cost/kg:": "Cost/kg:",
  "MV/kg:": "VP/kg:",
  "£/kg": "£/kg",
  "Source:": "Sursă:",
  "By BOM": "Din rețetă",
  "Flexible": "Flexibil",
  "BOM...": "Rețetă...",
  "Produced by:": "Produs de:",
  "Operation of the source BOM that yields this semi-product": "Operația din rețeta sursă care produce acest semifabricat",
  "Last op (auto)": "Ultima op. (auto)",
  "Create a per-size copy of the referenced BOM (nested shared semis stay shared) and use it on this row": "Creează o copie pe mărime a rețetei referite (semifabricatele comune imbricate rămân comune) și folosește-o pe acest rând",
  "Duplicate as variant": "Duplică ca variantă",
  "New product name…": "Nume produs nou…",
  "→ made at": "→ produs la",
  "Source materials ({count})": "Materii prime sursă ({count})",
  "Substitutes ({count})": "Înlocuitori ({count})",
  "Autofilled from": "Completat automat din",
  ". Quantities stay live with that BOM — edit it there. Choose here which operation consumes each material.": ". Cantitățile rămân sincronizate cu acea rețetă — editeaz-o acolo. Alege aici ce operație consumă fiecare materie primă.",
  "rerouted": "redirecționat",
  "Substitute added": "Înlocuitorul a fost adăugat",
  "Failed to add substitute": "Înlocuitorul nu a putut fi adăugat",
  "Failed to update ratio": "Raportul nu a putut fi actualizat",
  "Sub": "Înloc.",
  "Delete this substitute?": "Ștergi acest înlocuitor?",
  "Substitute deleted": "Înlocuitorul a fost șters",
  "No approved substitutes defined": "Niciun înlocuitor aprobat definit",
  "Product \"{name}\" updated": "Produsul „{name}” a fost actualizat",
  "Copy \"{name}\" created and selected on this row": "Copia „{name}” a fost creată și selectată pe acest rând",
  "Product \"{name}\" created": "Produsul „{name}” a fost creat",
  "Copy \"{name}\" created — switch the BOM to edit mode to use it here": "Copia „{name}” a fost creată — trece rețeta în modul de editare pentru a o folosi aici",
  "Add Operation": "Adaugă operație",
  "Select Operation": "Selectează operația",
  "Remove operation": "Elimină operația",
  "Mandatory": "Obligatorie",
  "Outsourced": "Externalizată",
  "Parallel": "Paralelă",
  "QC": "CC",
  "Setup": "Pregătire",
  "Cleanup": "Curățare",
  "Labor Rate £": "Tarif manoperă £",
  "Machine Rate £": "Tarif mașină £",
  "Attendance": "Prezență",
  "Operators": "Operatori",
  "Labor Time": "Timp manoperă",
  "Labor £{rate}/hr": "Manoperă £{rate}/oră",
  "Machine £{rate}/hr": "Mașină £{rate}/oră",
  "Labor £{amount}": "Manoperă £{amount}",
  "Machine £{amount}": "Mașină £{amount}",
  "Total Costs": "Costuri totale",
  "Labour": "Manoperă",
  "Machine": "Mașină",
  "No operations": "Nicio operație",
  "Click \"Add Operation\" to get started.": "Apasă „Adaugă operație” pentru a începe.",
  "This BOM doesn't have any operations defined yet.": "Această rețetă nu are încă nicio operație definită.",
  "Stock on hand": "Stoc disponibil",
  "stock {quantity} {unit}": "stoc {quantity} {unit}",
  "BOM Details Preview": "Previzualizare detalii rețetă",
  "BOM Type:": "Tip rețetă:",
  "Base Quantity:": "Cantitate de bază:",
  "Yield Quantity:": "Cantitate obținută:",
  "Estimated Cost:": "Cost estimat:",
  "Order: £{amount}": "Comandă: £{amount}",
  "semi": "semifabricat",
  "Materials ({count}):": "Materii prime ({count}):",
  "Operations ({count}):": "Operații ({count}):",
  "Failed to load pending cost updates": "Actualizările de cost în așteptare nu au putut fi încărcate",
  "Cost update approved": "Actualizarea costului a fost aprobată",
  "Approve failed": "Aprobarea a eșuat",
  "Reason for rejecting this cost update?": "Motivul respingerii acestei actualizări de cost?",
  "Cost update rejected": "Actualizarea costului a fost respinsă",
  "Reject failed": "Respingerea a eșuat",
  "Reason for rejecting selected updates?": "Motivul respingerii actualizărilor selectate?",
  "Bulk action failed": "Acțiunea în masă a eșuat",
  "Loading pending cost updates…": "Se încarcă actualizările de cost în așteptare…",
  "No {status} cost updates for this release.": "Nu există actualizări de cost cu starea {status} pentru această lansare.",
  "Proposed": "Propus",
  "Off baseline — review before approving": "În afara referinței — verifică înainte de aprobare",
  "Check cost": "Verifică costul",
  "Approve with override": "Aprobă cu suprascriere",
  "Save & Approve": "Salvează și aprobă",
  "Approve with manual amount": "Aprobă cu sumă introdusă manual",
  "materials ÷": "materii prime ÷",
  "produced =": "produs =",
  "per unit": "pe unitate",
  "Disassembly: {percent}% of the input cost allocated to this output": "Dezasamblare: {percent}% din costul de intrare alocat acestei ieșiri",
  "Off baseline": "În afara referinței",
  "Approved:": "Aprobat:",
  "Rejected:": "Respins:",
  "Consumed": "Consumat",
  "% of cost": "% din cost",
  "Semi-product made in this production — its cost is traced from the purchase batches that flowed into it": "Semifabricat realizat în această producție — costul său este urmărit din loturile de achiziție care au intrat în el",
  "Consumed quantity far exceeds produced quantity — check units/quantities": "Cantitatea consumată depășește cu mult cantitatea produsă — verifică unitățile/cantitățile",
  "Total materials": "Total materii prime",
  "Variance:": "Diferență:",
  "Unknown Operation": "Operație necunoscută",
  "Work Centre Type": "Tip centru de lucru",
  "Work Centre": "Centru de lucru",
  "Not assigned": "Nealocat",
  "Duration": "Durată",
  "Planned:": "Planificat:",
  "Actual:": "Efectiv:",
  "Cost / Efficiency": "Cost / eficiență",
  "{percent}% efficiency": "eficiență {percent}%",
  "Blocked:": "Blocat:",
  "Back to production orders": "Înapoi la comenzile de producție",
  "Partial run (up to {operation}) — produces {quantity} {unit} {product}": "Rulare parțială (până la {operation}) — produce {quantity} {unit} {product}",
  "Partial run — produces {quantity} {unit} {product}": "Rulare parțială — produce {quantity} {unit} {product}",
  "Item {number}": "Articolul {number}",
  "Type to search for products": "Scrie pentru a căuta produse",
  "No products found matching your search": "Nu s-au găsit produse care să corespundă căutării",
  "BOM auto-selected:": "Rețetă selectată automat:",
  "No BOMs found. Create a BOM first.": "Nu s-au găsit rețete. Creează mai întâi o rețetă.",
  "Negative stock — tap to set quantity to cover it": "Stoc negativ — atinge pentru a seta cantitatea care să-l acopere",
  "BOM": "Rețetă",
  "Select BOM...": "Selectează rețeta...",
  "Open BOM detail page": "Deschide pagina de detalii a rețetei",
  "Fill with the maximum producible quantity from available input stock": "Completează cu cantitatea maximă care se poate produce din stocul de intrare disponibil",
  "Very Low": "Foarte scăzută",
  "Any additional notes for this production order...": "Orice note suplimentare pentru această comandă de producție...",
  "Planned Start": "Început planificat",
  "No BOM": "Fără rețetă",
  "Required Inputs": "Intrări necesare",
  "Recalculate required materials from BOM": "Recalculează materiile prime necesare din rețetă",
  "Regeneration disabled: production has already started on this WIP": "Regenerarea este dezactivată: producția a început deja pe acest WIP",
  "Input Product": "Produs de intrare",
  "required": "necesar",
  "No materials found for this production order.": "Nu s-au găsit materii prime pentru această comandă de producție.",
  "Production Operations": "Operații de producție",
  "Refresh operations data": "Reîmprospătează datele operațiilor",
  "No operations found for this production order.": "Nu s-au găsit operații pentru această comandă de producție.",
  "Expected Outputs": "Ieșiri așteptate",
  "{count} product": { one: "{count} produs", few: "{count} produse", other: "{count} de produse" },
  "Good": "Bune",
  "Market value / unit:": "Valoare de piață / unitate:",
  "Allocated cost:": "Cost alocat:",
  "Associated Batches": "Loturi asociate",
  "Planned Quantity": "Cantitate planificată",
  "No expected outputs": "Nicio ieșire așteptată",
  "Expected outputs will be generated when the production order is processed.": "Ieșirile așteptate vor fi generate când comanda de producție este procesată.",
  "Production Timeline": "Cronologie producție",
  "Actual Start": "Început efectiv",
  "Current Progress": "Progres curent",
  "from {product} — {quantity} {unit} available": "din {product} — {quantity} {unit} disponibil",
  "Search orders...": "Caută comenzi...",
  "All Priority": "Toate prioritățile",
  "Select all ({count})": "Selectează tot ({count})",
  "No production orders found.": "Nu s-au găsit comenzi de producție.",
  "WIP ({count})": "WIP ({count})",
  "Working…": "Se lucrează…",
  "Preparing…": "Se pregătește…",
  "Print QR": "Tipărește QR",
  "Set Status": "Setează starea",
  "No edits yet.": "Încă nicio modificare.",
  "When": "Când",
  "Who": "Cine",
  "From": "De la",
  "To": "La",
  "Please select a product": "Selectează un produs",
  "Please select a yield unit": "Selectează o unitate pentru cantitatea obținută",
  "BOM created successfully": "Rețeta a fost creată cu succes",
  "Failed to create BOM: {errorMessages}": "Rețeta nu a putut fi creată: {errorMessages}",
  "Failed to create BOM": "Rețeta nu a putut fi creată",
  "Back to BOM Management": "Înapoi la gestionarea rețetelor",
  "Create New BOM": "Creează rețetă nouă",
  "Define a new Bill of Materials": "Definește o rețetă nouă",
  "e.g., v1.0, v2.1": "ex. v1.0, v2.1",
  "BOM Type (Current: {type})": "Tip rețetă (curent: {type})",
  "Assembly - Combine inputs into finished product": "Asamblare - combină intrările într-un produs finit",
  "Disassembly - Break down finished product into components": "Dezasamblare - descompune produsul finit în componente",
  "Combine multiple inputs into a finished product": "Combină mai multe intrări într-un produs finit",
  "Break down a finished product into components": "Descompune un produs finit în componente",
  "Market Value": "Valoare de piață",
  "Weight Based": "După greutate",
  "Weight Based - Allocate costs based on component weights": "După greutate - alocă costurile în funcție de greutățile componentelor",
  "Market Value - Allocate costs based on market values of saleable outputs": "Valoare de piață - alocă costurile în funcție de valorile de piață ale ieșirilor vandabile",
  "Obsolete Date (Optional)": "Dată de scoatere din uz (opțional)",
  "Validity Days (Optional)": "Zile de valabilitate (opțional)",
  "e.g., 30, 365": "ex. 30, 365",
  "Shelf life in days for final product": "Termen de valabilitate în zile pentru produsul final",
  "BOM Components": "Componente rețetă",
  "Component {number}": "Componenta {number}",
  "Select Material": "Selectează materia primă",
  "Component Type": "Tip componentă",
  "Raw Material": "Materie primă",
  "Semi Product": "Semifabricat",
  "Sequence Number": "Număr de secvență",
  "Quantity Required": "Cantitate necesară",
  "Waste Percentage (%)": "Procent deșeuri (%)",
  "Cost per Unit (£)": "Cost pe unitate (£)",
  "Make or Buy Decision": "Decizie: fabricare sau cumpărare",
  "Buy": "Cumpărare",
  "e.g., 7, 30": "ex. 7, 30",
  "Shelf life for produced components": "Termen de valabilitate pentru componentele produse",
  "Critical component": "Componentă critică",
  "Optional component": "Componentă opțională",
  "Specifications": "Specificații",
  "Quality and technical specifications...": "Specificații de calitate și tehnice...",
  "Supplier Requirements": "Cerințe pentru furnizor",
  "Specific supplier requirements or notes...": "Cerințe specifice sau note pentru furnizor...",
  "Disassembly Settings": "Setări dezasamblare",
  "Component Role": "Rolul componentei",
  "Input (consumed in disassembly)": "Intrare (consumată la dezasamblare)",
  "Output (produced from disassembly)": "Ieșire (produsă din dezasamblare)",
  "Waste / Scrap": "Deșeu / rebut",
  "Market Value per Unit (£)": "Valoare de piață pe unitate (£)",
  "e.g., 15.50": "ex. 15.50",
  "Required for market value-based cost allocation": "Necesară pentru alocarea costului după valoarea de piață",
  "Yield Balance:": "Bilanț randament:",
  "No components": "Nicio componentă",
  "Get started by adding a component to this BOM.": "Începe prin a adăuga o componentă în această rețetă.",
  "Operation {number}": "Operația {number}",
  "Weighing Scales": "Cântare",
  "Preparation Station": "Stație de pregătire",
  "Mincer/Grinder": "Mașină de tocat",
  "Mixer/Blender": "Malaxor/mixer",
  "Tumbler": "Masator",
  "Bowl Cutter": "Cutter",
  "Emulsifier": "Emulsionator",
  "Filling Machine": "Mașină de umplut",
  "Sausage Stuffer": "Mașină de umplut cârnați",
  "Clip Machine": "Clipsator",
  "Smokehouse": "Afumătoare",
  "Cooking Oven": "Cuptor de gătit",
  "Steam Cooker": "Fierbător cu abur",
  "Chiller/Cooler": "Răcitor",
  "Blast Freezer": "Congelator rapid",
  "Slicing Machine": "Mașină de feliat",
  "Vacuum Packing Machine": "Mașină de ambalat în vid",
  "Tray Sealing Machine": "Mașină de sigilat caserole",
  "Labeling Machine": "Mașină de etichetat",
  "Case Packing Station": "Stație de ambalare în cutii",
  "Quality Inspection Station": "Stație de control al calității",
  "Setup Time (minutes)": "Timp de pregătire (minute)",
  "Operation Time (minutes)": "Timp de operație (minute)",
  "Cleanup Time (minutes)": "Timp de curățare (minute)",
  "Operators Required": "Operatori necesari",
  "Labor Hours Required": "Ore de manoperă necesare",
  "Labor Rate per Hour (£)": "Tarif manoperă pe oră (£)",
  "Mandatory operation": "Operație obligatorie",
  "Outsourced operation": "Operație externalizată",
  "Quality inspection required": "Necesită control al calității",
  "Operation Instructions": "Instrucțiuni operație",
  "Specific work instructions for this BOM operation...": "Instrucțiuni de lucru specifice pentru această operație din rețetă...",
  "Safety requirements and PPE for this operation...": "Cerințe de siguranță și EIP pentru această operație...",
  "Add production operations to define the manufacturing process.": "Adaugă operații de producție pentru a defini procesul de fabricație.",
  "BOM hierarchy is valid": "Ierarhia rețetei este validă",
  "BOM has {errorCount} error(s) and {warningCount} warning(s)": "Rețeta are probleme — erori: {errorCount}, avertismente: {warningCount}",
  "BOM has {warningCount} warning(s)": "Avertismente în rețetă: {warningCount}",
  "Failed to validate BOM": "Rețeta nu a putut fi validată",
  "Failed to fetch operations": "Operațiile nu au putut fi preluate",
  "Failed to fetch work centres": "Centrele de lucru nu au putut fi preluate",
  "No components to reload prices for": "Nicio componentă pentru care să se reîncarce prețurile",
  "No cost price found for {material_name}": "Nu s-a găsit preț de cost pentru {material_name}",
  "Input cost is already up to date": "Costul de intrare este deja actualizat",
  "All component prices are already up to date": "Toate prețurile componentelor sunt deja actualizate",
  "Failed to reload prices": "Prețurile nu au putut fi reîncărcate",
  "No price type selected.": "Niciun tip de preț selectat.",
  "Reloaded prices for {updatedCount} component(s)": "Prețuri reîncărcate pentru componente: {updatedCount}",
  "BOM and all components/operations updated successfully": "Rețeta și toate componentele/operațiile au fost actualizate cu succes",
  "Save failed: {errorMessage}": "Salvarea a eșuat: {errorMessage}",
  "Save failed: {message}": "Salvarea a eșuat: {message}",
  "💡 Tip: Check that all components have valid materials and units, and all operations have valid sequence numbers.": "💡 Sfat: verifică dacă toate componentele au materii prime și unități valide și dacă toate operațiile au numere de secvență valide.",
  "Auto-filled yield unit: {name} ({symbol})": "Unitate pentru cantitatea obținută completată automat: {name} ({symbol})",
  "BOM activated successfully": "Rețeta a fost activată cu succes",
  "Failed to activate BOM": "Rețeta nu a putut fi activată",
  "BOM deactivated successfully": "Rețeta a fost dezactivată cu succes",
  "Failed to deactivate BOM": "Rețeta nu a putut fi dezactivată",
  "Auto-filled unit: {name} ({symbol})": "Unitate completată automat: {name} ({symbol})",
  "Auto-filled cost: £{amount}": "Cost completat automat: £{amount}",
  "Failed to auto-fill product details: {message}": "Detaliile produsului nu au putut fi completate automat: {message}",
  "BOM Not Found": "Rețeta nu a fost găsită",
  "The requested BOM could not be found.": "Rețeta solicitată nu a putut fi găsită.",
  "Validate": "Validează",
  "Print this BOM": "Tipărește această rețetă",
  "Input cost price · outputs average £{amount}/{unit} after waste and operations": "Preț de cost al intrării · ieșirile au în medie £{amount}/{unit} după deșeuri și operații",
  "Live BOM cost · total £{amount}": "Cost curent al rețetei · total £{amount}",
  "Click to deactivate this BOM": "Apasă pentru a dezactiva această rețetă",
  "Click to activate this BOM": "Apasă pentru a activa această rețetă",
  "BOM Details Configured": "Detaliile rețetei au fost configurate",
  "Your BOM details have been set above. Now add components and operations using the tabs.": "Detaliile rețetei au fost setate mai sus. Acum adaugă componente și operații folosind taburile.",
  "Add Operations": "Adaugă operații",
  "Add output product": "Adaugă produs rezultat",
  "Add root component": "Adaugă componentă rădăcină",
  "Add by Copy/Paste": "Adaugă prin copiere/lipire",
  "Click to use {amount}{unit} as yield": "Apasă pentru a folosi {amount}{unit} drept cantitate obținută",
  "Material total £{amount}": "Total materii prime £{amount}",
  "Mat £{amount}/{unit}": "MP £{amount}/{unit}",
  "{count} outputs": { one: "{count} ieșire", few: "{count} ieșiri", other: "{count} de ieșiri" },
  "{count} output": { one: "{count} ieșire", few: "{count} ieșiri", other: "{count} de ieșiri" },
  "{count} component": { one: "{count} componentă", few: "{count} componente", other: "{count} de componente" },
  "Collapse all details": "Restrânge toate detaliile",
  "Expand all details": "Extinde toate detaliile",
  "No output products": "Niciun produs rezultat",
  "Add output products that will result from disassembly.": "Adaugă produsele rezultate care vor rezulta din dezasamblare.",
  "Add components to build your bill of materials.": "Adaugă componente pentru a construi rețeta.",
  "Click to deactivate": "Apasă pentru a dezactiva",
  "Click to activate": "Apasă pentru a activa",
  "No cost price in the system for: {materials}": "Niciun preț de cost în sistem pentru: {materials}",
  "BOM Code": "Cod rețetă",
  "Rev {revision}": "Rev. {revision}",
  "£/unit": "£/unitate",
  "Average output cost after waste and operations": "Costul mediu al ieșirilor după deșeuri și operații",
  "out £{amount}": "ieșire £{amount}",
  "Comp.": "Comp.",
  "Ops": "Op.",
  "No BOMs found": "Nu s-au găsit rețete",
  "0 BOMs": "0 rețete",
  "{from}–{to} of {total} BOMs": "{from}–{to} din {total} rețete",
  "{size} / page": "{size} / pagină",
  "Previous page": "Pagina anterioară",
  "Next page": "Pagina următoare",
  "Failed to fetch BOMs": "Rețetele nu au putut fi preluate",
  "Failed to change BOM status": "Starea rețetei nu a putut fi schimbată",
  "BOM copied as {new_bom_code}": "Rețeta a fost copiată ca {new_bom_code}",
  "Failed to copy BOM": "Rețeta nu a putut fi copiată",
  "Prices reloaded for {boms} BOM(s) — {withMissing} still have components without a price": "Rețete cu prețuri reîncărcate: {boms} — rețete care încă au componente fără preț: {withMissing}",
  "Prices reloaded for {boms} BOM(s) — {updated} component price(s) updated": "Rețete cu prețuri reîncărcate: {boms} — prețuri de componente actualizate: {updated}",
  "{length} BOM(s) could not be refreshed": "Rețete care nu au putut fi reîmprospătate: {length}",
  "BOM List": "Listă rețete",
  "BOM Details": "Detalii rețetă",
  "Search by product name, SKU, BOM code, or version...": "Caută după nume produs, SKU, cod rețetă sau versiune...",
  "All BOMs": "Toate rețetele",
  "Hide inactive BOMs": "Ascunde rețetele inactive",
  "Show inactive BOMs": "Arată rețetele inactive",
  "Show Inactive": "Arată inactive",
  "Reloading prices…": "Se reîncarcă prețurile…",
  "Reload prices": "Reîncarcă prețurile",
  "Select BOMs to reload their component prices": "Selectează rețete pentru a reîncărca prețurile componentelor lor",
  "{count} BOM(s) using materials with no cost price": "Rețete care folosesc materii prime fără preț de cost: {count}",
  "{count} BOMs": { one: "{count} rețetă", few: "{count} rețete", other: "{count} de rețete" },
  "{count} BOM": { one: "{count} rețetă", few: "{count} rețete", other: "{count} de rețete" },
  "Version {version}": "Versiunea {version}",
  "Rev": "Rev.",
  "Version:": "Versiune:",
  "Production Time:": "Timp de producție:",
  "Allocation:": "Alocare:",
  "Material Cost": "Cost materii prime",
  "Operations Cost": "Cost operații",
  "Labor:": "Manoperă:",
  "Machine:": "Mașină:",
  "Operations:": "Operații:",
  "Operations Summary ({count} operations)": { one: "Rezumat operații ({count} operație)", few: "Rezumat operații ({count} operații)", other: "Rezumat operații ({count} de operații)" },
  "Unnamed Operation": "Operație fără nume",
  "Op: £{amount}": "Op.: £{amount}",
  "Timeline - Total:": "Cronologie - total:",
  "Components Tree": "Arbore componente",
  "No BOM Selected": "Nicio rețetă selectată",
  "Select a BOM from the list to view its details and components.": "Selectează o rețetă din listă pentru a vedea detaliile și componentele ei.",
  "Search BOMs...": "Caută rețete...",
  "View": "Vezi",
  "Operations ({count})": "Operații ({count})",
  "Select a BOM from the list to view details.": "Selectează o rețetă din listă pentru a vedea detaliile.",
  "Back to List": "Înapoi la listă",
  "Material: £{amount}": "Materii prime: £{amount}",
  "Seq": "Secv.",
  "Time:": "Timp:",
  "Labor: £{amount}": "Manoperă: £{amount}",
  "Machine: £": "Mașină: £",
  "No components found": "Nu s-au găsit componente",
  "Limited by {material}: {available} {unit} available": "Limitat de {material}: {available} {unit} disponibil",
  "No BOMs found for \"{name}\"": "Nu s-au găsit rețete pentru „{name}”",
  "Failed to load BOMs": "Rețetele nu au putut fi încărcate",
  "Select a BOM first": "Selectează mai întâi o rețetă",
  "Cannot compute quantity from available stock": "Cantitatea nu poate fi calculată din stocul disponibil",
  "Failed to compute quantity from stock": "Cantitatea nu a putut fi calculată din stoc",
  "Failed to load completed disassemblies": "Dezasamblările finalizate nu au putut fi încărcate",
  "No downstream products can be produced from this disassembly.": "Din această dezasamblare nu se pot produce produse în aval.",
  "Failed to load downstream candidates": "Produsele candidate din aval nu au putut fi încărcate",
  "Failed to search products": "Căutarea produselor a eșuat",
  "Please select a completed disassembly": "Selectează o dezasamblare finalizată",
  "Keep at least one product with a valid BOM and quantity": "Păstrează cel puțin un produs cu rețetă și cantitate valide",
  "Please complete product, BOM, and quantity for every row": "Completează produsul, rețeta și cantitatea pe fiecare rând",
  "Please select a BOM": "Selectează o rețetă",
  "Please enter a valid quantity": "Introdu o cantitate validă",
  "Select at least one operation to generate": "Selectează cel puțin o operație de generat",
  "Failed for {product}: {error}": "Eșuat pentru {product}: {error}",
  "Created {count} draft production order(s): {orders}": "Comenzi de producție ciornă create: {count} ({orders})",
  "Failed to create orders: {error}": "Comenzile nu au putut fi create: {error}",
  "server error": "eroare de server",
  "Failed to create production order: {error}": "Comanda de producție nu a putut fi creată: {error}",
  "Production order {number} created successfully": "Comanda de producție {number} a fost creată cu succes",
  "Failed to create production order - Network or server error": "Comanda de producție nu a putut fi creată - eroare de rețea sau de server",
  "Back to Production Orders": "Înapoi la comenzile de producție",
  "Create Production Order": "Creează comandă de producție",
  "Create a new production order with auto-generated materials and operations": "Creează o comandă de producție nouă cu materii prime și operații generate automat",
  "Create {count} Draft Order": { one: "Creează {count} comandă ciornă", few: "Creează {count} comenzi ciornă", other: "Creează {count} de comenzi ciornă" },
  "Create {count} Draft Orders": { one: "Creează {count} comandă ciornă", few: "Creează {count} comenzi ciornă", other: "Creează {count} de comenzi ciornă" },
  "Generate from disassembly": "Generează din dezasamblare",
  "Multiple products": "Mai multe produse",
  "Completed disassembly": "Dezasamblare finalizată",
  "Select a completed disassembly...": "Selectează o dezasamblare finalizată...",
  "Loading downstream products…": "Se încarcă produsele din aval…",
  "No downstream products can be produced from this disassembly's outputs.": "Din ieșirile acestei dezasamblări nu se pot produce produse în aval.",
  "{count} draft production order(s) will be created — one per kept product.": "Comenzi de producție ciornă care vor fi create: {count} — câte una pentru fiecare produs păstrat.",
  "Product to produce": "Produs de fabricat",
  "From output": "Din ieșire",
  "{quantity} {unit} available": "{quantity} {unit} disponibil",
  "Type to search products by name, SKU, or barcode...": "Scrie pentru a căuta produse după nume, SKU sau cod de bare...",
  "Negative stock — click to set quantity to cover it": "Stoc negativ — apasă pentru a seta cantitatea care să-l acopere",
  "Remove product": "Elimină produsul",
  "Mid-chain split: shared trunk through \"{operation}\"": "Divizare la mijlocul lanțului: trunchi comun până la „{operation}”",
  "The trunk produces {quantity} {unit} of {product}, then each product runs its own branch:": "Trunchiul produce {quantity} {unit} de {product}, apoi fiecare produs își urmează propria ramură:",
  "{name}: {quantity} {unit} of {product}": "{name}: {quantity} {unit} de {product}",
  "Will run as ONE combined WIP (no mid-chain split)": "Va rula ca UN SINGUR WIP combinat (fără divizare la mijlocul lanțului)",
  "The products share the same operation types but no common semi-product trunk was derived:": "Produsele au aceleași tipuri de operații, dar nu s-a putut deduce un trunchi comun de semifabricat:",
  "These products cannot share one order": "Aceste produse nu pot împărți o singură comandă",
  "Select / deselect all operations": "Selectează / deselectează toate operațiile",
  "Planned machine for this operation (Auto = first available of type)": "Mașina planificată pentru această operație (Auto = prima disponibilă de acest tip)",
  "Generate this operation into WIP": "Generează această operație în WIP",
  "Excluded — will not be generated into WIP": "Exclusă — nu va fi generată în WIP",
  "Record production on the planned start date": "Înregistrează producția la data de început planificată",
  "Only available when the planned start date is in the past": "Disponibil doar când data de început planificată este în trecut",
  "Operation start/finish times will pre-fill from this date instead of today": "Orele de început/sfârșit ale operațiilor se vor precompleta de la această dată în loc de azi",
  "Create {count} Draft": { one: "Creează {count} ciornă", few: "Creează {count} ciorne", other: "Creează {count} de ciorne" },
  "Create {count} Drafts": { one: "Creează {count} ciornă", few: "Creează {count} ciorne", other: "Creează {count} de ciorne" },
  "Work centre assigned": "Centrul de lucru a fost alocat",
  "Failed to assign work centre": "Centrul de lucru nu a putut fi alocat",
  "Failed to refresh order data: {error}": "Datele comenzii nu au putut fi reîmprospătate: {error}",
  "Materials and operations regenerated from BOM": "Materiile prime și operațiile au fost regenerate din rețetă",
  "Failed to regenerate: {error}": "Regenerarea a eșuat: {error}",
  "Produced batches created by this order are removed; consumption and picking history is kept.": "Loturile produse create de această comandă sunt eliminate; istoricul consumului și al culegerii se păstrează.",
  "Stock, batches and movements are not affected.": "Stocul, loturile și mișcările nu sunt afectate.",
  "Set {order} to \"{status}\"?": "Treci {order} la „{status}”?",
  "Status set to {status}": "Starea a fost setată la {status}",
  "Generate WIP for {order}?": "Generezi WIP pentru {order}?",
  "The order moves to \"in progress\".": "Comanda trece în „în desfășurare”.",
  "Failed to generate WIP": "WIP-ul nu a putut fi generat",
  "WIP generated": "WIP-ul a fost generat",
  "Completion data (produced/good/reject quantities, yield, actual costs and quality approval) is cleared. The linked WIP must already be back to not started.": "Datele de finalizare (cantitățile produse/bune/respinse, randamentul, costurile efective și aprobarea calității) sunt șterse. WIP-ul asociat trebuie să fie deja readus la neînceput.",
  "Revert {order} from \"{from}\" to \"{to}\"?": "Readuci {order} de la „{from}” la „{to}”?",
  "Revert to {status}": "Readu la {status}",
  "Failed to load edit data": "Datele pentru editare nu au putut fi încărcate",
  "Please add at least one product": "Adaugă cel puțin un produs",
  "Row {row}: Please select a product": "Rândul {row}: selectează un produs",
  "Row {row}: Please select a BOM": "Rândul {row}: selectează o rețetă",
  "Row {row}: Please enter a valid quantity": "Rândul {row}: introdu o cantitate validă",
  "Failed to update: {error}": "Actualizarea a eșuat: {error}",
  "invalid request": "cerere invalidă",
  "Production order updated - materials and operations regenerated": "Comanda de producție a fost actualizată - materiile prime și operațiile au fost regenerate",
  "Failed to update production order": "Comanda de producție nu a putut fi actualizată",
  "Priority {priority}": "Prioritate {priority}",
  "Open product": "Deschide produsul",
  "Production order not found": "Comanda de producție nu a fost găsită",
  "Split ×{count}": "Divizare ×{count}",
  "Shared trunk through \"{operation}\" — {quantity} {unit} {product}, then {count} branches": { one: "Trunchi comun până la „{operation}” — {quantity} {unit} {product}, apoi {count} ramură", few: "Trunchi comun până la „{operation}” — {quantity} {unit} {product}, apoi {count} ramuri", other: "Trunchi comun până la „{operation}” — {quantity} {unit} {product}, apoi {count} de ramuri" },
  "Edit Production Order": "Editează comanda de producție",
  "+ Add product": "+ Adaugă produs",
  "Open BOM": "Deschide rețeta",
  "Open BOM {code} — {product}": "Deschide rețeta {code} — {product}",
  "Regenerating materials and operations from BOM...": "Se regenerează materiile prime și operațiile din rețetă...",
  "Loading materials...": "Se încarcă materiile prime...",
  "Recalculate required materials from BOM (WIP not yet started — will be rebuilt too)": "Recalculează materiile prime necesare din rețetă (WIP-ul nu a început încă — va fi și el reconstruit)",
  "Recalculate required materials from BOM at current quantity": "Recalculează materiile prime necesare din rețetă la cantitatea curentă",
  "Materials may be generated automatically when BOM is assigned or operations are created.": "Materiile prime pot fi generate automat când se atribuie rețeta sau când se creează operațiile.",
  "{name} — click to view/edit product": "{name} — apasă pentru a vedea/edita produsul",
  "Var:": "Dif.:",
  "Loading operations...": "Se încarcă operațiile...",
  "Operation Name": "Nume operație",
  "Duration (hrs)": "Durată (ore)",
  "Operations may be generated automatically when BOM is assigned or updated.": "Operațiile pot fi generate automat când rețeta este atribuită sau actualizată.",
  "Planned work centre for this operation": "Centrul de lucru planificat pentru această operație",
  "Efficiency:": "Eficiență:",
  "Cost: £{amount}": "Cost: £{amount}",
  "Shared trunk": "Trunchi comun",
  "Branch — {product}": "Ramură — {product}",
  "{count} output product": { one: "{count} produs rezultat", few: "{count} produse rezultate", other: "{count} de produse rezultate" },
  "{count} output products": { one: "{count} produs rezultat", few: "{count} produse rezultate", other: "{count} de produse rezultate" },
  "Color: {color}": "Culoare: {color}",
  "By-Product": "Subprodus",
  "Actual Quantity": "Cantitate efectivă",
  "Good Quantity": "Cantitate bună",
  "Reject Quantity": "Cantitate respinsă",
  "Market Value per Unit": "Valoare de piață pe unitate",
  "Allocated Cost": "Cost alocat",
  "Main (Residual)": "Principal (rezidual)",
  "{percent}% of input": "{percent}% din intrare",
  "BOM Cost": "Cost rețetă",
  "Planned Start:": "Început planificat:",
  "Backdated recording": "Înregistrare antedatată",
  "Due Date:": "Termen:",
  "Actual Start:": "Început efectiv:",
  "Current Progress:": "Progres curent:",
  "Last Updated:": "Ultima actualizare:",
  "Failed to rename order": "Comanda nu a putut fi redenumită",
  "Status advanced successfully": "Starea a fost avansată cu succes",
  "Failed to advance status": "Starea nu a putut fi avansată",
  "Production order copied with updated BOM! New order: {order_number} (BOM updated from inactive to active version)": "Comanda de producție a fost copiată cu rețeta actualizată! Comandă nouă: {order_number} (rețeta a fost actualizată de la versiunea inactivă la cea activă)",
  "Cannot copy production order: No active BOM found for product \"{product_name}\". Please activate a BOM for this product first.": "Comanda de producție nu poate fi copiată: nu s-a găsit nicio rețetă activă pentru produsul „{product_name}”. Activează mai întâi o rețetă pentru acest produs.",
  "Cannot copy production order: The original BOM is inactive and retry failed. Please check BOM status.": "Comanda de producție nu poate fi copiată: rețeta originală este inactivă, iar reîncercarea a eșuat. Verifică starea rețetei.",
  "Cannot copy production order: Invalid planned quantity - {error}": "Comanda de producție nu poate fi copiată: cantitate planificată invalidă - {error}",
  "Cannot copy production order: {field} - {error}": "Comanda de producție nu poate fi copiată: {field} - {error}",
  "Failed to copy production order": "Comanda de producție nu a putut fi copiată",
  "Production order copied successfully! New order: {order_number}": "Comanda de producție a fost copiată cu succes! Comandă nouă: {order_number}",
  "Are you sure you want to delete production order {order}?\n\nThis action cannot be undone and will also delete:\n- Associated materials\n- Associated operations\n- WIP documents\n- QR codes": "Sigur vrei să ștergi comanda de producție {order}?\n\nAceastă acțiune nu poate fi anulată și va șterge și:\n- Materiile prime asociate\n- Operațiile asociate\n- Documentele WIP\n- Codurile QR",
  "Production order {order} deleted successfully": "Comanda de producție {order} a fost ștearsă cu succes",
  "Failed to delete production order": "Comanda de producție nu a putut fi ștearsă",
  "You do not have permission to delete production orders": "Nu ai permisiunea de a șterge comenzi de producție",
  "Cannot delete production order - it may be in progress or have dependencies": "Comanda de producție nu poate fi ștearsă - poate fi în desfășurare sau are dependențe",
  "Please select at least one production order": "Selectează cel puțin o comandă de producție",
  "WIP documents generated": "Documentele WIP au fost generate",
  "Failed to generate WIP documents": "Documentele WIP nu au putut fi generate",
  "Set {count} selected orders to \"{status}\"?": { one: "Treci {count} comandă selectată la „{status}”?", few: "Treci {count} comenzi selectate la „{status}”?", other: "Treci {count} de comenzi selectate la „{status}”?" },
  "Set {count} selected order to \"{status}\"?": { one: "Treci {count} comandă selectată la „{status}”?", few: "Treci {count} comenzi selectate la „{status}”?", other: "Treci {count} de comenzi selectate la „{status}”?" },
  "Status updated": "Starea a fost actualizată",
  "Failed to preview material transfer": "Previzualizarea transferului de materii prime a eșuat",
  "Please choose a destination location": "Alege o locație de destinație",
  "Created transfer {number}": "S-a creat transferul {number}",
  "Failed to create material transfer": "Transferul de materii prime nu a putut fi creat",
  "Failed to generate QR code for order {order}: {error}": "Codul QR pentru comanda {order} nu a putut fi generat: {error}",
  "Ready to print {count} QR code labels": { one: "Gata de tipărit {count} etichetă cu cod QR", few: "Gata de tipărit {count} etichete cu cod QR", other: "Gata de tipărit {count} de etichete cu cod QR" },
  "Ready to print {count} QR code label": { one: "Gata de tipărit {count} etichetă cu cod QR", few: "Gata de tipărit {count} etichete cu cod QR", other: "Gata de tipărit {count} de etichete cu cod QR" },
  "No QR codes could be generated for printing": "Nu s-a putut genera niciun cod QR pentru tipărire",
  "Failed to generate QR codes for printing": "Codurile QR pentru tipărire nu au putut fi generate",
  "Material transfer — {status}": "Transfer de materii prime — {status}",
  "{product} — partial run of {order} (up to {operation})": "{product} — rulare parțială din {order} (până la {operation})",
  "{product} — partial run of {order} (up to intermediate)": "{product} — rulare parțială din {order} (până la intermediar)",
  "Collapse items": "Restrânge articolele",
  "Show items": "Arată articolele",
  "Mid-chain split: shared trunk + one branch per product": "Divizare la mijlocul lanțului: trunchi comun + câte o ramură pe produs",
  "Split → {count} products": { one: "Divizare → {count} produs", few: "Divizare → {count} produse", other: "Divizare → {count} de produse" },
  "Multi-Product": "Multi-produs",
  "Click to revert status": "Apasă pentru a readuce starea",
  "Branch WIP status — click to open": "Starea WIP a ramurii — apasă pentru a deschide",
  "Generate WIP documents for selected orders": "Generează documente WIP pentru comenzile selectate",
  "Generate WIP ({count})": "Generează WIP ({count})",
  "Generate a material stock transfer to the production zone for selected orders": "Generează un transfer de stoc de materii prime către zona de producție pentru comenzile selectate",
  "Generate Material Transfer ({count})": "Generează transfer de materii prime ({count})",
  "Preparing...": "Se pregătește...",
  "Print QR ({count})": "Tipărește QR ({count})",
  "Target status for selected orders": "Starea țintă pentru comenzile selectate",
  "Change status of selected orders (does not affect stock, batches or movements)": "Schimbă starea comenzilor selectate (nu afectează stocul, loturile sau mișcările)",
  "Set Status ({count})": "Setează starea ({count})",
  "Material Transfer Preview": "Previzualizare transfer de materii prime",
  "Creating…": "Se creează…",
  "Choose a destination production location:": "Alege o locație de producție de destinație:",
  "No production-zone location is configured. Create a production zone with a location first, then try again.": "Nu este configurată nicio locație în zona de producție. Creează mai întâi o zonă de producție cu o locație, apoi încearcă din nou.",
  "Select destination…": "Selectează destinația…",
  "Destination: {code}": "Destinație: {code}",
  "Material types": "Tipuri de materii prime",
  "Allow negative stock transfer (transfer full required quantity even if short)": "Permite transfer cu stoc negativ (transferă întreaga cantitate necesară chiar dacă lipsește stoc)",
  "Skipped (already transferred): {orders}": "Sărite (deja transferate): {orders}",
  "Short stock: {materials}": "Stoc insuficient: {materials}",
  "Unit mismatch (excluded): {materials}": "Unități nepotrivite (excluse): {materials}",
  "{material} on {order}": "{material} pe {order}",
  "Filter by product category": "Filtrează după categoria de produs",
  "Hide detail panel": "Ascunde panoul de detalii",
  "Show detail panel": "Arată panoul de detalii",
  "Select All Orders": "Selectează toate comenzile",
  "Production Progress": "Progres producție",
  "TBD": "De stabilit",
  "Total Duration": "Durată totală",
  "{actual} / {planned} planned": "{actual} / {planned} planificat",
  "Overall Progress": "Progres general",
  "Risk Level": "Nivel de risc",
  "No Risk": "Fără risc",
  "Low Risk": "Risc scăzut",
  "High Risk": "Risc ridicat",
  "Resource Status": "Starea resurselor",
  "Input Product Availability": "Disponibilitatea produsului de intrare",
  "Materials Availability": "Disponibilitatea materiilor prime",
  "No input product required": "Nu este necesar niciun produs de intrare",
  "No materials required": "Nu sunt necesare materii prime",
  "{percent}% Available": "{percent}% disponibil",
  "Work Centre Assignment": "Alocare centre de lucru",
  "No operations defined": "Nicio operație definită",
  "No work centres assigned": "Niciun centru de lucru alocat",
  "Assigned to {count} work centres:": { one: "Alocat la {count} centru de lucru:", few: "Alocat la {count} centre de lucru:", other: "Alocat la {count} de centre de lucru:" },
  "Assigned to {count} work centre:": { one: "Alocat la {count} centru de lucru:", few: "Alocat la {count} centre de lucru:", other: "Alocat la {count} de centre de lucru:" },
  "+{count} more work centres": { one: "+{count} centru de lucru în plus", few: "+{count} centre de lucru în plus", other: "+{count} de centre de lucru în plus" },
  "Production Schedule": "Program de producție",
  "Loading schedule...": "Se încarcă programul...",
  "No operations scheduled": "Nicio operație programată",
  "Operations Schedule": "Program operații",
  "{count} operations": { one: "{count} operație", few: "{count} operații", other: "{count} de operații" },
  "Step {number}": "Pasul {number}",
  "Planning Metrics": "Indicatori de planificare",
  "Cost Tracking": "Urmărire costuri",
  "Final": "Final",
  "Schedule": "Program",
  "Days Left:": "Zile rămase:",
  "{days}d overdue": "întârziere {days} z",
  "On Time": "La timp",
  "At Risk": "La risc",
  "On Track": "Conform planului",
  "Efficiency": "Eficiență",
  "{percent}% Eff.": "{percent}% efic.",
  "Materials:": "Materii prime:",
  "Schedule:": "Program:",
  "Medium Risk": "Risc mediu",
  "No Order Selected": "Nicio comandă selectată",
  "Select a production order from the list to view its details.": "Selectează o comandă de producție din listă pentru a vedea detaliile ei.",
  "Production plan created successfully": "Planul de producție a fost creat cu succes",
  "Failed to create production plan: {errors}": "Planul de producție nu a putut fi creat: {errors}",
  "Failed to create production plan": "Planul de producție nu a putut fi creat",
  "Create Production Plan": "Creează plan de producție",
  "Define a new production plan": "Definește un plan de producție nou",
  "e.g., Weekly Production Plan - Week 45": "ex. Plan săptămânal de producție - Săptămâna 45",
  "Full Day": "Zi întreagă",
  "Morning": "Dimineață",
  "Afternoon": "După-amiază",
  "Night": "Noapte",
  "Planned Capacity Utilization (%)": "Grad de utilizare a capacității planificat (%)",
  "Typical range: 70-90%. Values above 100% indicate overtime planning.": "Interval tipic: 70-90%. Valorile peste 100% indică planificarea de ore suplimentare.",
  "Create Plan": "Creează planul",
  "Remove schedule": "Elimină programarea",
  "Split this schedule": "Divizează această programare",
  "Drop here to schedule": "Plasează aici pentru a programa",
  "Capacity": "Capacitate",
  "Failed to load scheduler data": "Datele de programare nu au putut fi încărcate",
  "Moved to {day}": "Mutat în {day}",
  "Failed to move schedule": "Programarea nu a putut fi mutată",
  "This item is already fully scheduled": "Acest articol este deja programat integral",
  "Scheduled {quantity} {unit} for {day}": "S-au programat {quantity} {unit} pentru {day}",
  "Failed to create schedule": "Programarea nu a putut fi creată",
  "Schedule removed": "Programarea a fost eliminată",
  "Failed to remove schedule": "Programarea nu a putut fi eliminată",
  "Split quantity must be greater than 0 and less than original quantity": "Cantitatea divizată trebuie să fie mai mare decât 0 și mai mică decât cantitatea inițială",
  "Split: {remaining} + {split}": "Divizare: {remaining} + {split}",
  "Failed to split schedule": "Programarea nu a putut fi divizată",
  "No unscheduled items": "Niciun articol neprogramat",
  "Auto-scheduled {count} items": { one: "S-a programat automat {count} articol", few: "S-au programat automat {count} articole", other: "S-au programat automat {count} de articole" },
  "Auto-schedule failed": "Programarea automată a eșuat",
  "No unreleased schedules to clear": "Nicio programare nelansată de șters",
  "Cleared {count} schedules": { one: "S-a șters {count} programare", few: "S-au șters {count} programări", other: "S-au șters {count} de programări" },
  "Failed to clear schedules": "Programările nu au putut fi șterse",
  "No planned schedules to convert to orders": "Nicio programare planificată de transformat în comenzi",
  "Generate production orders from {count} schedules?": { one: "Generezi comenzi de producție din {count} programare?", few: "Generezi comenzi de producție din {count} programări?", other: "Generezi comenzi de producție din {count} de programări?" },
  "Failed to generate orders": "Comenzile nu au putut fi generate",
  "Unscheduled Items ({count})": "Articole neprogramate ({count})",
  "Remaining:": "Rămas:",
  "All items are fully scheduled": "Toate articolele sunt programate integral",
  "Production Calendar": "Calendar de producție",
  "No planning period defined": "Nicio perioadă de planificare definită",
  "Auto-Schedule": "Programare automată",
  "Generate Orders": "Generează comenzi",
  "Split Schedule": "Divizează programarea",
  "Current quantity:": "Cantitate curentă:",
  "Quantity to split off:": "Cantitate de separat:",
  "Max: {max}": "Max.: {max}",
  "Remaining in original:": "Rămas în original:",
  "Please select both product and BOM": "Selectează atât produsul, cât și rețeta",
  "Demand item added successfully": "Articolul de cerere a fost adăugat cu succes",
  "Failed to add demand item": "Articolul de cerere nu a putut fi adăugat",
  "Are you sure you want to delete this demand item?": "Sigur vrei să ștergi acest articol de cerere?",
  "Demand item deleted": "Articolul de cerere a fost șters",
  "Failed to delete demand item": "Articolul de cerere nu a putut fi șters",
  "Production schedules generated": "Programările de producție au fost generate",
  "Failed to generate schedules": "Programările nu au putut fi generate",
  "Select a plan to manage demand": "Selectează un plan pentru a gestiona cererea",
  "BOM:": "Rețetă:",
  "Required Date": "Data necesară",
  "Demand Management": "Gestionare cerere",
  "Generate Schedules": "Generează programări",
  "Add Demand": "Adaugă cerere",
  "Add Demand Item": "Adaugă articol de cerere",
  "Select product...": "Selectează produsul...",
  "Demand Type": "Tip cerere",
  "Special requirements or notes...": "Cerințe speciale sau note...",
  "Adding...": "Se adaugă...",
  "No demand items found. Add your first demand item to get started.": "Nu s-au găsit articole de cerere. Adaugă primul articol de cerere pentru a începe.",
  "Total Items": "Total articole",
  "Orders Generated": "Comenzi generate",
  "Est. Cost": "Cost est.",
  "Scheduled Start": "Început programat",
  "Not scheduled": "Neprogramat",
  "Scheduled End": "Sfârșit programat",
  "Production Schedules": "Programări de producție",
  "No schedules found for this plan": "Nu s-au găsit programări pentru acest plan",
  "Planned Utilization %": "Utilizare planificată %",
  "Available Capacity %": "Capacitate disponibilă %",
  "Capacity Analysis": "Analiză capacitate",
  "No operations are placed on machines yet. Drag operations onto machines in the Gantt Chart tab.": "Nicio operație nu este încă plasată pe mașini. Trage operațiile pe mașini în tabul Diagramă Gantt.",
  "Overall Utilization": "Utilizare generală",
  "Peak Utilization": "Utilizare maximă",
  "Available Hours": "Ore disponibile",
  "Capacity counts {slot} working hours per machine for each of the plan's {days} days ({hours} h per machine). Only operations placed on a machine in the Gantt Chart are counted. Over 100% means the machine is overbooked.": "Capacitatea ia în calcul {slot} ore de lucru pe mașină pentru fiecare din cele {days} zile ale planului ({hours} h pe mașină). Se numără doar operațiile plasate pe o mașină în Diagrama Gantt. Peste 100% înseamnă că mașina este supraîncărcată.",
  "Availability": "Disponibilitate",
  "Unavailable": "Indisponibil",
  "Check availability": "Verifică disponibilitatea",
  "Validation Results": "Rezultatele validării",
  "Plan is valid": "Planul este valid",
  "Plan has issues": "Planul are probleme",
  "Errors:": "Erori:",
  "Warnings:": "Avertismente:",
  "Capacity Summary": "Sumar capacitate",
  "Overall Utilization:": "Utilizare generală:",
  "Required Work Centres:": "Centre de lucru necesare:",
  "Required Work Centres": "Centre de lucru necesare",
  "Plan updated successfully": "Planul a fost actualizat cu succes",
  "Failed to update plan": "Planul nu a putut fi actualizat",
  "Scheduled quantity": "Cantitate programată",
  "Production plan not found": "Planul de producție nu a fost găsit",
  "Back to Production Planning": "Înapoi la Planificare producție",
  "Target Utilization": "Utilizare țintă",
  "Plan Details": "Detalii plan",
  "Edit Plan": "Editează planul",
  "Plan Information": "Informații plan",
  "Performance": "Performanță",
  "Scheduled Quantity by Day": "Cantitate programată pe zile",
  "Create a copy of plan \"{name}\"?": "Creezi o copie a planului „{name}”?",
  "Plan copied successfully: {number}": "Planul a fost copiat cu succes: {number}",
  "Failed to copy plan": "Planul nu a putut fi copiat",
  "Are you sure you want to delete plan \"{name}\"? This action cannot be undone.": "Sigur vrei să ștergi planul „{name}”? Această acțiune nu poate fi anulată.",
  "Plan deleted successfully": "Planul a fost șters cu succes",
  "Failed to delete plan": "Planul nu a putut fi șters",
  "{hours} hrs": "{hours} ore",
  "Open plan": "Deschide planul",
  "Plan and schedule production activities": "Planifică și programează activitățile de producție",
  "New from Sales Data": "Nou din datele de vânzări",
  "Create Manually": "Creează manual",
  "Search plans...": "Caută planuri...",
  "{count} plans found": { one: "{count} plan găsit", few: "{count} planuri găsite", other: "{count} de planuri găsite" },
  "No production plans found.": "Nu s-au găsit planuri de producție.",
  "Create your first plan": "Creează primul plan",
  "Please enter a plan name": "Introdu un nume pentru plan",
  "Please select a production date": "Selectează o dată de producție",
  "Please select both start and end dates for custom period": "Selectează atât data de început, cât și data de sfârșit pentru perioada personalizată",
  "No products found. Make sure products have active BOMs (Bill of Materials).": "Nu s-au găsit produse. Asigură-te că produsele au rețete active.",
  "Loaded {count} products": { one: "S-a încărcat {count} produs", few: "S-au încărcat {count} produse", other: "S-au încărcat {count} de produse" },
  "Please set quantities for at least one product": "Setează cantitățile pentru cel puțin un produs",
  "Plan \"{number}\" created with {count} items": { one: "Planul „{number}” a fost creat cu {count} articol", few: "Planul „{number}” a fost creat cu {count} articole", other: "Planul „{number}” a fost creat cu {count} de articole" },
  "Failed to save plan": "Planul nu a putut fi salvat",
  "Current Stock": "Stoc curent",
  "Last 7 Days": "Ultimele 7 zile",
  "Last 4 Weeks": "Ultimele 4 săptămâni",
  "Confirmed Orders": "Comenzi confirmate",
  "Demand Forecast": "Prognoza cererii",
  "(Total Needed)": "(Total necesar)",
  "Plan to Produce": "De produs",
  "(After Stock)": "(După stoc)",
  "(Editable)": "(Editabil)",
  "Back to Plans": "Înapoi la planuri",
  "Create Production Plan from Sales Data": "Creează plan de producție din datele de vânzări",
  "Configure analysis parameters and review suggested quantities": "Configurează parametrii analizei și verifică cantitățile sugerate",
  "Plan Name": "Nume plan",
  "(auto-generated, editable)": "(generat automat, editabil)",
  "e.g., Weekly Sausages - Oct 7": "ex.: Cârnați săptămânal - 7 oct.",
  "Category (Optional)": "Categorie (opțional)",
  "Last 7 Days Sales": "Vânzări ultimele 7 zile",
  "Last 4 Weeks Average": "Media ultimelor 4 săptămâni",
  "Load Products & Calculate": "Încarcă produsele și calculează",
  "Products & Production Requirements": "Produse și necesar de producție",
  "Quantities are calculated as: Demand Forecast - Current Stock = Plan to Produce": "Cantitățile se calculează astfel: Prognoza cererii - Stoc curent = De produs",
  "Try adjusting your filters or analysis options": "Încearcă să ajustezi filtrele sau opțiunile de analiză",
  "{count} products selected for production": { one: "{count} produs selectat pentru producție", few: "{count} produse selectate pentru producție", other: "{count} de produse selectate pentru producție" },
  "Save as Draft": "Salvează ca ciornă",
  "Failed to fetch production release details": "Detaliile lansării în producție nu au putut fi încărcate",
  "Traceability data regenerated successfully": "Datele de trasabilitate au fost regenerate cu succes",
  "Failed to regenerate traceability data": "Datele de trasabilitate nu au putut fi regenerate",
  "Are you sure you want to delete this production release? This action cannot be undone.": "Sigur vrei să ștergi această lansare în producție? Această acțiune nu poate fi anulată.",
  "Release deleted successfully": "Lansarea a fost ștearsă cu succes",
  "Failed to delete release": "Lansarea nu a putut fi ștearsă",
  "Production Release Not Found": "Lansarea în producție nu a fost găsită",
  "The requested production release could not be found.": "Lansarea în producție solicitată nu a putut fi găsită.",
  "Back to Releases": "Înapoi la lansări",
  "Production Release Traceability Document": "Document de trasabilitate a lansării în producție",
  "Last updated: {date}": "Ultima actualizare: {date}",
  "{count} materials tracked": { one: "{count} materie primă urmărită", few: "{count} materii prime urmărite", other: "{count} de materii prime urmărite" },
  "Regenerate Traceability": "Regenerează trasabilitatea",
  "View WIP": "Vezi WIP",
  "Revert Release": "Anulează lansarea",
  "Multi-Item ({count} items)": { one: "Multi-articol ({count} articol)", few: "Multi-articol ({count} articole)", other: "Multi-articol ({count} de articole)" },
  "Input Quantity": "Cantitate intrare",
  "Total Obtained": "Total obținut",
  "Mix Cost Impact": "Impactul amestecului asupra costului",
  "vs BOM mix · yield {points}": "față de amestecul din rețetă · randament {points}",
  "Quality Grade": "Clasă de calitate",
  "Not Set": "Nesetat",
  "BOM Planned Consumption": "Consum planificat din rețetă",
  "Within spec": "În specificație",
  "Outside spec range": "În afara intervalului specificat",
  "Actual Consumption": "Consum real",
  "Actual vs BOM": "Real față de rețetă",
  "Product Spec Range:": "Interval specificație produs:",
  "Produced So Far": "Produs până acum",
  "Pending remainder": "Rest în așteptare",
  "Finish #{number}": "Finalizare #{number}",
  "No finishes recorded yet.": "Nicio finalizare înregistrată încă.",
  "Items Breakdown": "Defalcare articole",
  "Disassembly Cost Analysis": "Analiza costului de dezasamblare",
  "Provisional — settles on completion": "Provizoriu — se stabilește la finalizare",
  "(est.)": "(est.)",
  "Operations: £{amount}": "Operații: £{amount}",
  "Total Input Cost": "Cost total intrare",
  "⚠ estimated": "⚠ estimat",
  "Cost Breakdown": "Defalcare cost",
  "Allocation Method": "Metodă de alocare",
  "Cost distribution method": "Metoda de distribuire a costului",
  "Output Product": "Produs de ieșire",
  "Cost/Unit": "Cost/unitate",
  "Allocation %": "Alocare %",
  "Cutting Yield Variance": "Diferență randament tranșare",
  "Output": "Ieșire",
  "Standard Yield": "Randament standard",
  "Actual Yield": "Randament real",
  "Actual Qty": "Cant. reală",
  "Cost Analysis": "Analiza costului",
  "BOM Estimated Cost": "Cost estimat din rețetă",
  "Materials £{amount}/{unit}": "Materii prime £{amount}/{unit}",
  "Operations £{total} (£{amount}/{unit})": "Operații £{total} (£{amount}/{unit})",
  "Actual Production Cost": "Cost real de producție",
  "Cost Variance": "Diferență de cost",
  "Materials": "Materii prime",
  "Estimated": "Estimat",
  "Per-Product Cost Breakdown": "Defalcarea costului pe produs",
  "Variance = Actual − Estimated per product (same convention as the Cost Variance tile); negative means the product came in under its BOM estimate.": "Diferență = Real − Estimat pe produs (aceeași convenție ca la caseta Diferență de cost); negativ înseamnă că produsul a ieșit sub estimarea din rețetă.",
  "High variance detected:": "Diferență mare detectată:",
  "Actual cost is significantly different from BOM estimate. Review material consumption and waste.": "Costul real diferă semnificativ de estimarea din rețetă. Verifică consumul de materii prime și pierderile.",
  "Production efficiency achieved: Actual cost is lower than BOM estimate by {percent}%.": "Eficiență de producție obținută: costul real este mai mic decât estimarea din rețetă cu {percent}%.",
  "BOM at current prices:": "Rețeta la prețurile curente:",
  "({percent}% vs BOM Estimated). This reflects purchase-price drift since the BOM cost was last refreshed.": "({percent}% față de estimarea din rețetă). Aceasta reflectă variația prețurilor de achiziție de la ultima actualizare a costului rețetei.",
  "Yield & Mix Analysis": "Analiza randamentului și a amestecului",
  "Measured against {quantity} {unit} of input actually used · input cost £{cost}": "Măsurat față de {quantity} {unit} de intrare folosită efectiv · cost intrare £{cost}",
  "Sellable Yield": "Randament vandabil",
  "Mix Shift": "Deplasare amestec",
  "of input moved between outputs vs BOM": "din intrare mutat între ieșiri față de rețetă",
  "Cost Impact": "Impact asupra costului",
  "actual mix vs BOM mix at the same input cost": "amestecul real față de amestecul din rețetă, la același cost de intrare",
  "Output Variance Analysis": "Analiza diferențelor de ieșire",
  "Yield Variance Analysis": "Analiza diferențelor de randament",
  "Expected Total Output": "Ieșire totală așteptată",
  "Output Products Obtained": "Produse de ieșire obținute",
  "Material Consumption Variances": "Diferențe de consum de materii prime",
  "BOM/": "Rețetă/",
  "Expected/": "Așteptat/",
  "BOM mix/": "Amestec rețetă/",
  "%/unit (£)": "%/unitate (£)",
  "Batches Created": "Loturi create",
  "Planned/": "Planificat/",
  "Variance £ (%)": "Diferență £ (%)",
  "Batches Used": "Loturi folosite",
  "By-product": "Subprodus",
  "(replaces {name})": "(înlocuiește {name})",
  "(addition to {name})": "(în plus față de {name})",
  "Input Material Used": "Materie primă de intrare folosită",
  "Planned Qty": "Cant. planificată",
  "Variance %": "Diferență %",
  "Batch Used": "Lot folosit",
  "Substitution & Variance": "Înlocuire și diferență",
  "Original Material": "Materie primă originală",
  "Replaced By": "Înlocuită cu",
  "Cost Difference": "Diferență de cost",
  "Batch Genealogy Tree": "Arbore genealogic loturi",
  "Processing": "Procesare",
  "INPUT": "INTRARE",
  "OUTPUT": "IEȘIRE",
  "{count} batches = {total} kg": { one: "{count} lot = {total} kg", few: "{count} loturi = {total} kg", other: "{count} de loturi = {total} kg" },
  "Op {sequence}: {name}": "Op. {sequence}: {name}",
  "NO BATCH": "FĂRĂ LOT",
  "no batch recorded": "niciun lot înregistrat",
  "Produced at Op {sequence} — click to jump": "Produs la Op. {sequence} — apasă pentru a sări",
  "from Op {sequence}": "din Op. {sequence}",
  "Common — all products": "Comun — toate produsele",
  "No batch hierarchy available": "Nicio ierarhie de loturi disponibilă",
  "No Batch Data Available": "Nu există date despre loturi",
  "Batch traceability data hasn't been generated yet. This is usually populated when WIP operations are completed and production releases are generated from WIP documents.": "Datele de trasabilitate a loturilor nu au fost generate încă. De obicei se completează când operațiile WIP sunt finalizate și lansările în producție sunt generate din documentele WIP.",
  "Operations Performance": "Performanța operațiilor",
  "Operation {sequence}: {name}": "Operația {sequence}: {name}",
  "Produces:": "Produce:",
  "Timing": "Durate",
  "Planned Time": "Timp planificat",
  "Operator & Output": "Operator și ieșire",
  "Costs": "Costuri",
  "Overhead": "Regie",
  "No Operations Data Available": "Nu există date despre operații",
  "Operations summary data hasn't been generated yet. This is populated when WIP operations are completed and includes timing, operators, and performance metrics.": "Datele sumare ale operațiilor nu au fost generate încă. Se completează când operațiile WIP sunt finalizate și includ durate, operatori și indicatori de performanță.",
  "Operator Digital Signatures": "Semnăturile digitale ale operatorilor",
  "No Signatures Found": "Nu s-au găsit semnături",
  "No operator signatures have been recorded for this production release.": "Nu s-au înregistrat semnături ale operatorilor pentru această lansare în producție.",
  "Release Notes": "Note lansare",
  "⚠️ Critical": "⚠️ Critic",
  "Loading components...": "Se încarcă componentele...",
  "Failed to fetch available WIP documents": "Documentele WIP disponibile nu au putut fi încărcate",
  "API endpoint not found. Please ensure the backend server is running.": "Endpointul API nu a fost găsit. Asigură-te că serverul backend rulează.",
  "Server error. Please check the backend logs.": "Eroare de server. Verifică jurnalele backend.",
  "Please select at least one WIP document": "Selectează cel puțin un document WIP",
  "Generated {count} production release(s)": "Lansări în producție generate: {count}",
  "Skipped {count} WIP document(s)": "Documente WIP omise: {count}",
  "Failed to generate {count} release(s)": "Lansări care nu au putut fi generate: {count}",
  "Failed to generate production releases": "Lansările în producție nu au putut fi generate",
  "No releases selected for export": "Nicio lansare selectată pentru export",
  "Exported {succeeded}/{total} releases to 1C": "S-au exportat {succeeded}/{total} lansări în 1C",
  "Failed to export {count} release(s)": "Lansări care nu au putut fi exportate: {count}",
  "Failed to export {failed}/{total} release(s)": "Lansări care nu au putut fi exportate: {failed}/{total}",
  "Failed to export to 1C": "Exportul în 1C a eșuat",
  "Resent to 1C successfully": "Retrimis în 1C cu succes",
  "Resend failed": "Retrimiterea a eșuat",
  "Failed to resend to 1C": "Retrimiterea în 1C a eșuat",
  "Exported: {date}\nClick to resend": "Exportat: {date}\nApasă pentru a retrimite",
  "Available once production completes": "Disponibil după finalizarea producției",
  "Release #": "Lansare #",
  "1C": "1C",
  "Search releases...": "Caută lansări...",
  "1C ({count})": "1C ({count})",
  "WIP Documents": "Documente WIP",
  "Scan QR": "Scanează QR",
  "Available WIP Documents": "Documente WIP disponibile",
  "Loading WIP documents...": "Se încarcă documentele WIP...",
  "No WIP documents available": "Niciun document WIP disponibil",
  "All completed WIPs have production releases": "Toate WIP-urile finalizate au lansări în producție",
  "Select All ({selected} of {total})": "Selectează tot ({selected} din {total})",
  "Completed: {date}": "Finalizat: {date}",
  "Generate Releases ({count})": "Generează lansările ({count})",
  "No releases found": "Nu s-au găsit lansări",
  "Try a different date or clear the filter": "Încearcă altă dată sau șterge filtrul",
  "Showing {from} to {to} of {total} releases": "Se afișează {from}–{to} din {total} lansări",
  "Production Order: {number}": "Comandă de producție: {number}",
  "Planned: {quantity} {unit}": "Planificat: {quantity} {unit}",
  "Actual: {quantity} {unit}": "Real: {quantity} {unit}",
  "Warehouse: {name}": "Depozit: {name}",
  "View Full Traceability": "Vezi trasabilitatea completă",
  "Last exported: {date}": "Ultimul export: {date}",
  "Resending...": "Se retrimite...",
  "Sent to 1C - Resend": "Trimis în 1C - Retrimite",
  "Variance Analysis": "Analiza diferențelor",
  "Yield Variance": "Diferență de randament",
  "{actual} vs {planned} planned": "{actual} față de {planned} planificat",
  "Material Variances": "Diferențe materii prime",
  "Materials with variance > 5%": "Materii prime cu diferență > 5%",
  "Final Product Batches": "Loturi produs finit",
  "Total Operations": "Total operații",
  "Operator Signatures": "Semnăturile operatorilor",
  "Document Timeline": "Cronologia documentului",
  "Release Date:": "Data lansării:",
  "Generated:": "Generat:",
  "Quality Grade:": "Clasă de calitate:",
  "Document Version:": "Versiune document:",
  "Exported to 1C:": "Exportat în 1C:",
  "{date} by {name}": "{date} de {name}",
  "No Release Selected": "Nicio lansare selectată",
  "Select a production release from the list to view its details.": "Selectează o lansare în producție din listă pentru a-i vedea detaliile.",
  "Balance recalculated successfully": "Soldul a fost recalculat cu succes",
  "Failed to recalculate balance": "Soldul nu a putut fi recalculat",
  "Please enter amount and reason": "Introdu suma și motivul",
  "Balance adjusted successfully": "Soldul a fost ajustat cu succes",
  "Failed to adjust balance": "Soldul nu a putut fi ajustat",
  "Account set as default": "Contul a fost setat ca implicit",
  "Failed to set default account": "Contul implicit nu a putut fi setat",
  "Account not found": "Contul nu a fost găsit",
  "Set as Default": "Setează ca implicit",
  "Adjust Balance": "Ajustează soldul",
  "Current Balance": "Sold curent",
  "Account Number": "Număr cont",
  "Account Details": "Detalii cont",
  "Money In": "Intrări",
  "Money Out": "Ieșiri",
  "Clear Filters": "Șterge filtrele",
  "Recent Transactions": "Tranzacții recente",
  "View All": "Vezi tot",
  "No transactions found": "Nu s-au găsit tranzacții",
  "Adjust Account Balance": "Ajustează soldul contului",
  "Adjustment Amount (positive or negative)": "Suma ajustării (pozitivă sau negativă)",
  "e.g., 100.00 or -50.00": "ex.: 100.00 sau -50.00",
  "Reason for Adjustment": "Motivul ajustării",
  "Enter reason for this adjustment": "Introdu motivul acestei ajustări",
  "Adjusting...": "Se ajustează...",
  "Apply Adjustment": "Aplică ajustarea",
  "Default for {type}": "Implicit pentru {type}",
  "View Details": "Vezi detaliile",
  "Cash Accounts": "Conturi de numerar",
  "Manage Accounts": "Gestionează conturile",
  "Total Accounts": "Total conturi",
  "Active Accounts": "Conturi active",
  "Total Balance": "Sold total",
  "Suspended": "Suspendat",
  "Closed": "Închis",
  "Account Type": "Tip cont",
  "Default Only": "Doar implicite",
  "Non-Default Only": "Doar neimplicite",
  "Loading accounts...": "Se încarcă conturile...",
  "No accounts": "Niciun cont",
  "Get started by creating a new cash account in settings.": "Începe prin a crea un cont de numerar nou în setări.",
  "Go to Settings": "Mergi la Setări",
  "Mark this transaction as completed?": "Marchezi această tranzacție ca finalizată?",
  "Transaction completed successfully": "Tranzacția a fost finalizată cu succes",
  "Failed to complete transaction": "Tranzacția nu a putut fi finalizată",
  "Cancel this transaction? This action cannot be undone.": "Anulezi această tranzacție? Această acțiune nu poate fi anulată.",
  "Transaction cancelled successfully": "Tranzacția a fost anulată cu succes",
  "Failed to cancel transaction": "Tranzacția nu a putut fi anulată",
  "Inter-Account Transfer": "Transfer între conturi",
  "Updated: {name}": "Actualizat: {name}",
  "Last Modified": "Ultima modificare",
  "Cash Transactions": "Tranzacții de numerar",
  "Reconcile": "Reconciliază",
  "Reports": "Rapoarte",
  "Search by reference, description, customer, supplier...": "Caută după referință, descriere, client, furnizor...",
  "Date range": "Interval de date",
  "Reversed": "Stornat",
  "Transaction Type": "Tip tranzacție",
  "Account": "Cont",
  "All Accounts": "Toate conturile",
  "Loading transactions...": "Se încarcă tranzacțiile...",
  "No transactions found matching your criteria.": "Nu s-au găsit tranzacții care să corespundă criteriilor.",
  "Showing {from} to {to} of {total} transactions": "Se afișează {from}–{to} din {total} tranzacții",
  "Please select a transaction type": "Selectează un tip de tranzacție",
  "Please select an account": "Selectează un cont",
  "Please enter a valid amount": "Introdu o sumă validă",
  "Total allocated ({allocated}) exceeds receipt amount ({amount})": "Totalul alocat ({allocated}) depășește suma încasării ({amount})",
  "Receipt recorded successfully": "Încasarea a fost înregistrată cu succes",
  "Failed to record receipt": "Încasarea nu a putut fi înregistrată",
  "(Default)": "(Implicit)",
  "Record Receipt": "Înregistrează încasarea",
  "Record a payment received from a customer": "Înregistrează o plată primită de la un client",
  "Select a type…": "Selectează un tip…",
  "Pick a category…": "Alege o categorie…",
  "(optional)": "(opțional)",
  "Search for a customer...": "Caută un client...",
  "Selected: {name}": "Selectat: {name}",
  "Receive Into Account": "Încasează în contul",
  "Select an account": "Selectează un cont",
  "e.g., Cheque number, bank reference...": "ex.: număr cec, referință bancară...",
  "Invoice Allocation": "Alocare pe facturi",
  "{count} invoice(s) allocated - {amount}": "Facturi alocate: {count} - {amount}",
  "{count} invoice(s) allocated": "Facturi alocate: {count}",
  "No invoices allocated (payment will be on account)": "Nicio factură alocată (plata va rămâne în avans pe cont)",
  "Edit Allocation": "Editează alocarea",
  "Allocate to Invoices": "Alocă pe facturi",
  "Save Receipt": "Salvează încasarea",
  "Please select an employee": "Selectează un angajat",
  "Payment recorded successfully": "Plata a fost înregistrată cu succes",
  "Failed to record payment": "Plata nu a putut fi înregistrată",
  "Outstanding: {amount}": "Restant: {amount}",
  "Record Employee Payment": "Înregistrează plata către angajat",
  "Record a payroll payment to an employee": "Înregistrează o plată salarială către un angajat",
  "Search for an employee...": "Caută un angajat...",
  "Payroll Entry (Optional)": "Înregistrare salarială (opțional)",
  "Payment on account": "Plată în avans pe cont",
  "Select a payroll entry to link this payment to specific wages": "Selectează o înregistrare salarială pentru a lega această plată de anumite salarii",
  "Pay From Account": "Plătește din contul",
  "Payment must be after pay period ends ({date})": "Plata trebuie să fie după sfârșitul perioadei de plată ({date})",
  "e.g., Bank transfer reference...": "ex.: referința transferului bancar...",
  "Expense Category": "Categorie de cheltuieli",
  "Payment Summary": "Sumar plată",
  "Employee:": "Angajat:",
  "Amount:": "Sumă:",
  "Linked to:": "Legat de:",
  "Payroll Entry": "Înregistrare salarială",
  "Save Payment": "Salvează plata",
  "Principal amount is required and must be greater than zero": "Suma principală este obligatorie și trebuie să fie mai mare decât zero",
  "Issue date is required": "Data acordării este obligatorie",
  "Employee is required for employee loans": "Angajatul este obligatoriu pentru împrumuturile către angajați",
  "A counterparty (supplier or customer) is required": "Este necesar un partener (furnizor sau client)",
  "Loan created": "Împrumutul a fost creat",
  "Loan updated": "Împrumutul a fost actualizat",
  "Failed to save loan": "Împrumutul nu a putut fi salvat",
  "Delete loan {number}? This cannot be undone.": "Ștergi împrumutul {number}? Această acțiune nu poate fi anulată.",
  "Loan deleted": "Împrumutul a fost șters",
  "Failed to delete loan": "Împrumutul nu a putut fi șters",
  "Enter principal amount and period (months) to generate schedule": "Introdu suma principală și perioada (luni) pentru a genera graficul",
  "Set issue date or first repayment date": "Setează data acordării sau data primei rambursări",
  "Locked rows principal exceeds total principal amount": "Principalul rândurilor blocate depășește suma principală totală",
  "All rows are locked — nothing to generate": "Toate rândurile sunt blocate — nimic de generat",
  "Regenerated schedule ({locked} locked, {recalculated} recalculated)": "Grafic regenerat (blocate: {locked}, recalculate: {recalculated})",
  "Generated {count} installments": { one: "S-a generat {count} rată", few: "S-au generat {count} rate", other: "S-au generat {count} de rate" },
  "Loading loan...": "Se încarcă împrumutul...",
  "Lock row from auto-generate": "Blochează rândul la generarea automată",
  "Lock": "Blochează",
  "Lock this row from recalculation": "Blochează acest rând la recalculare",
  "Payment Date": "Data plății",
  "Interest": "Dobândă",
  "Commission": "Comision",
  "Paid": "Plătit",
  "Installment": "Rată",
  "Transaction": "Tranzacție",
  "New Loan Contract": "Contract de împrumut nou",
  "Loan": "Împrumut",
  "Repaid": "Rambursat",
  "Outstanding": "Restant",
  "Interest Paid": "Dobândă plătită",
  "Borrowed": "Împrumutat (primit)",
  "Lent to Counterparty": "Acordat partenerului",
  "Lent to Employee": "Acordat angajatului",
  "Lender": "Creditor",
  "Borrower": "Debitor",
  "Search employees...": "Caută angajați...",
  "Search suppliers (lenders)...": "Caută furnizori (creditori)...",
  "Search customers (borrowers)...": "Caută clienți (debitori)...",
  "Partially Repaid": "Rambursat parțial",
  "Written Off": "Anulat (pierdere)",
  "Select currency...": "Selectează moneda...",
  "e.g. 12": "ex.: 12",
  "No Commission": "Fără comision",
  "Amount (per month)": "Sumă (pe lună)",
  "% of Principal": "% din principal",
  "% of Balance": "% din sold",
  "Custom": "Personalizat",
  "Annuity Payments": "Rate egale (anuități)",
  "Fixed Principal": "Principal fix",
  "Interest Only (Principal on Maturity)": "Doar dobândă (principal la scadență)",
  "Principal Only (Interest on Maturity)": "Doar principal (dobânda la scadență)",
  "Custom Installments": "Rate personalizate",
  "Bank": "Bancă",
  "Cash": "Numerar",
  "Select account...": "Selectează contul...",
  "External reference": "Referință externă",
  "Repayment Schedule": "Grafic de rambursare",
  "Auto-Generate": "Generează automat",
  "Add Row": "Adaugă rând",
  "No repayment schedule defined": "Niciun grafic de rambursare definit",
  "Auto-generate schedule": "Generează automat graficul",
  "or": "sau",
  "Add manually": "Adaugă manual",
  "Payment History": "Istoric plăți",
  "No payments recorded yet": "Nicio plată înregistrată încă",
  "Save the loan first to track payments": "Salvează mai întâi împrumutul pentru a urmări plățile",
  "No payment data available": "Nu există date despre plăți",
  "Principal Repaid:": "Principal rambursat:",
  "Interest Paid:": "Dobândă plătită:",
  "Commission Paid:": "Comision plătit:",
  "Balance Outstanding:": "Sold restant:",
  "Loan description...": "Descrierea împrumutului...",
  "Audit Trail": "Istoric audit",
  "Loan Number:": "Număr împrumut:",
  "Delete loan {number}?": "Ștergi împrumutul {number}?",
  "Maturity": "Scadență",
  "Loan Contracts": "Contracte de împrumut",
  "New Loan": "Împrumut nou",
  "Search loans...": "Caută împrumuturi...",
  "No loans found": "Nu s-au găsit împrumuturi",
  "Create your first loan contract": "Creează primul contract de împrumut",
  "Please enter a name": "Introdu un nume",
  "Please select a bill type": "Selectează un tip de factură de cheltuieli",
  "Please select a VAT rate": "Selectează o cotă TVA",
  "Scheduled payment updated": "Plata programată a fost actualizată",
  "Scheduled payment created": "Plata programată a fost creată",
  "Failed to save scheduled payment": "Plata programată nu a putut fi salvată",
  "Execute \"{name}\" now?": "Execuți „{name}” acum?",
  "Payment executed. Transaction: {number}": "Plata a fost executată. Tranzacție: {number}",
  "Failed to execute payment": "Plata nu a putut fi executată",
  "Payment paused": "Plata a fost suspendată",
  "Failed to pause payment": "Plata nu a putut fi suspendată",
  "Payment resumed": "Plata a fost reluată",
  "Failed to resume payment": "Plata nu a putut fi reluată",
  "Cancel \"{name}\"? This cannot be undone.": "Anulezi „{name}”? Această acțiune nu poate fi anulată.",
  "Payment cancelled": "Plata a fost anulată",
  "Failed to cancel payment": "Plata nu a putut fi anulată",
  "Delete \"{name}\"? This cannot be undone.": "Ștergi „{name}”? Această acțiune nu poate fi anulată.",
  "Payment deleted": "Plata a fost ștearsă",
  "Failed to delete payment": "Plata nu a putut fi ștearsă",
  "Success": "Reușit",
  "Start Date": "Data de început",
  "End Date": "Data de sfârșit",
  "Last Executed": "Ultima execuție",
  "Execution History": "Istoric execuții",
  "No executions yet": "Nicio execuție încă",
  "Next Due": "Următoarea scadență",
  "Auto-execute": "Execuție automată",
  "Execute Now": "Execută acum",
  "Pause": "Suspendă",
  "Manage recurring payments and expected receipts": "Gestionează plățile recurente și încasările așteptate",
  "New Scheduled Payment": "Plată programată nouă",
  "Paused": "Suspendat",
  "Expected Receipts": "Încasări așteptate",
  "No scheduled payments": "Nicio plată programată",
  "Get started by creating a new scheduled payment.": "Începe prin a crea o plată programată nouă.",
  "Edit Scheduled Payment": "Editează plata programată",
  "Bill": "Factură de cheltuieli",
  "Cash Transaction": "Tranzacție de numerar",
  "Auto-verify generated bills if amount unchanged": "Verifică automat facturile de cheltuieli generate dacă suma nu s-a schimbat",
  "For fixed-amount recurring obligations (rent, locked-price subscriptions). When the generated bill's amount matches the template, skip the verify step.": "Pentru obligații recurente cu sumă fixă (chirie, abonamente cu preț blocat). Când suma facturii de cheltuieli generate corespunde șablonului, pasul de verificare se omite.",
  "e.g., Monthly Rent, Weekly Supplier Payment": "ex.: Chirie lunară, Plată săptămânală furnizor",
  "Receipt (In)": "Încasare (intrare)",
  "Payment (Out)": "Plată (ieșire)",
  "Select bill type": "Selectează tipul facturii de cheltuieli",
  "Select account": "Selectează contul",
  "Select type": "Selectează tipul",
  "-- None --": "-- Niciunul --",
  "Default (GBP)": "Implicit (GBP)",
  "Day of month": "Ziua lunii",
  "Week + day": "Săptămână + zi",
  "1st": "Prima",
  "2nd": "A doua",
  "3rd": "A treia",
  "4th": "A patra",
  "Last": "Ultima",
  "Next Due Date": "Următoarea dată scadentă",
  "Max Executions": "Nr. maxim de execuții",
  "Unlimited": "Nelimitat",
  "Auto-execute on due date": "Execută automat la data scadentă",
  "Please select a director": "Selectează un director",
  "Record a payment made to a customer (e.g. refund)": "Înregistrează o plată făcută unui client (ex.: rambursare)",
  "Record a payment": "Înregistrează o plată",
  "Record a payment made to a supplier": "Înregistrează o plată făcută unui furnizor",
  "{count} payroll entry allocated": { one: "{count} înregistrare salarială alocată", few: "{count} înregistrări salariale alocate", other: "{count} de înregistrări salariale alocate" },
  "{count} payroll entries allocated": { one: "{count} înregistrare salarială alocată", few: "{count} înregistrări salariale alocate", other: "{count} de înregistrări salariale alocate" },
  "{count} payroll entry allocated - {amount}": { one: "{count} înregistrare salarială alocată - {amount}", few: "{count} înregistrări salariale alocate - {amount}", other: "{count} de înregistrări salariale alocate - {amount}" },
  "{count} payroll entries allocated - {amount}": { one: "{count} înregistrare salarială alocată - {amount}", few: "{count} înregistrări salariale alocate - {amount}", other: "{count} de înregistrări salariale alocate - {amount}" },
  "No outstanding payroll entries for this employee — the payment saves without them": "Nicio înregistrare salarială restantă pentru acest angajat — plata se salvează fără ele",
  "No outstanding payroll entries — the payment saves without them": "Nicio înregistrare salarială restantă — plata se salvează fără ele",
  "No entries allocated (payment will be on account)": "Nicio înregistrare alocată (plata va rămâne în avans pe cont)",
  "Allocate the payment across the employees it covers": "Alocă plata pe angajații pe care îi acoperă",
  "Director": "Director",
  "Search for a director...": "Caută un director...",
  "Leave blank to pay several employees in one payment": "Lasă gol pentru a plăti mai mulți angajați într-o singură plată",
  "Search for a supplier...": "Caută un furnizor...",
  "Part of the amount · net {amount}": "Inclus în sumă · net {amount}",
  "Part of the amount, not on top of it": "Inclus în sumă, nu adăugat peste ea",
  "Amount ({currency})": "Sumă ({currency})",
  "Link to Proforma (Advance Payment)": "Leagă de proformă (plată în avans)",
  "No proforma (regular payment)": "Fără proformă (plată obișnuită)",
  "Proforma:": "Proformă:",
  "Currency:": "Monedă:",
  "e.g., Invoice number, bank reference...": "ex.: număr factură, referință bancară...",
  "Payroll Allocation": "Alocare salarială",
  "Raise a pay period and payroll entries in Payroll to allocate a payment to them": "Creează o perioadă de plată și înregistrări salariale în Salarizare pentru a le aloca o plată",
  "Allocate to Payroll Entries": "Alocă pe înregistrări salariale",
  "{allocated} allocated of a {amount} payment": "{allocated} alocat dintr-o plată de {amount}",
  "The allocated total differs from the payment amount": "Totalul alocat diferă de suma plății",
  "Are you sure you want to cancel this transaction?": "Sigur vrei să anulezi această tranzacție?",
  "Transaction cancelled": "Tranzacția a fost anulată",
  "Transaction set to draft": "Tranzacția a fost trecută în ciornă",
  "Failed to set transaction to draft": "Tranzacția nu a putut fi trecută în ciornă",
  "Auto-allocated to {count} invoices": { one: "Alocat automat pe {count} factură", few: "Alocat automat pe {count} facturi", other: "Alocat automat pe {count} de facturi" },
  "Failed to auto-allocate": "Alocarea automată a eșuat",
  "This payment is completed. Removing this allocation will reduce the bill / invoice’s paid amount and free this portion of the payment. Continue?": "Această plată este finalizată. Eliminarea acestei alocări va reduce suma plătită a facturii și va elibera această parte a plății. Continui?",
  "Allocation removed": "Alocarea a fost eliminată",
  "This payment is completed. Removing all {count} allocation(s) will reset their paid amounts. Continue?": "Această plată este finalizată. Eliminarea tuturor alocărilor va reseta sumele lor plătite. Alocări: {count}. Continui?",
  "All allocations cleared": "Toate alocările au fost șterse",
  "Failed to clear allocations": "Alocările nu au putut fi șterse",
  "Select a target account for the transfer": "Selectează contul de destinație pentru transfer",
  "Cannot transfer to the same account": "Nu se poate transfera în același cont",
  "Changing the transaction kind removes its {count} allocation(s). Continue?": "Schimbarea tipului tranzacției îi elimină alocările. Alocări: {count}. Continui?",
  "Transaction updated": "Tranzacția a fost actualizată",
  "Failed to update transaction": "Tranzacția nu a putut fi actualizată",
  "Proforma unlinked": "Proforma a fost dezlegată",
  "Failed to unlink proforma": "Proforma nu a putut fi dezlegată",
  "Proforma linked": "Proforma a fost legată",
  "Failed to link proforma": "Proforma nu a putut fi legată",
  "Allocated to 1 payroll entry": "Alocat pe 1 înregistrare salarială",
  "Allocated to {count} payroll entries": { one: "Alocat pe {count} înregistrare salarială", few: "Alocat pe {count} înregistrări salariale", other: "Alocat pe {count} de înregistrări salariale" },
  "Allocated to 1 invoice": "Alocat pe 1 factură",
  "Allocated to {count} invoices": { one: "Alocat pe {count} factură", few: "Alocat pe {count} facturi", other: "Alocat pe {count} de facturi" },
  "Failed to create allocations": "Alocările nu au putut fi create",
  "Click to complete": "Apasă pentru a finaliza",
  "Click to set to draft": "Apasă pentru a trece în ciornă",
  "Transaction not found": "Tranzacția nu a fost găsită",
  "Money In (Receipt)": "Intrare (încasare)",
  "Money Out (Payment)": "Ieșire (plată)",
  "View sales invoice": "Vezi factura de vânzare",
  "View bill": "Vezi factura de cheltuieli",
  "View purchase invoice": "Vezi factura de achiziție",
  "Remove allocation (confirms first)": "Elimină alocarea (cere confirmare)",
  "Allocated (GBP)": "Alocat (GBP)",
  "group": "grup",
  "Sales Invoice": "Factură de vânzare",
  "Amount ({code})": "Sumă ({code})",
  "incl. {vat} VAT · net {net}": "incl. TVA {vat} · net {net}",
  "VAT included in amount": "TVA inclus în sumă",
  "from document": "din document",
  "Taken pro-rata from the allocated bill/invoice — not editable here.": "Preluat proporțional din factura alocată — nu se poate edita aici.",
  "Not stated — the full amount counts as expense.": "Nespecificat — întreaga sumă se consideră cheltuială.",
  "Net expense {amount}.": "Cheltuială netă {amount}.",
  "Leave blank if not stated": "Lasă gol dacă nu este specificat",
  "Part of the amount above, not on top of it. Net expense {amount}.": "Inclus în suma de mai sus, nu adăugat peste ea. Cheltuială netă {amount}.",
  "Transaction Date & Time": "Data și ora tranzacției",
  "Value: {date}": "Valoare: {date}",
  "View Account": "Vezi contul",
  "Transaction Details": "Detalii tranzacție",
  "Uncategorised": "Necategorisit",
  "Taken from the allocated bill/invoice — not editable here.": "Preluat din factura alocată — nu se poate edita aici.",
  "From invoices:": "Din facturi:",
  "Default ({code})": "Implicit ({code})",
  "Enter description": "Introdu descrierea",
  "Linked Proforma (Advance Payment)": "Proformă legată (plată în avans)",
  "Remove linked proforma": "Elimină proforma legată",
  "Payment ({code})": "Plată ({code})",
  "Remaining ({code})": "Rămas ({code})",
  "Link to Proforma": "Leagă de proformă",
  "Select a proforma...": "Selectează o proformă...",
  "No active proformas found for this supplier.": "Nu s-au găsit proforme active pentru acest furnizor.",
  "Director Information": "Informații director",
  "Employee Information": "Informații angajat",
  "Search director...": "Caută director...",
  "Search employee...": "Caută angajat...",
  "View Statement": "Vezi fișa",
  "Search supplier...": "Caută furnizor...",
  "Payroll Allocations": "Alocări salariale",
  "Invoice Allocations": "Alocări pe facturi",
  "Posted payment — confirms before unallocating": "Plată înregistrată — cere confirmare înainte de dezalocare",
  "Auto-Allocate": "Alocă automat",
  "Add Allocation": "Adaugă alocare",
  "Allocated: {amount}": "Alocat: {amount}",
  "Unallocated: {amount}": "Nealocat: {amount}",
  "Include group invoices": "Include facturile grupului",
  "No allocations yet": "Nicio alocare încă",
  "Use Auto-Allocate or manually allocate to payroll entries": "Folosește Alocă automat sau alocă manual pe înregistrări salariale",
  "Use Auto-Allocate or manually allocate to invoices": "Folosește Alocă automat sau alocă manual pe facturi",
  "Audit Information": "Informații de audit",
  "1 change": "1 modificare",
  "{count} changes": { one: "{count} modificare", few: "{count} modificări", other: "{count} de modificări" },
  "Change History": "Istoric modificări",
  "Please select a source account": "Selectează un cont sursă",
  "Please select a destination account": "Selectează un cont de destinație",
  "Source and destination accounts must be different": "Conturile sursă și destinație trebuie să fie diferite",
  "Transfer funds between accounts": "Transferă fonduri între conturi",
  "Select source account": "Selectează contul sursă",
  "Current balance: {amount}": "Sold curent: {amount}",
  "Select destination account": "Selectează contul de destinație",
  "Failed to load employee": "Angajatul nu a putut fi încărcat",
  "First name and last name are required": "Prenumele și numele sunt obligatorii",
  "Start date is required": "Data de început este obligatorie",
  "Employee created successfully": "Angajatul a fost creat cu succes",
  "Employee updated successfully": "Angajatul a fost actualizat cu succes",
  "Failed to save employee": "Angajatul nu a putut fi salvat",
  "Pay Period": "Perioadă de plată",
  "Total Hours": "Total ore",
  "Gross Pay": "Salariu brut",
  "Net Pay": "Salariu net",
  "New Employee": "Angajat nou",
  "Amount Due: £{amount}": "De plată: £{amount}",
  "Personal Details": "Date personale",
  "Employee Number": "Număr angajat",
  "Auto-generated if empty": "Generat automat dacă este gol",
  "First Name": "Prenume",
  "Last Name": "Nume",
  "Employment Details": "Detalii angajare",
  "Employment Type": "Tip de angajare",
  "Full Time": "Normă întreagă",
  "Part Time": "Normă parțială",
  "Casual": "Ocazional",
  "Contractor": "Colaborator",
  "Pay Frequency": "Frecvența plății",
  "Fortnightly": "La două săptămâni",
  "Monthly": "Lunar",
  "— None —": "— Niciunul —",
  "Skills this employee has. They will only see WIP operations that require no skill or one of their skills. No skills = sees all operations.": "Competențele acestui angajat. Va vedea doar operațiile WIP care nu necesită nicio competență sau care necesită una dintre competențele sale. Fără competențe = vede toate operațiile.",
  "No skills defined yet.": "Nicio competență definită încă.",
  "Pay Details": "Detalii plată",
  "Pay Scenario": "Scenariu de plată",
  "Select a pay scenario": "Selectează un scenariu de plată",
  "Enter rate": "Introdu tariful",
  "Select scenario first": "Selectează mai întâi scenariul",
  "Bank Name": "Nume bancă",
  "Sort Code": "Sort code",
  "Additional notes about this employee...": "Note suplimentare despre acest angajat...",
  "No payroll history found": "Nu s-a găsit istoric salarial",
  "Failed to load employees": "Angajații nu au putut fi încărcați",
  "Please fill at least one field to update": "Completează cel puțin un câmp de actualizat",
  "Updated {count} employees": { one: "S-a actualizat {count} angajat", few: "S-au actualizat {count} angajați", other: "S-au actualizat {count} de angajați" },
  "Updated {count} employee": { one: "S-a actualizat {count} angajat", few: "S-au actualizat {count} angajați", other: "S-au actualizat {count} de angajați" },
  "Failed to update employees": "Angajații nu au putut fi actualizați",
  "Pay Rate": "Tarif de plată",
  "Amount Due": "De plată",
  "Departments & Titles": "Departamente și funcții",
  "Add Employee": "Adaugă angajat",
  "All Pay Scenarios": "Toate scenariile de plată",
  "All Departments": "Toate departamentele",
  "All Titles": "Toate funcțiile",
  "{count} employees selected": { one: "{count} angajat selectat", few: "{count} angajați selectați", other: "{count} de angajați selectați" },
  "{count} employee selected": { one: "{count} angajat selectat", few: "{count} angajați selectați", other: "{count} de angajați selectați" },
  "Clear Selection": "Șterge selecția",
  "Bulk Update": "Actualizare în masă",
  "No employees found": "Nu s-au găsit angajați",
  "Add your first employee": "Adaugă primul angajat",
  "Bulk Update ({count} employees)": { one: "Actualizare în masă ({count} angajat)", few: "Actualizare în masă ({count} angajați)", other: "Actualizare în masă ({count} de angajați)" },
  "Bulk Update ({count} employee)": { one: "Actualizare în masă ({count} angajat)", few: "Actualizare în masă ({count} angajați)", other: "Actualizare în masă ({count} de angajați)" },
  "Leave fields empty to keep current values. Only filled fields will be updated.": "Lasă câmpurile goale pentru a păstra valorile curente. Vor fi actualizate doar câmpurile completate.",
  "-- Keep Current --": "-- Păstrează valoarea curentă --",
  "Pay Rate (£)": "Tarif de plată (£)",
  "Keep current": "Păstrează valoarea curentă",
  "Failed to load pay period": "Perioada de plată nu a putut fi încărcată",
  "Imported {imported} entries, updated {updated}": "Înregistrări importate: {imported}, actualizate: {updated}",
  "Failed to import CSV file": "Fișierul CSV nu a putut fi importat",
  "Failed to load entry details": "Detaliile înregistrării nu au putut fi încărcate",
  "Calculated payroll for {count} employees": { one: "Salarizare calculată pentru {count} angajat", few: "Salarizare calculată pentru {count} angajați", other: "Salarizare calculată pentru {count} de angajați" },
  "{count} approved or paid entries were left as they are": "Înregistrări aprobate sau plătite lăsate neschimbate: {count}",
  "Failed to calculate payroll": "Salarizarea nu a putut fi calculată",
  "Created {created} entries from {period} ({skipped} already existed)": "Înregistrări create din {period}: {created} (existau deja: {skipped})",
  "Created {created} entries from {period}": "Înregistrări create din {period}: {created}",
  "Failed to fill from previous period": "Completarea din perioada anterioară a eșuat",
  "Are you sure you want to close this pay period? This will prevent further edits.": "Sigur vrei să închizi această perioadă de plată? Nu vor mai fi permise modificări.",
  "Pay period closed": "Perioada de plată a fost închisă",
  "Failed to close pay period": "Perioada de plată nu a putut fi închisă",
  "Pay period reopened": "Perioada de plată a fost redeschisă",
  "Failed to reopen pay period": "Perioada de plată nu a putut fi redeschisă",
  "Timesheet updated": "Pontajul a fost actualizat",
  "Failed to update timesheet": "Pontajul nu a putut fi actualizat",
  "Are you sure you want to delete this timesheet entry?": "Sigur vrei să ștergi această înregistrare de pontaj?",
  "Timesheet deleted": "Pontajul a fost șters",
  "Failed to delete timesheet": "Pontajul nu a putut fi șters",
  "Are you sure you want to delete {count} timesheet entries?": { one: "Sigur vrei să ștergi {count} înregistrare de pontaj?", few: "Sigur vrei să ștergi {count} înregistrări de pontaj?", other: "Sigur vrei să ștergi {count} de înregistrări de pontaj?" },
  "Failed to delete timesheets": "Pontajele nu au putut fi șterse",
  "Are you sure you want to delete {count} payroll entries?": { one: "Sigur vrei să ștergi {count} înregistrare salarială?", few: "Sigur vrei să ștergi {count} înregistrări salariale?", other: "Sigur vrei să ștergi {count} de înregistrări salariale?" },
  "Failed to delete payroll entries": "Înregistrările salariale nu au putut fi șterse",
  "Are you sure you want to delete this pay period? This will also delete all associated timesheets and payroll entries. This action cannot be undone.": "Sigur vrei să ștergi această perioadă de plată? Vor fi șterse și toate pontajele și înregistrările salariale asociate. Această acțiune nu poate fi anulată.",
  "Pay period deleted": "Perioada de plată a fost ștearsă",
  "Failed to delete pay period": "Perioada de plată nu a putut fi ștearsă",
  "Failed to load data for creating entry": "Datele pentru crearea înregistrării nu au putut fi încărcate",
  "Please select an employee and pay scenario": "Selectează un angajat și un scenariu de plată",
  "Payroll entry updated": "Înregistrarea salarială a fost actualizată",
  "Payroll entry created": "Înregistrarea salarială a fost creată",
  "Failed to save entry": "Înregistrarea nu a putut fi salvată",
  "Pay period not found": "Perioada de plată nu a fost găsită",
  "Back to Pay Periods": "Înapoi la Perioade de plată",
  "Rate": "Tarif",
  "View Payslip": "Vezi fluturașul de salariu",
  "Day": "Zi",
  "Clock In": "Intrare",
  "Clock Out": "Ieșire",
  "Hours": "Ore",
  "Payroll Entries ({count})": "Înregistrări salariale ({count})",
  "Timesheets ({count})": "Pontaje ({count})",
  "Pay Date: {date}": "Data plății: {date}",
  "Import CSV": "Importă CSV",
  "Fill from Previous": "Completează din perioada anterioară",
  "Calculate Payroll": "Calculează salarizarea",
  "Close Period": "Închide perioada",
  "Delete Period": "Șterge perioada",
  "This pay period is closed. No further changes can be made.": "Această perioadă de plată este închisă. Nu mai pot fi făcute modificări.",
  "Import Results": "Rezultatele importului",
  "Imported:": "Importate:",
  "Updated:": "Actualizate:",
  "Skipped:": "Omise:",
  "...and {count} more": "...și încă {count}",
  "Add Entry": "Adaugă înregistrare",
  "{count} entries selected": { one: "{count} înregistrare selectată", few: "{count} înregistrări selectate", other: "{count} de înregistrări selectate" },
  "{count} entry selected": { one: "{count} înregistrare selectată", few: "{count} înregistrări selectate", other: "{count} de înregistrări selectate" },
  "No payroll entries yet. Import timesheet data and calculate payroll, or add entries manually.": "Nicio înregistrare salarială încă. Importă datele de pontaj și calculează salarizarea sau adaugă înregistrări manual.",
  "{count} timesheets selected": { one: "{count} pontaj selectat", few: "{count} pontaje selectate", other: "{count} de pontaje selectate" },
  "{count} timesheet selected": { one: "{count} pontaj selectat", few: "{count} pontaje selectate", other: "{count} de pontaje selectate" },
  "No timesheet entries yet. Import a CSV file from Clockedin.": "Nicio înregistrare de pontaj încă. Importă un fișier CSV din Clockedin.",
  "Edit Timesheet Entry": "Editează înregistrarea de pontaj",
  "Break (hours)": "Pauză (ore)",
  "Final Hours": "Ore finale",
  "Recalculate from times": "Recalculează din ore",
  "Optional notes about this correction...": "Note opționale despre această corectare...",
  "Edit Payroll Entry": "Editează înregistrarea salarială",
  "Add Payroll Entry": "Adaugă înregistrare salarială",
  "Select an employee...": "Selectează un angajat...",
  "All employees already have entries in this period": "Toți angajații au deja înregistrări în această perioadă",
  "Select a pay scenario...": "Selectează un scenariu de plată...",
  "Fixed Amount (£)": "Sumă fixă (£)",
  "Base wage: £{amount} — difference goes to Other Pay": "Salariu de bază: £{amount} — diferența trece la Alte sume",
  "Difference from the base wage goes to Other Pay": "Diferența față de salariul de bază trece la Alte sume",
  "Auto-calculates hours from employee rate": "Calculează automat orele din tariful angajatului",
  "Regular Hours": "Ore normale",
  "Overtime Hours": "Ore suplimentare",
  "Weekend Hours": "Ore de weekend",
  "Other Pay (£)": "Alte sume (£)",
  "Bonuses, adjustments": "Bonusuri, ajustări",
  "Deductions (£)": "Rețineri (£)",
  "Create Entry": "Creează înregistrarea",
  "Failed to load pay periods": "Perioadele de plată nu au putut fi încărcate",
  "Failed to load schedules": "Programele nu au putut fi încărcate",
  "Pay period created": "Perioada de plată a fost creată",
  "Failed to run payroll": "Rularea salarizării a eșuat",
  "Close pay period \"{name}\"? This locks it from further edits.": "Închizi perioada de plată „{name}”? Aceasta o blochează pentru modificări ulterioare.",
  "Pay period \"{name}\" closed": "Perioada de plată „{name}” a fost închisă",
  "Click to close this period": "Apasă pentru a închide această perioadă",
  "Pay Date": "Data plății",
  "Open": "Deschis",
  "All Frequencies": "Toate frecvențele",
  "Schedules": "Programe",
  "Run Payroll": "Rulează salarizarea",
  "No pay periods found": "Nu s-au găsit perioade de plată",
  "Run Your First Payroll": "Rulează prima salarizare",
  "No active payroll schedules found.": "Nu s-au găsit programe de salarizare active.",
  "Create a schedule first": "Creează mai întâi un program",
  "Select Schedule": "Selectează programul",
  "{frequency} • {count} employees": { one: "{frequency} • {count} angajat", few: "{frequency} • {count} angajați", other: "{frequency} • {count} de angajați" },
  "Last: {name}": "Ultima: {name}",
  "This is the first pay period for this schedule. Please select the start date.": "Aceasta este prima perioadă de plată pentru acest program. Selectează data de început.",
  "Period Start Date": "Data de început a perioadei",
  "Last period:": "Ultima perioadă:",
  "Next period will be calculated automatically.": "Perioada următoare va fi calculată automat.",
  "Custom Start Date (optional)": "Dată de început personalizată (opțional)",
  "Leave empty to continue from last period": "Lasă gol pentru a continua de la ultima perioadă",
  "Create Pay Period": "Creează perioada de plată",
  "Failed to load payroll entries": "Înregistrările salariale nu au putut fi încărcate",
  "Failed to download payslip": "Fluturașul de salariu nu a putut fi descărcat",
  "Payroll entry approved": "Înregistrarea salarială a fost aprobată",
  "Failed to approve entry": "Înregistrarea nu a putut fi aprobată",
  "Search by employee name...": "Caută după numele angajatului...",
  "All Pay Periods": "Toate perioadele de plată",
  "Calculated": "Calculat",
  "Partially Paid": "Plătit parțial",
  "Total Gross Pay": "Total salariu brut",
  "Total Net Pay": "Total salariu net",
  "No payroll entries found": "Nu s-au găsit înregistrări salariale",
  "Page {page} of {pages}": "Pagina {page} din {pages}",
  "Failed to load payroll entry": "Înregistrarea salarială nu a putut fi încărcată",
  "Failed to approve payroll entry": "Înregistrarea salarială nu a putut fi aprobată",
  "Payroll entry reverted to calculated": "Înregistrarea salarială a fost readusă la Calculat",
  "Failed to revert payroll entry": "Înregistrarea salarială nu a putut fi readusă",
  "Payroll recalculated": "Salarizarea a fost recalculată",
  "Failed to view payslip": "Fluturașul de salariu nu a putut fi afișat",
  "Failed to update payroll entry": "Înregistrarea salarială nu a putut fi actualizată",
  "Click to revert to calculated": "Apasă pentru a readuce la Calculat",
  "WE": "WE",
  "Payroll Entry #{id}": "Înregistrare salarială #{id}",
  "Hours Breakdown": "Defalcare ore",
  "Regular": "Normal",
  "Overtime": "Ore suplimentare",
  "Weekend": "Weekend",
  "Pay Breakdown": "Defalcare plată",
  "Regular Pay ({hours}h × £{rate})": "Plată normală ({hours}h × £{rate})",
  "Regular Pay ({hours}h)": "Plată normală ({hours}h)",
  "Overtime Pay ({hours}h)": "Plată ore suplimentare ({hours}h)",
  "Weekend Pay ({hours}h)": "Plată weekend ({hours}h)",
  "Night Premium ({hours}h)": "Spor de noapte ({hours}h)",
  "Other Pay": "Alte sume",
  "Deductions": "Rețineri",
  "Daily Breakdown": "Defalcare zilnică",
  "Payment Status": "Starea plății",
  "Scenario": "Scenariu",
  "Calculated By": "Calculat de",
  "Note": "Notă",
  "Principal": "Principal",
  "Note...": "Notă...",
  "Batch created successfully": "Lotul a fost creat cu succes",
  "Loading batches...": "Se încarcă loturile...",
  "Batch Info": "Informații lot",
  "units": "unități",
  "Batch Management": "Gestionare loturi",
  "Rejected": "Respins",
  "All Expiry": "Toate expirările",
  "Expiring Soon": "Expiră curând",
  "Fresh": "Proaspăt",
  "Hide OOS": "Ascunde fără stoc",
  "Create Batch": "Creează lot",
  "Health:": "Stare:",
  "No Batches Found": "Nu s-au găsit loturi",
  "No batches match your current filters. Try adjusting your search criteria or create a new batch.": "Niciun lot nu corespunde filtrelor curente. Ajustează criteriile de căutare sau creează un lot nou.",
  "Create New Batch": "Creează un lot nou",
  "Select supplier": "Selectează furnizorul",
  "Enter quantity received": "Introdu cantitatea recepționată",
  "Supplier Batch Code": "Cod lot furnizor",
  "Enter supplier batch code": "Introdu codul lotului furnizorului",
  "Production Date": "Data producției",
  "Enter quality notes...": "Introdu notele de calitate...",
  "Failed to delete cycle count": "Inventarul ciclic nu a putut fi șters",
  "Registration number is required": "Numărul de înmatriculare este obligatoriu",
  "Make is required": "Marca este obligatorie",
  "Model is required": "Modelul este obligatoriu",
  "Year must be between 1900 and {max}": "Anul trebuie să fie între 1900 și {max}",
  "Weight capacity cannot be negative": "Capacitatea de greutate nu poate fi negativă",
  "Volume capacity cannot be negative": "Capacitatea de volum nu poate fi negativă",
  "Fuel type is required": "Tipul de combustibil este obligatoriu",
  "Full-tank capacity must be between 10 and 200 litres": "Capacitatea rezervorului plin trebuie să fie între 10 și 200 de litri",
  "Please fix the highlighted fields.": "Corectează câmpurile evidențiate.",
  "Failed to save vehicle. Please try again.": "Vehiculul nu a putut fi salvat. Încearcă din nou.",
  "Edit Vehicle": "Editează vehiculul",
  "Duplicate from {registration}": "Duplicat din {registration}",
  "Add New Vehicle": "Adaugă vehicul nou",
  "Registration Number": "Număr de înmatriculare",
  "Vehicle Type": "Tip vehicul",
  "Fuel Type": "Tip combustibil",
  "Full Tank (litres)": "Rezervor plin (litri)",
  "Litres when tank is at 100%. MPG is calculated from this.": "Litri când rezervorul este la 100%. MPG se calculează pe baza acestei valori.",
  "Weight Capacity (kg)": "Capacitate de greutate (kg)",
  "Volume Capacity (m³)": "Capacitate de volum (m³)",
  "Insurance Expiry Date": "Data expirării asigurării",
  "MOT Expiry Date": "Data expirării MOT",
  "Tax Expiry Date": "Data expirării taxei auto",
  "Last Service Date": "Data ultimei revizii",
  "Vehicle is active and available for routes": "Vehiculul este activ și disponibil pentru rute",
  "Update Vehicle": "Actualizează vehiculul",
  "Add Vehicle": "Adaugă vehicul",
  "Failed to load dashboard data": "Datele tabloului de bord nu au putut fi încărcate",
  "Cost Variance Alerts": "Alerte de variație a costului",
  "No cost alerts": "Nicio alertă de cost",
  "All products have stable costs": "Toate produsele au costuri stabile",
  "Source: {source}": "Sursă: {source}",
  "Document: {number}": "Document: {number}",
  "Date: {date}": "Data: {date}",
  "About Cost Alerts": "Despre alertele de cost",
  "Alerts are shown for products with cost changes greater than 10% compared to their previous cost.": "Alertele sunt afișate pentru produsele cu modificări de cost mai mari de 10% față de costul anterior.",
  "Monitor these alerts to identify significant cost fluctuations that may impact pricing decisions.": "Urmărește aceste alerte pentru a identifica fluctuațiile semnificative de cost care pot influența deciziile de preț.",
  "Delete {count} selected cost-price record(s)? This cannot be undone.": "Ștergi înregistrările de preț de cost selectate ({count})? Acțiunea nu poate fi anulată.",
  "Deleted {count} cost-price record(s)": "Înregistrări de preț de cost șterse: {count}",
  "Failed to delete selected records": "Înregistrările selectate nu au putut fi șterse",
  "Delete all cost-price records with £0.00 or empty amounts? This cannot be undone.": "Ștergi toate înregistrările de preț de cost cu valoarea £0.00 sau goală? Acțiunea nu poate fi anulată.",
  "Deleted {count} zero-price records": { one: "S-a șters {count} înregistrare cu preț zero", few: "S-au șters {count} înregistrări cu preț zero", other: "S-au șters {count} de înregistrări cu preț zero" },
  "Failed to delete zero-price records": "Înregistrările cu preț zero nu au putut fi șterse",
  "Document": "Document",
  "Hide Breakdown": "Ascunde defalcarea",
  "Show Breakdown": "Arată defalcarea",
  "Labor Cost": "Cost manoperă",
  "Overhead Cost": "Cost regie",
  "Operation: {operation}": "Operație: {operation}",
  "Duration: {hours} hours": "Durată (ore): {hours}",
  "Quantity: {quantity} units": "Cantitate (unități): {quantity}",
  "Search by product name, SKU, or document...": "Caută după numele produsului, SKU sau document...",
  "WIP Operations": "Operații WIP",
  "Delete the selected cost-price records": "Șterge înregistrările de preț de cost selectate",
  "Remove all £0.00 cost-price records": "Elimină toate înregistrările de preț de cost de £0.00",
  "Remove 0 prices": "Elimină prețurile 0",
  "No cost price records found": "Nu s-au găsit înregistrări de preț de cost",
  "Please fix the errors in the form": "Corectează erorile din formular",
  "Price type updated successfully": "Tipul de preț a fost actualizat cu succes",
  "Price type created successfully": "Tipul de preț a fost creat cu succes",
  "Failed to save price type": "Tipul de preț nu a putut fi salvat",
  "Edit Price Type": "Editează tipul de preț",
  "Add Price Type": "Adaugă tip de preț",
  "e.g., Retail Price": "ex.: Preț cu amănuntul",
  "e.g., RETAIL": "ex.: RETAIL",
  "Optional description...": "Descriere opțională...",
  "e.g., COST * 1.5": "ex.: COST * 1.5",
  "Supported: COST*1.5, RETAIL*0.85, MAX(COST, RETAIL*0.8), ROUND(), +, -, *, /": "Acceptate: COST*1.5, RETAIL*0.85, MAX(COST, RETAIL*0.8), ROUND(), +, -, *, /",
  "Mode History": "Istoric mod",
  "{mode} formula changed": "Formula {mode} a fost modificată",
  "Prices dated before a switch to Dynamic keep using the manual price documents from that time.": "Prețurile datate înainte de trecerea la Dinamic folosesc în continuare documentele de prețuri manuale din acea perioadă.",
  "VAT Inclusive:": "Cu TVA inclus:",
  "Check this if prices for this price type already include VAT.": "Bifează dacă prețurile pentru acest tip de preț includ deja TVA.",
  "Use Product Base Price:": "Folosește prețul de bază al produsului:",
  "Check this to use the product's default price field directly (for 1C imported prices). Only one price type can use this. Automatically sets calculation mode to IMPORT.": "Bifează pentru a folosi direct câmpul de preț implicit al produsului (pentru prețurile importate din 1C). Doar un singur tip de preț poate folosi această opțiune. Setează automat modul de calcul la IMPORT.",
  "Auto-record from Purchase Invoices": "Înregistrare automată din facturile de achiziție",
  "Automatically create cost records when purchase invoices are approved": "Creează automat înregistrări de cost când facturile de achiziție sunt aprobate",
  "Record production costs at release": "Înregistrează costurile de producție la lansare",
  "Proposes cost prices for produced items (finished + semis) on the Production Release for operator confirmation. Costs are rolled up from consumed purchase-batch costs — WIP operations do not set prices.": "Propune prețuri de cost pentru articolele produse (finite + semifabricate) în lansarea în producție, pentru confirmarea operatorului. Costurile se calculează cumulat din costurile loturilor de achiziție consumate — operațiile WIP nu stabilesc prețuri.",
  "Purchase-invoice cost records are created automatically with ACTIVE status.": "Înregistrările de cost din facturile de achiziție sunt create automat cu starea ACTIVE.",
  "Production cost prices are proposed at the Production Release and written only when the operator confirms each produced item.": "Prețurile de cost de producție sunt propuse în lansarea în producție și scrise doar când operatorul confirmă fiecare articol produs.",
  "Only one price type can be marked as cost price.": "Doar un singur tip de preț poate fi marcat ca preț de cost.",
  "Only one price type can be marked as default.": "Doar un singur tip de preț poate fi marcat ca implicit.",
  "Category Filtering": "Filtrare pe categorii",
  "Applies to All Categories": "Se aplică tuturor categoriilor",
  "Restricted Categories": "Categorii restricționate",
  "Hold Ctrl/Cmd to select multiple categories": "Ține apăsat Ctrl/Cmd pentru a selecta mai multe categorii",
  "Auto-Documentation": "Documentare automată",
  "Auto Create Documents": "Creează automat documente",
  "Automatically create snapshot documents of calculated prices for audit trail": "Creează automat documente instantaneu ale prețurilor calculate, pentru pista de audit",
  "Document Frequency": "Frecvența documentelor",
  "On Change": "La modificare",
  "Min Change % (0 = any change)": "Modificare minimă % (0 = orice modificare)",
  "Min Change £ (0 = any change)": "Modificare minimă £ (0 = orice modificare)",
  "Day of Week": "Ziua săptămânii",
  "Monday": "Luni",
  "Tuesday": "Marți",
  "Wednesday": "Miercuri",
  "Thursday": "Joi",
  "Friday": "Vineri",
  "Saturday": "Sâmbătă",
  "Sunday": "Duminică",
  "Day of Month": "Ziua lunii",
  "Enter a day from 1 to 31. If month has fewer days, last day will be used.": "Introdu o zi de la 1 la 31. Dacă luna are mai puține zile, se va folosi ultima zi.",
  "Failed to load price type details": "Detaliile tipului de preț nu au putut fi încărcate",
  "Are you sure you want to delete this price type?": "Sigur vrei să ștergi acest tip de preț?",
  "Price type deleted successfully": "Tipul de preț a fost șters cu succes",
  "Failed to delete price type": "Tipul de preț nu a putut fi șters",
  "Create a price document with all current prices for \"{name}\"?": "Creezi un document de prețuri cu toate prețurile curente pentru „{name}”?",
  "Price document {number} created and activated": "Documentul de prețuri {number} a fost creat și activat",
  "Failed to create price document": "Documentul de prețuri nu a putut fi creat",
  "Name & Code": "Nume și cod",
  "Create Price Document": "Creează document de prețuri",
  "Search by name or code...": "Caută după nume sau cod...",
  "All Modes": "Toate modurile",
  "Dynamic": "Dinamic",
  "No price types found": "Nu s-au găsit tipuri de preț",
  "Price document activated successfully": "Documentul de prețuri a fost activat cu succes",
  "Failed to activate document": "Documentul nu a putut fi activat",
  "Price document deleted successfully": "Documentul de prețuri a fost șters cu succes",
  "Failed to delete document": "Documentul nu a putut fi șters",
  "Document duplicated as {number}": "Documentul a fost duplicat ca {number}",
  "Failed to duplicate document": "Documentul nu a putut fi duplicat",
  "Document converted to draft successfully": "Documentul a fost readus la ciornă cu succes",
  "Failed to convert document": "Documentul nu a putut fi convertit",
  "Click to revert to Draft": "Apasă pentru a readuce la Ciornă",
  "Document #": "Nr. document",
  "Duplicate as draft": "Duplică ca ciornă",
  "Activate": "Activează",
  "Search document number...": "Caută numărul documentului...",
  "All Price Types": "Toate tipurile de preț",
  "New Document": "Document nou",
  "No price documents found": "Nu s-au găsit documente de prețuri",
  "Create your first price document to get started": "Creează primul document de prețuri pentru a începe",
  "Save these changes?": "Salvezi aceste modificări?",
  "Moving this stocktake to another warehouse rebuilds every sheet from scratch. Nothing counted so far survives.": "Mutarea acestui inventar în alt depozit reconstruiește fiecare fișă de la zero. Nu se păstrează nimic din ce s-a numărat până acum.",
  "{count} areas will be deleted": { one: "{count} zonă va fi ștearsă", few: "{count} zone vor fi șterse", other: "{count} de zone vor fi șterse" },
  "{counted}/{total} counted · {entries} entries": "{counted}/{total} numărate · intrări: {entries}",
  "{entries} counted observations across {lines} lines will be permanently deleted. This cannot be undone.": "Observații numărate: {entries} · linii: {lines} — vor fi șterse definitiv. Acțiunea nu poate fi anulată.",
  "{count} areas will be added": { one: "{count} zonă va fi adăugată", few: "{count} zone vor fi adăugate", other: "{count} de zone vor fi adăugate" },
  "Nothing counted so far is affected — the sheets already open keep every entry.": "Nimic din ce s-a numărat până acum nu este afectat — fișele deja deschise își păstrează toate intrările.",
  "No sheet changes. Only the settings on this stocktake change.": "Fișele nu se modifică. Se schimbă doar setările acestui inventar.",
  "Cannot save": "Nu se poate salva",
  "Delete and save": "Șterge și salvează",
  "No zone": "Fără zonă",
  "Consume from": "Consumă din",
  "Where the materials are consumed from — batch pickers only offer stock held there": "De unde se consumă materiile prime — selectoarele de lot oferă doar stocul aflat acolo",
  "Any zone": "Orice zonă",
  "All of": "Toată zona",
  "Load into": "Încarcă în",
  "Finish time": "Ora de finalizare",
  "Optional: record the real finish time for this run (defaults to now)": "Opțional: înregistrează ora reală de finalizare pentru această rulare (implicit acum)",
  "running": "în lucru",
  "Revert this operation? Its {produced} produced so far will be removed, along with the batches and stock movements that recorded it.": "Anulezi această operație? Cele {produced} produse până acum vor fi eliminate, împreună cu loturile și mișcările de stoc care le-au înregistrat.",
  "Double click to revert the WIP completion — the last operation reopens": "Dublu clic pentru a anula finalizarea WIP — ultima operație se redeschide",
  "Double click to reopen the line — the close is withdrawn, every run stays": "Dublu clic pentru a redeschide linia — închiderea este retrasă, toate rulările rămân",
  "Double click to reopen — the close is withdrawn, every run stays": "Dublu clic pentru a redeschide — închiderea este retrasă, toate rulările rămân",
  "Double click to revert the latest finish": "Dublu clic pentru a anula ultima finalizare",
  "Click to revert to previous status (last member first)": "Apasă pentru a readuce la starea anterioară (începând cu ultimul membru)",
  "Double click to revert to previous status": "Dublu clic pentru a readuce la starea anterioară",
  "Production operations": "Operații de producție",
  "Start this operation": "Pornește această operație",
  "Fill in every output quantity before finishing": "Completează fiecare cantitate rezultată înainte de finalizare",
  "Finish this operation": "Finalizează această operație",
  "Start every operation on this line": "Pornește toate operațiile de pe această linie",
  "Finish this production line": "Finalizează această linie de producție",
  "Correct Run {number}": "Corectează rularea {number}",
  "Correct Run": "Corectează rularea",
  "Remove finished Run {number}": "Elimină rularea finalizată {number}",
  "Remove Run": "Elimină rularea",
  "Cancel Run {number}": "Anulează rularea {number}",
  "Cancel Run": "Anulează rularea",
  "Runs": "Rulări",
  "Remove this trolley": "Elimină acest cărucior",
  "Run {n}": "Rularea {n}",
  "Start this run — takes the next free machine": "Pornește această rulare — ia următoarea mașină liberă",
  "Finish this run": "Finalizează această rulare",
  "Open this run first — Finish records the quantities of the run on screen": "Deschide mai întâi această rulare — Finalizează înregistrează cantitățile rulării afișate pe ecran",
  "op": "op.",
  "since": "de la",
  "{output} {unit} out of {input} {unit} in. Standard for this step is {std}%": "{output} {unit} ieșite din {input} {unit} intrate. Standardul pentru această etapă este {std}%",
  "std": "std",
  "from batches": "din loturile",
  "from batch": "din lotul",
  "every kilo is in a run — close the operation when the runs are done": "fiecare kilogram este într-o rulare — închide operația când rulările sunt gata",
  "Branch WIPs": "WIP-uri ramură",
  "Input from trunk": "Intrare din trunchi",
  "Trunk": "Trunchi",
  "In this cimber": "În acest cimber",
  "Nothing assigned yet": "Nimic alocat încă",
  "Take this material out of the cimber": "Scoate această materie primă din cimber",
  "of": "din",
  "Give this material the rest of the weighing": "Atribuie acestei materii prime restul cântăririi",
  "all assigned": "totul alocat",
  "{left} kg unassigned": "{left} kg nealocate",
  "{over} kg over": "{over} kg în plus",
  "Not started — {pending} {unit} is still being produced by an earlier operation. Press Start once it arrives.": "Neînceput — {pending} {unit} sunt încă în producție la o operație anterioară. Apasă Pornește când ajung.",
  "Not started — press Start on the run to record materials and output.": "Neînceput — apasă Pornește pe rulare pentru a înregistra materiile prime și producția.",
  "This operation is closed. Revert the run to change what it recorded.": "Această operație este închisă. Anulează rularea pentru a schimba ce a înregistrat.",
  "Run {number}": "Rularea {number}",
  "No run open": "Nicio rulare deschisă",
  "open": "deschisă",
  "queued": "în așteptare",
  "recorded": "înregistrată",
  "Operator": "Operator",
  "Tap a quantity to open the keypad": "Atinge o cantitate pentru a deschide tastatura",
  "Materials & batches": "Materii prime și loturi",
  "Selected Run inputs": "Intrările rulării selectate",
  "Output quantities & weighing": "Cantități rezultate și cântărire",
  "Output quantities": "Cantități rezultate",
  "Quality, notes & traceability": "Calitate, note și trasabilitate",
  "Created batches and production history": "Loturi create și istoric de producție",
  "Back to WIP list": "Înapoi la lista WIP",
  "Reload this WIP from the server": "Reîncarcă acest WIP de pe server",
  "Reload": "Reîncarcă",
  "Revert this WIP from {status} to the previous status?": "Readuci acest WIP din {status} la starea anterioară?",
  "WIP progress": "Progres WIP",
  "operations complete": "operații finalizate",
  "Trunk WIP": "WIP trunchi",
  "Branch WIP": "WIP ramură",
  "operation": "operația",
  "Expected output": "Producție așteptată",
  "at {pct}% yield": "la randament de {pct}%",
  "Runs claim {over} {unit} more than this operation received — check the intake weight or an earlier run’s quantity.": "Rulările declară cu {over} {unit} mai mult decât a primit această operație — verifică greutatea la intrare sau cantitatea unei rulări anterioare.",
  "Upstream: {finished} {unit} finished, {pending} {unit} still in production.": "Etapa anterioară: {finished} {unit} finalizate, {pending} {unit} încă în producție.",
  "Scanner ready": "Scaner pregătit",
  "Scan a batch to assign it to the selected Run.": "Scanează un lot pentru a-l aloca rulării selectate.",
  "Product Release readiness": "Pregătire pentru lansarea în producție",
  "Production complete — review the Product Release.": "Producție finalizată — verifică lansarea în producție.",
  "Complete all required operations and Run records before release.": "Finalizează toate operațiile obligatorii și înregistrările rulărilor înainte de lansare.",
  "Selected Run quantity": "Cantitatea rulării selectate",
  "Close quantity keypad": "Închide tastatura de cantitate",
  "Quantity or calculation": "Cantitate sau calcul",
  "Choose batch": "Alege lotul",
  "Quantity keypad": "Tastatură de cantitate",
  "Backspace": "Șterge",
  "Apply quantity": "Aplică cantitatea",
  "Could not load this sign-in request.": "Această cerere de autentificare nu a putut fi încărcată.",
  "Something went wrong. Start again from your AI app.": "Ceva nu a funcționat. Începe din nou din aplicația AI.",
  "Connect an AI app": "Conectează o aplicație AI",
  "This link is missing its sign-in request.": "Acestui link îi lipsește cererea de autentificare.",
  "{client} wants to use AvaCore at {system} as {username}.": "{client} vrea să folosească AvaCore la {system} ca {username}.",
  "It will be able to:": "Va putea să:",
  "(optional — you still confirm every draft in AvaCore)": "(opțional — tot tu confirmi fiecare ciornă în AvaCore)",
  "After you approve, you will be sent back to": "După ce aprobi, vei fi trimis înapoi la",
  "App identity published at {url}": "Identitatea aplicației este publicată la {url}",
  "This app runs on your own computer. Only approve if you started this connection yourself just now.": "Această aplicație rulează pe propriul tău calculator. Aprobă doar dacă tu ai inițiat această conexiune chiar acum.",
  "This sign-in request has expired. Start again from your AI app.": "Această cerere de autentificare a expirat. Începe din nou din aplicația AI.",
  "The AI connector is turned off on this system.": "Conectorul AI este dezactivat pe acest sistem.",
  "Your role is not allowed to use the AI connector. Ask your administrator.": "Rolul tău nu are permisiunea de a folosi conectorul AI. Contactează administratorul.",
  "Answers the AI app receives from AvaCore are kept in that app's chat history. You can disconnect it any time under My Account → AI connections.": "Răspunsurile primite de aplicația AI de la AvaCore sunt păstrate în istoricul conversațiilor acelei aplicații. O poți deconecta oricând din Contul meu → Conexiuni AI.",
  "Deny": "Refuză",
  "Zone code and name are required": "Codul și numele zonei sunt obligatorii",
  "Zone updated successfully": "Zona a fost actualizată cu succes",
  "Loading zone details...": "Se încarcă detaliile zonei...",
  "Error": "Eroare",
  "Back to Zones": "Înapoi la zone",
  "Zone Code:": "Cod zonă:",
  "Edit Zone": "Editează zona",
  "Zone Information": "Informații zonă",
  "Zone Type": "Tip zonă",
  "Typical Volume": "Volum tipic",
  "Congestion Factor": "Factor de aglomerare",
  "Service Time Modifier": "Modificator timp de servire",
  "Delivery Hours": "Ore de livrare",
  "Postcode Coverage": "Acoperire coduri poștale",
  "Geographic Center": "Centru geografic",
  "Used for distance calculations and route optimization": "Folosit pentru calculul distanțelor și optimizarea rutelor",
  "Zone Statistics": "Statistici zonă",
  "Neighbors": "Vecini",
  "Postcodes": "Coduri poștale",
  "Avg Distance": "Distanță medie",
  "Assigned Locations": "Locații alocate",
  "View All Locations": "Vezi toate locațiile",
  "No locations assigned": "Nicio locație alocată",
  "No locations are currently assigned to this zone.": "În prezent nu este alocată nicio locație acestei zone.",
  "Neighboring Zones": "Zone vecine",
  "Manage All Relationships": "Gestionează toate relațiile",
  "Standard": "Standard",
  "Distance:": "Distanță:",
  "Travel Time:": "Timp de deplasare:",
  "View Zone": "Vezi zona",
  "No neighboring zones": "Nicio zonă vecină",
  "No neighboring relationships have been defined for this zone.": "Nu au fost definite relații de vecinătate pentru această zonă.",
  "Zone Performance Metrics": "Indicatori de performanță ai zonei",
  "Active Locations": "Locații active",
  "Connected Zones": "Zone conectate",
  "Service Hours": "Ore de servire",
  "No performance data available": "Nu există date de performanță",
  "Performance metrics will be available once deliveries are made in this zone.": "Indicatorii de performanță vor fi disponibili după ce se fac livrări în această zonă.",
  "Edit Delivery Zone": "Editează zona de livrare",
  "Zone Code": "Cod zonă",
  "e.g., LONDON_C, MANCHESTER": "ex.: LONDON_C, MANCHESTER",
  "Zone Name": "Nume zonă",
  "e.g., Central London, Greater Manchester": "ex.: Central London, Greater Manchester",
  "Select Region": "Selectează regiunea",
  "Center Latitude": "Latitudine centru",
  "Center Longitude": "Longitudine centru",
  "Postcode Prefixes": "Prefixe de cod poștal",
  "WC, EC, W1, SW1": "WC, EC, W1, SW1",
  "Comma-separated list of postcode prefixes for this zone": "Listă de prefixe de cod poștal pentru această zonă, separate prin virgulă",
  "Priority (1-10)": "Prioritate (1-10)",
  "Delivery Start Time": "Ora de început a livrărilor",
  "Delivery End Time": "Ora de sfârșit a livrărilor",
  "Zone is active": "Zona este activă",
  "Update Zone": "Actualizează zona",
  "Zone created successfully": "Zona a fost creată cu succes",
  "Are you sure you want to delete zone \"{name}\"? This action cannot be undone.": "Sigur vrei să ștergi zona „{name}”? Această acțiune nu poate fi anulată.",
  "Zone deleted successfully": "Zona a fost ștearsă cu succes",
  "Failed to delete zone": "Zona nu a putut fi ștearsă",
  "Loading delivery zones...": "Se încarcă zonele de livrare...",
  "Volume": "Volum",
  "Center": "Centru",
  "Delete Zone": "Șterge zona",
  "Manage UK delivery zones and geographic coverage": "Gestionează zonele de livrare din Regatul Unit și acoperirea geografică",
  "Add Zone": "Adaugă zonă",
  "Search Zones": "Caută zone",
  "Search by name, code...": "Caută după nume, cod...",
  "Region": "Regiune",
  "All Regions": "Toate regiunile",
  "Urban": "Urban",
  "Suburban": "Suburban",
  "Rural": "Rural",
  "Apply Filters": "Aplică filtrele",
  "No zones found": "Nu s-au găsit zone",
  "Get started by adding your first delivery zone.": "Începe prin a adăuga prima zonă de livrare.",
  "Create New Delivery Zone": "Creează o zonă de livrare nouă",
  "Create Zone": "Creează zona",
  "Select a global badge first": "Selectează mai întâi un badge global",
  "{badge} applied to {count} product(s)": "{badge} aplicat pe produse: {count}",
  "{badge} removed from {count} product(s)": "{badge} eliminat de pe produse: {count}",
  "Product already has a fixed price": "Produsul are deja un preț fix",
  "Discount name is required": "Numele reducerii este obligatoriu",
  "Discount code is required": "Codul reducerii este obligatoriu",
  "At least one product with a fixed price is required for multi-price mode": "Pentru modul multi-preț este necesar cel puțin un produs cu preț fix",
  "All product fixed prices must have a valid product and price": "Toate prețurile fixe trebuie să aibă un produs și un preț valid",
  "Source price type is required": "Tipul de preț sursă este obligatoriu",
  "Discount value must be greater than 0": "Valoarea reducerii trebuie să fie mai mare decât 0",
  "Percentage discount cannot exceed 100%": "Reducerea procentuală nu poate depăși 100%",
  "Discount created successfully": "Reducerea a fost creată cu succes",
  "Discount updated successfully": "Reducerea a fost actualizată cu succes",
  "Failed to save discount": "Reducerea nu a putut fi salvată",
  "(Optional)": "(Opțional)",
  "New Discount": "Reducere nouă",
  "Edit Discount": "Editează reducerea",
  "e.g., Bulk Purchase Discount": "ex.: Reducere la cumpărare în volum",
  "e.g., BULK10": "ex.: BULK10",
  "Describe the discount...": "Descrie reducerea...",
  "Select price type...": "Selectează tipul de preț...",
  "5 or -10": "5 sau -10",
  "Expire in: only apply to items with a picked batch expiring within N days": "Expiră în: se aplică doar articolelor cu un lot cules care expiră în cel mult N zile",
  "Days to expiry": "Zile până la expirare",
  "Enable Multi-Price Mode": "Activează modul multi-preț",
  "Set different fixed prices for each product instead of a single value": "Setează prețuri fixe diferite pentru fiecare produs în locul unei singure valori",
  "{count} product(s) - See right panel →": "Produse: {count} - vezi panoul din dreapta →",
  "Active Days": "Zile active",
  "(Leave empty for all days)": "(Lasă gol pentru toate zilele)",
  "Product Prices": "Prețuri produse",
  "Add product...": "Adaugă produs...",
  "No products added yet": "Niciun produs adăugat încă",
  "Discount Rules": "Reguli de reducere",
  "Define conditions that must be met for the discount to apply": "Definește condițiile care trebuie îndeplinite pentru ca reducerea să se aplice",
  "Add Rule": "Adaugă regulă",
  "Rule Logic": "Logica regulilor",
  "All rules must pass (per product)": "Toate regulile trebuie îndeplinite (pe produs)",
  "Any rule must pass": "Oricare regulă trebuie îndeplinită",
  "Combine rules (sum cart quantities)": "Combină regulile (însumează cantitățile din coș)",
  "Each product must meet ALL conditions individually.": "Fiecare produs trebuie să îndeplinească TOATE condițiile individual.",
  "Any single rule passing triggers the discount.": "Îndeplinirea oricărei reguli declanșează reducerea.",
  "Quantities are summed across all matching products in cart. E.g., 2×A + 1×B = 3 total for MIN_QUANTITY check.": "Cantitățile se însumează pentru toate produsele corespunzătoare din coș. Ex.: 2×A + 1×B = 3 în total pentru verificarea MIN_QUANTITY.",
  "Evaluation Mode": "Mod de evaluare",
  "Per Item": "Pe articol",
  "All or Nothing": "Tot sau nimic",
  "Each item evaluated individually": "Fiecare articol este evaluat individual",
  "All items must qualify": "Toate articolele trebuie să se califice",
  "Items that meet the rules get the discount, others don't. E.g., Item A (qty=3) gets discount, Item B (qty=2) doesn't.": "Articolele care îndeplinesc regulile primesc reducerea, celelalte nu. Ex.: articolul A (cant.=3) primește reducerea, articolul B (cant.=2) nu.",
  "ALL items must meet the rules for ANY to get the discount. If one item fails, no items get the discount.": "TOATE articolele trebuie să îndeplinească regulile pentru ca ORICARE să primească reducerea. Dacă un articol nu le îndeplinește, niciun articol nu primește reducerea.",
  "No rules defined. The discount will apply without conditions.": "Nicio regulă definită. Reducerea se va aplica fără condiții.",
  "Rule {number}": "Regula {number}",
  "Rule Type": "Tip regulă",
  "Applies only to customer's first order": "Se aplică doar la prima comandă a clientului",
  "# of Products": "Nr. de produse",
  "Amount (£)": "Sumă (£)",
  "e.g., 5": "ex.: 5",
  "e.g., 3": "ex.: 3",
  "Max Value": "Valoare maximă",
  "Quantity Tiers": "Praguri de cantitate",
  "Define different discount levels based on quantity purchased": "Definește niveluri diferite de reducere în funcție de cantitatea cumpărată",
  "Add Tier": "Adaugă prag",
  "No quantity tiers defined. The base discount value will be used for all quantities.": "Niciun prag de cantitate definit. Valoarea de bază a reducerii se va folosi pentru toate cantitățile.",
  "Tier {number}": "Pragul {number}",
  "Min Quantity *": "Cantitate minimă *",
  "Max Quantity": "Cantitate maximă",
  "Leave empty for unlimited": "Lasă gol pentru nelimitat",
  "Discount Type": "Tip reducere",
  "Discount Value *": "Valoare reducere *",
  "Product Targeting Disabled": "Țintirea produselor este dezactivată",
  "Multi-Price Mode is enabled. Products are defined in the Product Prices panel on the Basic Info tab.": "Modul multi-preț este activ. Produsele sunt definite în panoul Prețuri produse din tabul Informații de bază.",
  "Product Targeting": "Țintire produse",
  "Apply to all products": "Aplică la toate produsele",
  "Search products by name or SKU...": "Caută produse după nume sau SKU...",
  "Search categories...": "Caută categorii...",
  "No categories available": "Nu există categorii disponibile",
  "Product Groups": "Grupe de produse",
  "Search product groups...": "Caută grupe de produse...",
  "No product groups available": "Nu există grupe de produse disponibile",
  "Customer Targeting": "Țintire clienți",
  "Apply to all customers": "Aplică la toți clienții",
  "Specific Customers": "Clienți specifici",
  "Search customers by name or code...": "Caută clienți după nume sau cod...",
  "Target Price": "Preț țintă",
  "Leave empty to apply to any price type. Select one or more to restrict this discount to lines priced under those price types.": "Lasă gol pentru a aplica la orice tip de preț. Selectează unul sau mai multe pentru a limita reducerea la liniile cu prețuri din acele tipuri de preț.",
  "No price types available": "Nu există tipuri de preț disponibile",
  "Badge Appearance": "Aspect badge",
  "Customize how this discount appears on product cards in the catalogue": "Personalizează modul în care apare această reducere pe cardurile de produs din catalog",
  "Show badge on products": "Arată badge pe produse",
  "When enabled, a badge will appear on product cards in the catalogue": "Când este activat, pe cardurile de produs din catalog va apărea un badge",
  "e.g., Get {price} or -{percent} off": "ex.: Ia la {price} sau cu -{percent} reducere",
  "Custom badge text. Use placeholders for dynamic values. Leave empty to auto-generate.": "Text personalizat pentru badge. Folosește substituenți pentru valori dinamice. Lasă gol pentru generare automată.",
  "e.g., Buy {min_qty}+ to get {percent} off": "ex.: Cumpără {min_qty}+ și primești {percent} reducere",
  "Custom description shown when clicking the badge. Use placeholders for dynamic values.": "Descriere personalizată afișată la apăsarea pe badge. Folosește substituenți pentru valori dinamice.",
  "Available Placeholders": "Substituenți disponibili",
  "n/a": "n/a",
  "min quantity": "cantitate minimă",
  "products required": "produse necesare",
  "{price_tag} is the new price, {amount_tag} is the saving: \"Only {price_tag}\" becomes \"Only £5.99\", \"Save {amount_tag}\" becomes \"Save £1.13\"": "{price_tag} este prețul nou, {amount_tag} este economia: „Doar {price_tag}” devine „Doar £5.99”, „Economisești {amount_tag}” devine „Economisești £1.13”",
  "Badge:": "Badge:",
  "Info:": "Info:",
  "Discount Name": "Nume reducere",
  "Quick Colour Presets": "Culori predefinite rapide",
  "Global Product Badge": "Badge global de produs",
  "Bulk-apply one of the catalogue badges to every product this discount targets, instead of tagging them one by one. It shows in the card corner and in the Badge filter like any other badge, and stays until you remove it. The price badge above is separate and unaffected.": "Aplică în masă unul dintre badge-urile din catalog pe toate produsele vizate de această reducere, în loc să le etichetezi unul câte unul. Apare în colțul cardului și în filtrul Badge ca orice alt badge și rămâne până îl elimini. Badge-ul de preț de mai sus este separat și nu este afectat.",
  "No badge": "Fără badge",
  "Working...": "Se lucrează...",
  "Apply to {count} product(s)": "Aplică pe produse: {count}",
  "Remove from them": "Elimină de pe ele",
  "Save the discount to remember the selection. Applying again after changing the targeted products tops up the new ones.": "Salvează reducerea pentru a reține selecția. Dacă aplici din nou după ce schimbi produsele vizate, se completează cele noi.",
  "Discount deactivated": "Reducerea a fost dezactivată",
  "Discount activated": "Reducerea a fost activată",
  "Failed to toggle discount status": "Starea reducerii nu a putut fi schimbată",
  "Please enter a new discount code": "Introdu un cod nou de reducere",
  "Discount duplicated successfully": "Reducerea a fost duplicată cu succes",
  "Failed to duplicate discount": "Reducerea nu a putut fi duplicată",
  "Discount deleted successfully": "Reducerea a fost ștearsă cu succes",
  "Failed to delete discount": "Reducerea nu a putut fi ștearsă",
  "Type / Value": "Tip / Valoare",
  "Invalid": "Invalid",
  "From: {date}": "De la: {date}",
  "To: {date}": "Până la: {date}",
  "Always valid": "Valabil oricând",
  "Rules / Tiers": "Reguli / Praguri",
  "Deactivate": "Dezactivează",
  "Manage product discounts, quantity tiers, and promotional pricing": "Gestionează reducerile de produse, pragurile de cantitate și prețurile promoționale",
  "No discounts found": "Nu s-au găsit reduceri",
  "Showing {from} to {to} of {total} discounts": "Se afișează {from}–{to} din {total} reduceri",
  "Duplicate Discount": "Duplică reducerea",
  "Enter a new code for the duplicated discount:": "Introdu un cod nou pentru reducerea duplicată:",
  "Delete Discount": "Șterge reducerea",
  "Are you sure you want to delete {name}? This action cannot be undone.": "Sigur vrei să ștergi {name}? Această acțiune nu poate fi anulată.",
  "Error updating event. Please check the form and try again.": "Eroare la actualizarea evenimentului. Verifică formularul și încearcă din nou.",
  "Are you sure you want to delete this event?": "Sigur vrei să ștergi acest eveniment?",
  "Error deleting event": "Eroare la ștergerea evenimentului",
  "Loading event details...": "Se încarcă detaliile evenimentului...",
  "Event not found": "Evenimentul nu a fost găsit",
  "← Back to Events": "← Înapoi la evenimente",
  "{type} Event": "Eveniment {type}",
  "Lead:": "Lead:",
  "Event Details": "Detalii eveniment",
  "Select Type": "Selectează tipul",
  "Date & Time": "Data și ora",
  "Select Outcome": "Selectează rezultatul",
  "Select Lead": "Selectează lead-ul",
  "Name of person contacted": "Numele persoanei contactate",
  "Order Value (£)": "Valoare comandă (£)",
  "Order Value": "Valoare comandă",
  "Add any relevant notes about this event...": "Adaugă orice note relevante despre acest eveniment...",
  "Quick Stats": "Statistici rapide",
  "Follow-up Status": "Stare revenire",
  "Related Lead": "Lead asociat",
  "View Lead Details →": "Vezi detaliile lead-ului →",
  "Related Customer": "Client asociat",
  "{count} {type}": "{count} {type}",
  "Follow-up Due": "Revenire scadentă",
  "Lead / Customer": "Lead / Client",
  "Contact": "Contact",
  "Follow-up": "Revenire",
  "Loading events...": "Se încarcă evenimentele...",
  "Search events...": "Caută evenimente...",
  "1 event": "1 eveniment",
  "{count} events": { one: "{count} eveniment", few: "{count} evenimente", other: "{count} de evenimente" },
  "Event Type": "Tip eveniment",
  "Outcome": "Rezultat",
  "All Outcomes": "Toate rezultatele",
  "All Leads": "Toate lead-urile",
  "No Events Found": "Nu s-au găsit evenimente",
  "No events match your current filters.": "Niciun eveniment nu corespunde filtrelor curente.",
  "Start logging your customer interactions to track sales activity.": "Începe să înregistrezi interacțiunile cu clienții pentru a urmări activitatea de vânzări.",
  "Log Your First Event": "Înregistrează primul eveniment",
  "Error sending onboarding invite": "Eroare la trimiterea invitației de înrolare",
  "Resend the onboarding invite? This invalidates the previous link.": "Retrimiți invitația de înrolare? Linkul anterior va deveni invalid.",
  "Error resending invite": "Eroare la retrimiterea invitației",
  "What changes are needed?": "Ce modificări sunt necesare?",
  "Error requesting changes": "Eroare la solicitarea modificărilor",
  "No application on file — the customer will be created directly from this lead\\u2019s details, with no signed form or documents.\n\nGenerate customer anyway?": "Nu există nicio cerere înregistrată — clientul va fi creat direct din datele acestui lead, fără formular semnat sau documente.\n\nGenerezi totuși clientul?",
  "Application not signed or submitted — no attested data or documents on file.\n\nGenerate customer anyway?": "Cererea nu a fost semnată sau trimisă — nu există date atestate sau documente înregistrate.\n\nGenerezi totuși clientul?",
  "Missing documents: {missing} ({present}/3 standard documents uploaded, {verified} verified).\n\nGenerate customer anyway?": "Documente lipsă: {missing} (documente standard încărcate: {present}/3, verificate: {verified}).\n\nGenerezi totuși clientul?",
  "Generate a customer account from this application?": "Generezi un cont de client din această cerere?",
  "Error generating customer": "Eroare la generarea clientului",
  "A customer with this name already exists. Enter a different customer name:": "Există deja un client cu acest nume. Introdu un alt nume de client:",
  "Application link copied": "Linkul cererii a fost copiat",
  "Copy the application link:": "Copiază linkul cererii:",
  "Failed to load customers": "Clienții nu au putut fi încărcați",
  "Link this lead to customer \"{name}\"? The lead will be marked won and become read-only.": "Legi acest lead de clientul „{name}”? Lead-ul va fi marcat ca câștigat și va deveni doar pentru citire.",
  "Lead linked to {name}": "Lead-ul a fost legat de {name}",
  "Failed to link to customer": "Legarea de client nu a reușit",
  "Error updating document": "Eroare la actualizarea documentului",
  "Error downloading document": "Eroare la descărcarea documentului",
  "Document uploaded": "Documentul a fost încărcat",
  "Error uploading document": "Eroare la încărcarea documentului",
  "Error updating lead": "Eroare la actualizarea lead-ului",
  "Are you sure you want to delete this lead? This action cannot be undone.": "Sigur vrei să ștergi acest lead? Această acțiune nu poate fi anulată.",
  "Error deleting lead": "Eroare la ștergerea lead-ului",
  "Error creating task": "Eroare la crearea sarcinii",
  "Loading lead details...": "Se încarcă detaliile lead-ului...",
  "Lead not found": "Lead-ul nu a fost găsit",
  "← Back to Leads": "← Înapoi la lead-uri",
  "Quick Task for {name}": "Sarcină rapidă pentru {name}",
  "Task Title *": "Titlu sarcină *",
  "Task Type": "Tip sarcină",
  "First Visit": "Prima vizită",
  "Follow-up Visit": "Vizită de revenire",
  "Meet Manager": "Întâlnire cu managerul",
  "Deliver Samples": "Livrează mostre",
  "Make Call": "Efectuează apel",
  "Due Date *": "Termen *",
  "Create Task": "Creează sarcină",
  "Credentials updated": "Datele de autentificare au fost actualizate",
  "Failed to update credentials": "Datele de autentificare nu au putut fi actualizate",
  "Customer Created": "Client creat",
  "An existing login for this email was found and has been kept — no new password was generated.": "A fost găsit un cont de autentificare existent pentru acest e-mail și a fost păstrat — nu s-a generat o parolă nouă.",
  "This password is shown only once — copy it now.": "Această parolă este afișată o singură dată — copiaz-o acum.",
  "Click to cycle capitalisation: UPPERCASE → lowercase → First letter capital": "Apasă pentru a schimba scrierea: MAJUSCULE → minuscule → Prima literă mare",
  "Copy username": "Copiază numele de utilizator",
  "Click to generate a new password": "Apasă pentru a genera o parolă nouă",
  "Temporary Password": "Parolă temporară",
  "Copy password": "Copiază parola",
  "Save New Credentials": "Salvează noile date de autentificare",
  "The customer was created without an online account.": "Clientul a fost creat fără cont online.",
  "View Customer": "Vezi clientul",
  "on {date}": "pe {date}",
  "Task": "Sarcină",
  "Rep": "Agent",
  "File": "Fișier",
  "✓ Verified": "✓ Verificat",
  "Mark Verified": "Marchează ca verificat",
  "Generate Customer": "Generează client",
  "Link to Existing Customer": "Leagă de un client existent",
  "Shop name": "Numele magazinului",
  "Quick Task": "Sarcină rapidă",
  "Linked to customer": "Legat de client",
  "this lead is a read-only archive; manage the relationship on the customer record.": "acest lead este o arhivă doar pentru citire; gestionează relația din fișa clientului.",
  "View Customer →": "Vezi clientul →",
  "Shop Information": "Informații magazin",
  "Not set — required for onboarding invite": "Nesetat — necesar pentru invitația de înrolare",
  "Total Tasks": "Total sarcini",
  "Total Visits": "Total vizite",
  "Decision Maker": "Factor de decizie",
  "Identified": "Identificat",
  "Not identified": "Neidentificat",
  "Quick Actions": "Acțiuni rapide",
  "Schedule Task": "Programează sarcină",
  "Log Visit": "Înregistrează vizită",
  "Tasks ({count})": "Sarcini ({count})",
  "New Task": "Sarcină nouă",
  "No tasks created for this lead yet": "Încă nu s-au creat sarcini pentru acest lead",
  "Create First Task": "Creează prima sarcină",
  "Visits ({count})": "Vizite ({count})",
  "No visits logged for this lead yet": "Încă nu s-au înregistrat vizite pentru acest lead",
  "Log First Visit": "Înregistrează prima vizită",
  "Contacts ({count})": "Contacte ({count})",
  "No contacts added for this lead yet": "Încă nu s-au adăugat contacte pentru acest lead",
  "Add First Contact": "Adaugă primul contact",
  "Edit Notes": "Editează notele",
  "No notes added for this lead yet": "Încă nu s-au adăugat note pentru acest lead",
  "Add Notes": "Adaugă note",
  "Loading application...": "Se încarcă cererea...",
  "Failed to load application": "Cererea nu a putut fi încărcată",
  "Retry": "Reîncearcă",
  "This lead was linked to an existing customer": "Acest lead a fost legat de un client existent",
  "No onboarding application was needed.": "Nu a fost necesară nicio cerere de înrolare.",
  "Become a customer": "Devino client",
  "Invite this lead to complete an online onboarding application (company details, documents, signature) and generate a new customer — or link the lead to a customer that already exists.": "Invită acest lead să completeze o cerere de înrolare online (datele companiei, documente, semnătură) și generează un client nou — sau leagă lead-ul de un client care există deja.",
  "Invite to Onboard": "Invită la înrolare",
  "This lead has no email address — add one before sending an invite.": "Acest lead nu are adresă de e-mail — adaug-o înainte de a trimite o invitație.",
  "This lead's application was approved and the lead is linked to {name}": "Cererea acestui lead a fost aprobată, iar lead-ul este legat de {name}",
  "This lead's application was approved and the lead is linked to a customer": "Cererea acestui lead a fost aprobată, iar lead-ul este legat de un client",
  "The application data and documents below are kept for your records.": "Datele cererii și documentele de mai jos sunt păstrate pentru evidența ta.",
  "Link expires {date}": "Linkul expiră pe {date}",
  "Submitted {date}": "Trimisă pe {date}",
  "Copy Link": "Copiază linkul",
  "Re-send Invite": "Retrimite invitația",
  "Request Changes": "Solicită modificări",
  "Requested changes:": "Modificări solicitate:",
  "Application Data": "Datele cererii",
  "No data submitted yet.": "Încă nu s-au trimis date.",
  "Signed By": "Semnat de",
  "Documents ({count})": "Documente ({count})",
  "Upload Document": "Încarcă document",
  "No documents uploaded yet.": "Încă nu s-au încărcat documente.",
  "No customers match this search.": "Niciun client nu corespunde acestei căutări.",
  "Are you sure you want to delete this lead?": "Sigur vrei să ștergi acest lead?",
  "Shop": "Magazin",
  "Potential": "Potențial",
  "{days} days old": "Vechime (zile): {days}",
  "Decision maker found": "Factor de decizie identificat",
  "Activity": "Activitate",
  "{count} tasks": { one: "{count} sarcină", few: "{count} sarcini", other: "{count} de sarcini" },
  "{count} visits": { one: "{count} vizită", few: "{count} vizite", other: "{count} de vizite" },
  "Edit Lead": "Editează lead-ul",
  "1 Star - Low": "1 stea - scăzut",
  "2 Stars": "2 stele",
  "3 Stars - Medium": "3 stele - mediu",
  "4 Stars": "4 stele",
  "5 Stars - High": "5 stele - ridicat",
  "e.g., North London": "ex.: North London",
  "Any additional information...": "Orice informații suplimentare...",
  "Update Lead": "Actualizează lead-ul",
  "Error creating lead": "Eroare la crearea lead-ului",
  "Add New Lead": "Adaugă lead nou",
  "Create Lead": "Creează lead",
  "{count} leads • Manage your grocery shop prospects": { one: "{count} lead • Gestionează magazinele alimentare potențiale", few: "{count} lead-uri • Gestionează magazinele alimentare potențiale", other: "{count} de lead-uri • Gestionează magazinele alimentare potențiale" },
  "Add Lead": "Adaugă lead",
  "Shop name, address...": "Numele magazinului, adresa...",
  "Shop Type": "Tip magazin",
  "All Ratings": "Toate evaluările",
  "5 Stars": "5 stele",
  "3 Stars": "3 stele",
  "1 Star": "1 stea",
  "Loading leads...": "Se încarcă lead-urile...",
  "No leads found": "Nu s-au găsit lead-uri",
  "No leads match your current filters.": "Niciun lead nu corespunde filtrelor curente.",
  "Get started by adding your first lead.": "Începe prin a adăuga primul lead.",
  "Add Your First Lead": "Adaugă primul lead",
  "Deleted {deleted} deliveries. {errors} errors occurred.": "Livrări șterse: {deleted}. Erori apărute: {errors}.",
  "Successfully synced {count} delivery addresses.": { one: "S-a sincronizat cu succes {count} adresă de livrare.", few: "S-au sincronizat cu succes {count} adrese de livrare.", other: "S-au sincronizat cu succes {count} de adrese de livrare." },
  "No draft routes available. Create a new route instead.": "Nu există rute ciornă disponibile. Creează în schimb o rută nouă.",
  "Failed to load routes. Please try again.": "Rutele nu au putut fi încărcate. Încearcă din nou.",
  "Successfully assigned {count} delivery to route #{route}": { one: "{count} livrare a fost alocată cu succes rutei #{route}", few: "{count} livrări au fost alocate cu succes rutei #{route}", other: "{count} de livrări au fost alocate cu succes rutei #{route}" },
  "Successfully assigned {count} deliveries to route #{route}": { one: "{count} livrare a fost alocată cu succes rutei #{route}", few: "{count} livrări au fost alocate cu succes rutei #{route}", other: "{count} de livrări au fost alocate cu succes rutei #{route}" },
  "Failed to add deliveries to route": "Livrările nu au putut fi adăugate la rută",
  "Failed to load drivers and vehicles. Please try again.": "Șoferii și vehiculele nu au putut fi încărcați. Încearcă din nou.",
  "Route #{route} created successfully": "Ruta #{route} a fost creată cu succes",
  "Assigned {count} delivery to route #{route}": { one: "{count} livrare a fost alocată rutei #{route}", few: "{count} livrări au fost alocate rutei #{route}", other: "{count} de livrări au fost alocate rutei #{route}" },
  "Assigned {count} deliveries to route #{route}": { one: "{count} livrare a fost alocată rutei #{route}", few: "{count} livrări au fost alocate rutei #{route}", other: "{count} de livrări au fost alocate rutei #{route}" },
  "Failed to create route": "Ruta nu a putut fi creată",
  "Successfully linked {count} deliveries to locations.": { one: "{count} livrare a fost legată cu succes de locație.", few: "{count} livrări au fost legate cu succes de locații.", other: "{count} de livrări au fost legate cu succes de locații." },
  "Address matches location": "Adresa corespunde locației",
  "Address differs from location": "Adresa diferă de cea a locației",
  "Mismatch": "Neconcordanță",
  "No location linked": "Nicio locație legată",
  "Delivery Management": "Gestionare livrări",
  "Loading deliveries...": "Se încarcă livrările...",
  "Coordinates: {lat}, {lng}": "Coordonate: {lat}, {lng}",
  "Has coordinates": "Are coordonate",
  "Missing coordinates": "Lipsesc coordonatele",
  "No address": "Fără adresă",
  "Route/Driver": "Rută/Șofer",
  "No driver": "Fără șofer",
  "Seq: {sequence}": "Secv.: {sequence}",
  "Address Status": "Stare adresă",
  "Order: #{order}": "Comandă: #{order}",
  "Address:": "Adresă:",
  "Route:": "Rută:",
  "Link deliveries to their customer locations": "Leagă livrările de locațiile clienților",
  "Link to Locations ({count})": "Leagă de locații ({count})",
  "Select all deliveries with address mismatches": "Selectează toate livrările cu adrese neconcordante",
  "Select Mismatched ({count})": "Selectează neconcordanțele ({count})",
  "Sync selected delivery addresses with their location addresses": "Sincronizează adresele livrărilor selectate cu adresele locațiilor lor",
  "Sync Addresses ({count})": "Sincronizează adresele ({count})",
  "Add or move selected deliveries to an existing draft route. You can also create a new route from this modal.": "Adaugă sau mută livrările selectate într-o rută ciornă existentă. Poți crea și o rută nouă din această fereastră.",
  "Add to Route ({count})": "Adaugă la rută ({count})",
  "Delete ({count})": "Șterge ({count})",
  "Customer name or address...": "Numele clientului sau adresa...",
  "Route {id}": "Ruta {id}",
  "No deliveries found matching \"{search}\".": "Nu s-au găsit livrări care să corespundă cu „{search}”.",
  "No deliveries found matching your criteria.": "Nu s-au găsit livrări care să corespundă criteriilor tale.",
  "Showing {start} to {end} of {total} deliveries": "Se afișează {start}–{end} din {total} livrări",
  "Changing date for {count} deliveries": { one: "Se schimbă data pentru {count} livrare", few: "Se schimbă data pentru {count} livrări", other: "Se schimbă data pentru {count} de livrări" },
  "Mark as Planned": "Marchează ca planificat",
  "This will change the status to \"Pending\" for {count} deliveries:": { one: "Starea va fi schimbată în „În așteptare” pentru {count} livrare:", few: "Starea va fi schimbată în „În așteptare” pentru {count} livrări:", other: "Starea va fi schimbată în „În așteptare” pentru {count} de livrări:" },
  "This will remove deliveries from their assigned routes and mark them as unassigned.": "Livrările vor fi scoase din rutele alocate și marcate ca nealocate.",
  "Delete Deliveries": "Șterge livrările",
  "Are you sure you want to delete {count} deliveries?": { one: "Sigur vrei să ștergi {count} livrare?", few: "Sigur vrei să ștergi {count} livrări?", other: "Sigur vrei să ștergi {count} de livrări?" },
  "This action cannot be undone. Only pending deliveries can be deleted.": "Această acțiune nu poate fi anulată. Pot fi șterse doar livrările în așteptare.",
  "Add to Existing Route": "Adaugă la o rută existentă",
  "Select a draft route to add {count} selected deliveries": { one: "Selectează o rută ciornă la care să adaugi {count} livrare selectată", few: "Selectează o rută ciornă la care să adaugi {count} livrări selectate", other: "Selectează o rută ciornă la care să adaugi {count} de livrări selectate" },
  "Loading routes...": "Se încarcă rutele...",
  "No draft routes available for this date.": "Nu există rute ciornă disponibile pentru această dată.",
  "Create New Route Instead": "Creează în schimb o rută nouă",
  "Route #{id}": "Ruta #{id}",
  "Route ID: #{id}": "ID rută: #{id}",
  "Driver:": "Șofer:",
  "Vehicle:": "Vehicul:",
  "Deliveries:": "Livrări:",
  "Create New Route": "Creează rută nouă",
  "Creating route with {count} selected deliveries": { one: "Se creează ruta cu {count} livrare selectată", few: "Se creează ruta cu {count} livrări selectate", other: "Se creează ruta cu {count} de livrări selectate" },
  "Creating empty route": "Se creează o rută goală",
  "Route Name (Optional)": "Nume rută (opțional)",
  "Planned Date": "Data planificată",
  "Failed to load available drivers for selected date": "Șoferii disponibili pentru data selectată nu au putut fi încărcați",
  "Driver (Optional)": "Șofer (opțional)",
  "Select Driver": "Selectează șoferul",
  "Driver #{id}": "Șofer #{id}",
  "No vehicle": "Fără vehicul",
  "No drivers found": "Nu s-au găsit șoferi",
  "{count} drivers available. Vehicle will be auto-assigned from selected driver.": { one: "{count} șofer disponibil. Vehiculul va fi alocat automat de la șoferul selectat.", few: "{count} șoferi disponibili. Vehiculul va fi alocat automat de la șoferul selectat.", other: "{count} de șoferi disponibili. Vehiculul va fi alocat automat de la șoferul selectat." },
  "Create empty route (don't add selected deliveries)": "Creează o rută goală (fără livrările selectate)",
  "Route will be created in 'draft' status and can be edited from the route detail page.": "Ruta va fi creată cu starea „ciornă” și poate fi editată din pagina de detalii a rutei.",
  "{count} deliveries will be added to this route.": { one: "{count} livrare va fi adăugată la această rută.", few: "{count} livrări vor fi adăugate la această rută.", other: "{count} de livrări vor fi adăugate la această rută." },
  "Create Route": "Creează ruta",
  "Are you sure you want to unassign this delivery from the route?": "Sigur vrei să scoți această livrare din rută?",
  "Enter failure reason (not_home, refused, wrong_address, damaged, payment_issue, other):": "Introdu motivul eșecului (not_home, refused, wrong_address, damaged, payment_issue, other):",
  "Additional notes (optional):": "Note suplimentare (opțional):",
  "Enter signatory name:": "Introdu numele semnatarului:",
  "Please enter a delivery address to geocode": "Introdu o adresă de livrare pentru geocodare",
  "Address geocoded successfully!": "Adresa a fost geocodată cu succes!",
  "Failed to geocode address: {error}": "Adresa nu a putut fi geocodată: {error}",
  "Back to Deliveries": "Înapoi la livrări",
  "Delivery not found": "Livrarea nu a fost găsită",
  "Create New Delivery": "Creează livrare nouă",
  "Delivery #{id} ({count} orders)": { one: "Livrarea #{id} ({count} comandă)", few: "Livrarea #{id} ({count} comenzi)", other: "Livrarea #{id} ({count} de comenzi)" },
  "Delivery for Order #{number}": "Livrare pentru comanda #{number}",
  "Hide Map": "Ascunde harta",
  "Show Map": "Arată harta",
  "Create Delivery": "Creează livrarea",
  "Edit Delivery": "Editează livrarea",
  "Mark In Transit": "Marchează în tranzit",
  "Mark Arriving": "Marchează în curs de sosire",
  "Mark Delivered": "Marchează ca livrat",
  "Mark Failed": "Marchează ca eșuat",
  "Delivery Filters": "Filtre livrări",
  "Close Filters": "Închide filtrele",
  "Delivery Status": "Stare livrare",
  "Arriving": "În curs de sosire",
  "Delivered": "Livrat",
  "Delivery Address:": "Adresă de livrare:",
  "Coordinates:": "Coordonate:",
  "(from customer)": "(de la client)",
  "No coordinates available": "Nu există coordonate",
  "Time Window": "Interval orar",
  "Any Time": "Oricând",
  "to": "până la",
  "Max Reached": "Maxim atins",
  "{count} Left": "Rămase: {count}",
  "No Attempts": "Nicio încercare",
  "Edit Delivery Information": "Editează informațiile livrării",
  "Delivery Information": "Informații livrare",
  "Select Order": "Selectează comanda",
  "Order #{id} - {customer}": "Comanda #{id} - {customer}",
  "Loading orders... If no orders appear, ensure there are orders available in the system.": "Se încarcă comenzile... Dacă nu apare nicio comandă, verifică dacă există comenzi disponibile în sistem.",
  "Will be assigned upon creation": "Va fi atribuit la creare",
  "Contact Phone": "Telefon de contact",
  "Not provided": "Nefurnizat",
  "Customer contact phone": "Telefonul de contact al clientului",
  "Enter delivery address": "Introdu adresa de livrare",
  "Geocode Address": "Geocodează adresa",
  "Not available": "Indisponibil",
  "Latitude": "Latitudine",
  "Longitude": "Longitudine",
  "Signature Required": "Semnătură necesară",
  "Leave at Door": "Lasă la ușă",
  "Delivery Notes": "Note de livrare",
  "No delivery notes": "Nicio notă de livrare",
  "Special instructions for the delivery": "Instrucțiuni speciale pentru livrare",
  "Route & Timeline": "Rută și cronologie",
  "Route Assignment": "Alocare rută",
  "Route information not available": "Informațiile despre rută nu sunt disponibile",
  "Driver: {driver}": "Șofer: {driver}",
  "Stop #{sequence} of {total}": "Oprirea #{sequence} din {total}",
  "Removing...": "Se elimină...",
  "Unassign": "Dezalocă",
  "Previous Stop": "Oprirea anterioară",
  "Start Location": "Locația de plecare",
  "Next Stop": "Oprirea următoare",
  "End Location": "Locația de sosire",
  "Not assigned to any route": "Nealocat niciunei rute",
  "Add to Route": "Adaugă la rută",
  "Delivery Timeline": "Cronologia livrării",
  "Delivery Created": "Livrare creată",
  "Assigned to Route": "Alocată pe rută",
  "Arriving Soon": "Sosește curând",
  "Delivery Failed": "Livrare eșuată",
  "Reason: {reason}": "Motiv: {reason}",
  "Pending Delivery": "Livrare în așteptare",
  "Delivery Proof": "Dovada livrării",
  "Add Signature": "Adaugă semnătură",
  "Add Photo": "Adaugă fotografie",
  "Signatory: {name}": "Semnatar: {name}",
  "Delivery proof": "Dovada livrării",
  "No proof of delivery added yet": "Încă nu s-a adăugat nicio dovadă de livrare",
  "Consolidated ({count} orders)": { one: "Consolidată ({count} comandă)", few: "Consolidată ({count} comenzi)", other: "Consolidată ({count} de comenzi)" },
  "Related Orders": "Comenzi asociate",
  "Order Information": "Informații comandă",
  "Order Date": "Data comenzii",
  "Order Status": "Stare comandă",
  "Total Quantities": "Cantități totale",
  "{quantity} Kg": "{quantity} kg",
  "Items Summary": "Rezumat articole",
  "{quantity} Kg {product}": "{quantity} kg {product}",
  "← Back to Drivers": "← Înapoi la șoferi",
  "Driver details updated.": "Detaliile șoferului au fost actualizate.",
  "Failed to save changes.": "Modificările nu au putut fi salvate.",
  "Deactivate {name}? Their mobile-app login will be disabled too.": "Dezactivezi pe {name}? Și autentificarea în aplicația mobilă va fi dezactivată.",
  "Reactivate {name}? Their mobile-app login will be re-enabled.": "Reactivezi pe {name}? Autentificarea în aplicația mobilă va fi reactivată.",
  "Failed to update driver status.": "Starea șoferului nu a putut fi actualizată.",
  "User account updated (password changed).": "Contul de utilizator a fost actualizat (parola a fost schimbată).",
  "User account updated.": "Contul de utilizator a fost actualizat.",
  "Failed to update user.": "Utilizatorul nu a putut fi actualizat.",
  "License": "Permis",
  "Vehicle": "Vehicul",
  "Never": "Niciodată",
  "Last location": "Ultima locație",
  "Displaced": "Înlocuit",
  "Vehicle Scans ({count})": "Scanări vehicul ({count})",
  "Loading scans…": "Se încarcă scanările…",
  "No vehicle scans recorded.": "Nu s-au înregistrat scanări de vehicul.",
  "Routes ({count})": "Rute ({count})",
  "Loading routes…": "Se încarcă rutele…",
  "No routes in this period.": "Nicio rută în această perioadă.",
  "Edit user account": "Editează contul de utilizator",
  "Reactivate": "Reactivează",
  "This driver is deactivated. Mobile-app login is disabled. They won't appear in driver pickers.": "Acest șofer este dezactivat. Autentificarea în aplicația mobilă este dezactivată. Nu va apărea în listele de selecție a șoferilor.",
  "Edit driver": "Editează șoferul",
  "New password (optional)": "Parolă nouă (opțional)",
  "Leave blank to keep current": "Lasă gol pentru a o păstra pe cea curentă",
  "Account is inactive": "Contul este inactiv",
  "No email": "Fără e-mail",
  "License:": "Permis:",
  "No vehicle assigned": "Niciun vehicul alocat",
  "Last seen:": "Văzut ultima dată:",
  "No location data": "Nu există date de locație",
  "Success:": "Succes:",
  "{count} deliveries ({rate}% success)": { one: "{count} livrare ({rate}% succes)", few: "{count} livrări ({rate}% succes)", other: "{count} de livrări ({rate}% succes)" },
  "On Break": "În pauză",
  "Driver Management": "Gestionare șoferi",
  "Total Drivers": "Total șoferi",
  "On Route": "Pe traseu",
  "All Drivers": "Toți șoferii",
  "Active Only": "Doar activi",
  "Inactive Only": "Doar inactivi",
  "Reset Filters": "Resetează filtrele",
  "Add Driver": "Adaugă șofer",
  "Available Drivers ({count})": "Șoferi disponibili ({count})",
  "On Route ({count})": "Pe traseu ({count})",
  "Other Drivers": "Alți șoferi",
  "Add New Driver": "Adaugă șofer nou",
  "Assign existing user": "Alocă un utilizator existent",
  "Select User": "Selectează utilizatorul",
  "Search users...": "Caută utilizatori...",
  "No users found matching your search": "Niciun utilizator nu corespunde căutării",
  "No available users": "Niciun utilizator disponibil",
  "Name Surname": "Nume Prenume",
  "License Number": "Număr permis de conducere",
  "Emergency Contact": "Contact de urgență",
  "Create Driver": "Creează șofer",
  "Location assigned to zone successfully": "Locația a fost alocată zonei cu succes",
  "Failed to assign zone": "Zona nu a putut fi alocată",
  "Location must have a postcode for automatic zone assignment": "Locația trebuie să aibă cod poștal pentru alocarea automată a zonei",
  "Location automatically assigned to {name}": "Locația a fost alocată automat la {name}",
  "No zone found for this postcode": "Nu s-a găsit nicio zonă pentru acest cod poștal",
  "Failed to auto-assign zone": "Zona nu a putut fi alocată automat",
  "Are you sure you want to remove the zone assignment from this location?": "Sigur vrei să elimini alocarea zonei de la această locație?",
  "Zone assignment removed successfully": "Alocarea zonei a fost eliminată cu succes",
  "Failed to remove zone": "Zona nu a putut fi eliminată",
  "Location activated successfully": "Locația a fost activată cu succes",
  "Location deactivated successfully": "Locația a fost dezactivată cu succes",
  "Failed to update location status": "Starea locației nu a putut fi actualizată",
  "Error Loading Location": "Eroare la încărcarea locației",
  "Back to Locations": "Înapoi la locații",
  "Select a warehouse...": "Selectează un depozit...",
  "Already has location": "Are deja locație",
  "Loading warehouses...": "Se încarcă depozitele...",
  "Manager": "Manager",
  "Address & Coordinates": "Adresă și coordonate",
  "Automatically assign zone based on postcode": "Alocă automat zona după codul poștal",
  "Assigning...": "Se alocă...",
  "Auto-Assign": "Alocare automată",
  "Change Zone": "Schimbă zona",
  "Assign Zone": "Alocă zona",
  "Remove zone": "Elimină zona",
  "View Zone Details": "Vezi detaliile zonei",
  "Assign a delivery zone to optimize route planning for this location.": "Alocă o zonă de livrare pentru a optimiza planificarea rutelor pentru această locație.",
  "Postcode: {postcode} - Click \"Auto-Assign\" to assign zone automatically": "Cod poștal: {postcode} - Apasă „Alocare automată” pentru a aloca zona automat",
  "Delivery instructions, address corrections, etc.": "Instrucțiuni de livrare, corecturi de adresă etc.",
  "Verification Information": "Informații de verificare",
  "Location Map": "Harta locației",
  "Edit mode activated. Pin placed - use Save to apply changes.": "Modul de editare este activ. Pinul a fost plasat - folosește Salvează pentru a aplica modificările.",
  "Delivery History ({count})": "Istoric livrări ({count})",
  "No deliveries found": "Nu s-au găsit livrări",
  "No deliveries have been made to this location yet.": "Nu s-a făcut încă nicio livrare la această locație.",
  "Delivery #{id}": "Livrarea #{id}",
  "No date set": "Nicio dată setată",
  "Associated Routes ({count})": "Rute asociate ({count})",
  "No routes found": "Nu s-au găsit rute",
  "This location has not been included in any routes yet.": "Această locație nu a fost inclusă încă în nicio rută.",
  "Enter location name": "Introdu numele locației",
  "Assign Delivery Zone": "Alocă zona de livrare",
  "Select Delivery Zone": "Selectează zona de livrare",
  "Select a zone...": "Selectează o zonă...",
  "Loading zones...": "Se încarcă zonele...",
  "Priority:": "Prioritate:",
  "Volume:": "Volum:",
  "Hours:": "Ore:",
  "Postcodes:": "Coduri poștale:",
  "Loading map...": "Se încarcă harta...",
  "Created {created_count} locations": "Locații create: {created_count}",
  "Failed to create locations": "Locațiile nu au putut fi create",
  "Location created for warehouse": "Locația a fost creată pentru depozit",
  "Failed to create warehouse location": "Locația depozitului nu a putut fi creată",
  "Location deleted successfully": "Locația a fost ștearsă cu succes",
  "Failed to delete location": "Locația nu a putut fi ștearsă",
  "Successfully assigned zones to {assigned} location(s)": "Zone alocate cu succes. Locații: {assigned}",
  "No locations were assigned zones": "Nicio locație nu a primit zonă",
  "Failed to assign zones": "Zonele nu au putut fi alocate",
  "Associated Entity": "Entitate asociată",
  "Address modified from original": "Adresă modificată față de original",
  "No zone assigned": "Nicio zonă alocată",
  "No coordinates": "Fără coordonate",
  "Edit Location": "Editează locația",
  "Delete Location": "Șterge locația",
  "Please enter a postcode first": "Introdu mai întâi un cod poștal",
  "Zone detected: {name}": "Zonă detectată: {name}",
  "Failed to detect zone": "Zona nu a putut fi detectată",
  "Logistics Location Management": "Gestionare locații logistice",
  "Manage customer delivery locations and warehouse addresses": "Gestionează locațiile de livrare ale clienților și adresele depozitelor",
  "Bulk Create": "Creare în masă",
  "Auto-Assign Zones": "Alocă automat zonele",
  "Create Warehouse Location": "Creează locație depozit",
  "Search locations...": "Caută locații...",
  "Location Type": "Tip locație",
  "Customer Locations": "Locații clienți",
  "Warehouse Locations": "Locații depozite",
  "Customer Status": "Stare client",
  "Active Customers": "Clienți activi",
  "Inactive Customers": "Clienți inactivi",
  "Loading locations...": "Se încarcă locațiile...",
  "No locations found": "Nu s-au găsit locații",
  "Try adjusting your search terms.": "Încearcă să modifici termenii de căutare.",
  "Create locations to get started.": "Creează locații pentru a începe.",
  "Showing {from} to {to} of {total} locations": "Se afișează {from}–{to} din {total} locații",
  "Location Details": "Detalii locație",
  "Enter the full address": "Introdu adresa completă",
  "e.g., SW1A 1AA": "ex.: SW1A 1AA",
  "Detect Zone": "Detectează zona",
  "Detected zone:": "Zonă detectată:",
  "Select a warehouse to create a logistics location for. This will allow the warehouse to be used in route planning and deliveries.": "Selectează un depozit pentru care să creezi o locație logistică. Astfel depozitul va putea fi folosit la planificarea rutelor și la livrări.",
  "Select Warehouse": "Selectează depozitul",
  "Choose a warehouse...": "Alege un depozit...",
  "Loading available warehouses...": "Se încarcă depozitele disponibile...",
  "No warehouses available (all warehouses already have locations)": "Niciun depozit disponibil (toate depozitele au deja locații)",
  "Selected Warehouse Details:": "Detaliile depozitului selectat:",
  "Name:": "Nume:",
  "Manager:": "Manager:",
  "Phone:": "Telefon:",
  "Email:": "E-mail:",
  "Create Location": "Creează locația",
  "Auto-Assign Delivery Zones": "Alocă automat zonele de livrare",
  "Automatically assign delivery zones to locations based on their postcodes. The system will use UK postcode mapping to determine the appropriate zone for each location.": "Alocă automat zonele de livrare locațiilor după codurile lor poștale. Sistemul va folosi corespondența codurilor poștale din Marea Britanie pentru a stabili zona potrivită pentru fiecare locație.",
  "How it works:": "Cum funcționează:",
  "Primary method: Postcode matching (35 UK delivery zones)": "Metoda principală: potrivire după codul poștal (35 de zone de livrare din Marea Britanie)",
  "Fallback method: Coordinate-based nearest zone": "Metoda de rezervă: cea mai apropiată zonă după coordonate",
  "Locations without postcodes or coordinates will be skipped": "Locațiile fără cod poștal sau coordonate vor fi omise",
  "Assignment Scope": "Domeniul alocării",
  "Unassigned locations only ({count} locations)": { one: "Doar locațiile nealocate ({count} locație)", few: "Doar locațiile nealocate ({count} locații)", other: "Doar locațiile nealocate ({count} de locații)" },
  "Selected locations only ({count} selected)": { one: "Doar locațiile selectate ({count} selectată)", few: "Doar locațiile selectate ({count} selectate)", other: "Doar locațiile selectate ({count} selectate)" },
  "All locations ({count} locations)": { one: "Toate locațiile ({count} locație)", few: "Toate locațiile ({count} locații)", other: "Toate locațiile ({count} de locații)" },
  "Force reassign:": "Forțează realocarea:",
  "Overwrite existing zone assignments (use with caution)": "Suprascrie alocările de zone existente (folosește cu atenție)",
  "No locations selected. Please select locations from the table first.": "Nicio locație selectată. Selectează mai întâi locații din tabel.",
  "Summary:": "Sumar:",
  "{count} selected location(s) will be processed": "Locații selectate care vor fi procesate: {count}",
  "No locations will be processed": "Nu va fi procesată nicio locație",
  "{count} unassigned location(s) will be processed": "Locații nealocate care vor fi procesate: {count}",
  "{count} location(s) will be processed (including reassignment)": "Locații care vor fi procesate (inclusiv realocare): {count}",
  "{count} location(s) will be processed": "Locații care vor fi procesate: {count}",
  "Assignment Complete": "Alocare finalizată",
  "Failed Assignments:": "Alocări eșuate:",
  "... and {count} more": "... și încă {count}",
  "Assign Zones": "Alocă zonele",
  "Click to zoom to address": "Apasă pentru a mări harta la adresă",
  "Time window: {start} - {end}": "Interval orar: {start} - {end}",
  "Est: {time}": "Estimat: {time}",
  "Actual: {time}": "Efectiv: {time}",
  "Remove this delivery from the route?": "Elimini această livrare din rută?",
  "Back to Routes": "Înapoi la rute",
  "Route not found": "Ruta nu a fost găsită",
  "Route #": "Ruta #",
  "Route Number (e.g., 251204 01)": "Număr rută (ex.: 251204 01)",
  "Driver/Route Name": "Nume șofer/rută",
  "Edit Route": "Editează ruta",
  "Send to Driver": "Trimite șoferului",
  "Start Route": "Începe ruta",
  "Complete Route": "Finalizează ruta",
  "Driver": "Șofer",
  "Cannot edit in this mode": "Nu se poate edita în acest mod",
  "Edit Route Information": "Editează informațiile rutei",
  "Route Information": "Informații rută",
  "Driver {id}": "Șofer {id}",
  "Actual Time": "Timp efectiv",
  "{distance} km": "{distance} km",
  "{minutes} min": "{minutes} min",
  "Enter start location address": "Introdu adresa locației de pornire",
  "Enter end location address": "Introdu adresa locației de sosire",
  "Enter notes or special instructions": "Introdu note sau instrucțiuni speciale",
  "Route Progress": "Progresul rutei",
  "{count} completed": { one: "{count} finalizată", few: "{count} finalizate", other: "{count} finalizate" },
  "{count} total stops": { one: "{count} oprire în total", few: "{count} opriri în total", other: "{count} de opriri în total" },
  "Deliveries Status": "Starea livrărilor",
  "Route Created by {name}": "Rută creată de {name}",
  "Route Created": "Rută creată",
  "Route Started": "Rută începută",
  "Route Completed": "Rută finalizată",
  "Route Deliveries ({count})": "Livrările rutei ({count})",
  "(Drag to reorder)": "(Trage pentru a reordona)",
  "Add Delivery": "Adaugă livrare",
  "No deliveries assigned to this route": "Nicio livrare alocată acestei rute",
  "Go to Route Planner": "Mergi la Planificatorul de rute",
  "Add Delivery to Route ({date})": "Adaugă livrare la rută ({date})",
  "Search by customer, address, or order number...": "Caută după client, adresă sau număr comandă...",
  "Loading available deliveries...": "Se încarcă livrările disponibile...",
  "No pending deliveries available for {date}": "Nicio livrare în așteptare disponibilă pentru {date}",
  "this date": "această dată",
  "Try adjusting your search term": "Încearcă să modifici termenul de căutare",
  "Zone: {zone}": "Zonă: {zone}",
  "Showing {count} pending deliveries for {date}": { one: "Se afișează {count} livrare în așteptare pentru {date}", few: "Se afișează {count} livrări în așteptare pentru {date}", other: "Se afișează {count} de livrări în așteptare pentru {date}" },
  "route date": "data rutei",
  "Assign Driver": "Alocă șofer",
  "Assign": "Alocă",
  "Cancel Route": "Anulează ruta",
  "Driver / Vehicle": "Șofer / Vehicul",
  "Stops / Progress": "Opriri / Progres",
  "{completed}/{total} stops": "{completed}/{total} opriri",
  "No routes found for the selected filters": "Nu s-au găsit rute pentru filtrele selectate",
  "Total Routes": "Total rute",
  "Total Deliveries": "Total livrări",
  "Active Routes": "Rute active",
  "Completed Routes": "Rute finalizate",
  "Route Management": "Gestionare rute",
  "Optimize Selected": "Optimizează selecția",
  "Select routes with checkboxes to show optimization options.": "Bifează rute pentru a vedea opțiunile de optimizare.",
  "Optimize": "Optimizează",
  "Planner": "Planificator",
  "Sort by...": "Sortează după...",
  "Ascending": "Crescător",
  "Descending": "Descrescător",
  "Showing {start} to {end} of {total} routes": "Se afișează {start}–{end} din {total} rute",
  "per page": "pe pagină",
  "First": "Prima",
  "{start}-{end} of {total}": "{start}-{end} din {total}",
  "Select Optimization Type": "Selectează tipul de optimizare",
  "Choose how to optimize {count} route(s):": "Rute de optimizat: {count}. Alege modul de optimizare:",
  "Distance": "Distanță",
  "Minimize total travel distance": "Minimizează distanța totală parcursă",
  "Minimize total delivery time": "Minimizează timpul total de livrare",
  "Balanced": "Echilibrat",
  "Balance between distance and time": "Echilibru între distanță și timp",
  "Optimizing routes...": "Se optimizează rutele...",
  "Back in service on {date}": "Revine în funcțiune pe {date}",
  "In service (no end date set)": "În service (fără dată de încheiere)",
  "In Service until {date}": "În service până pe {date}",
  "In Service": "În service",
  "Expired 1 day ago": "Expirat acum 1 zi",
  "Expired {count} days ago": { one: "Expirat acum {count} zi", few: "Expirat acum {count} zile", other: "Expirat acum {count} de zile" },
  "1 day left": "1 zi rămasă",
  "{count} days left": { one: "{count} zi rămasă", few: "{count} zile rămase", other: "{count} de zile rămase" },
  "Tracked by Verizon ({id})": "Urmărit prin Verizon ({id})",
  "Verizon": "Verizon",
  "Next Service": "Următoarea revizie",
  "MOT Expiry": "Expirare MOT",
  "Tax Expiry": "Expirare taxă auto",
  "Insurance Expiry": "Expirare asigurare",
  "Duplicate Vehicle": "Duplică vehiculul",
  "Vehicle Management": "Gestionare vehicule",
  "Total Vehicles": "Total vehicule",
  "Service Due": "Revizie scadentă",
  "Compliance Due": "Conformitate scadentă",
  "Motorcycle": "Motocicletă",
  "Car": "Autoturism",
  "Van": "Dubă",
  "Truck": "Camion",
  "Search vehicles...": "Caută vehicule...",
  "More Filters": "Mai multe filtre",
  "All Fuel Types": "Toate tipurile de combustibil",
  "Diesel": "Motorină",
  "Petrol": "Benzină",
  "Electric": "Electric",
  "Service Status": "Stare revizie",
  "All Service Status": "Toate stările reviziei",
  "Due Soon (≤30 days)": "Scadent curând (≤30 zile)",
  "Overdue": "Depășit",
  "Up to Date": "La zi",
  "Year Range": "Interval de ani",
  "All Years": "Toți anii",
  "2020 and newer": "2020 și mai noi",
  "Before 2010": "Înainte de 2010",
  "Sort By": "Sortează după",
  "Registration A-Z": "Înmatriculare A-Z",
  "Registration Z-A": "Înmatriculare Z-A",
  "Type A-Z": "Tip A-Z",
  "Year (Newest)": "An (cele mai noi)",
  "Year (Oldest)": "An (cele mai vechi)",
  "No vehicles found for the selected filters": "Nu s-au găsit vehicule pentru filtrele selectate",
  "Failed to load BOM costs": "Costurile din rețete nu au putut fi încărcate",
  "None of the selected lines have an active BOM": "Niciuna dintre liniile selectate nu are o rețetă activă",
  "— {count} skipped (no BOM)": { one: "— {count} omisă (fără rețetă)", few: "— {count} omise (fără rețetă)", other: "— {count} omise (fără rețetă)" },
  "Please add at least one product to the document": "Adaugă cel puțin un produs în document",
  "This document is not editable": "Acest document nu poate fi editat",
  "Please enter prices for at least one product": "Introdu prețuri pentru cel puțin un produs",
  "Price document created successfully": "Documentul de preț a fost creat cu succes",
  "Price document updated successfully": "Documentul de preț a fost actualizat cu succes",
  "Failed to save document": "Documentul nu a putut fi salvat",
  "Invalid data detected. Please paste product names and prices only (e.g., \"Product Name, 10.50\")": "Date invalide. Lipește doar nume de produse și prețuri (ex.: „Nume produs, 10.50”)",
  "Invalid format - expected \"Product Name, Price\"": "Format invalid - se aștepta „Nume produs, Preț”",
  "Invalid price \"{price}\" - expected a number": "Preț invalid „{price}” - se aștepta un număr",
  "Added {count} product(s)": "Produse adăugate: {count}",
  "Product matched successfully": "Produsul a fost potrivit cu succes",
  "Skipped {count} unmatched product(s)": "Produse nepotrivite omise: {count}",
  "Please select a price type first": "Selectează mai întâi un tip de preț",
  "Auto-fill is only available for dynamic price types": "Completarea automată este disponibilă doar pentru tipurile de preț dinamice",
  "No calculated prices available for this price type": "Nu există prețuri calculate pentru acest tip de preț",
  "Auto-filled {count} products with calculated prices": { one: "S-a completat automat {count} produs cu preț calculat", few: "S-au completat automat {count} produse cu prețuri calculate", other: "S-au completat automat {count} de produse cu prețuri calculate" },
  "Failed to auto-fill calculated prices": "Prețurile calculate nu au putut fi completate automat",
  "Calculated by formula": "Calculat prin formulă",
  "Previous Price": "Preț anterior",
  "New Price (£)": "Preț nou (£)",
  "Change %": "Modificare %",
  "New Price Document": "Document de preț nou",
  "Locked": "Blocat",
  "Auto-fill Calculated Prices": "Completează automat prețurile calculate",
  "Select Products to Add": "Selectează produsele de adăugat",
  "Add Selected ({count})": "Adaugă selecția ({count})",
  "Add single product": "Adaugă un singur produs",
  "Type to search for products or select a category": "Scrie pentru a căuta produse sau selectează o categorie",
  "Percent": "Procent",
  "e.g. -5 for -5%": "ex. -5 pentru -5%",
  "e.g. 1.50 or -0.25": "ex. 1.50 sau -0.25",
  "Fill by BOM": "Completează din rețetă",
  "Click \"Add Product\" to start adding products": "Apasă „Adaugă produs” pentru a începe să adaugi produse",
  "Optional notes for this price document...": "Note opționale pentru acest document de preț...",
  "{count} products added": { one: "{count} produs adăugat", few: "{count} produse adăugate", other: "{count} de produse adăugate" },
  "{count} with prices set": "Cu prețuri setate: {count}",
  "Fill Prices from BOM": "Completează prețurile din rețetă",
  "Loading BOM costs…": "Se încarcă costurile din rețete…",
  "costs as of {date}": "costuri la data de {date}",
  "Add Products by Copy/Paste": "Adaugă produse prin copiere/lipire",
  "Paste data with SKU/Product Name and Price separated by tab, comma, semicolon, or space (one product per line):": "Lipește date cu SKU/Nume produs și Preț, separate prin tab, virgulă, punct și virgulă sau spațiu (un produs pe linie):",
  "Match Unrecognized Products ({count})": "Potrivește produsele nerecunoscute ({count})",
  "The following products could not be matched automatically. Select a matching product or skip.": "Următoarele produse nu au putut fi potrivite automat. Selectează un produs corespunzător sau omite-le.",
  "Line {line}:": "Linia {line}:",
  "Looking for:": "Se caută:",
  "Skip this product": "Omite acest produs",
  "Suggestions (click to match):": "Sugestii (apasă pentru a potrivi):",
  "{percent}% match": "potrivire {percent}%",
  "(matched on SKU)": "(potrivit după SKU)",
  "(matched on name)": "(potrivit după nume)",
  "Manual Search": "Căutare manuală",
  "Search by product name or SKU...": "Caută după numele produsului sau SKU...",
  "No products found matching \"{query}\"": "Niciun produs nu corespunde căutării „{query}”",
  "Skip Remaining": "Omite restul",
  "Manage price types, formulas, and product pricing": "Gestionează tipurile de preț, formulele și prețurile produselor",
  "Tabs": "Tab-uri",
  "Copied": "Copiat",
  "Could not copy — select the text and copy it manually": "Nu s-a putut copia — selectează textul și copiază-l manual",
  "Could not create the token": "Tokenul nu a putut fi creat",
  "Revoke \"{label}\"? Any AI app using it will lose access immediately.": "Revoci „{label}”? Orice aplicație AI care îl folosește va pierde accesul imediat.",
  "Could not revoke the token": "Tokenul nu a putut fi revocat",
  "Could not update the token": "Tokenul nu a putut fi actualizat",
  "Disconnect \"{name}\"? It will lose access immediately.": "Deconectezi „{name}”? Își va pierde accesul imediat.",
  "Could not disconnect the app": "Aplicația nu a putut fi deconectată",
  "AI connections": "Conexiuni AI",
  "Connect Claude, ChatGPT or another AI app to AvaCore. It acts as you, with exactly your permissions.": "Conectează Claude, ChatGPT sau altă aplicație AI la AvaCore. Aceasta acționează în numele tău, cu exact permisiunile tale.",
  "Address to paste into Claude or ChatGPT": "Adresa de lipit în Claude sau ChatGPT",
  "Add it as a custom connector, then sign in with your AvaCore account. If an app asks for the full address, use {url}.": "Adaug-o ca un conector personalizat, apoi autentifică-te cu contul tău AvaCore. Dacă o aplicație cere adresa completă, folosește {url}.",
  "Connected apps": "Aplicații conectate",
  "Connected {created} · last used {used}": "Conectat {created} · ultima utilizare {used}",
  "Disconnect": "Deconectează",
  "Copy your token now — it will not be shown again.": "Copiază tokenul acum — nu va mai fi afișat.",
  "I have saved it": "L-am salvat",
  "New token name": "Numele tokenului nou",
  "e.g. ChatGPT, Claude, Gemini, Grok": "ex. ChatGPT, Claude, Gemini, Grok",
  "Expires after": "Expiră după",
  "{count} days": { one: "{count} zi", few: "{count} zile", other: "{count} de zile" },
  "Create token": "Creează token",
  "Allow acting in AvaCore on my behalf": "Permite acțiuni în AvaCore în numele meu",
  "Exactly the actions my AvaCore permissions allow, nothing more. An administrator controls those from Assistant Settings.": "Exact acțiunile permise de permisiunile mele AvaCore, nimic mai mult. Un administrator le controlează din Setări asistent.",
  "Read/write mode: can act in AvaCore as you, limited to what your AvaCore permissions allow. Click to switch to read only mode.": "Mod citire/scriere: poate acționa în AvaCore în numele tău, limitat la ce permit permisiunile tale AvaCore. Apasă pentru a trece în modul doar citire.",
  "Read only mode: can only read data. Click to switch to read/write mode.": "Mod doar citire: poate doar citi date. Apasă pentru a trece în modul citire/scriere.",
  "is read/write mode": "este în modul citire/scriere",
  "is read only mode": "este în modul doar citire",
  "Created {created} · last used {used} · expires {expires}": "Creat {created} · ultima utilizare {used} · expiră {expires}",
  "Revoke": "Revocă",
  "Revoked": "Revocat",
  "Answers the AI app receives from AvaCore are kept in that app's chat history.": "Răspunsurile primite de aplicația AI de la AvaCore sunt păstrate în istoricul conversațiilor acelei aplicații.",
  "Please enter a project name": "Introdu un nume de proiect",
  "End date must be after start date": "Data de sfârșit trebuie să fie după data de început",
  "Project created successfully!": "Proiectul a fost creat cu succes!",
  "Failed to create project. Please try again.": "Proiectul nu a putut fi creat. Încearcă din nou.",
  "Create Project": "Creează proiect",
  "Project Information": "Informații proiect",
  "Enter project name...": "Introdu numele proiectului...",
  "Detailed description of the project goals and scope...": "Descriere detaliată a obiectivelor și a domeniului proiectului...",
  "Project Details": "Detalii proiect",
  "Budget (£)": "Buget (£)",
  "Assigned team": "Echipa alocată",
  "Assign Team Members": "Alocă membri ai echipei",
  "Select team members to assign to this project...": "Selectează membrii echipei de alocat acestui proiect...",
  "Additional Information": "Informații suplimentare",
  "Any additional notes, requirements, or important information about this project...": "Orice note suplimentare, cerințe sau informații importante despre acest proiect...",
  "Project Timeline": "Calendarul proiectului",
  "This project is scheduled to run from {start} to {end} ({days} days)": "Acest proiect este programat să se desfășoare între {start} și {end} (zile: {days})",
  "Are you sure you want to delete this project?": "Sigur vrei să ștergi acest proiect?",
  "Project deleted successfully": "Proiectul a fost șters cu succes",
  "Failed to delete project": "Proiectul nu a putut fi șters",
  "Project started": "Proiectul a fost început",
  "Project completed": "Proiectul a fost finalizat",
  "Loading project details...": "Se încarcă detaliile proiectului...",
  "Project not found": "Proiectul nu a fost găsit",
  "Back to Projects": "Înapoi la proiecte",
  "Project Overview": "Prezentare generală proiect",
  "Team Members ({count})": "Membrii echipei ({count})",
  "Team Members": "Membrii echipei",
  "Project Tasks": "Sarcinile proiectului",
  "Add Task": "Adaugă sarcină",
  "No tasks assigned to this project yet.": "Nicio sarcină alocată încă acestui proiect.",
  "Project updated successfully!": "Proiectul a fost actualizat cu succes!",
  "Failed to update project. Please try again.": "Proiectul nu a putut fi actualizat. Încearcă din nou.",
  "Loading project...": "Se încarcă proiectul...",
  "Edit Project": "Editează proiectul",
  "Project": "Proiect",
  "Mark Complete": "Marchează ca finalizat",
  "Loading projects...": "Se încarcă proiectele...",
  "New Project": "Proiect nou",
  "Search projects...": "Caută proiecte...",
  "1 project": "1 proiect",
  "{count} projects": { one: "{count} proiect", few: "{count} proiecte", other: "{count} de proiecte" },
  "All Priorities": "Toate prioritățile",
  "No Projects Found": "Nu s-au găsit proiecte",
  "No projects match your current filters.": "Niciun proiect nu corespunde filtrelor curente.",
  "Create your first project to get started with project management.": "Creează primul proiect pentru a începe gestionarea proiectelor.",
  "Create Your First Project": "Creează primul proiect",
  "Marked as paid": "Marcat ca plătit",
  "Failed to mark as paid": "Nu a putut fi marcat ca plătit",
  "Deadline date and description are required": "Data termenului și descrierea sunt obligatorii",
  "Deadline added, reminder created": "Termenul a fost adăugat, mementoul a fost creat",
  "Failed to add deadline": "Termenul nu a putut fi adăugat",
  "Failed to update deadline": "Termenul nu a putut fi actualizat",
  "Delete this deadline and its reminder?": "Ștergi acest termen și mementoul lui?",
  "Failed to delete deadline": "Termenul nu a putut fi șters",
  "Uploaded": "Încărcat",
  "Failed to upload file": "Fișierul nu a putut fi încărcat",
  "Delete {name}?": "Ștergi {name}?",
  "Failed to delete attachment": "Atașamentul nu a putut fi șters",
  "Actioned": "Rezolvat",
  "Archived": "Arhivat",
  "Mark Paid": "Marchează plătit",
  "Document Information": "Informații document",
  "{amount} on {date}": "{amount} pe {date}",
  "Notes: {notes}": "Note: {notes}",
  "Deadlines": "Termene",
  "Won": "Câștigate",
  "Lost": "Pierdute",
  "The status filter is set, so these are ignored": "Filtrul de stare este setat, așa că acestea sunt ignorate",
  "Add Deadline": "Adaugă termen",
  "e.g. Reduced payment": "ex. Plată redusă",
  "Remind days before": "Amintește cu zile înainte",
  "Visible To (optional)": "Vizibil pentru (opțional)",
  "Who else should see this reminder...": "Cine altcineva ar trebui să vadă acest memento...",
  "No deadlines.": "Niciun termen.",
  "Reminder ({status})": "Memento ({status})",
  "Visible to: {names}": "Vizibil pentru: {names}",
  "Mark met": "Marchează ca respectat",
  "Scans / Photos": "Scanări / Fotografii",
  "Take Photo / Add File": "Fă o fotografie / Adaugă fișier",
  "No files attached.": "Niciun fișier atașat.",
  "Open original in new tab": "Deschide originalul într-un tab nou",
  "Mark as Paid": "Marchează ca plătit",
  "Paid Amount (£)": "Sumă plătită (£)",
  "All pending deadlines are marked as met and their reminders completed.": "Toate termenele în așteptare sunt marcate ca respectate, iar mementourile lor sunt finalizate.",
  "Confirm Paid": "Confirmă plata",
  "Please enter a document title": "Introdu un titlu pentru document",
  "Please enter the received date": "Introdu data primirii",
  "Document updated": "Documentul a fost actualizat",
  "Failed to upload {name}": "{name} nu a putut fi încărcat",
  "Document registered": "Documentul a fost înregistrat",
  "Edit Document": "Editează documentul",
  "Register Document": "Înregistrează document",
  "Register": "Înregistrează",
  "e.g. Parking fine PCN 123456": "ex. Amendă de parcare PCN 123456",
  "e.g. City Council": "ex. Consiliul local",
  "e.g. PCN 123456": "ex. PCN 123456",
  "e.g. 100.00": "ex. 100.00",
  "What is this document about...": "Despre ce este acest document...",
  "Each deadline creates a reminder in Task Management. For a fine with a reduced early price, add two deadlines: the reduced payment and the full payment.": "Fiecare termen creează un memento în Gestionare sarcini. Pentru o amendă cu preț redus la plata timpurie, adaugă două termene: plata redusă și plata integrală.",
  "No deadlines added.": "Niciun termen adăugat.",
  "No files added. On a phone, \"Take Photo\" opens the camera; photos are compressed automatically before upload.": "Niciun fișier adăugat. Pe telefon, „Fă o fotografie” deschide camera; fotografiile sunt comprimate automat înainte de încărcare.",
  "Remove file": "Elimină fișierul",
  "Internal notes...": "Note interne...",
  "{date} — {days}d overdue": "{date} — depășit cu {days} z",
  "{date} — today": "{date} — azi",
  "{date} — {days}d left": "{date} — rămas {days} z",
  "Ref": "Ref.",
  "Add Document": "Adaugă document",
  "Search title, sender, reference...": "Caută titlu, expeditor, referință...",
  "No received documents yet. Add the first letter or fine with the button above.": "Niciun document primit încă. Adaugă prima scrisoare sau amendă cu butonul de mai sus.",
  "Posted as {number} — cancel that adjustment before removing it": "Înregistrat ca {number} — anulează acea ajustare înainte de a-l elimina",
  "The only area — double-click the stocktake in the list to swap it": "Singura zonă — dublu-clic pe inventar în listă pentru a o schimba",
  "Remove from this stocktake": "Elimină din acest inventar",
  "Posted as {number} — cancel that adjustment to remove it": "Înregistrat ca {number} — anulează acea ajustare pentru a-l elimina",
  "posted": "înregistrat",
  "Edit {number}": "Editează {number}",
  "Review changes": "Verifică modificările",
  "Checking…": "Se verifică…",
  "{count} areas selected.": { one: "{count} zonă selectată.", few: "{count} zone selectate.", other: "{count} de zone selectate." },
  "Assume changes delete counted data.": "Presupune că modificările șterg datele numărate.",
  "Unticking an area deletes its sheet and every count on it, and changing the warehouse rebuilds all of them. You will be shown exactly what is lost before anything is saved.": "Debifarea unei zone îi șterge fișa și toate numărările de pe ea, iar schimbarea depozitului le reconstruiește pe toate. Ți se va arăta exact ce se pierde înainte de a salva ceva.",
  "{number} is {status} — reopen it before editing": "{number} este {status} — redeschide-l înainte de editare",
  "Could not check that change": "Nu s-a putut verifica acea modificare",
  "Could not save the stocktake": "Nu s-a putut salva inventarul",
  "{number} updated": "{number} a fost actualizat",
  "Delete {number}? Its {sheets} sheets and {counted} counted lines are deleted with it. This cannot be undone.": "Ștergi {number}? Odată cu el se șterg fișele (număr: {sheets}) și liniile numărate (număr: {counted}). Această acțiune nu poate fi anulată.",
  "Could not delete the stocktake": "Nu s-a putut șterge inventarul",
  "{number} deleted": "{number} a fost șters",
  "{status} — reopen it to edit": "{status} — redeschide-l pentru a-l edita",
  "Double-click to edit": "Dublu-clic pentru a edita",
  "Double-click to reopen": "Dublu-clic pentru a redeschide",
  "Double-click to close": "Dublu-clic pentru a închide",
  "Delete this stocktake and its sheets": "Șterge acest inventar și fișele lui",
  "Please enter both category name and display name": "Introdu atât numele categoriei, cât și numele afișat",
  "Category created successfully!": "Categoria a fost creată cu succes!",
  "Please enter a task title": "Introdu un titlu pentru sarcină",
  "Task created successfully!": "Sarcina a fost creată cu succes!",
  "Failed to create task. Please try again.": "Sarcina nu a putut fi creată. Încearcă din nou.",
  "Task Information": "Informații sarcină",
  "Task Title": "Titlu sarcină",
  "Enter task title...": "Introdu titlul sarcinii...",
  "Detailed description of the task...": "Descriere detaliată a sarcinii...",
  "Select a project (optional)...": "Selectează un proiect (opțional)...",
  "Any additional notes or requirements...": "Orice note sau cerințe suplimentare...",
  "Task Details": "Detalii sarcină",
  "+ Add New Category": "+ Adaugă categorie nouă",
  "Assign Users": "Alocă utilizatori",
  "Select users to assign this task to...": "Selectează utilizatorii cărora să le aloci această sarcină...",
  "Viewers": "Observatori",
  "Select users who can see this without being responsible...": "Selectează utilizatorii care pot vedea fără a fi responsabili...",
  "e.g. 2.5": "ex. 2.5",
  "Create New Category": "Creează categorie nouă",
  "Category Name": "Nume categorie",
  "e.g. quality_control": "ex. control_calitate",
  "Will be converted to lowercase with underscores": "Va fi convertit în litere mici cu liniuțe de subliniere",
  "Display Name": "Nume afișat",
  "e.g. Quality Control": "ex. Control calitate",
  "Create Category": "Creează categoria",
  "Are you sure you want to delete this task?": "Sigur vrei să ștergi această sarcină?",
  "Task deleted successfully": "Sarcina a fost ștearsă cu succes",
  "Failed to delete task": "Sarcina nu a putut fi ștearsă",
  "Task started": "Sarcina a fost începută",
  "Task completed": "Sarcina a fost finalizată",
  "Comment cannot be empty": "Comentariul nu poate fi gol",
  "Comment added": "Comentariul a fost adăugat",
  "Failed to add comment": "Comentariul nu a putut fi adăugat",
  "Delete this comment?": "Ștergi acest comentariu?",
  "Comment deleted": "Comentariul a fost șters",
  "Failed to delete comment": "Comentariul nu a putut fi șters",
  "Attachment uploaded": "Atașamentul a fost încărcat",
  "Failed to upload attachment": "Atașamentul nu a putut fi încărcat",
  "Delete this attachment?": "Ștergi acest atașament?",
  "Attachment deleted": "Atașamentul a fost șters",
  "Loading task details...": "Se încarcă detaliile sarcinii...",
  "Task not found": "Sarcina nu a fost găsită",
  "Back to Tasks": "Înapoi la sarcini",
  "Reminder about": "Memento despre",
  "Related to": "Legat de",
  "{type}: {name}": "{type}: {name}",
  "Assigned To ({count})": "Alocat lui ({count})",
  "Visible To ({count})": "Vizibil pentru ({count})",
  "(Overdue)": "(Depășit)",
  "{hours}h": "{hours}h",
  "Comments ({count})": "Comentarii ({count})",
  "Add Comment": "Adaugă comentariu",
  "Write a comment...": "Scrie un comentariu...",
  "Save Comment": "Salvează comentariul",
  "Delete comment": "Șterge comentariul",
  "No comments yet": "Niciun comentariu încă",
  "Attachments ({count})": "Atașamente ({count})",
  "Uploading...": "Se încarcă...",
  "Add Attachment": "Adaugă atașament",
  "Uploaded by {name} on {date}": "Încărcat de {name} pe {date}",
  "Download": "Descarcă",
  "No attachments yet": "Niciun atașament încă",
  "Task updated successfully!": "Sarcina a fost actualizată cu succes!",
  "Failed to update task. Please try again.": "Sarcina nu a putut fi actualizată. Încearcă din nou.",
  "Loading task...": "Se încarcă sarcina...",
  "Edit Task": "Editează sarcina",
  "Uncategorized": "Necategorisit",
  "Pick at least one user": "Alege cel puțin un utilizator",
  "Remove all viewers from {count} task(s)?": "Elimini toți observatorii din sarcinile selectate? Sarcini: {count}",
  "{updated} updated, {skipped} skipped (no permission to edit)": "Actualizate: {updated}, omise: {skipped} (fără permisiune de editare)",
  "Viewers updated on {count} task(s)": "Sarcini cu observatorii actualizați: {count}",
  "Failed to update viewers": "Observatorii nu au putut fi actualizați",
  "Task copied successfully!": "Sarcina a fost copiată cu succes!",
  "Failed to copy task. Please try again.": "Sarcina nu a putut fi copiată. Încearcă din nou.",
  "Reminder": "Memento",
  "Can view this — not responsible for it": "Poate vedea — nu este responsabil",
  "Comments": "Comentarii",
  "Attachments": "Atașamente",
  "Select all {count}": "Selectează toate ({count})",
  "Clear selection": "Golește selecția",
  "1 task selected": "1 sarcină selectată",
  "{count} tasks selected": { one: "{count} sarcină selectată", few: "{count} sarcini selectate", other: "{count} de sarcini selectate" },
  "No Tasks Found": "Nu s-au găsit sarcini",
  "All tasks are completed. Uncheck 'Hide Completed' to view them.": "Toate sarcinile sunt finalizate. Debifează „Ascunde finalizate” pentru a le vedea.",
  "No tasks match your current filters.": "Nicio sarcină nu corespunde filtrelor curente.",
  "Create your first task to get started with task management.": "Creează prima sarcină pentru a începe gestionarea sarcinilor.",
  "Create Your First Task": "Creează prima sarcină",
  "Edit Note": "Editează nota",
  "Delete Note": "Șterge nota",
  "until {date}": "până pe {date}",
  "Loading calendar...": "Se încarcă calendarul...",
  "Loading tasks...": "Se încarcă sarcinile...",
  "Search tasks...": "Caută sarcini...",
  "Hide Completed": "Ascunde finalizate",
  "1 task": "1 sarcină",
  "({count} hidden)": { one: "({count} ascunsă)", few: "({count} ascunse)", other: "({count} ascunse)" },
  "Tasks & Reminders (default)": "Sarcini și mementouri (implicit)",
  "Tasks only": "Doar sarcini",
  "Reminders only": "Doar mementouri",
  "All Projects": "Toate proiectele",
  "Bulk Edit Viewers": "Editează observatorii în masă",
  "Applies to {count} selected task(s). Tasks you cannot edit are skipped.": "Se aplică sarcinilor selectate: {count}. Sarcinile pe care nu le poți edita sunt omise.",
  "Add viewers — keep existing ones": "Adaugă observatori — păstrează-i pe cei existenți",
  "Replace viewers — overwrite existing ones": "Înlocuiește observatorii — suprascrie-i pe cei existenți",
  "Remove viewers — drop the ones picked below": "Elimină observatori — scoate-i pe cei aleși mai jos",
  "Pick who should see these tasks...": "Alege cine ar trebui să vadă aceste sarcini...",
  "Replace overwrites the viewer list on every selected task. Anyone currently watching a task and not picked above will lose access to it.": "Înlocuirea suprascrie lista de observatori pe fiecare sarcină selectată. Oricine urmărește acum o sarcină și nu a fost ales mai sus își va pierde accesul la ea.",
  "Resolution notes...": "Note de rezolvare...",
  "Are you sure you want to deactivate {registration_number}?": "Sigur vrei să dezactivezi {registration_number}?",
  "Are you sure you want to reactivate {registration_number}?": "Sigur vrei să reactivezi {registration_number}?",
  "Failed to deactivate vehicle. Please try again.": "Vehiculul nu a putut fi dezactivat. Încearcă din nou.",
  "Failed to reactivate vehicle. Please try again.": "Vehiculul nu a putut fi reactivat. Încearcă din nou.",
  "Daily Mileage": "Kilometraj zilnic",
  "Cumulative": "Cumulat",
  "Fuel Efficiency (MPG)": "Eficiență combustibil (MPG)",
  "Baseline": "Referință",
  "Click to reactivate": "Apasă pentru a reactiva",
  "This vehicle is in service and unavailable for route assignment": "Acest vehicul este în service și nu poate fi alocat pe rute",
  "In Service (no end date set)": "În service (fără dată de încheiere)",
  "Print Barcode": "Tipărește codul de bare",
  "Current Mileage": "Kilometraj curent",
  "mi left": "mile rămase",
  "Avg MPG": "MPG mediu",
  "Active Alerts": "Alerte active",
  "Vehicle Information": "Informații vehicul",
  "Basic Details": "Detalii de bază",
  "Capacity (Weight)": "Capacitate (greutate)",
  "Capacity (Volume)": "Capacitate (volum)",
  "m³": "m³",
  "Compliance": "Conformitate",
  "Last Service": "Ultima revizie",
  "Inspection History": "Istoric inspecții",
  "Add Inspection": "Adaugă inspecție",
  "Edit this inspection": "Editează această inspecție",
  "Mileage": "Kilometraj",
  "Visual": "Vizual",
  "Oil": "Ulei",
  "Tyres": "Anvelope",
  "Fuel": "Combustibil",
  "Defects:": "Defecte:",
  "Hide history": "Ascunde istoricul",
  "History ({count})": "Istoric ({count})",
  "Created by {name}": "Creat de {name}",
  "{field}: {old} → {new} by {name}": "{field}: {old} → {new} de {name}",
  "No inspection records found": "Nu s-au găsit înregistrări de inspecție",
  "Maintenance Records": "Înregistrări de întreținere",
  "Add Record": "Adaugă înregistrare",
  "Edit this record": "Editează această înregistrare",
  "Service Dates": "Date revizie",
  "Workshop": "Atelier service",
  "Mileage / Cost": "Kilometraj / Cost",
  "No maintenance records found": "Nu s-au găsit înregistrări de întreținere",
  "Driver Assignment History": "Istoric alocări șoferi",
  "{count} routes completed": { one: "{count} rută finalizată", few: "{count} rute finalizate", other: "{count} de rute finalizate" },
  "Present": "Prezent",
  "{count} miles": { one: "{count} milă", few: "{count} mile", other: "{count} de mile" },
  "No driver history found": "Nu s-a găsit istoric de șoferi",
  "No active alerts": "Nicio alertă activă",
  "Vehicle Analytics": "Analiză vehicul",
  "Mileage Trend (miles per day, last 30 days)": "Evoluție kilometraj (mile pe zi, ultimele 30 de zile)",
  "No mileage in the last 30 days. The chart pulls from completed routes (and inspection overrides when present).": "Niciun kilometraj în ultimele 30 de zile. Graficul preia datele din rutele finalizate (și din corecțiile din inspecții, când există).",
  "Fuel Efficiency (MPG, last 30 days)": "Eficiență combustibil (MPG, ultimele 30 de zile)",
  "MPG is not tracked for electric vehicles.": "MPG nu se urmărește pentru vehiculele electrice.",
  "No fuel efficiency data yet. MPG comes from daily inspections.": "Încă nu există date despre eficiența combustibilului. MPG provine din inspecțiile zilnice.",
  "Avg Daily Mileage": "Kilometraj zilnic mediu",
  "Utilization Rate": "Grad de utilizare",
  "Yield: {got} of {planned} {unit} — {miss} {unit} below plan": "Randament: {got} din {planned} {unit} — cu {miss} {unit} sub plan",
  "Failed to update where materials come from": "Sursa materiilor prime nu a putut fi actualizată",
  "New Production WIP": "WIP de producție nou",
  "Select work by product, operation, machine or operator": "Selectează lucrul după produs, operație, mașină sau operator",
  "Failed to load the queue": "Coada nu a putut fi încărcată",
  "Failed to load available products": "Produsele disponibile nu au putut fi încărcate",
  "Enter a quantity first": "Introdu mai întâi o cantitate",
  "Failed to start production": "Producția nu a putut fi pornită",
  "trunk": "trunchi",
  "waiting on {operation}": "așteaptă {operation}",
  "Select your operation above.": "Selectează-ți operația mai sus.",
  "Pick a single operation to see the stock waiting for it.": "Alege o singură operație pentru a vedea stocul care o așteaptă.",
  "No stock is waiting for this operation.": "Niciun stoc nu așteaptă această operație.",
  "{count} batches": { one: "{count} lot", few: "{count} loturi", other: "{count} de loturi" },
  "makes": "produce",
  "Use this batch quantity": "Folosește această cantitate pe șarjă",
  "No recipe you can start for this product.": "Nicio rețetă pe care o poți porni pentru acest produs.",
  "Choose recipe…": "Alege rețeta…",
  "Choose what to make…": "Alege ce produci…",
  "Choose what to make first": "Alege mai întâi ce produci",
  "Open this job": "Deschide această lucrare",
  "On hold": "În așteptare",
  "My operations": "Operațiile mele",
  "{count} jobs in your queue": { one: "{count} lucrare în coada ta", few: "{count} lucrări în coada ta", other: "{count} de lucrări în coada ta" },
  "Pick your operation to start working": "Alege-ți operația pentru a începe lucrul",
  "updated": "actualizat",
  "The operation you are working on": "Operația la care lucrezi",
  "The machine you are working on now": "Mașina la care lucrezi acum",
  "All machines": "Toate mașinile",
  "Jobs": "Lucrări",
  "Nothing waiting for you right now.": "Nimic nu te așteaptă acum.",
  "Waiting on an earlier operation": "Așteaptă o operație anterioară",
  "Queue": "Coadă",
  "Pick a job from the queue to start working on it.": "Alege o lucrare din coadă pentru a începe să lucrezi la ea.",
  "Your jobs will appear here.": "Lucrările tale vor apărea aici.",
  "Excel file downloaded": "Fișierul Excel a fost descărcat",
  "Opening": "Inițial",
  "(Cr)": "(Cr)",
  "View current balances for all GL accounts": "Vezi soldurile curente pentru toate conturile din registrul general",
  "Fiscal Year": "An fiscal",
  "Select Year": "Selectează anul",
  "(Current)": "(Curent)",
  "Fiscal Period": "Perioadă fiscală",
  "All Periods (YTD)": "Toate perioadele (de la începutul anului)",
  "Show zero balances": "Arată soldurile zero",
  "Loading balances...": "Se încarcă soldurile...",
  "No balances found": "Nu s-au găsit solduri",
  "Account updated successfully": "Contul a fost actualizat cu succes",
  "Failed to update account": "Contul nu a putut fi actualizat",
  "Edit Account": "Editează contul",
  "Posting Account": "Cont de înregistrare",
  "Posting": "Înregistrare",
  "Total Debits:": "Total debit:",
  "Total Credits:": "Total credit:",
  "Balance not available": "Sold indisponibil",
  "View General Ledger": "Vezi registrul general",
  "Create Journal Entry": "Creează notă contabilă",
  "From date": "De la data",
  "To date": "Până la data",
  "Contra Account": "Cont rectificativ",
  "Manage your general ledger accounts": "Gestionează conturile din registrul general",
  "Add Account": "Adaugă cont",
  "Search accounts...": "Caută conturi...",
  "No accounts found": "Nu s-au găsit conturi",
  "Please fill in all required fields": "Completează toate câmpurile obligatorii",
  "Account created successfully": "Contul a fost creat cu succes",
  "Failed to create account": "Contul nu a putut fi creat",
  "Create New Account": "Creează cont nou",
  "Add a new account to the chart of accounts": "Adaugă un cont nou în planul de conturi",
  "e.g., 1-1000": "ex.: 1-1000",
  "e.g., Cash - Main Bank Account": "ex.: Numerar - Cont bancar principal",
  "For reports": "Pentru rapoarte",
  "Select type...": "Selectează tipul...",
  "Select category...": "Selectează categoria...",
  "None (Top Level)": "Niciunul (nivel superior)",
  "Header Account": "Cont de grupare",
  "Allow Manual Posting": "Permite înregistrare manuală",
  "Requires Cost Center": "Necesită centru de cost",
  "Control Account": "Cont de control",
  "Select control type...": "Selectează tipul de control...",
  "Create Account": "Creează cont",
  "Asset updated successfully": "Mijlocul fix a fost actualizat cu succes",
  "Asset created successfully": "Mijlocul fix a fost creat cu succes",
  "Failed to save asset": "Mijlocul fix nu a putut fi salvat",
  "Edit Fixed Asset": "Editează mijlocul fix",
  "Create Fixed Asset": "Creează mijloc fix",
  "e.g., FA-001": "ex.: FA-001",
  "Asset name/description": "Nume/descriere mijloc fix",
  "Additional details about the asset": "Detalii suplimentare despre mijlocul fix",
  "Acquisition Cost (£)": "Cost de achiziție (£)",
  "Salvage Value (£)": "Valoare reziduală (£)",
  "Annual Rate (%)": "Rată anuală (%)",
  "Location & Assignment": "Locație și alocare",
  "Physical location of asset": "Locația fizică a mijlocului fix",
  "No cost center": "Fără centru de cost",
  "Create Asset": "Creează mijloc fix",
  "Journal entry must have at least 2 lines": "Nota contabilă trebuie să aibă cel puțin 2 linii",
  "Please select a document type": "Selectează un tip de document",
  "Please enter a posting date": "Introdu o dată de înregistrare",
  "Please enter a description": "Introdu o descriere",
  "Journal entry must have at least 2 valid lines": "Nota contabilă trebuie să aibă cel puțin 2 linii valide",
  "Journal entry must be balanced (debits must equal credits)": "Nota contabilă trebuie să fie echilibrată (debitul trebuie să fie egal cu creditul)",
  "A line cannot have both debit and credit amounts": "O linie nu poate avea sume atât pe debit, cât și pe credit",
  "Journal entry created successfully": "Nota contabilă a fost creată cu succes",
  "Failed to create journal entry": "Nota contabilă nu a putut fi creată",
  "Enter a new manual journal entry": "Introdu o notă contabilă manuală nouă",
  "Entry Details": "Detalii notă",
  "Enter description...": "Introdu descrierea...",
  "External reference...": "Referință externă...",
  "Journal Lines": "Liniile notei contabile",
  "Add Line": "Adaugă linie",
  "Cost Center": "Centru de cost",
  "Line description...": "Descrierea liniei...",
  "Post immediately after creation": "Înregistrează imediat după creare",
  "Period opened successfully": "Perioada a fost deschisă cu succes",
  "Failed to open period": "Perioada nu a putut fi deschisă",
  "Are you sure you want to close this period?": "Sigur vrei să închizi această perioadă?",
  "Period closed successfully": "Perioada a fost închisă cu succes",
  "Failed to close period": "Perioada nu a putut fi închisă",
  "This will permanently lock the period. Are you sure?": "Perioada va fi blocată definitiv. Ești sigur?",
  "Period locked successfully": "Perioada a fost blocată cu succes",
  "Failed to lock period": "Perioada nu a putut fi blocată",
  "Current fiscal year updated": "Anul fiscal curent a fost actualizat",
  "Failed to set current year": "Anul curent nu a putut fi setat",
  "Fiscal year created successfully": "Anul fiscal a fost creat cu succes",
  "Failed to create fiscal year": "Anul fiscal nu a putut fi creat",
  "Special": "Special",
  "Permanently locked": "Blocat definitiv",
  "Manage fiscal years and periods": "Gestionează anii și perioadele fiscale",
  "New Fiscal Year": "An fiscal nou",
  "Fiscal Years": "Ani fiscali",
  "{open} open / {total} periods": "{open} deschise / {total} perioade",
  "No fiscal years found": "Nu s-au găsit ani fiscali",
  "{name} Periods": "Perioadele {name}",
  "Set as Current": "Setează ca curent",
  "{start} to {end}": "{start} – {end}",
  "Select a fiscal year to view its periods": "Selectează un an fiscal pentru a-i vedea perioadele",
  "Create Fiscal Year": "Creează an fiscal",
  "Year Code": "Cod an",
  "e.g., 2025": "ex.: 2025",
  "e.g., Fiscal Year 2025": "ex.: An fiscal 2025",
  "Automatically create monthly periods": "Creează automat perioade lunare",
  "Asset activated successfully": "Mijlocul fix a fost activat cu succes",
  "Failed to activate asset": "Mijlocul fix nu a putut fi activat",
  "Asset disposed successfully": "Mijlocul fix a fost scos din funcțiune cu succes",
  "Failed to dispose asset": "Mijlocul fix nu a putut fi scos din funcțiune",
  "Are you sure you want to delete this asset?": "Sigur vrei să ștergi acest mijloc fix?",
  "Asset deleted successfully": "Mijlocul fix a fost șters cu succes",
  "Failed to delete asset": "Mijlocul fix nu a putut fi șters",
  "Period": "Perioadă",
  "Accumulated": "Cumulat",
  "Month {period}": "Luna {period}",
  "Depreciation": "Amortizare",
  "Book Value": "Valoare contabilă",
  "Back to Fixed Assets": "Înapoi la mijloace fixe",
  "Dispose": "Scoate din funcțiune",
  "Acquisition Cost": "Cost de achiziție",
  "Useful Life": "Durată de utilizare",
  "{years} years {months} months": "Ani: {years}, luni: {months}",
  "{years} years": "Ani: {years}",
  "Depreciation Start": "Început amortizare",
  "Not yet": "Încă nu",
  "Model": "Model",
  "Proceeds": "Încasări",
  "Gain/Loss": "Câștig/Pierdere",
  "No depreciation entries recorded yet": "Nicio înregistrare de amortizare încă",
  "No future depreciation schedule available": "Nu există un grafic de amortizare viitor",
  "Dispose Asset": "Scoate mijlocul fix din funcțiune",
  "Current book value:": "Valoare contabilă curentă:",
  "Disposal Type": "Tip de ieșire",
  "Disposal Date": "Data ieșirii",
  "Proceeds (£)": "Încasări (£)",
  "Buyer Name (optional)": "Numele cumpărătorului (opțional)",
  "Fixed Assets Register": "Registrul mijloacelor fixe",
  "Manage your company's fixed assets and depreciation": "Gestionează mijloacele fixe ale companiei și amortizarea lor",
  "Run Depreciation": "Rulează amortizarea",
  "Add Asset": "Adaugă mijloc fix",
  "Total Assets": "Total mijloace fixe",
  "Accumulated Depreciation": "Amortizare cumulată",
  "Net Book Value": "Valoare contabilă netă",
  "Search assets...": "Caută mijloace fixe...",
  "Loading assets...": "Se încarcă mijloacele fixe...",
  "No fixed assets found": "Nu s-au găsit mijloace fixe",
  "Showing {from} to {to} of {total} assets": "Se afișează {from}–{to} din {total} mijloace fixe",
  "Period Totals": "Totaluri pe perioadă",
  "Account transaction history": "Istoricul tranzacțiilor contului",
  "Include opening balance": "Include soldul inițial",
  "Generate Report": "Generează raportul",
  "Select an account to view its general ledger": "Selectează un cont pentru a-i vedea registrul general",
  "Loading report...": "Se încarcă raportul...",
  "{from} to {to}": "{from} – {to}",
  "Period Debits": "Debit pe perioadă",
  "Period Credits": "Credit pe perioadă",
  "View and manage journal entries": "Vezi și gestionează notele contabile",
  "New Journal Entry": "Notă contabilă nouă",
  "Search by document number, description...": "Caută după număr document, descriere...",
  "All Periods": "Toate perioadele",
  "Loading entries...": "Se încarcă notele...",
  "No journal entries found": "Nu s-au găsit note contabile",
  "Are you sure you want to post this journal entry? This action cannot be undone.": "Sigur vrei să înregistrezi această notă contabilă? Această acțiune nu poate fi anulată.",
  "Journal entry posted successfully": "Nota contabilă a fost înregistrată cu succes",
  "Failed to post journal entry": "Nota contabilă nu a putut fi înregistrată",
  "Journal entry reversed successfully": "Nota contabilă a fost stornată cu succes",
  "Failed to reverse journal entry": "Nota contabilă nu a putut fi stornată",
  "Journal entry not found": "Nota contabilă nu a fost găsită",
  "Post Entry": "Înregistrează nota",
  "Reverse Entry": "Stornează nota",
  "Total Debits": "Total debit",
  "Total Credits": "Total credit",
  "This entry has been reversed by": "Această notă a fost stornată prin",
  "This is a reversal of": "Aceasta este stornarea notei",
  "Reverse Journal Entry": "Stornează nota contabilă",
  "Reversal Date": "Data stornării",
  "Reason for Reversal": "Motivul stornării",
  "Enter reason for reversal...": "Introdu motivul stornării...",
  "Please select a fiscal period": "Selectează o perioadă fiscală",
  "Failed to preview depreciation": "Previzualizarea amortizării a eșuat",
  "Are you sure you want to run depreciation? This will create journal entries.": "Sigur vrei să rulezi amortizarea? Se vor crea note contabile.",
  "Depreciation completed: {count} assets depreciated": { one: "Amortizare finalizată: {count} mijloc fix amortizat", few: "Amortizare finalizată: {count} mijloace fixe amortizate", other: "Amortizare finalizată: {count} de mijloace fixe amortizate" },
  "Failed to run depreciation": "Amortizarea nu a putut fi rulată",
  "Asset": "Mijloc fix",
  "Current Value": "Valoare curentă",
  "After": "După",
  "Calculate and post depreciation for your fixed assets": "Calculează și înregistrează amortizarea mijloacelor fixe",
  "Select Period": "Selectează perioada",
  "Select period": "Selectează perioada",
  "{name} ({start} to {end})": "{name} ({start} – {end})",
  "Asset Category (optional)": "Categorie mijloc fix (opțional)",
  "Running...": "Se rulează...",
  "Preview: {period}": "Previzualizare: {period}",
  "{count} assets, {total} total": { one: "{count} mijloc fix, total {total}", few: "{count} mijloace fixe, total {total}", other: "{count} de mijloace fixe, total {total}" },
  "{count} assets": { one: "{count} mijloc fix", few: "{count} mijloace fixe", other: "{count} de mijloace fixe" },
  "No assets eligible for depreciation in this period": "Niciun mijloc fix eligibil pentru amortizare în această perioadă",
  "Depreciation Complete": "Amortizare finalizată",
  "Depreciated": "Amortizat",
  "{count} error(s) occurred during depreciation": "Erori apărute la amortizare: {count}",
  "Depreciation Entries:": "Note de amortizare:",
  "View Journal Entries": "Vezi notele contabile",
  "Deleted {deleted} deliveries. {skipped} skipped because only pending deliveries can be deleted.": "Livrări șterse: {deleted}. Omise: {skipped}, deoarece doar livrările în așteptare pot fi șterse.",
  "This price document could not be loaded.": "Acest document de prețuri nu a putut fi încărcat.",
  "Price Document": "Document de prețuri",
  "Data access {scope}: {a} {levelA}, {b} {levelB}": "Acces date {scope}: {a} {levelA}, {b} {levelB}",
  "Data access {scope}: {from} → {to}": "Acces date {scope}: {from} → {to}",
  "Customers assigned to members of the ticked groups, plus the customers assigned to the user.": "Clienții alocați membrilor grupelor bifate, plus clienții alocați utilizatorului.",
  "Unapproving reverses the £{amount} of staff purchases taken from this pay, so those invoices are owed again. Continue?": "Anularea aprobării inversează cele £{amount} de cumpărături ale angajatului reținute din acest salariu, așa că facturile respective devin din nou datorate. Continui?",
  "Staff Purchases": "Cumpărături angajat",
  "Customer account": "Cont de client",
  "Taken from pay": "Reținut din salariu",
  "Owed up to {date}": "Datorat până la {date}",
  "Limit": "Limită",
  "Taken from pay on approval": "Se reține din salariu la aprobare",
  "container": "container",
  "Products may share a container of this step only if they are in the same load group": "Produsele pot împărți un container la această operație doar dacă sunt în același grup de încărcare",
  "Load group": "Grup de încărcare",
  "kg": "kg",
  "kg per container for this product; empty = the load group default": "kg pe container pentru acest produs; gol = valoarea implicită a grupului de încărcare",
  "{kg} kg / {container}": "{kg} kg / {container}",
  "no kg per container set": "nu sunt setate kg pe container",
  "{group}: {loaded} {unit} loaded of {capacity} {unit} ({containers} × {container} of {kg} {unit})": "{group}: {loaded} {unit} încărcate din {capacity} {unit} ({containers} × {container} de {kg} {unit})",
  "Load group of this step: products of the same group may share a container": "Grupul de încărcare al acestei operații: produsele din același grup pot împărți un container",
  "{group} · {kg} {unit} / {container}": "{group} · {kg} {unit} / {container}",
  "Load groups: these products should not share a load": "Grupuri de încărcare: aceste produse nu ar trebui încărcate împreună",
  "Products that may share a load at {operation}:": "Produse care pot fi încărcate împreună la {operation}:",
  "no load group": "fără grup de încărcare",
  "Make one order per group instead. This is a warning only; the order can still be created.": "Fă în schimb câte o comandă pe grup. Este doar un avertisment; comanda poate fi creată în continuare.",
  "{operation}: all in load group {group} — they may share a load": "{operation}: toate în grupul de încărcare {group} — pot fi încărcate împreună",
  "{group} · {kg} kg / {container}": "{group} · {kg} kg / {container}",
  "Failed to load the container sizes": "Mărimile containerelor nu au putut fi încărcate",
  "Container sizes set on {count} products": "Mărimile containerelor au fost setate pentru {count} produse",
  "Failed to set the container sizes": "Mărimile containerelor nu au putut fi setate",
  "Use container sizes": "Folosește mărimile containerelor",
  "Products whose recipe has a load group get its kg per container as their batch and kg per container × containers per run as their max per order. Their launch quantities are worked out again, unrounded: the week plan rounds each load group to whole containers. Quantities you typed for them are replaced.": "Produsele a căror rețetă are un grup de încărcare primesc kg pe container ca lot și kg pe container × containere pe rulare ca maxim pe comandă. Cantitățile lor de lansare sunt recalculate, nerotunjite: planul săptămânal rotunjește fiecare grup de încărcare la containere întregi. Cantitățile introduse de tine pentru ele sunt înlocuite.",
  "Every product with a load group already has its container sizes.": "Toate produsele cu grup de încărcare au deja mărimile containerelor.",
  "Round to": "Rotunjire la",
  "Max / order": "Max / comandă",
  "Apply to {count} products": "Aplică la {count} produse",
  "Give the products with a load group their kg per container as batch and their run as max per order": "Dă produselor cu grup de încărcare kg pe container ca lot și rularea ca maxim pe comandă",
  "Container sizes": "Mărimi containere",
  "Load group: rounded with the other products of the group to whole containers on the week plan": "Grup de încărcare: rotunjit împreună cu celelalte produse din grup la containere întregi în planul săptămânal",
  "Rounded with its load group to whole containers of {kg} kg": "Rotunjit cu grupul de încărcare la containere întregi de {kg} kg",
  "{group}: {containers} × {container}": "{group}: {containers} × {container}",
  "{runs} runs of {per_run}": "{runs} rulări a câte {per_run}",
  "partial container – combine with the same load group": "container parțial – combină cu același grup de încărcare",
  "Rounded with the other products of its load group to whole containers": "Rotunjit împreună cu celelalte produse din grupul de încărcare la containere întregi",
  "Containers per launch day of this load group: whole containers, or a partial one to combine with the rest of the group": "Containere pe zi de lansare pentru acest grup de încărcare: containere întregi sau unul parțial de combinat cu restul grupului",
  "{group} · {container} of {kg} kg": "{group} · {container} de {kg} kg",
  "{count} per run": "{count} pe rulare",
  "Enter 0 or more for {name}": "Introdu 0 sau mai mult pentru {name}",
  "Cut targets saved": "Țintele de tranșare au fost salvate",
  "Failed to save cut targets": "Salvarea țintelor de tranșare a eșuat",
  "Reset every cut target to the recipe % of the input?": "Resetezi toate țintele de tranșare la % din rețetă aplicat intrării?",
  "Cut targets reset to the recipe": "Țintele de tranșare au fost resetate la rețetă",
  "Failed to reset cut targets": "Resetarea țintelor de tranșare a eșuat",
  "Cut targets": "Ținte de tranșare",
  "Targets: order": "Ținte: comandă",
  "Targets: recipe %": "Ținte: % rețetă",
  "Save targets": "Salvează țintele",
  "Reset to recipe %": "Resetează la % rețetă",
  "Edit targets": "Editează țintele",
  "Cut": "Tăietură",
  "Recipe": "Rețetă",
  "not cut": "nu se taie",
  "unit": "unitate",
  "Targets add up to {total} kg but the input is {input} kg.": "Țintele însumează {total} kg, dar intrarea este de {input} kg.",
  "Hide cuts not planned ({count})": "Ascunde tăieturile neplanificate ({count})",
  "Show all ({count} not planned)": "Arată tot ({count} neplanificate)",
  "Not planned": "Neplanificat",
  "Recipe: {qty}": "Rețetă: {qty}",
  "Cut targets were set on the production order": "Țintele de tranșare au fost setate pe comanda de producție",
  "Cut targets are the recipe % of the input": "Țintele de tranșare sunt % din rețetă aplicat intrării",
  "Missed": "Ratat",
  "Due today": "Scadente azi",
  "Any time": "Oricând",
  "Anyone": "Oricine",
  "Assigned to me": "Atribuite mie",
  "Close reminder": "Închide memento",
  "Mark missed": "Marchează ratat",
  "Paid / done": "Plătit / rezolvat",
  "No reminders due yet.": "Niciun memento scadent încă.",
  "Reminders ({count})": "Mementouri ({count})",
  "Hide upcoming ({count})": "Ascunde viitoarele ({count})",
  "Show upcoming ({count})": "Arată viitoarele ({count})",
  "Was this deadline met? Marking it paid also settles any later deadline on a fine.": "A fost respectat acest termen? Marcarea ca plătit închide și termenele ulterioare ale unei amenzi.",
  "Not classified": "Neclasificat",
  "Unknown size": "Mărime necunoscută",
  "Not rated": "Neevaluat",
  "Pick an owner...": "Alege un responsabil...",
  "Decision maker identified": "Factor de decizie identificat",
  "Decision maker": "Factor de decizie",
  "Delete this project? Its {count} task(s) will be deleted with it.": "Ștergi acest proiect? Cele {count} sarcini ale lui vor fi șterse odată cu el.",
  "Add Contact for {name}": "Adaugă contact pentru {name}",
  "Error adding contact": "Eroare la adăugarea contactului",
  "Owner": "Proprietar",
  "Buyer": "Cumpărător",
  "Supervisor": "Supervizor",
  "Cashier": "Casier",
  "Accountant": "Contabil",
  "Activity ({count})": "Activitate ({count})",
  "Log Activity": "Înregistrează activitate",
  "No activity logged for this lead yet": "Nicio activitate înregistrată pentru acest lead",
  "Log First Activity": "Înregistrează prima activitate",
  "Shop Visit": "Vizită la magazin",
  "Phone Call": "Apel telefonic",
  "Email Sent": "Email trimis",
  "Meeting": "Întâlnire",
  "Sample Delivery": "Livrare mostre",
  "Quote Sent": "Ofertă trimisă",
  "Follow-up Contact": "Contact de revenire",
  "Product Presentation": "Prezentare produse",
  "Order Discussion": "Discuție comandă",
  "Payment Reminder": "Memento plată",
  "People ({count})": "Persoane ({count})",
  "No people added yet.": "Nicio persoană adăugată încă.",
  "Assign to": "Atribuie lui",
  "Pick who should do this...": "Alege cine se ocupă...",
  "Sales Information": "Informații de vânzare",
  "WhatsApp": "WhatsApp",
  "Current supplier": "Furnizor actual",
  "Estimated weekly volume": "Volum săptămânal estimat",
  "Price sensitivity": "Sensibilitate la preț",
  "Best visit time": "Cel mai bun moment pentru vizită",
  "Product interests": "Produse de interes",
  "e.g. Weekday mornings": "ex. dimineața, în zilele lucrătoare",
  "e.g. beef, chicken, pork": "ex. vită, pui, porc",
  "Sales zone": "Zonă de vânzări",
  "No sales zone": "Fără zonă de vânzări",
  "Shop phone": "Telefon magazin",
  "Mobile phone": "Telefon mobil",
  "Not identified — tick Decision maker on a person": "Neidentificat — bifează Factor de decizie la o persoană",
  "Filled in from the fields below — type to change it.": "Completat din câmpurile de mai jos — scrie pentru a-l schimba.",
  "Task done. Log what happened?": "Sarcină finalizată. Înregistrezi ce s-a întâmplat?",
  "Log it": "Înregistrează",
  "Task Completed": "Sarcină finalizată",
  'No batch — movements with no batch assigned': 'Fără lot — mișcări fără lot atribuit',
  'Overdraft — movements that took their batch below zero': 'Depășire — mișcări care au dus lotul sub zero',
  'Healthy — movements on batches with stock left': 'Sănătos — mișcări pe loturi cu stoc rămas',
  'Expired — movements on batches already expired at the time': 'Expirat — mișcări pe loturi deja expirate la acel moment',
  "Match refund": "Potrivește rambursarea",
  "{customer} - Refund: {amount}": "{customer} - Rambursare: {amount}",
  "Matched:": "Potrivit:",
  "Unmatched:": "Nepotrivit:",
  "This customer has no unallocated receipts and no credit notes left to refund.": "Clientul nu are încasări nealocate și nici note de credit rămase de rambursat.",
  "Match (£)": "Potrivește (£)",
  "Unallocated receipt": "Încasare nealocată",
  "Credit note": "Notă de credit",
  "Click to match": "Click pentru a potrivi",
  "Matched total is more than the refund": "Totalul potrivit depășește rambursarea",
  "Confirm match": "Confirmă potrivirea",
  "Refund Matching": "Potrivirea rambursării",
  "Matched to {documents} - {amount}": "Potrivită cu {documents} - {amount}",
  "Not matched yet. Match the refund to the receipt or credit note it pays back.": "Încă nepotrivită. Potrivește rambursarea cu încasarea sau nota de credit pe care o returnează.",
  "Enter the refund amount first": "Introdu întâi suma rambursată",
  "Edit Match": "Editează potrivirea",
  "Match to Receipt / Credit Note": "Potrivește cu încasare / notă de credit",
  "Refund matched": "Rambursare potrivită",
  "Remove this match? The money goes back to being credit on the customer’s account.": "Ștergi potrivirea? Banii redevin credit în contul clientului.",
  "Match removed": "Potrivire ștearsă",
  "Matched (GBP)": "Potrivit (GBP)",
  "Customer Refund": "Rambursare client",
  "Refund Matches": "Potriviri rambursare",
  "Matched: {amount}": "Potrivit: {amount}",
  "Unmatched: {amount}": "Nepotrivit: {amount}",
  "System User": "Utilizator sistem",
  "No user linked": "Niciun utilizator asociat",
  "Create user": "Creează utilizator",
  "Failed to load users": "Nu s-au putut încărca utilizatorii",
  "User linked": "Utilizator asociat",
  "User unlinked": "Utilizator dezasociat",
  "Failed to link user": "Nu s-a putut asocia utilizatorul",
  "Search by username, name or email": "Caută după utilizator, nume sau email",
  "No free users found": "Nu s-au găsit utilizatori liberi",
  "Link existing user": "Asociază utilizator existent",
  "Unlink": "Dezasociază",
  "Auto-allocated to {count} loans": { one: "Alocat automat pe {count} împrumut", few: "Alocat automat pe {count} împrumuturi", other: "Alocat automat pe {count} de împrumuturi" },
  "Allocated to 1 loan": "Alocat pe 1 împrumut",
  "Allocated to {count} loans": { one: "Alocat pe {count} împrumut", few: "Alocat pe {count} împrumuturi", other: "Alocat pe {count} de împrumuturi" },
  "Use Auto-Allocate or manually allocate to loans": "Folosește Alocă automat sau alocă manual pe împrumuturi",
  "Amount (GBP)": "Sumă (GBP)",
  "Principal {amount}": "Principal {amount}",
  "Interest {amount}": "Dobândă {amount}",
  "Commission {amount}": "Comision {amount}",
  "Instalment {number}": "Rata {number}",
  "Loan principal": "Principal împrumut",
  "Loan balance": "Sold împrumut",
  "VAT {amount}": "TVA {amount}",
  "Principal / interest / VAT breakdown": "Defalcare principal / dobândă / TVA",
  "What this receipt covers": "Ce acoperă această încasare",
  "What this payment pays": "Ce plătește această plată",
  "Fee {amount}": "Comision de documentare {amount}",
  "VAT deposit": "Avans TVA",
  "Documentation fee": "Comision de documentare",
  "Upfront charges": "Costuri inițiale",
  "Paid with the first instalment": "Se plătește odată cu prima rată",
  "Charges paid": "Costuri plătite",
  "Charges Paid:": "Costuri plătite:",
  "Amount outstanding": "Total de plată rămas",
  "Amount Outstanding": "Total de plată rămas",
  "Amount Outstanding:": "Total de plată rămas:",
  "Principal Outstanding": "Principal restant",
  "Principal, unpaid interest, commission and charges": "Principal, dobândă, comision și costuri neplătite",
  "Part paid": "Plătit parțial",
  "incl. VAT deposit {vat} · fee {fee}": "incl. avans TVA {vat} · comision {fee}",
  "Instalment {amount} + VAT deposit {vat} + documentation fee {fee}": "Rata {amount} + avans TVA {vat} + comision de documentare {fee}",
  "Classifications": "Clasificări",
  "Settings": "Setări",
  "Add option": "Adaugă opțiune",
  "New option for {name}": "Opțiune nouă pentru {name}",
  "-- Not set --": "-- Nesetat --",
  "Move up": "Mută în sus",
  "Move down": "Mută în jos",
  "Delete \"{name}\"?": "Ștergi „{name}”?",
  "Delete \"{name}\"? It is set on {count} customers and leads, and will be removed from them.": "Ștergi „{name}”? Este setată pe {count} clienți și potențiali clienți și va fi eliminată de pe aceștia.",
  "Delete \"{name}\"? It is set on {customers} customers and {leads} leads, and will be removed from them. Untick Active instead to keep existing values.": "Ștergi „{name}”? Este setată pe {customers} clienți și {leads} potențiali clienți și va fi eliminată de pe aceștia. Debifează Activ ca să păstrezi valorile existente.",
  "Your own groupings for leads and customers, e.g. Community: Turkish shop, Polish shop.": "Grupările tale pentru potențiali clienți și clienți, de ex. Comunitate: magazin turcesc, magazin polonez.",
  "No classifications yet. Add the first one below.": "Nu există încă clasificări. Adaugă prima mai jos.",
  "Delete classification": "Șterge clasificarea",
  "Delete option": "Șterge opțiunea",
  "{customers} customers · {leads} leads": "{customers} clienți · {leads} potențiali clienți",
  "New option, e.g. Turkish shop": "Opțiune nouă, de ex. magazin turcesc",
  "New classification, e.g. Community": "Clasificare nouă, de ex. Comunitate",
  "Add classification": "Adaugă clasificare",
  "Shop size": "Mărimea magazinului",
  "Shop Size": "Mărimea magazinului",
  "No size": "Fără mărime",
  "Small (1-2 fridges)": "Mic (1-2 frigidere)",
  "Medium (3-5 fridges)": "Mediu (3-5 frigidere)",
  "Large (6+ fridges)": "Mare (6+ frigidere)",
  "Failed to create option": "Opțiunea nu a putut fi creată",
  "Failed to update option": "Opțiunea nu a putut fi actualizată",
  "Failed to delete option": "Opțiunea nu a putut fi ștearsă",
  "Failed to create classification": "Clasificarea nu a putut fi creată",
  "Failed to update classification": "Clasificarea nu a putut fi actualizată",
  "Failed to delete classification": "Clasificarea nu a putut fi ștearsă",
  "Page settings": "Setări pagină",
  "Top Bar": "Bara de sus",
  "Filter Panel": "Panou de filtre",
  "Columns": "Coloane",
  "Fulfilment": "Livrare",
  "Location status": "Stare locație",
  "Credit limit": "Limită de credit",
  "Last invoice": "Ultima factură",
  "Company number": "Număr companie",
  "Toggle which columns are visible in the customer list.": "Alege ce coloane sunt vizibile în lista de clienți.",
};

export default ro;
